/** PROTOTYPED */
const getLocale = () => ({
  general: {
    voltar: "Voltar",
    procurar: "Procurar",
    adicionar: "Adicionar",
    editar: "Editar",
    informacoes: "Informações",
    buscar: "Buscar",
    salvar: "Salvar",
    duplicar: "Duplicar",
    salvarEdicao: "Salvar edição",
    semDados: "Não há dados cadastrados",
    alertas: "Alertas",
    desde: "desde",
    pesquisar: "Pesquisar",
    sim: "Sim",
    nao: "Não",
    consulta: "Consulta",
    exportar: "Exportar",
    exportarPDF: "Exportar PDF",
    exportarXLS: "Exportar XLS",
    exportarTextoCSV: "Exportar CSV",
    diaMesAno: "dd/mm/aaaa",
    mesAno: "mm/aaaa",
    horaMinuto: "hh:mm",
    diaMesAnoHoraMinuto: "dd/mm/aaaa hh:mm",
    recarregar: "Recarregar",
    mudarLinguagem: "Change to English",
    ingles: "Inglês",
    portugues: "Português",
  },

  OcorrenciaAnormal: {
    ListaDeOcorrenciasAnormais: {
      deletar: "Tem certeza que gostaria de deletar essa ocorrência anormal?",
      titulo: "Lista de ocorrências anormais",
      botaoAdicionar: "Adicionar ocorrência anormal",
      tabela: {
        semOcorrencias: "Não há ocorrências cadastrados",
        ID: "ID",
        Tipo: "Tipo",
        Descricao: "Descrição",
        Acoes: "Ações",
      },
    },

    AdicionarOcorrenciaAnormal: {
      titulo: "Cadastrar ocorrência anormal",
      formulario: {
        Tipo: "Tipo",
        Descricao: "Descrição",
        AcaoRequerida: "Ação requerida",
      },
    },

    EditarOcorrenciaAnormal: {
      titulo: "Editar ocorrência anormal",
      formulario: {
        Tipo: "Tipo",
        Descricao: "Descrição",
        AcaoRequerida: "Ação requerida",
      },
    },
  },

  Frotas: {
    StatusFrotas: {
      deletar: "Tem certeza que gostaria de deletar essa frota?",
      alertaFadiga:
        "Tem certeza que gostaria de trocar o alerta de fadiga deste tripulante?",
      titulo: "Status de frotas",
      botaoEditarStatus: "Editar status",
      botaoMudarData: "Mudar data",
      tituloStatusParaData: "Status da frota para",
      listaFrotas: {
        PMD: "PMD",
        Disponivel: "Disponível",
        Motivo: "Motivo",
        Previsao: "Previsão",
        IndisponivelDesde: "Indisponivel desde",
        AdicionadoPor: "Adicionado por",
        InspetorMecanico: "Inspetor / Mêcanico",
        FlightFollowing: "Flight Following",
        Comandantes: "Comandantes",
        Copilotos: "Copilotos",
        Comissarios: "Comissários",
        Observacoes: "Observações",
      },
    },

    AdicionarFrota: {
      deletar: "Tem certeza que gostaria de deletar essa frota?",
      titulo: "Adicionar frota",
      botaoEditarStatus: "Editar status",
      formulario: {
        Base: "Base",
        Aeronave: "Aeronave",
        Disponivel: "Disponível",
        Motivo: "Motivo",
        Previsao: "Previsão",
        IndisponivelDesde: "Indisponível desde",
        InspetorMecanico: "Inspetor / Mecânico",
        Comandantes: "Comandantes",
        Copilotos: "Copilotos",
        Comissarios: "Comissários",
        FlightFollowingAnormal: "Flight following anormal",
        Motivo: "Motivo",
        Desde: "Desde",
        Observacoes: "Observações",
        placeholder: {
          SelecionarBase: "Selecionar base",
          SelecionarFrota: "Selecionar frota",
        },
      },
      listaFrotas: {
        PMD: "PMD",
        Disponivel: "Disponível",
        Motivo: "Motivo",
        Previsao: "Previsão",
        IndisponivelDesde: "Indisponivel desde",
        AdicionadoPor: "Adicionado por",
        InspetorMecanico: "Inspetor / Mêcanico",
        FlightFollowing: "Flight Following",
        Comandantes: "Comandantes",
        Copilotos: "Copilotos",
        Comissarios: "Comissários",
        Observacoes: "Observações",
      },
    },
  },

  PeriodoReboqueAeronave: {
    ListaDePeriodoReboqueAeronave: {
      deletar: "Tem certeza que gostaria de deletar esse período de reboque?",
      titulo: "Lista de Períodos de Reboque de Aeronaves",
      botaoAdicionarPeriodo: "Adicionar período de reboque",
      tabela: {
        ID: "ID",
        Usuario: "Usuário",
        Aeronave: "Aeronave",
        Localidade: "Localidade",
        Inicio: "Início",
        Fim: "Fim",
        TempoTotal: "Tempo Total",
        Acoes: "Ações",
      },
    },
    AdicionarPeriodoReboqueAeronave: {
      titulo: "Cadastrar período de reboque",
      tituloErro: "Os seguintes erros de preenchimento impediram o relatório de ser finalizado",
      formulario: {
        Aeronave: "Aeronave",
        Localidade: "Localidade",
        Inicio: "Inicio",
        Fim: "Fim",
        botaoAdicionarPeriodoReboque: "Adicionar período de reboque",
        placeholder: {
          SelecioneAeronave: "Selecione a Aeronave",
          SelecioneLocalidade: "Selecione a localidade",
        },
      },
    },

    EditarPeriodoReboqueAeronave: {
      titulo: "Editar período de reboque",
      tituloErro: "Os seguintes erros de preenchimento impediram o relatório de ser finalizado",
      formulario: {
        Aeronave: "Aeronave",
        Localidade: "Localidade",
        Inicio: "Inicio",
        Fim: "Fim",
        TempoTotal: "Tempo Total",
        botaoSalvarEdicao: "Salvar edição",
        placeholder: {
          SelecioneAeronave: "Selecione a aeronave",
          SelecioneLocalidade: "Selecione a localidade",
        },
      },
    },    
  },

  ModelosAeronaves: {
    ListaModelosAeronaves: {
      deletar: "Tem certeza que gostaria de deletar esse modelo de aeronave?",
      titulo: "Lista de modelos de aeronave",
      botaoAdicionarModelo: "Adicionar modelo de aeronave",
      tabela: {
        semAeronaves: "Não há aeronaves cadastrados",
        ID: "ID",
        Nome: "Nome",
        Modelo: "Modelo",
        Classe: "Classe",
        Porte: "Porte",
        Motorização: "Motorização",
        Acoes: "Ações",
      },
    },

    AdicionarModelosAeronaves: {
      titulo: "Cadastrar modelo de aeronave",
      formulario: {
        Nome: "Nome",
        Modelo: "Modelo",
        Classe: "Classe",
        opcoesClasses: {
          Aviao: "Avião",
          Helicoptero: "Helicóptero",
        },
        Porte: "Porte",
        opcoesPorte: {
          Pequeno: "Pequeno-porte",
          Medio: "Médio-porte",
          SuperMedio: "Super médio-porte",
          Grande: "Grande-porte",
        },
        UnidadeCombustivel: "Unidade de combustível",
        TipoCombustivel: "Tipo de combustível",
        Motorizacao: "Motorização",
        opcoesMotorizacao: {
          Multimotor: "Multimotor",
          Monomotor: "Monomotor",
        },

        TipoTripulacao: "Tipo de tripulação",
        opcoesTipoTripulacao: {
          DualPilot: "DualPilot",
          SinglePilot: "SinglePilot",
        },

        CentroDeCusto: "Centro de custo",
        Fabricante: "Fabricante",
        UsarEmPlanejamento: "Usar em planejamento",
        ExibirPMDnoStatusFrota: "Exibir PMD no Status de Frota",
        ConsumoHoraSolo: "Consumo/Hora - Solo",
        ConsumoHoraVoo: "Consumo/Hora - Voo",
        CapacidadeDeCombustível: "Capacidade de Combustível",

        botaoAdicionarModelo: "Adicionar modelo de aeronave",

        placeholder: {
          NomeAeronave: "Nome da aeronave",
          ModeloAeronave: "Modelo da aeronave",
          SelecioneClasse: "Selecione a classe",
          SelecionePorte: "Selecione o porte",
          SelecioneUnidadeCombustivel: "Selecione a unidade de combustível",
          SelecioneTipoCombustivel: "Selecione o tipo de combustível",
          SelecioneMotorizacao: "Selecione a motorização",
          SelecioneTripulacao: "Selecione a tripulação",
          CentroDeCustoAeronave: "Centro de custo da aeronave",
          FabricanteAeronave: "Fabricante da aeronave",
        },
      },
    },

    EditarModelosAeronaves: {
      deletar: "Tem certeza que gostaria de deletar esse modelo similar?",
      titulo: "Editar modelo de aeronave",
      formulario: {
        Nome: "Nome",
        Modelo: "Modelo",
        Classe: "Classe",
        opcoesClasses: {
          Aviao: "Avião",
          Helicoptero: "Helicóptero",
        },
        Porte: "Porte",
        opcoesPorte: {
          Pequeno: "Pequeno-porte",
          Medio: "Médio-porte",
          SuperMedio: "Super médio-porte",
          Grande: "Grande-porte",
        },
        UnidadeCombustivel: "Unidade de combustível",
        TipoCombustivel: "Tipo de combustível",
        Motorizacao: "Motorização",
        opcoesMotorizacao: {
          Multimotor: "Multimotor",
          Monomotor: "Monomotor",
        },

        TipoTripulacao: "Tipo de tripulação",
        opcoesTipoTripulacao: {
          DualPilot: "DualPilot",
          SinglePilot: "SinglePilot",
        },

        CentroDeCusto: "Centro de custo",
        Fabricante: "Fabricante",
        UsarEmPlanejamento: "Usar em planejamento",
        ExibirPMDnoStatusFrota: "Exibir PMD no Status de Frota",
        ConsumoHoraSolo: "Consumo/Hora - Solo",
        ConsumoHoraVoo: "Consumo/Hora - Voo",
        CapacidadeDeCombustível: "Capacidade de Combustível",
        DiasPreservacaoCelula: "Dias para preservação de célula",
        DiasPreservacaoMotor: "Dias para preservação de motor",
        QuantidadeMotores: "Quantidade de motores",

        botaoSalvarEdicao: "Salvar edição",

        placeholder: {
          NomeAeronave: "Nome da aeronave",
          ModeloAeronave: "Modelo da aeronave",
          SelecioneClasse: "Selecione a classe",
          SelecionePorte: "Selecione o porte",
          SelecioneUnidadeCombustivel: "Selecione a unidade de combustível",
          SelecioneTipoCombustivel: "Selecione o tipo de combustível",
          SelecioneMotorizacao: "Selecione a motorização",
          SelecioneTripulacao: "Selecione a tripulação",
          CentroDeCustoAeronave: "Centro de custo da aeronave",
          FabricanteAeronave: "Fabricante da aeronave",
          SelecionarModeloSimilar: "Selecionar modelo similar",
        },
      },
      motores: {
        titulo: "Motores",
        Aeronave: "Aeronave",
        PartNumber: "Part Number",
        SerialNumber: "Serial Number",
        HorasIniciais: "Horas iniciais",
        HorasAtuais: "Horas atuais",
        acoes: "Ações",
        formulario: {
          AdicionarMotor: "Adicionar Motor",
        },
      },
      versoes: {
        titulo: "Versões",
        Versao: "Versão",
        acoes: "Ações",
        formulario: {
          AdicionarVersao: "Adicionar Versão",
        },
      },
      contadores: {
        titulo: "Contadores Especiais",
        Contador: "Contador",
        Versao: "Versão",
        Referencia: "Referência",
        TipoContagem: "Tipo de Contagem",
        TipoCampo: "Tipo de Campo",
        acoes: "Ações",
        formulario: {
          AdicionarContador: "Adicionar Contador Especial",
        },
        placeholder: {
          SelecionarReferencia: "Selecionar referência",
          SelecionarVersao: "Selecionar versão",
          SelecionarTipoContagem: "Selecionar tipo de contagem",
          SelecionarTipoCampo: "Selecionar tipo de campo",
        },
        options: {
          Referencia: {
            Modelo: "Modelo",
            Versao: "Versão",
          },
          TipoContagem: {
            PartidaCorte: "Partida ao Corte",
            DecolagemPouso: "Decolagem ao Pouso",
            Manual: "Manual",
          },
          TipoCampo: {
            Inteiro: "Número Inteiro",
            Horario: "Horário",
            Decimal: "Decimal",
          },
        },
      },
      modalItensPersonalizados: {
        titulo: "Itens Personalizados da Versão",
        formulario: {
          titulo: "Cadastrar Item Personalizado da Versão",
          Tipo: "Tipo",
          Nome: "Nome",
          BotaoCadastrarItem: "Cadastrar Item Personalizado da Versão",
          Opcoes: "Opções",
          PlaceholderOpcao: "Informe a opção",
          BotaoAdicionarOpcao: "Adicionar opção",
          MensagemInformeOpcao: "Informe ao menos uma opção válida.",
        },
        tabela: {
          titulo: "Itens Personalizados da Versão",
          Tipo: "Tipo",
          Nome: "Nome",
          Opcoes: "Opções",
          Acoes: "Ações",
        },
        placeholder: {
          SelecionarTipo: "Selecionar tipo",
        },
        options: {
          Tipo: {
            Numero: "Número",
            Texto: "Texto",
            Horas: "Horas",
            Decimais: "Decimais",
            Opcoes: "Opções",
          },
        },
      },
      tabela: {
        titulo: "Modelos similares",
        modelo: "Modelo",
        acoes: "Ações",
        formulario: {
          AdicionarModelo: "Adicionar Modelo",
          botaoAdicionarSimilar: "Adicionar similar",
          placeholder: {
            SelecionarModeloSimilar: "Selecionar modelo similar",
          },
        },
      },
    },
  },

  Aeronaves: {
    ListaDeAeronaves: {
      ativar: "Tem certeza que gostaria de ativar essa aeronave?",
      arquivar: "Tem certeza que gostaria de arquivar essa aeronave?",
      ativo: "Ativo",
      arquivado: "Arquivado",
      deletar: "Tem certeza que gostaria de deletar essa aeronave?",
      titulo: "Lista de aeronaves",
      botaoAdicionarAeronave: "Adicionar aeronave",
      tabela: {
        semAeronaves: "Não há aeronaves cadastrados",
        ID: "ID",
        Matricula: "Matrícula",
        Modelo: "Modelo",
        Status: "Status",
        Acoes: "Ações",
      },
    },

    AdicionarAeronaves: {
      titulo: "Cadastrar aeronave",
      formulario: {
        Modelo: "Modelo",
        Matricula: "Matrícula",
        Tipo: "Tipo",
        NumeroSerie: "Número de série",
        CentroCustoTripulacao: "Centro de custo - Tripulação",
        CentroCUstoCoordenacao: "Centro de custo - Coordenação",
        CA: "C.A.",
        IAM: "I.A.M",
        Peso: "Peso",
        OutOfService: "Fora de serviço?",
        CodigoPTBR: "Código PTBR",
        ConsumoHoraSolo: "Consumo/Hora - Solo",
        ConsumoHoraVoo: "Consumo/Hora - Voo",
        CapacidadeDeCombustível: "Capacidade de Combustível",
        Versao: "Versão",
        Logbook: "Logbook Digital",
        DataAberturaLogbook: "Data de abertura do logbook",
        DataEncerramentoLogbook: "Data de encerramento do logbook",
        HorasIniciais: "Horas de voo iniciais",
        HorasAtuais: "Horas de voo atuais",
        PousosIniciais: "Pousos iniciais",
        PousosAtuais: "Pousos atuais",
        botaoAdicionarAeronave: "Adicionar aeronave",


        placeholder: {
          SelecioneModeloAeronave: "Selecionar modelo de aeronave",
          RegistroAeronave: "Registro da aeronave",
          SelecionarTipoOperacao: "Selecionar tipo de operação",
        },
      },
    },

    EditarAeronaves: {
      opcoesTipoDeCargo: {
        Tripulacao: "Tripulação",
        CVODVO: "CVO/DVO",
        MestreDeCarga: "Mestre de Carga",
        Mecanico: "Mecânico",
        Administrativo: "Administrativo",
        Indireto: "Indireto",
      },

      deletarCentroDeCusto: "Tem certeza que deseja deletar este centro de custo?",
      atualizarVoeOmni: "Tem certeza que deseja atualizar os campos:\nPeso;\nConsumo/Hora - Solo;\nConsumo/Hora - Voo; e\nCapacidade de Combustível.\nCom os dados do VoeOmni?",
      titulo: "Editar aeronave",
      botaoVoeOmni: "Atualização VoeOmni",
      formulario: {
        Modelo: "Modelo",
        Matricula: "Matrícula",
        Tipo: "Tipo",
        NumeroSerie: "Número de série",
        CentroCustoTripulacao: "Centro de custo - Tripulação",
        CentroCUstoCoordenacao: "Centro de custo - Coordenação",
        CA: "C.A.",
        IAM: "I.A.M",
        Peso: "Peso",
        OutOfService: "Fora de serviço?",
        CodigoPTBR: "Código PTBR",
        ConsumoHoraSolo: "Consumo/Hora - Solo",
        ConsumoHoraVoo: "Consumo/Hora - Voo",
        Hums: "Possui HUMS",
        Fdm: "Possui FDM",
        CargaExterna: "Transporta Carga Externa",
        Versao: "Versão",
        Logbook: "Logbook Digital",
        botaoIntegrarLogbook: "Integrar com Logbook App",
        DataAberturaLogbook: "Data de abertura do logbook",
        DataEncerramentoLogbook: "Data de encerramento do logbook",
        HorasIniciais: "Horas de voo iniciais",
        HorasAtuais: "Horas de voo atuais",
        PousosIniciais: "Pousos iniciais",
        PousosAtuais: "Pousos atuais",
        CapacidadeDeCombustível: "Capacidade de Combustível",
        botaoSalvarEdicao: "Salvar edição",

        placeholder: {
          SelecioneModeloAeronave: "Selecionar modelo de aeronave",
          RegistroAeronave: "Registro da aeronave",
          SelecionarTipoOperacao: "Selecionar tipo de operação",
          SelecionarVersao: "Selecionar versão",
        },
      },

      CentroDeCustos: {
        tituloCentroDeCustos: "Centros de custos",
        adicionarCentroDeCusto: "Adicionar centro de custo",

        formulario: {
          TipoDeCargo: "Tipo de cargo",
          CentrosDeCusto: "Centros de Custo",

          botaoAdicionarCentroDeCusto: "Adicionar Centro de Custo",

          placeholder: {
            SelecionarTipoDeCargo: "Selecionar tipo de cargo",
            SelecionarCentroDeCusto: "Selecionar centro de custo",
          },
        },

        tabela: {
          tituloTipoDeCargo: "Tipo de cargo",
          tituloCentroDeCusto: "Centro de Custo",
        },
      },
    },

    ControleMensalDeMovimentacao: {
      titulo: "Controle Mensal de Movimentação de Aeronaves Contratadas",
      formulario: {
        MesAno: "Mês/Ano",
      },
      semColaboradores: "Não há colaboradores cadastrados",
    },

    ControleAnualDeMovimentacao: {
      titulo: "Controle Anual de Movimentação de Aeronaves Contratadas",
      formulario: {
        Ano: "Ano",
      },
      semColaboradores: "Não há colaboradores cadastrados",
    },
  },

  OperadoresAeroporto: {
    ListaDeOperadores: {
      titulo: "Lista de operadores aeroportuários",
      botaoAdicionarOperador: "Adicionar operador aeroportuário",
      tabela: {
        ID: "ID",
        Nome: "Nome",
        Email: "E-mail",
        Acoes: "Ações",
      },
    },
    AdicionarOperadoresAeroporto: {
      titulo: "Cadastrar operador aeroportuário",
      formulario: {
        Nome: "Nome",
        Email: "E-mail",
        botaoAdicionarOperadoresAeroporto: "Adicionar",
      },
    },

    EditarOperadoresAeroporto: {
      titulo: "Editar operadores aeroportuários",
      formulario: {
        Nome: "Nome",
        Email: "E-mail",
        botaoSalvarEdicao: "Salvar edição",
      },

      localidades: {
        titulo: "Localidades",
        adicionarCentroDeCusto: "Adicionar localidades",
        formulario: {
          Localidade: "Localidade",
          botaoAdicionarLocalidade: "Adicionar localidade",

          placeholder: {
            SelecionarLocalidade: "Selecionar localidade",
          },
        },
        tabela: {
          Localidade: "Localidade",
          Acoes: "Ações",
        },
      },
      tabelaPpe: {
        titulo: "Tabela de PPE (Tarifa de Permanência na Área de Estadia)",
        formulario: {
          NaturezaDoVoo: "Natureza do vôo",
          OpcoesNaturezaDoVoo: {
            Domestico: "Doméstico",
            Internacional: "Internacional",
          },
          Grupo: "Grupo",
          PmdDe: "Pmd de",
          PmdAte: "Pmd até",
          Moeda: "Moeda",
          DataDeInicioDeVigencia: "Data de início da vigência",
          DataDeTerminoDeVigencia: "Data de término da vigência",
          Valor: "Valor",
          botaoAdicionarPpe: "Adicionar PPE",
        },
        tabela: {
          NaturezaDoVoo: "Natureza do vôo",
          PmdDe: "PMD de",
          PmdAte: "PMD até",
          Grupo: "Grupo",
          Moeda: "Moeda",
          Valor: "Valor",
          DataInicioVigencia: "Data Início Vigência",
          DataTerminoVigencia: "Data Término Vigência",
          Acoes: "Ações",
        },
        modalDuplicarPpe:{
          titulo: "Duplicação",
          formulario:{
            DataDeInicioDeVigencia: "Data de início da vigência",
            DataDeTerminoDeVigencia: "Data de término da vigência",
            Valor: "Valor",
            botaoDuplicarPpe: "Duplicar PPE",
          },
        },
        modalEditarPpe:{
          titulo: "Editar PPE",
          formulario:{
            NaturezaDoVoo: "Natureza do vôo",
            OpcoesNaturezaDoVoo: {
              Domestico: "Doméstico",
              Internacional: "Internacional",
            },
            Grupo: "Grupo",
            PmdDe: "Pmd de",
            PmdAte: "Pmd até",
            Moeda: "Moeda",
            DataDeInicioDeVigencia: "Data de início da vigência",
            DataDeTerminoDeVigencia: "Data de término da vigência",
            Valor: "Valor",
            botaoEditarPpe: "Editar PPE",
          },
        },
      },
      tabelaPpm: {
        titulo: "Tabela de PPM (Tarifa de Permanência no Pátio de Manobras)",
        formulario: {
          NaturezaDoVoo: "Natureza do vôo",
          OpcoesNaturezaDoVoo: {
            Domestico: "Doméstico",
            Internacional: "Internacional",
          },
          Grupo: "Grupo",
          PmdDe: "Pmd de",
          PmdAte: "Pmd até",
          Moeda: "Moeda",
          DataDeInicioDeVigencia: "Data de início da vigência",
          DataDeTerminoDeVigencia: "Data de término da vigência",
          Valor: "Valor",
          botaoAdicionarPpm: "Adicionar PPM",
        },
        tabela: {
          NaturezaDoVoo: "Natureza do vôo",
          PmdDe: "PMD de",
          PmdAte: "PMD até",
          Grupo: "Grupo",
          Moeda: "Moeda",
          Valor: "Valor",
          DataInicioVigencia: "Data Início Vigência",
          DataTerminoVigencia: "Data Término Vigência",
          Acoes: "Ações",
        },
        modalDuplicarPpm:{
          titulo: "Duplicação",
          formulario:{
            DataDeInicioDeVigencia: "Data de início da vigência",
            DataDeTerminoDeVigencia: "Data de término da vigência",
            Valor: "Valor",
            botaoDuplicarPpm: "Duplicar PPM",
          },
        },
        modalEditarPpm:{
          titulo: "Editar PPM",
          formulario:{
            NaturezaDoVoo: "Natureza do vôo",
            OpcoesNaturezaDoVoo: {
              Domestico: "Doméstico",
              Internacional: "Internacional",
            },
            Grupo: "Grupo",
            PmdDe: "Pmd de",
            PmdAte: "Pmd até",
            Moeda: "Moeda",
            DataDeInicioDeVigencia: "Data de início da vigência",
            DataDeTerminoDeVigencia: "Data de término da vigência",
            Valor: "Valor",
            botaoEditarPpm: "Editar PPM",
          },
        },
      },
      tabelaTpo: {
        titulo: "Tabela de TPO (Tarifa de Pouso)",
        formulario: {
          NaturezaDoVoo: "Natureza do vôo",
          OpcoesNaturezaDoVoo: {
            Domestico: "Doméstico",
            Internacional: "Internacional",
          },
          Grupo: "Grupo",
          PmdDe: "Pmd de",
          PmdAte: "Pmd até",
          Moeda: "Moeda",
          DataDeInicioDeVigencia: "Data de início da vigência",
          DataDeTerminoDeVigencia: "Data de término da vigência",
          Valor: "Valor",
          botaoAdicionarTpo: "Adicionar TPO",
        },
        tabela: {
          NaturezaDoVoo: "Natureza do vôo",
          PmdDe: "PMD de",
          PmdAte: "PMD até",
          Grupo: "Grupo",
          Moeda: "Moeda",
          Valor: "Valor",
          DataInicioVigencia: "Data Início Vigência",
          DataTerminoVigencia: "Data Término Vigência",
          Acoes: "Ações",
        },
        modalDuplicarTpo:{
          titulo: "Duplicação",
          formulario:{
            DataDeInicioDeVigencia: "Data de início da vigência",
            DataDeTerminoDeVigencia: "Data de término da vigência",
            Valor: "Valor",
            botaoDuplicarTpo: "Duplicar TPO",
          },
        },
        modalEditarTpo:{
          titulo: "Editar TPO",
          formulario:{
            NaturezaDoVoo: "Natureza do vôo",
            OpcoesNaturezaDoVoo: {
              Domestico: "Doméstico",
              Internacional: "Internacional",
            },
            Grupo: "Grupo",
            PmdDe: "Pmd de",
            PmdAte: "Pmd até",
            Moeda: "Moeda",
            DataDeInicioDeVigencia: "Data de início da vigência",
            DataDeTerminoDeVigencia: "Data de término da vigência",
            Valor: "Valor",
            botaoEditarTpo: "Editar TPO",
          },
        },
      },
    },    
  },

  ResponsaveisPeloEspacoAereo: {
    ListaDeResponsaveisPeloEspacoAereo: {
      titulo: "Lista de controladores",
      botaoAdicionarResponsavel: "Adicionar controlador",
      tabela: {
        ID: "ID",
        Nome: "Nome",
        Email: "E-mail",
        Acoes: "Ações",
      },
    },
    AdicionarResponsaveisPeloEspacoAereo: {
      titulo: "Cadastrar controlador",
      formulario: {
        Nome: "Nome",
        Email: "E-mail",
        Pais: "País",
        botaoAdicionarResponsaveisPeloEspacoAereo: "Adicionar",
        placeHolder: {
          SelecionarPais: "Selecionar país",
        },
      },
    },

    EditarResponsaveisPeloEspacoAereo: {
      titulo: "Editar controlador",
      formulario: {
        Nome: "Nome",
        Email: "E-mail",
        Pais: "País",
        botaoSalvarEdicao: "Salvar edição",
        placeHolder: {
          SelecionarPais: "Selecionar país",
        },
      },
      tabelaAdr: {
        titulo: "Tabela de TAT ADR (Tarifa de Uso das Comunicações e dos Auxílios-Rádio à Navegação Aérea em Área de Controle)",
        formulario: {
          NaturezaDoVoo: "Natureza do vôo",
          OpcoesNaturezaDoVoo: {
            Domestico: "Doméstico",
            Internacional: "Internacional",
          },
          Classe: "Classe",
          PmdDe: "Pmd de",
          PmdAte: "Pmd até",
          DataDeInicioDeVigencia: "Data de início da vigência",
          DataDeTerminoDeVigencia: "Data de término da vigência",
          Valor: "Valor",
          botaoAdicionarAdr: "Adicionar ADR",
        },
        tabela: {
          NaturezaDoVoo: "Natureza do vôo",
          PmdDe: "PMD de",
          PmdAte: "PMD até",
          Classe: "Classe",
          Moeda: "Moeda",
          Valor: "Valor",
          DataInicioVigencia: "Data Início Vigência",
          DataTerminoVigencia: "Data Término Vigência",
          Acoes: "Ações",
        },
        modalDuplicarAdr:{
          titulo: "Duplicação",
          formulario:{
            DataDeInicioDeVigencia: "Data de início da vigência",
            DataDeTerminoDeVigencia: "Data de término da vigência",
            Valor: "Valor",
            botaoDuplicarAdr: "Duplicar ADR",
          },
        },
        modalEditarAdr:{
          titulo: "Editar ADR",
          formulario:{
            NaturezaDoVoo: "Natureza do vôo",
            OpcoesNaturezaDoVoo: {
              Domestico: "Doméstico",
              Internacional: "Internacional",
            },
            Classe: "Classe",
            PmdDe: "Pmd de",
            PmdAte: "Pmd até",
            DataDeInicioDeVigencia: "Data de início da vigência",
            DataDeTerminoDeVigencia: "Data de término da vigência",
            Valor: "Valor",
            botaoEditarAdr: "Editar ADR",
          },
        },
      },
      tabelaApp: {
        titulo: "Tabela de TAT APP (Tarifa de Uso das Comunicações e dos Auxílios-Rádio à Navegação Aérea em Área de Controle de Aproximação)",
        formulario: {
          NaturezaDoVoo: "Natureza do vôo",
          OpcoesNaturezaDoVoo: {
            Domestico: "Doméstico",
            Internacional: "Internacional",
          },
          Classe: "Classe",
          PmdDe: "Pmd de",
          PmdAte: "Pmd até",
          DataDeInicioDeVigencia: "Data de início da vigência",
          DataDeTerminoDeVigencia: "Data de término da vigência",
          Valor: "Valor",
          botaoAdicionarApp: "Adicionar APP",
        },
        tabela: {
          NaturezaDoVoo: "Natureza do vôo",
          PmdDe: "PMD de",
          PmdAte: "PMD até",
          Classe: "Classe",
          Moeda: "Moeda",
          Valor: "Valor",
          DataInicioVigencia: "Data Início Vigência",
          DataTerminoVigencia: "Data Término Vigência",
          Acoes: "Ações",
        },
        modalDuplicarApp:{
          titulo: "Duplicação",
          formulario:{
            DataDeInicioDeVigencia: "Data de início da vigência",
            DataDeTerminoDeVigencia: "Data de término da vigência",
            Valor: "Valor",
            botaoDuplicarApp: "Duplicar APP",
          },
        },
        modalEditarApp:{
          titulo: "Editar APP",
          formulario:{
            NaturezaDoVoo: "Natureza do vôo",
            OpcoesNaturezaDoVoo: {
              Domestico: "Doméstico",
              Internacional: "Internacional",
            },
            Classe: "Classe",
            PmdDe: "Pmd de",
            PmdAte: "Pmd até",
            DataDeInicioDeVigencia: "Data de início da vigência",
            DataDeTerminoDeVigencia: "Data de término da vigência",
            Valor: "Valor",
            botaoEditarApp: "Editar APP",
          },
        },
      },
      tabelaPan: {
        titulo: "Tabela de PAN (Tarifa de Uso das Comunicações e dos Auxílios à Navegação Aérea em Rota)",
        formulario: {
          NaturezaDoVoo: "Natureza do vôo",
          OpcoesNaturezaDoVoo: {
            Domestico: "Doméstico",
            Internacional: "Internacional",
          },
          PmdDe: "Pmd de",
          PmdAte: "Pmd até",
          DataDeInicioDeVigencia: "Data de início da vigência",
          DataDeTerminoDeVigencia: "Data de término da vigência",
          Valor: "Valor",
          botaoAdicionarPan: "Adicionar PAN",
        },
        tabela: {
          NaturezaDoVoo: "Natureza do vôo",
          PmdDe: "PMD de",
          PmdAte: "PMD até",
          Moeda: "Moeda",
          Valor: "Valor",
          DataInicioVigencia: "Data Início Vigência",
          DataTerminoVigencia: "Data Término Vigência",
          Acoes: "Ações",
        },
        modalDuplicarPan:{
          titulo: "Duplicação",
          formulario:{
            DataDeInicioDeVigencia: "Data de início da vigência",
            DataDeTerminoDeVigencia: "Data de término da vigência",
            Valor: "Valor",
            botaoDuplicarPan: "Duplicar PAN",
          },
        },
        modalEditarPan:{
          titulo: "Editar PAN",
          formulario:{
            NaturezaDoVoo: "Natureza do vôo",
            OpcoesNaturezaDoVoo: {
              Domestico: "Doméstico",
              Internacional: "Internacional",
            },
            PmdDe: "Pmd de",
            PmdAte: "Pmd até",
            DataDeInicioDeVigencia: "Data de início da vigência",
            DataDeTerminoDeVigencia: "Data de término da vigência",
            Valor: "Valor",
            botaoEditarPan: "Editar PAN",
          },
        },
      },
      unidades: {
        deletar: "Tem certeza que gostaria de deletar essa unidade?",
        titulo: "Unidades",
        formulario:{
          Nome: "Nome",
          Email: "E-mail",
          botaoAdicionarUnidade: "Adicionar unidade",
        },
        tabela: {
          Unidade: "Unidade",
          Email: "E-mail",
          Acoes: "Ações",
        },
      },
      localidadeDaUnidade: {
        deletar: "Tem certeza que gostaria de deletar essa localidade?",
        titulo: "Localidades das Unidades",
        formulario:{
          Localidade: "Localidade",
          Unidade: "Unidade",
          botaoAdicionarLocalidadeDaUnidade: "Adicionar localidade da unidade",

          placeHolder: {
            SelecionarLocalidade: "Selecionar localidade",
            SelecionarUnidade: "Selecionar unidade",  
          },
        },
        tabela: {
          Localidade: "Localidade",
          Unidade: "Unidade",
          Acoes: "Ações",
        },
      },
    },    
  },

  Indisponibilidades: {
    ListaDeIndisponibilidades: {
      deletar: "Tem certeza que gostaria de deletar essa indisponibilidade?",
      titulo: "Lista de indisponibilidades",
      botaoAdicionarIndisponibilidade: "Adicionar indisponibilidade",
      semIndisponibilidades: "Não há indisponibilidades cadastradas",

      tabela: {
        ID: "ID",
        Matricula: "Matrícula",
        Frota: "Frota",
        Contrato: "Contrato",
        Desde: "Desde",
        Ate: "Até",
        Total: "Total",
        Acoes: "Ações",
      },
    },

    AeronavesIndisponiveis: {
      deletar: "Tem certeza que gostaria de deletar essa indisponibilidade?",
      titulo: "Aeronaves indisponiveis",
      botaoAdicionarIndisponibilidade: "Adicionar indisponibilidade",
      semIndisponibilidades: "Não há indisponibilidades cadastradas",

      tabela: {
        ID: "ID",
        Matricula: "Matrícula",
        Frota: "Frota",
        Contrato: "Contrato",
        Desde: "Desde",
        Ate: "Até",
        Total: "Total",
        Acoes: "Ações",
      },
    },

    AdicionarIndisponibilidade: {
      titulo: "Cadastrar indisponbilidade",
      erros:
        "Os seguintes erros de preenchimento impediram a ficha de indisponibilidade de ser processada",
      formulario: {
        Contrato: "Contrato",
        InicioInterrupcao: "Interrupção - início",
        Base: "Base",
        Tipo: "Tipo",
        HoraInicialContratual: "Hora inicial contratual",
        HoraTerminoContratual: "Hora Término Contratual",
        TempoDisponibilidadeContratual: "Tempo de Disponibilidade Contratual",
        Franquia: "Franquia",
        OcorrenciaAnormal: "Ocorrência anormal",
        opcoesOcorrenciaAnormal: {
          Sim: "Sim",
          Nao: "Não",
        },
        Razao: "Razão",
        PrevisaoRetorno: "Previsão de Retorno",
        FimInterrupcao: "Interrupção - fim",
        DiferencaPrevisaoRetorno: "Diferença - Previsão x Retorno",
        botaoAdicionarIndisponibilidade: "Adicionar indisponibilidade",

        placeholder: {
          SelecionarContrato: "Selecionar contrato",
          SelecionarBase: "Selecionar base",
          SelecionarTipo: "Selecionar tipo",
        },
      },
    },

    EditarIndisponibilidade: {
      finalizarFicha: "Tem certeza que deseja finalizar esta ficha?",
      reprovarFicha: "Tem certeza que deseja reprovar esta ficha?",
      deletarBackup: "Tem certeza que deseja deletar este backup?",

      titulo: "Editar indisponibilidade",
      erros:
        "Os seguintes erros de preenchimento impediram a ficha de indisponibilidade de ser processada",

      formulario: {
        Contrato: "Contrato",
        InicioInterrupcao: "Interrupção - início",
        Base: "Base",
        Tipo: "Tipo",
        HoraInicialContratual: "Hora inicial contratual",
        HoraTerminoContratual: "Hora Término Contratual",
        TempoDisponibilidadeContratual: "Tempo de Disponibilidade Contratual",
        Franquia: "Franquia",
        OcorrenciaAnormal: "Ocorrência anormal",
        opcoesOcorrenciaAnormal: {
          Sim: "Sim",
          Nao: "Não",
        },
        Razao: "Razão",
        PrevisaoRetorno: "Previsão de Retorno",
        FimInterrupcao: "Interrupção - fim",
        DiferencaPrevisaoRetorno: "Diferença - Previsão x Retorno",

        botaoAdicionarIndisponibilidade: "Adicionar indisponibilidade",

        placeholder: {
          SelecionarBase: "Selecionar base",
          SelecionarTipo: "Selecionar tipo",
        },
      },

      backup: {
        titulo: "Adicionar Backup",
        formulario: {
          AeronaveBackup: "Aeronave backup",
          DataInicial: "Data Inicial",
          DataFinal: "Data Final",
          botaoSalvarBackup: "Salvar backup",

          placeholder: {
            SelecionarAeronaveDeBackup: "Selecionar aeronave de backup",
          },
        },
      },

      tabelaBackup: {
        titulo: "Backups",
        aeronave: "Aeronave",
        dataInicial: "Data inicial",
        dataFinal: "Data final",
        acoes: "Ações",
      },

      tabelaTotais: {
        titulo: "Totais",
        inicioDisponibilidade: "Início disp.",
        fimDisponibilidade: "Fim disp.",
        disponibilidade: "Disponibilidade",
        franquia: "Franquia",
        indisponibilidadeContratual: "Indisponibilidade contratual",
        indisponibilidadeContratualSemFranquia:
          "Indisponibilidade Contratual - Sem Franquia",
        indisponibilidadeReal: "Indisponibilidade real",
      },

      tabelaAprovacoes: {
        titulo: "Aprovações",
        ID: "ID",
        tipo: "Tipo",
        interrompido: "Interrompido",
        finalizado: "Finalizado",
        aprovado: "Aprovado",
        interrompidoPor: "Interrompido por",
        finalizadoPor: "Finalizado por",
        aprovadoPor: "Aprovado por",
        justificativa: "Justificativa",
        acoes: "Ações",
      },

      modalJustificativa: {
        titulo: "Justifique a reprovação",
        formulario: {
          Justificar: "Justificar",
        },
      },
    },

    ListaDeIndisponibilidadesFinalizadas: {
      deletar: "Tem certeza que gostaria de deletar essa indisponibilidade?",
      titulo: "Lista de indisponibilidades finalizadas",
      botaoAdicionarIndisponibilidade: "Adicionar indisponibilidade",
      semIndisponibilidades: "Não há indisponibilidades cadastradas",

      tabela: {
        ID: "ID",
        Matricula: "Matrícula",
        Frota: "Frota",
        Contrato: "Contrato",
        Desde: "Desde",
        Ate: "Até",
        Total: "Total",
        Acoes: "Ações",
      },
    },
  },

  Bases: {
    ListaDeBases: {
      ativar: "Tem certeza que gostaria de ativar essa base?",
      arquivar: "Tem certeza que gostaria de arquivar essa base?",
      ativo: "Ativo",
      arquivado: "Arquivado",
      deletar: "Tem certeza que gostaria de deletar essa base?",

      titulo: "Lista de bases",
      botaoAdicionarBase: "Adicionar base",
      tabela: {
        semBases: "Não há bases cadastrados",
        ID: "ID",
        Nome: "Nome",
        CodigoICAO: "Código ICAO",
        CodigoIATA: "Código IATA",
        Cidade: "Cidade",
        UF: "UF",
        Status: "Status",
        Acoes: "Ações",
      },
    },
    AdicionarBase: {
      titulo: "Cadastrar base",
      formulario: {
        Nome: "Nome",
        CodigoICAO: "Cód. ICAO",
        CodigoIATA: "Cód. IATA",
        Cidade: "Cidade",
        Estado: "Estado",
        CEP: "CEP",
        Telefone: "Telefone",
        Ordem: "Ordem",
        Email: "E-mail",
        DiariasAdicionais: "Diárias Adicionais",
        DiariaObrigatoria: "Diária obrigatória",
        VerbaIndenizadoraDeTransporte: "Verba indenizatória de Transporte",
        VerbaIndenizadoraDeDeslocamento: "Verba indenizatória de Deslocamento",
        Observacoes: "Observações",
        botaoAdicionarBase: "Adicionar base",

        placeholder: {
          NomeDaBase: "Nome da base",
          CodigoICAO: "Código ICAO",
          CodigoIATA: "Código IATA",
          CidadeDaBase: "Cidade da base",
          EstadoDaBase: "Estado da base",
          CEPdaBase: "CEP da base",
          TelefoneDaBase: "Telefone da base",
          OrdemDaBase: "Ordem da base",
          Email: "E-mail",
        },
      },
    },

    EditarBase: {
      titulo: "Edição de base",

      tabDadosDaBase: {
        tituloTab: "Dados da Base",

        tiposDeCargo: {
          Tripulacao: "Tripulação",
          CVODVO: "CVO/DVO",
          MestreCarga: "Mestre de carga",
          Mecanico: "Mecânico",
          Administrativo: "Administrativo",
          Indireto: "Indireto",
        },

        deletarData: "Tem certeza que deseja deletar esta data?",
        deletarCentroDeCusto:
          "Tem certeza que deseja deletar este centro de custo?",
        deletarEmpresa:
          "Tem certeza que deseja deletar esta empresa?",

        formulario: {
          Nome: "Nome",
          CodigoICAO: "Cód. ICAO",
          CodigoIATA: "Cód. IATA",
          Cidade: "Cidade",
          Estado: "Estado",
          CEP: "CEP",
          Telefone: "Telefone",
          Responsavel: "Responsável",
          Ordem: "Ordem",
          Email: "E-mail",
          BasesDoSigmec: "Bases do Sigmec",
          DiariasAdicionais: "Diárias adicionais",
          Ativa: "Ativa",
          DiariaObrigatoria: "Diária obrigatória",
          VerbaIndenizatoriaDeTransporte: "Verba indenizatória de Transporte",
          VerbaIndenizatoriaDeDeslocamento:
            "Verba indenizatória de Deslocamento",
          Observacoes: "Observações",
          botaoSalvarEdicao: "Salvar edição",

          placeholder: {
            NomeDaBase: "Nome da base",
            CodigoICAO: "Código ICAO",
            CodigoIATA: "Código IATA",
            CidadeDaBase: "Cidade da base",
            EstadoDaBase: "Estado da base",
            CEPdaBase: "CEP da base",
            TelefoneDaBase: "Telefone da base",
            SelecionarResponsavel: "Selecionar responsável",
            OrdemDaBase: "Ordem da base",
            Email: "E-mail",
            SelecionarPorte: "Selecionar porte",
          },
        },

        basesRubi: {
          titulo: "Bases - Rubi",
          formulario: {
            CodigoRubi: "Código Rubi",
            placeholder: {
              CodigoRubi: "Código Rubi",
            },
          },
          tabela: {
            Codigo: "Código",
            Acoes: "Ações",
          },
        },

        datasDeTroca: {
          titulo: "Datas de Troca",
          datasQueNaoPagamDeslocamento: "Estas datas não pagam deslocamento",
          formulario: {
            Data: "Data",
          },

          tabela: {
            Data: "Data",
          },
        },

        centrosDeCusto: {
          titulo: "Centros de custo",
          adicionarCentroDeCusto: "Adicionar centro de custo",
          formulario: {
            TipoDeCargo: "Tipo de cargo",
            CentrosDeCusto: "Centros de Custo",
            botaoAdicionarCentroDeCusto: "Adicionar Centro de Custo",

            placeholder: {
              SelecionarTipoDeCargo: "Selecionar tipo de cargo",
              SelecionarCentroDeCusto: "Selecionar centro de custo",
            },
          },
          tabela: {
            TipoDeCargo: "Tipo de Cargo",
            CentroDeCusto: "Centro de Custo",
          },
        },
        empresas: {
          titulo: "Empresas",
          adicionarEmpresa: "Adicionar empresa",
          formulario: {
            Empresas: "Empresas",
            botaoAdicionarEmpresa: "Adicionar empresa",

            placeholder: {
              SelecionarEmpresa: "Selecionar tipo de cargo",
            },
          },
          tabela: {
            Empresa: "Empresa",
          },
        },
      },
    },
  },

  Certificados: {
    ListaDeCertificados: {
      titulo: "Lista de certificados",
      botaoAdicionarCertificado: "Adicionar certificado",
      tabela: {
        semCertificados: "Não há certificados cadastrados",
        ID: "ID",
        Nome: "Nome",
        Tipo: "Tipo",
        Modelo: "Modelo",
        Validade: "Validade",
        CargaHoraria: "Carga horária",
        Acoes: "Ações",
      },
    },

    AdicionarCerfiticado: {
      opcoesPresenca: {
        Presenca: "Presença",
        EAD: "EAD",
      },

      mensagemSelecioneDestinado: "Selecione o \"Destinado a:\"",
      mensagemSelecioneTipo: "Selecione o \"Tipo:\"",
      mensagemSelecioneNome: "Selecione o \"Nome:\"",
      titulo: "Cadastrar certificado",
      formulario: {
        Nome: "Nome",
        TipoDeVencimento: "Tipo de Vencimento",
        opcoesVencimento: {
          VencimentoPorDia: "Vencimento por Dia (dd/mm/aaaa)",
          VencimentoPorMes: "Vencimento por Mês (mm/aaaa)",
        },

        Modelo: "Modelo",
        Tipo: "Tipo",
        DestinadoA: "Destinado a",
        NotaMinima: "Nota mínima",
        Validade: "Validade",
        CargaHoraria: "Carga horária",
        ContaExperienciaOffShore: "Conta Experiência Off-Shore",
        ContaExperienciaSelva: "Conta Experiência de Selva",
        ExperienciaNoturna: "Experiência Noturna",
        botaoAdicionarCertificado: "Adicionar certificado",

        placeholder: {
          RegistroDeCertificado: "Registro de certificado",
          SelecionarTipoDeVencimento: "Selecionar tipo de vencimento",
          SelecionarModeloDeAeronave: "Selecionar modelo de aeronave",
          SelecionarTipo: "Selecionar tipo",
          NotaMinimaParaValidacaoDoCertificado:
            "Nota mínima para validação do certificado.",
          ValidadeEmMesesDoCertificado:
            "Validade em meses do certificado. Somente números.",
          CargaHorariaDoCertificado: "Carga horária do certificado.",
        },
      },
    },

    ListaDeCertificadosGeral: {
      titulo: "Lista de certificados geral",
      tabela: {
        semCertificados: "Não há certificados cadastrados",
        ID: "ID",
        Matricula: "Mat.",
        NomeDoTripulante: "Nome do tripulante",
        Certificado: "Certificado",
        CargaHoraria: "Carga Horária",
        Inicio: "Início",
        Fim: "Fim",
        Vencimento: "Vencimento",
        Ativo: "Ativo?",
      },
    },

    EditarCertificado: {
      titulo: "Edição de certificado",

      tabDadosDoCertificado: {
        tituloTab: "Dados do certificado",
        mensagemSelecioneDestinado: "Selecione o \"Destinado a:\"",
        mensagemSelecioneTipo: "Selecione o \"Tipo:\"",
        mensagemSelecioneNome: "Selecione o \"Nome:\"",
        deletar: "Tem certeza que gostaria de deletar esse grupo?",
        formulario: {
          Nome: "Nome",
          TipoDeVencimento: "Tipo de Vencimento",
          opcoesVencimento: {
            VencimentoPorDia: "Vencimento por Dia (dd/mm/aaaa)",
            VencimentoPorMes: "Vencimento por Mês (mm/aaaa)",
          },
          Modelo: "Modelo",
          Tipo: "Tipo",
          DestinadoA: "Destinado a",
          NotaMinima: "Nota mínima",
          Validade: "Validade",
          CargaHoraria: "Carga horária",
          ContaExperienciaOffShore: "Conta Experiência Off-Shore",
          ContaExperienciaSelva: "Conta Experiência de Selva",
          ExperienciaNoturna: "Experiência Noturna",
          botaoSalvarEdicao: "Salvar edição",

          placeholder: {
            RegistroDeCertificado: "Registro de certificado",
            SelecionarTipoDeVencimento: "Selecionar tipo de vencimento",
            SelecionarModeloDeAeronave: "Selecionar modelo de aeronave",
            SelecionarTipo: "Selecionar tipo",
            NotaMinimaParaValidacaoDoCertificado:
              "Nota mínima para validação do certificado.",
            ValidadeEmMesesDoCertificado:
              "Validade em meses do certificado. Somente números.",
            CargaHorariaDoCertificado: "Carga horária do certificado.",
          },
        },
        adicionarGrupoDeCertificados: "Adicionar grupos de certificados",
        paragrafoRelacionarQuaisCertificadosSaoNecessarios:
          "Aqui você poderá relacionar quais certificados são necessários para que este possa ser obtido",
        adicionarNovoGrupo: "Adicionar Novo Grupo",
        formularioAdicionarNovoGrupo: {
          Nome: "Nome",
          MesesAnteriores: "Meses Anteriores",
          Tipo: "Tipo",
          Aplicabilidade: "Aplicabilidade",
          Certificados: "Certificados",
          botaoSalvarGrupo: "Salvar grupo",

          placeholder: {
            NomeDoGrupo: "Nome do grupo",
            InformarEmMesesDefasagemDoTreinamentoOcertificadoPodeTer:
              "Informar, em meses, quantos meses de defasagem do treinamento o certificado requerido pode ter",
            SelecionarTipo: "Selecionar tipo",
          },
        },
        gruposDeCertificado: "Grupos de certificados",
        deletarCertificadoDesseGrupo:
          "Tem certeza que gostaria de deletar esse certificado desse grupo?",
        formularioGruposDeCertificado: {
          Nome: "Nome",
          Tipo: "Tipo",
          opcoesTipo: {
            E: "E",
            OU: "OU",
          },
          MesesAnteriores: "Meses anteriores",
          Aplicabilidade: "Aplicabilidade",
          botaoEditarGrupo: "Editar grupo",

          placeholder: {
            NomeDoGrupo: "Nome do grupo",
            SelecioneTipo: "Selecione o tipo",
            InformarEmMesesDefasagemDoTreinamentoOcertificadoPodeTer:
              "Informar, em meses, quantos meses de defasagem do treinamento o certificado requerido pode ter",
          },
        },

        formularioCertificados: {
          Certificados: "Certificados",
          botaoIncluirCertificado: "Incluir certificado",

          placeholder: {
            NomeDoGrupo: "Nome do grupo",
            SelecioneTipo: "Selecione o tipo",
          },
        },

        tabelaCertificado: {
          Certificado: "Certificado",
          Acoes: "Ações",
        },
      },
      tabFornecedoresDesteCertificado: {
        tituloTab: "Fornecedores deste certificado",
        deletarFornecedor:
          "Tem certeza que gostaria de deletar esse fornecedor?",
        tabelaFornecedor: {
          Fornecedor: "Fornecedor",
          Tipo: "Tipo",
          Telefone: "Telefone",
          Cidade: "Cidade",
          Pais: "País",
          Expiracao: "Expiração",
          CustoH: "Custo/H",
          Reembolso: "Reembolso",
          Acoes: "Ações",
        },
        adicionarFornecedor: "Adicionar fornecedor",
        formularioAdicionarFornecedor: {
          Fornecedores: "Fornecedores",
          CodigoANAC: "Código ANAC",
          Expiracao: "Expiração",
          Certificacao: "Certificação",
          PrazoDeCancelamentoComRetornoDoPagamentoEmDias:
            "Prazo para Cancelamento com Retorno do Pagamento (em dias)",
          Endereço: "Endereço",
          Cidade: "Cidade",
          Estado: "Estado",
          Pais: "País",
          ContatoNome: "Contato nome",
          Telefone: "Telefone",
          Email: "E-mail",
          Observacoes: "Observações",
          ValorHora: "Valor hora",
          botaoSalvarFornecedor: "Salvar fornecedor",

          placeholder: {
            SelecionarFornecedor: "Selecionar fornecedor",
            EndereçoDoFornecedor: "Endereço do fornecedor",
            CidadeDoFornecedor: "Cidade do fornecedor",
            EstadoDoFornecedor: "Estado/Provincia do fornecedor",
            SelecionePais: "Selecione país",
            TelefoneDoFornecedor: "Telefone do fornecedor",
            EmailDoFornecedor: "E-mail do fornecedor",
          },
        },

        editarCertificadoFornecedor: "Editar certificado/fornecedor",
        formularioEditarFornecedor: {
          Certificacao: "Certificação",
          CodigoANAC: "Código ANAC",
          Expiracao: "Expiração",
          ValorHora: "Valor hora",
          PrazoDeCancelamentoComRetornoDoPagamentoEmDias:
            "Prazo para Cancelamento com Retorno do Pagamento (em dias)",
          Endereço: "Endereço",
          Cidade: "Cidade",
          Estado: "Estado",
          Pais: "País",
          ContatoNome: "Contato nome",
          Telefone: "Telefone",
          Email: "E-mail",
          Observacoes: "Observações",

          botaoSalvarFornecedor: "Salvar fornecedor",

          placeholder: {
            EndereçoDoFornecedor: "Endereço do fornecedor",
            CidadeDoFornecedor: "Cidade do fornecedor",
            EstadoDoFornecedor: "Estado/Provincia do fornecedor",
            SelecionePais: "Selecione país",
            TelefoneDoFornecedor: "Telefone do fornecedor",
            EmailDoFornecedor: "E-mail do fornecedor",
          },
        },
      },
      tabArquivoMorto: {
        tituloTab: "Arquivo morto",
        deletarArquivo: "Tem certeza que gostaria de deletar esse arquivo?",
        adicionarCertificadoDeArquivoMorto:
          "Adicionar certificado de arquivo morto",
        formularioArquivoMorto: {
          Nome: "Nome",
          botaoAdicionarCertificadoDeArquivoMorto:
            "Adicionar certificado de arquivo morto",
        },
        tabelaArquivoMorto: {
          Nome: "Nome",
          Acoes: "Ações",
        },
      },
    },
  },

  CertificadosAVencer: {
    titulo: "Lista de certificados a vencer",
    tabela: {
      semCertificadosAVencer: "Não há certificados a vencer cadastrados",
      ID: "ID",
      Certificado: "Certificado",
      Fornecedor: "Fornecedor",
      Cidade: "Cidade",
      Pais: "País",
      Expirado: "Expirado?",
      DataDeExpiracao: "Data de expiração",
    },
  },

  Clientes: {
    ListaDeClientes: {
      titulo: "Lista de clientes",
      deletar: "Tem certeza que gostaria de deletar esse cliente?",
      botaoAdicionarCliente: "Adicionar cliente",
      tabela: {
        semFornecedores: "Não há fornecedores cadastrados",
        ID: "ID",
        Nome: "Nome",
        Email: "E-mail",
        Telefone: "Telefone",
        Pais: "País",
        Acoes: "Ações",
      },
    },

    AdicionarCliente: {
      titulo: "Cadastrar cliente",
      formulario: {
        Nome: "Nome",
        Pais: "País",
        Endereco: "Endereço",
        Telefone: "Telefone",
        Cidade: "Cidade",
        Email: "E-mail",
        Estado: "Estado",
        Observacoes: "Observações",
        ExigeAprovacaoDosTripulantes: "Exige aprovação dos tripulantes",
        RequerDuplaAprovacaoFluidosEDB: "Requer dupla aprovação de abastecimento de fluidos no eDB?",
        Operador: "Operador",
        botaoAdicionarCliente: "Adicionar cliente",

        placeholder: {
          NomeDoCliente: "Nome do cliente",
          SelecionarPais: "Selecionar país",
          EnderecoDoCliente: "Endereço do cliente",
          TelefoneDoCliente: "Telefone do cliente",
          CidadeDoCliente: "Cidade do cliente",
          EmailDoCliente: "E-mail do cliente",
          EstadoDoCliente: "Estado/Provincia do cliente",
        },
      },
    },

    EditarCliente: {
      titulo: "Edição de cliente",

      tabDadosDoCliente: {

        tituloTab: "Dados do cliente",

        formulario: {
          Nome: "Nome",
          Pais: "País",
          Endereco: "Endereço",
          Telefone: "Telefone",
          Cidade: "Cidade",
          Email: "E-mail",
          Estado: "Estado",
          Observacoes: "Observações",
          ExigeAprovacaoDosTripulantes: "Exige aprovação dos tripulantes autorizados",
          RequerDuplaAprovacaoFluidosEDB: "Requer dupla aprovação de abastecimento de fluidos no eDB?",
          Operador: "Operador",
          RequerEmailAbastecimento: "Requer e-mail de abastecimentos?",
          botaoSalvarEdicao: "Salvar edição",

          placeholder: {
            NomeDoCliente: "Nome do cliente",
            SelecionarPais: "Selecionar país",
            EnderecoDoCliente: "Endereço do cliente",
            TelefoneDoCliente: "Telefone do cliente",
            CidadeDoCliente: "Cidade do cliente",
            EmailDoCliente: "E-mail do cliente",
            EstadoDoCliente: "Estado/Provincia do cliente",
          },
        },

        adicionarNovoGrupo: "Adicionar novo grupo",
        formularioNovoGrupo: {
          Nome: "Nome",
          botaoSalvarGrupo: "Salvar grupo",

          placeholder: {
            NomeDoGrupo: "Nome do grupo",
          },
        },
      },

      tabGrupoCliente: {
        botaoEscalar: "Escalar",
        botaoDesescalar: "Desescalar",
        botaoCOPIL: "COPIL",
        botaoCDMT: "CDMT",
        botaoCMS: "CMS",

        deletarAeronave: "Tem certeza que gostaria de deletar essa aeronave?",
        deletarTripulante:
          "Tem certeza que gostaria de deletar esse tripulante?",

        tabelaAeronaves: {
          tituloAeronaves: "Aeronaves",
          aeronavesDisponiveis: "Disponíveis",
          semAeronaves: "Não há aeronaves cadastradas",
          IDaeronave: "ID",
          Aeronave: "Aeronave",
          AcoesAeronave: "Ações",

          tituloEscalados: "Escalados",
          semAeronaveEscaladas: "Não há aeronaves cadastradas",
          IDaeronaveEscalada: "ID",
          AeronaveEscalada: "Aeronave",
          AcoesEscalada: "Ações",
        },

        tabelaTripulantes: {
          tituloTripulantes: "Tripulantes",
          tripulanteDisponivel: "Disponível",
          semTripulantes: "Não há tripulantes cadastrados",
          IDtripulante: "ID",
          Tripulante: "Tripulante",
          AcoesTripulante: "Ações",

          tituloEscalados: "Escalados",
          semTripulantesEscalados: "Não há tripulantes cadastrados",
          IDescalado: "ID",
          TripulanteEscalado: "Tripulante",
          CargoEscalado: "Cargo",
          AcoesEscalado: "Ações",
        },
      },
    },
  },

  Empresas: {
    ListaDeEmpresas: {
      ativar: "Tem certeza que gostaria de ativar essa empresa?",
      arquivar: "Tem certeza que gostaria de arquivar essa empresa?",
      ativo: "Ativo",
      arquivado: "Arquivado",
      titulo: "Lista de empresas",
      botaoAdicionarEmpresa: "Adicionar empresa",

      tabela: {
        semEmpresas: "Não há empresas cadastradas",
        ID: "ID",
        RazaoSocial: "Razão Social",
        Trigrama: "Trigrama",
        Acoes: "Ações",
      },
    },
    AdicionarEmpresa: {
      titulo: "Cadastrar empresa",
      formulario: {
        RazaoSocial: "Razão Social",
        Trigrama: "Trigrama",

        botaoAdicionarEmpresa: "Adicionar empresa",

        placeholder: {
          RazaoSocial: "Razão Social",
          Trigrama: "Trigrama",
        },
      },
    },
    EditarEmpresa: {
      titulo: "Editar empresa",
      formulario: {
        RazaoSocial: "Razão Social",
        Trigrama: "Trigrama",
        RequerEmailAbastecimento: "Requer e-mail de abastecimentos?",
        botaoEditarEmpresa: "Editar empresa",
        placeholder: {
          RazaoSocial: "Razão Social",
          Trigrama: "Trigrama",
        },
      },
    },

  },

  Contratos: {
    ListaDeContratos: {
      ativar: "Tem certeza que gostaria de ativar esse contrato?",
      arquivar: "Tem certeza que gostaria de arquivar esse contrato?",
      ativo: "Ativo",
      arquivado: "Arquivado",
      titulo: "Lista de contratos",
      botaoAdicionarContrato: "Adicionar contrato",

      tabela: {
        semContratos: "Não há contratos cadastrados",
        ID: "ID",
        Aeronave: "Aeronave",
        NumDeContrato: "Nº contrato",
        Gerencia: "Gerência",
        Expiracao: "Expiração",
        Status: "Status",
        Acoes: "Ações",
      },
    },

    AdicionarContrato: {
      titulo: "Cadastrar contrato",
      erros:
        "Os seguintes erros de preenchimento impediram o contrato de ser processado",

      formulario: {
        Cliente: "Cliente",
        Aeronave: "Aeronave",
        Tipo: "Tipo",

        opcoesTipo: {
          TripulacaoRegular: "Tripulação Regular",
          TripulacaoNoturna: "Tripulação Noturna",
          TripulacaoMEDVAC: "Tripulação MEDVAC",
          TripulacaoRegularComComissarios:
            "Tripulação Regular - com comissários",
          TripulacaoNoturnaComComissarios:
            "Tripulação Noturna - com comissários",
          TripulacaoMEDVACComComissarios: "Tripulação MEDVAC - com comissários",
        },

        NumDeContrato: "Nº Contrato",
        Gerencia: "Gerência",
        IdadeMinimaEmAnos: "Idade mínima (em anos)",
        IdadeMaximaEmAnos: "Idade máxima (em anos)",
        Inicio: "Início",
        Termino: "Término",
        DiaFixoDeVencimento: "Dia Fixo de Vencimento",
        TipoDePagamento: "Tipo de pagamento",

        opcoesTipoDePagamento: {
          PartidaAoCorte: "Partida ao Corte",
          DecolagemAoPouso: "Decolagem ao Pouso",
        },

        Consumo: "Consumo",
        TempoDeDisponibilidade: "Tempo de Disponibilidade",
        HoraInicialDaDisponibilidade: "Hora Inicial da Disponibilidade",
        BaseContratual: "Base Contratual",
        XML: "XML",
        Noturno: "Noturno",
        CargaExterna: "Carga externa",
        Comissarios: "Comissários",
        Fretamento: "Fretamento",

        botaoAdicionarContrato: "Adicionar contrato",

        placeholder: {
          SelecionarCliente: "Selecionar cliente",
          SelecionarAeronave: "Selecionar aeronave",
          SelecionarTipo: "Selecionar tipo",
          EstadoDoEmpregador: "Estado do Empregador",
          NumeroDeContrato: "Número do contrato",
          Gerencia: "Gerência",
          IdadeMinimaEmAnos: "Idade mínima (em anos)",
          IdadeMaximaEmAnos: "Idade máxima (em anos)",
          DataDeInicio: "Data de início",
          DataDeTermino: "Data de término",
          DiaFixoDeVencimento: "Dia Fixo de Vencimento",
          TipoDePagamento: "Tipo de pagamento",
          Consumo: "Consumo",
          Disponibilidade: "Disponiblidade",
          HoraInicialDaDisponibilidade: "Hora Inicial da Disponibilidade",
        },
      },
    },

    EditarContrato: {
      deletar: "Tem certeza que deseja deletar a requisição?",
      titulo: "Edição de contrato",
      adicionarExcecao: "Adicionar Exceção",

      formulario: {
        Designacao: "Designação",
        HorasDeVoo: "Horas de voo",
        Treinamento: "Treinamento",
        Personalizados: "Personalizados",

        botaoAdicionarRequisito: "Adicionar requisito",

        placeholder: {
          SelecionarDesignacao: "Selecionar designação",
          SelecionarRequisito: "Selecionar requisito",
        },
      },

      tabelaDesignacao: {
        Designacao: "Designação",
        Tipo: "Tipo",
        RequisitoExcepcional: "Requisito Excepcional",
        Acoes: "Ações",
      },

      tabelaPrimeiroEUltimoVoo: {
        titulo: "Primeiro e último voos do contrato",
        ID: "ID",
        NumDoVoo: "N° do Voo",
        Data: "Data",
      },

      deletarBackup: "Tem certeza que deseja deletar este backup?",
      erros:
        "Os seguintes erros de preenchimento impediram o contrato de ser processado",

      formularioCliente: {
        Cliente: "Cliente",
        Aeronave: "Aeronave",
        Tipo: "Tipo",

        opcoesTipo: {
          TripulacaoRegular: "Tripulação Regular",
          TripulacaoNoturna: "Tripulação Noturna",
          TripulacaoMEDVAC: "Tripulação MEDVAC",
          TripulacaoRegularComComissarios:
            "Tripulação Regular - com comissários",
          TripulacaoNoturnaComComissarios:
            "Tripulação Noturna - com comissários",
          TripulacaoMEDVACComComissarios: "Tripulação MEDVAC - com comissários",
        },

        NumDeContrato: "Nº Contrato",
        Gerencia: "Gerência",
        IdadeMinimaEmAnos: "Idade mínima (em anos)",
        IdadeMaximaEmAnos: "Idade máxima (em anos)",
        Inicio: "Início",
        Termino: "Término",
        DiaFixoDeVencimento: "Dia Fixo de Vencimento",
        TipoDePagamento: "Tipo de pagamento",

        opcoesTipoDePagamento: {
          PartidaAoCorte: "Partida ao Corte",
          DecolagemAoPouso: "Decolagem ao Pouso",
        },

        Consumo: "Consumo",
        TempoDeDisponibilidade: "Tempo de Disponibilidade",
        HoraInicialDaDisponibilidade: "Hora Inicial da Disponibilidade",
        BaseContratual: "Base Contratual",
        XML: "XML",
        Noturno: "Noturno",
        CargaExterna: "Carga externa",
        Comissarios: "Comissários",
        Fretamento: "Fretamento",

        botaoSalvarEdicao: "Salvar edição",

        placeholder: {
          SelecionarCliente: "Selecionar cliente",
          SelecionarAeronave: "Selecionar aeronave",
          EstadoDoEmpregador: "Estado do Empregador",
          SelecionarTipo: "Selecionar tipo",
          NumeroDeContrato: "Número do contrato",
          Gerencia: "Gerência",
          IdadeMinimaEmAnos: "Idade mínima (em anos)",
          IdadeMaximaEmAnos: "Idade máxima (em anos)",
          DataDeInicio: "Data de início",
          DataDeTermino: "Data de término",
          DiaFixoDeVencimento: "Dia Fixo de Vencimento",
          TipoDePagamento: "Tipo de pagamento",
          Consumo: "Consumo",
          Disponibilidade: "Disponiblidade",
          HoraInicialDaDisponibilidade: "Hora Inicial da Disponibilidade",
        },
      },

      adicionarBackup: "Adicionar Backup",
      formularioAdicionarBackup: {
        AeronaveBackup: "Aeronave backup",
        Numero: "Número",
        botaoSalvarBackup: "Salvar backup",

        placeholder: {
          SelecionarAeronaveDeBackup: "Selecionar aeronave de backup",
        },
      },

      backups: "Backups",
      tabelaBackup: {
        Numero: "Número",
        Aeronave: "Aeronave",
        Acoes: "Ações",
      },
    },

    ConsultarContrato: {
      titulo: "Consulta de contrato",
      adicionarExcecao: "Adicionar Exceção",
      formulario: {
        SomenteAtivos: "Somente Ativos",
        Aeronave: "Aeronave",
        Cliente: "Cliente",
        TipoDeTripulacao: "Tipo de Tripulação",

        opcoesTipo: {
          TripulacaoRegular: "Tripulação Regular",
          TripulacaoNoturna: "Tripulação Noturna",
          TripulacaoMEDVAC: "Tripulação MEDVAC",
          TripulacaoRegularComComissarios:
            "Tripulação Regular - com comissários",
          TripulacaoNoturnaComComissarios:
            "Tripulação Noturna - com comissários",
          TripulacaoMEDVACComComissarios: "Tripulação MEDVAC - com comissários",
        },

        TipoDePagamento: "Tipo de pagamento",

        opcoesTipoDePagamento: {
          PartidaAoCorte: "Partida ao Corte",
          DecolagemAoPouso: "Decolagem ao Pouso",
        },

        BaseContratual: "Base Contratual",
        XML: "XML",
        Noturno: "Noturno",
        CargaExterna: "Carga externa",
        Comissarios: "Comissários",
        Fretamento: "Fretamento",
        AeronaveBackup: "Aeronave Backup",
        botaoDownloadXLS: "Download XLS",
      },

      tabela: {
        semContrato: "Nenhum contrato encontrato",
        ID: "ID",
        Ativo: "Ativo",
        Cliente: "Cliente",
        Aeronave: "Aeronave",
        Frota: "Frota",
        TipoDeTripulacao: "Tipo de Tripulação",
        NumDeContrato: "N° do Contrato",
        Gerencia: "Gerência",
        IdadeMin: "Idade Mín.",
        IdadeMax: "Idade Máx.",
        Inicio: "Início",
        Termino: "Término",
        DiaFixoDeVencimento: "Dia Fixo de Vencimento",
        TipoDePagamento: "Tipo de Pagamento",
        Consumo: "Consumo",
        TempoDeDisponibilidade: "Tempo de Disponibilidade",
        HoraInicialDaDisponibilidade: "Hora Inicial da Disponibilidade",
        BaseContratual: "Base Contratual",
        XML: "XML",
        Noturno: "Noturno",
        CargaExterna: "Carga Externa",
        Comissarios: "Comissários",
        Fretamento: "Fretamento",
        Backups: "Backups",
        Excecoes: "Exceções",
      },
    },
  },

  Designacoes: {
    ListaDeDesignacoes: {
      titulo: "Lista de designações",
      botaoAdicionarDesignicao: "Adicionar designação",

      tabela: {
        semDesignacoes: "Não há designações cadastrados",
        ID: "ID",
        Nome: "Nome",
        Iniciais: "Iniciais",
        Acoes: "Ações",
      },
    },

    AdicionarDesignacao: {
      opcoesTipos: {
        Comum: "Comum",
        Instrutor: "Instrutor",
        Examinador: "Examinador",
      },

      opcoesCargos: {
        Comandante: "Comandante",
        Copiloto: "Copiloto",
        Comissario: "Comissário",
      },

      titulo: "Cadastrar designação",

      formulario: {
        Nome: "Nome",
        Iniciais: "Iniciais",
        Tipo: "Tipo",
        Funcao: "Função",
        Prioridade: "Prioridade",
        ChefeDeEquipamento: "Chefe de Equipamento",
        botaoAdicionarDesignicao: "Adicionar designação",

        placeholder: {
          SelecionarTipo: "Selecionar tipo",
          SelecionarFuncao: "Selecionar função",
        },
      },
    },

    EditarDesignacao: {
      titulo: "Edição de designação",

      tabDadosDaDesignacao: {
        listaDeTipos: {
          Comum: "Comum",
          Instrutor: "Instrutor",
          Examinador: "Examinador",
        },

        listaDeCargos: {
          Comandante: "Comandante",
          Copiloto: "Copiloto",
          Comissario: "Comissário",
        },

        tituloTab: "Dados da designação",

        formulario: {
          Nome: "Nome",
          Iniciais: "Iniciais",
          Tipo: "Tipo",
          Funcao: "Função",
          Prioridade: "Prioridade",
          ChefeDeEquipamento: "Chefe de Equipamento",
          botaoSalvarEdicao: "Salvar edição",

          placeholder: {
            SelecionarTipo: "Selecionar tipo",
            SelecionarFuncao: "Selecionar função"
          }
        }

      },

      tabRequisitosHorasDeVoo: {

        tituloTab: "Requisitos - Horas de Voo",
        deletarRequisicaoDeHoras: "Tem certeza que deseja deletar esta requisição de horas?",
        
        formulario:{
          Frota: "Frota",
          TotalDeHorasDeVooEmModelosDeComplexidadeSimilar: "Total de horas de voo em modelos de complexidade similar",
          TotalGeralDeHorasDeVoo: "Total geral de horas de voo",
          TotalDeHorasDeVooNoModeloExato: "Total de horas de voo no modelo exato",
          TotalDeHorasEmComando: "Total de horas de voo em comando",
          TotalDeHorasEmComandoNoModeloExato: "Total de horas de voo em comando no modelo exato",
          TotalDeHorasDeVooComOTipoDeMotor: "Total de horas de voo com o tipo de motor",
          TotalDeHorasDeVooEmComandoNoTipoDeMotor: "Total de horas de voo em comando no tipo de motor",
          TotalDeHorasDeVooEmIFR: "Total de horas de voo em IFR",
          TotalDeHorasDeVooEmModeloDeMesmoPorte: "Total de horas de voo em modelo de mesmo porte",
          Nome: "Nome",
          Excecao: "Exceção",
          botaoAdicionarRequisito: "Adicionar requisito",

          placeholder:{
            SelecionarFrota: "Selecionar frota",
            TotalDeHorasDeVooEmModelosDeComplexidadeSimilar: "Total de horas de voo em modelos de complexidade similar",
            TotalGeralDeHorasDeVoo: "Total geral de horas de voo",
            TotalDeHorasDeVooNoModeloExato: "Total de horas de voo no modelo exato",
            TotalDeHorasEmComando: "Total de horas de voo em comando",
            TotalDeHorasEmComandoNoModeloExato: "Total de horas de voo em comando no modelo exato",
            TotalDeHorasDeVooComOTipoDeMotor: "Total de horas de voo com o tipo de motor",
            TotalDeHorasDeVooEmComandoNoTipoDeMotor: "Total de horas de voo em comando no tipo de motor",
            TotalDeHorasDeVooEmIFR: "Total de horas de voo em IFR",
            TotalDeHorasDeVooEmModeloDeMesmoPorte: "Total de horas de voo em modelo de mesmo porte",
            NomeDoRegistro: "Nome do requisito",
          }
        },

        tabela: {
          Frota: "Frota",
          Nome: "Nome",
          Total: "Total",
          UmP: "1P",
          Motor: "Motor",
          Similar: "Similar",
          IFR: "IFR",
          UmPFrota: "1P Frota",
          Porte: "Porte",
          Excecao: "Exceção",
          Acoes: "Ações",
          SIM: "SIM",
          NAO: "NÃO",
        },

        deletarGrupo: "Tem certeza que gostaria de deletar esse grupo?",
        tituloEditarCertificadoFornecedor: "Editar certificado/fornecedor",
        tituloEditarRequisitos: "Editar requisitos",
        formularioEditarRequisito:{
          Frota: "Frota",
          TotalDeHorasDeVooEmModelosDeComplexidadeSimilar: "Total de horas de voo em modelos de complexidade similar",
          TotalGeralDeHorasDeVoo: "Total geral de horas de voo",
          TotalDeHorasDeVooNoModeloExato: "Total de horas de voo no modelo exato",
          TotalDeHorasEmComando: "Total de horas de voo em comando",
          TotalDeHorasEmComandoNoModeloExato: "Total de horas de voo em comando no modelo exato",
          TotalDeHorasDeVooComOTipoDeMotor: "Total de horas de voo com o tipo de motor",
          TotalDeHorasDeVooEmComandoNoTipoDeMotor: "Total de horas de voo em comando no tipo de motor",
          TotalDeHorasDeVooEmIFR: "Total de horas de voo em IFR",
          TotalDeHorasDeVooEmModeloDeMesmoPorte: "Total de horas de voo em modelo de mesmo porte",
          Nome: "Nome",
          Excecao: "Exceção",
          botaoEditarRequisito: "Editar requisito",

          placeholder:{
            SelecionarFrota: "Selecionar frota",
            TotalDeHorasDeVooEmModelosDeComplexidadeSimilar: "Total de horas de voo em modelos de complexidade similar",
            TotalGeralDeHorasDeVoo: "Total geral de horas de voo",
            TotalDeHorasDeVooNoModeloExato: "Total de horas de voo no modelo exato",
            TotalDeHorasEmComando: "Total de horas de voo em comando",
            TotalDeHorasEmComandoNoModeloExato: "Total de horas de voo em comando no modelo exato",
            TotalDeHorasDeVooComOTipoDeMotor: "Total de horas de voo com o tipo de motor",
            TotalDeHorasDeVooEmComandoNoTipoDeMotor: "Total de horas de voo em comando no tipo de motor",
            TotalDeHorasDeVooEmIFR: "Total de horas de voo em IFR",
            TotalDeHorasDeVooEmModeloDeMesmoPorte: "Total de horas de voo em modelo de mesmo porte",
            NomeDoRegistro: "Nome do requisito",
          }
        },



      },

      tabRequisitosCertificados: {
        tituloTab: "Requisitos - Certificados",
        deletarGrupo: "Tem certeza que gostaria de deletar esse grupo?",
        tituloAdicionarNovoGrupo: "Adicionar novo grupo",
        formulario:{
          Nome: "Nome",
          Tipo: "Tipo",
          opcoesTipo: {
            E: "E",
            OU: "OU",
          },
          Frota: "Frota",
          Excecao: "Exceção",
          botaoSalvarGrupo: "Salvar grupo",

          placeholder:{
            NomeDoGrupo: "Nome do grupo",
            SelecioneTipo: "Selecione o tipo",
            SelecionarFrota: "Selecionar frota",
          }
        },

        deletarTreinamento: "Tem certeza que gostaria de deletar esse treinamento?",
        formularioEditarGrupo:{
          Nome: "Nome",
          Tipo: "Tipo",
          opcoesTipo: {
            E: "E",
            OU: "OU",
          },
          Frota: "Frota",
          Excecao: "Exceção",
          botaoEditarGrupo: "Editar grupo",

          placeholder:{
            NomeDoGrupo: "Nome do grupo",
            SelecioneTipo: "Selecione o tipo",
            SelecionarFrota: "Selecionar frota",
          }
        },

        formularioIncluirTreinamento:{
          Treinamento: "Treinamento",
          botaoIncluirTreinamento: "Incluir treinamento",

          placeholder:{
            SelecionarTreinamento: "Selecionar treinamento",
          }
        },

        tabela:{
          Treinamento: "Treinamento",
          Acoes: "Ações",
        }

      },

      tabRequisitosPersonalizados: {
        tituloTab: "Requisitos - Personalizados",
        deletarRequisicaoDeHoras: "Tem certeza que deseja deletar esta requisição de horas?",
        formulario:{
          Nome: "Nome",
          Tipo: "Tipo",
          opcoesTipo:{
            LimiteDeHorasDeVoo: "Limite de Horas de Voo",
            LimiteDeHorasDeJornada: "Limite de Horas de Jornada",
          },
          LimiteDeHoras: "Limite de horas",
          DiasCorridos: "Dias corridos",
          botaoAdicionarRequisito: "Adicionar requisito",

          placeholder: {
            NomeDoRequisito: "Nome do requisito",
            SelecionarTipo: "Selecionar tipo",
            LimiteDeHoras: "Limite de horas",
            DiasCorridos: "Dias corridos",
          }
        },

        tabela:{
          Nome: "Nome",
          Tipo: "Tipo",
          LimiteDeHoras: "Limite de horas",
          DiasCorridos: "Dias corridos",
          Excecao: "Exceção",
          Acoes: "Ações",
          SIM: "SIM",
          NAO: "NÃO",
        },

        tituloEditarCertificadoFornecedor: "Editar certificado/fornecedor",
        tituloEditarRequisitos: "Editar requisitos",
        formularioEditarRequisito:{
          Nome: "Nome",
          Tipo: "Tipo",
          botaoEditarRequisito: "Editar requisito",
          opcoesTipo:{
            LimiteDeHorasDeVoo: "Limite de Horas de Voo",
            LimiteDeHorasDeJornada: "Limite de Horas de Jornada",
          },
          LimiteDeHoras: "Limite de horas",
          DiasCorridos: "Dias corridos",
          botaoEditarRequisito: "Editar requisito",

          placeholder: {
            Nome: "Nome",
            SelecionarTipo: "Selecionar tipo",
            LimiteDeHoras: "Limite de horas",
            DiasCorridos: "Total de dias corridos",
          }
        }
      },
    },
  },

  Documentos:{

    ListaDeDocumentos:{
      deletar: "Tem certeza que gostaria de deletar esse documento?",
      titulo: "Lista de documentos",
      botaoAdicionarDocumento: "Lista de documentos",
      
      tabela:{
        semDocumentos: "Não há documentos cadastrados",
        ID: "ID",
        Nome: "Nome",
        Acoes: "Ações",
      }
    },

    AdicionarDocumentos: {
      titulo: "Cadastrar documento",
      forumlario:{
        Nome: "Nome",
        botaoAdicionarDocumento: "Adicionar documento",

        placeholder:{
          NomeDoDocumento: "Nome do documento",
        }
      }
    },

    EditarDocumentos: {
      titulo: "Editar documento",
      
      formulario:{
        Nome: "Nome",
        botaoSalvarEdicao: "Salvar edição",

        placeholder: {
          RegistroDeDocumento: "Registro da documento",
        }
      }
    }

  },
  
  EscalasDeTesteDeSonolencia: {

    ListaDeEscalasDeTesteDeSonolencia:{
      titulo: "Lista de escalas de teste de sonolência",
      botaoAdicionarEscala: "Adicionar escala",

      tabela:{
        semEscalas: "Não há escalas de testes cadastradas",
        ID: "ID",
        Nome: "Nome",
        DataInicial: "Data inicial",
        DataFinal: "Data final",
        Acoes: "Ações",
      }
    },

    AdicionarEscalaDeSonolencia: {
      aguardeEnquantoAEscalaGerada: "Aguarde enquanto a escala é gerada. Este processo pode levar alguns minutos.",
      titulo: "Cadastrar escala de testes de sonolência",

      formulario: {
        Nome: "Nome",
        HorariosDeEnvio: "Horários de envio",
        DataInicial: "Data inicial",
        DataFinal: "Data final",
        AplicabilidadeTipoDeColaborador: "Aplicabilidade - Tipo de Colaborador",
        Tripulantes: "Tripulantes",
        Mecanicos: "Mecânicos",
        Coordenadores: "Coordenadores",
        botaoAdicionarEscalaDeTeste: "Adicionar escala de teste",

        placeholder: {
          NomeDaEscalaDeSonolencia: "Nome da escala de sonolência",
          HorariosDeEnvio: "hh:mm, separados por virgula.",
          SelecionarAplicabilidade: "Selecionar aplicabilidade",
        }
      }

    },

    EditarEscalaDeSonolencia: {
      trocarStatusDaEscala: "Tem certeza que gostaria de trocar o status da escala?",
      trocarStatusDaEscalaParaAprovado: "Tem certeza que gostaria de trocar o status da escala para aprovado?",
      trocarStatusDaEscalaParaFinalizado: "Tem certeza que gostaria de trocar o status da escala para finalizado?",
      titulo: "Edição de escala de sonolência",

      botaoDeFichas: {
        TrocarParaAprovado: "Trocar para aprovado",
        TrocarParaFinalizado: "Trocar para finalizado",
      },

      tabDadosDaEscala: {
        tituloTab: "Dados da escala",
        formulario: {
          Nome: "Nome",
          DataInicial: "Data inicial",
          DataFinal: "Data final",
          botaoSalvarEdicao: "Salvar edição",

          placeholder: {
            NomeDaEscalaDeSonolencia: "Nome da escala de sonolência",
          }
        }
      },

      tabTestesDeEscala: {
        tituloTab: "Testes de escala",
        deletarColaboradorDaEscalaDeTeste: "Tem certeza que gostaria de deletar esse colaborador da escala de testes?",
        tituloTestesDeEscalaDeSonolencia: "Testes de escala de sonolência",
        
        tabela: {
          semColaboradores: "Não há colaboradores cadastrados",
          ID: "ID",
          Colaborador: "Colaborador",
          ProgramacaoDeEnvio: "Programação de Envio",
          Acoes: "Ações",
        },

        tituloEditarTeste: "Editar teste",

        formulario: {
          Data: "Data",
          HorariosDeEnvio: "Horário de envio",
          Colaborador: "Colaborador",
          botaoSalvarEdicao: "Salvar edição",

          placeholder: {
            SelecionarAplicabilidade: "Selecionar aplicabilidade",
          }
        }
      },

      tabRelatorioFinal: {
        tituloTab: "Relatório final",
        
        formulario: {
          PeriodoDeJornada: "Período de Jornada",
          DiasDeJornada: "Dias de jornada",
          Bases: "Bases",
          Designacoes: "Designações",
          Funcoes: "Funções",
          Cargos: "Cargos",
          Frotas: "Frotas",
          Grupos: "Grupos",

          botaoProcurarRelatorios: "Procurar relatórios",

          placeholder:{
            SelecionarPeriodoDeJornada: "Selecionar períodos de jornada",
            DiasDeJornada: "Dias, separados por virgula. Ex.: 01,02,10,11,etc.",
            SelecionarBases: "Selecionar bases",
            SelecionarDesignacoes: "Selecionar designações",
            SelecionarFuncoes: "Selecionar funções",
            SelecionarCargos: "Selecionar cargos",
            SelecionarFrotas: "Selecionar frotas",
            SelecionarGrupos: "Selecionar grupos",
          }
          
        },

        tituloPontosPorHorarioDeResposta: "Pontos por horário de resposta",
        paragrafoPercentualDeAdesaoParcial: "Percentual de adesão parcial (até a data)",
        paragrafoPercentualDeAdesaoGlobal: "Percentual de adesão global",
        paragrafoTempoMedioDeResposta: "Tempo médio de resposta",
        paragrafoTotalRespostas: "Total respostas",
        tituloCadaHorarioDeResposta: "Cada horário de resposta",

        tabelaHorariosDeResposta: {
          PeriodoHoras: "Período horas",
          Total: "Total",
          Pontos: "Pontos",
          Media: "Média",
        },

        tituloPontosPorPeriodoDeJornada: "Pontos por período de jornada",
        tabelaPontosPorPeriodoDeJornada: {
          PeriodoHoras: "Período horas",
          Total: "Total",
          Pontos: "Pontos",
          Media: "Média",
        },

        tituloPontosPorDiasDeJornada: "Pontos por dias de jornada",
        tabelaPontosPorDiasDeJornada: {
          PeriodoDias: "Período dias",
          Total: "Total",
          Pontos: "Pontos",
          Media: "Média",
        },

        tituloBases: "Bases",

        tabelaBases: {
          Base: "Base",
          Total: "Total",
          Pontos: "Pontos",
          Media: "Média",
        },

        tituloFuncoes: "Funções",
      
        tabelaFuncoes: {
          Funcao: "Função",
          Total: "Total",
          Pontos: "Pontos",
          Media: "Média",
        },

        tituloGrupos: "Grupos",

        tabelaGrupos: {
          Grupo: "Grupo",
          Total: "Total",
          Pontos: "Pontos",
          Media: "Média",
        },

        tituloDesignacoes: "Designações",

        tabelaDesignacoes: {
          Designacao: "Designação",
          Total: "Total",
          Pontos: "Pontos",
          Media: "Média",
        },
        
        tituloFrotas: "Frotas",

        tabelaFrotas: {
          Frota: "Frota",
          Total: "Total",
          Pontos: "Pontos",
          Media: "Média",
        },
      },

    }

  },

  FuncoesDeBordo: {

    ListaDeFuncoesDeBordo: {
      deletar: "Tem certeza que gostaria de deletar essa função?",
      titulo: "Lista de funções de bordo",
      botaoAdicionarFuncaoDeBordo: "Adicionar função de bordo",

      tabela: {
        semFuncoesDeBordo: "Não há funções de bordo cadastrados",
        ID: "ID",
        Nome: "Nome",
        Abreviacao: "Abreviação",
        CodigoANAC: "Código ANAC",
        Funcao: "Função",
        Instrutor: "Instrutor",
        PermiteCopilotoLancarHorasDeComando: "Permite Copiloto Lançar Horas de Comando",
        Acoes: "Ações",
      }
    },

    AdicionarFuncaoDeBordo: {
      titulo: "Cadastrar função de bordo",
      formulario: {
        Nome: "Nome",
        Abreviacao: "Abreviação",
        CodigoANAC: "Código ANAC",
        Funcao: "Função",

        opcoesFuncao: {
          CMDT: "CMDT",
          COPIL: "COPIL",
          CMS: "CMS",
        },

        Instrutor: "Instrutor",
        PermiteCopilotoRealizarHorasEmComandoDesdePossuaOsRequisitos: "Permite ao copiloto realizar horas em comando desde que possua os requisitos específicos",
    
        placeholder: {
         SelecioneCodigoANAC: "Selecione o código ANAC",
         SelecioneFuncao: "Selecione a função",
        },
      }
    },

    EditarFuncaoDeBordo: {
      titulo: "Editar função de bordo",

      formulario: {
        Nome: "Nome",
        Abreviacao: "Abreviação",
        CodigoANAC: "Código ANAC",
        Funcao: "Função",

        opcoesFuncao: {
          CMDT: "CMDT",
          COPIL: "COPIL",
          CMS: "CMS",
        },

        Instrutor: "Instrutor",
        PermiteCopilotoRealizarHorasEmComandoDesdePossuaAutorizacao: "Permite ao copiloto realizar horas em comando desde que possua os requisitos específicos",
    
        placeholder: {
         SelecioneCodigoANAC: "Selecione o código ANAC",
         SelecioneFuncao: "Selecione a função",
        },
      }

    }

  },

  ParametrosDeFadigas:{

    ListaDeParametrosDeFadigas: {

      deletar: "Tem certeza que gostaria de deletar esse parâmetro de fadiga?",
      titulo: "Lista de parâmetros de fadigas",
      botaoAdicionarFadiga: "Adicionar fadiga",

      tabela: {
        semParametroDeFadiga: "Não há parâmetros de fadiga cadastrados",
        ID: "ID",
        Aplicabilidade: "Aplicabilidade",
        Nome: "Nome",
        Tipo: "Tipo",
        Operador: "Operador",
        PontosPorHora: "PontosPorHora",
        PontosPorQuantidade: "Pontos por quantidade",
        LimiteDePontos: "Limite de pontos",
        ObrigatorioPreenchimento: "Obrigatório preenchimento",
        Acoes: "Ações",
      }
    },

    AdicionarParametroDeFadiga: {
      titulo: "Cadastrar seções de efetividade",

      formulario: {
        Nome: "Nome",
        AplicabilidadeTipoDeColaborador: "Aplicabilidade - Tipo de Colaborador",

        botaoAdicionarParametroDeFadiga: "Adicionar parâmetro de fadiga",

        placeholder: {
          NomeDaSecaoDeEfetividade: "Nome da seção de efetividade",
          SelecionarAplicabilidade: "Selecionar aplicabilidade",
        }
      }
    },

    EditarParametroDeFadiga: {
      opcoesTipos:{
        Quantidade: "Quantidade",
        Tempo: "Tempo",
      },

      deletar: "Tem certeza que gostaria de deletar essa opção?",
      titulo: "Editar seção de efetividade",

      formulario: {
        Nome: "Nome",
        Aplicabilidade: "Aplicabilidade",

        placeholder: {
          NomeDaSecaoDeEfetividade: "Nome da seção de efetividade",
          SelecionarCliente: "Selecionar cliente",
        },
      },

      tituloAdicionarParametrosDaSecao: "Adicionar parâmetros da seção",
      formularioAdicionarParametrosDaSecao: {
        Nome: "Nome",
        Tipo: "Tipo",
        ParametroObrigatorio: "Parâmetro Obrigatório",
        ParametroAutomatico: "Parâmetro Automático",
        TipoDeAutomacao: "Tipo de automação",

        placeholder: {
          NomeDaSecaoDeEfetividade: "Nome da seção de efetividade",
          SelecionarTipoDoCampo: "Selecionar tipo do campo",
          SelecionarTipo: "Selecionar tipo",
        }
      },

      tituloParametrosDaSecao: "Parâmetros da seção",
      tabela:{
        Nome: "Nome",
        Automatico: "Automático",
        Acoes: "Ações",
      }

    }

  },

  Emails: {

    ConfiguracaoDeEmailsDestinatario: {

      titulo: "Configuração de e-mails destinatário",

      tabela: {
        semAeronaves: "Não há aeronaves cadastrados",
        ID: "ID",
        TipoDeEnvio: "Tipo de envio",
        Acoes: "Ações",
      },

    },

    EditarEmail: {
      deletar: "Tem certeza que gostaria de deletar esse endereço de email?",
      titulo: "E-mail destinatários",
      tituloCadastrarEmail: "Cadastrar e-mail",

      formulario: {
        Email: "E-mail",
        botaoSalvarEdicao: "Salvar edição",
      },

      tituloEmailsCadastrados: "E-mails cadastrados",

      tabela: {
        semEmails: "Não há emails cadastrados",
        ID: "ID",
        TipoDeEnvio: "Tipo de envio",
        Acoes: "Ações"
      }
    }

  },

  Fadigas: {

    ListaDeFadigas: {
      deletar: "Tem certeza que gostaria de deletar esse parâmetro de fadiga?",
      titulo: "Lista de parâmetros de fadigas",
      botaoAdicionarFadiga: "Adicionar Fadiga",
      
      tabela: {
        semParametroDeFadiga: "Não há parâmetros de fadiga cadastrados",
        ID: "ID",
        Aplicabilidade: "Aplicabilidade",
        Nome: "Nome",
        Tipo: "Tipo",
        Operador: "Operador",
        PontosPorHora: "PontosPorHora",
        PontosPorQuantidade: "Pontos por quantidade",
        LimiteDePontos: "Limite de pontos",
        ObrigatorioPreenchimento: "Obrigatório preenchimento",
        Acoes: "Ações",
      }
    },

    AdicionarFadiga: {
      titulo: "Cadastrar parâmetro de fadiga",
      formulario: {
        Nome: "Nome",
        Tipo: "Tipo",
        Operador: "Operador",
        PontosPorHora: "Pontos por hora",
        PontosPorQuantidade: "Pontos por quantidade",
        LimiteDePontos: "Limite de pontos",
        PontuacaoExtraPorHoraNoturna: "Pontuação Extra por Hora Noturna",
        AplicabilidadeTipoDeColaborador: "Aplicabilidade - Tipo de Colaborador",
        PontosAReduzirParaTreinamento: "Pontos a reduzir para treinamento",
        ParametroObrigatorio: "Parâmetro Obrigatório"  ,
        ParametroAutomatico: "Parâmetro Automático",
        TipoDeAutomacao: "Tipo de automação",

        tituloAlertas: "Alertas",

        LimiteMaximoDePontos: "Limite máximo de pontos",
        LimiteMinimoDePontos: "Limite mínimo de pontos",
        LimiteDePontosDeHoraExtraPorSemana: "Limite de pontos de hora extra por semana",
        LimiteDePontosDeHoraExtraPorMes: "Limite de pontos de hora extra por mês",
        LimiteDeDiasComHoraExtraPorSemana: "Limite de dias com hora extra por semana",
        LimiteDeDiasComHoraExtraPorMes: "Limite de dias com hora extra por mês",

        botaoAdicionarParametroDeFadiga: "Adicionar parâmetro de fadiga",

        placeholder: {
          NomeDoParametroDeFadiga: "Nome do parâmetro de fadiga",
          SelecionarTipo: "Selecionar tipo",
          SelecionarOperador: "Selecionar operador",
          QuantidadeDePontosPorHora: "Quantidade de pontos por hora",
          QuantidadeDePontosPorQuantidade: "Quantidade de pontos por quantidade",
          LimiteDePontosDoParametro: "Limite de pontos do parâmetro",
          PontuacaoExtraPorHoraNoturna: "Pontuação Extra por Hora Noturna",
          SelecionarAplicabilidade: "Selecionar aplicabilidade",
          PontosAReduzirParaTreinamento: "Pontos a reduzir para treinamento",
          ParametroObrigatorio: "Parâmetro Obrigatório",
          ParametroAutomatico: "Parâmetro Automático",
          SelecionarTipo: "Selecionar tipo",
          LimiteMaximoDePontos: "Limite máximo de pontos",
          LimiteMinimoDePontos: "Limite mínimo de pontos",
        }
      }
    },

    EditarFadiga: {

      deletar: "Tem certeza que gostaria de deletar essa opção?",
      titulo: "Editar parâmetro de fadiga",
      formulario: {
        Nome: "Nome",
        Tipo: "Tipo",
        Operador: "Operador",
        PontosPorHora: "Pontos por hora",
        PontosPorQuantidade: "Pontos por quantidade",
        LimiteDePontos: "Limite de pontos",
        PontuacaoExtraPorHoraNoturna: "Pontuação Extra por Hora Noturna",
        AplicabilidadeTipoDeColaborador: "Aplicabilidade - Tipo de Colaborador",
        PontosAReduzirParaTreinamento: "Pontos a reduzir para treinamento",
        ParametroObrigatorio: "Parâmetro Obrigatório"  ,
        ParametroAutomatico: "Parâmetro Automático",
        TipoDeAutomacao: "Tipo de automação",

        tituloAlertas: "Alertas",

        LimiteMaximoDePontos: "Limite máximo de pontos",
        LimiteMinimoDePontos: "Limite mínimo de pontos",
        LimiteDePontosDeHoraExtraPorSemana: "Limite de pontos de hora extra por semana",
        LimiteDePontosDeHoraExtraPorMes: "Limite de pontos de hora extra por mês",
        LimiteDeDiasComHoraExtraPorSemana: "Limite de dias com hora extra por semana",
        LimiteDeDiasComHoraExtraPorMes: "Limite de dias com hora extra por mês",

        placeholder: {
          NomeDoParametroDeFadiga: "Nome do parâmetro de fadiga",
          SelecionarCliente: "Selecionar cliente",
          QuantidadeDePontosPorHora: "Quantidade de pontos por hora",
          QuantidadeDePontosPorQuantidade: "Quantidade de pontos por quantidade",
          LimiteDePontosDoParametro: "Limite de pontos do parâmetro",
          PontuacaoExtraPorHoraNoturna: "Pontuação Extra por Hora Noturna",
          SelecionarAplicabilidade: "Selecionar aplicabilidade",
          PontosAReduzirParaTreinamento: "Pontos a reduzir para treinamento",
          ParametroObrigatorio: "Parâmetro Obrigatório",
          ParametroAutomatico: "Parâmetro Automático",
          SelecionarTipo: "Selecionar tipo",
          LimiteMaximoDePontos: "Limite máximo de pontos",
          LimiteMinimoDePontos: "Limite mínimo de pontos",
        }
      },

      tituloAdicionarOpcoes: "Adicionar opções",
      formularioAdicionarOpcoes: {
        Nome: "Nome",
        Pontos: "Pontos",

        placeholder: {
          NomeDoParametroDeFadiga: "Nome do parâmetro de fadiga",
          QuantidadeDePontos: "Quantidade de pontos",
        }
      },

      tituloOpcoes: "Opções",
      tabela: {
        Opcao: "Opção",
        Pontos: "Pontos",
        Acoes: "Ações"
      }

    }

  },

  RelatoriosAuxiliaresFadiga: {

    ProcurarRelatorioAuxiliar: {
      titulo: "Estatísticas (FAPA)",

      formulario: {
        DataInicial: "Data inicial",
        DataFinal: "Data final",
      },

      tituloResultadosDeAutoavaliacoes: "Resultados de Autoavaliações",

      tabela: {
        semParametroDeFadiga: "Não há parâmetros de fadiga cadastrados",
        ID: "ID",
        Data: "Data",
        Colaborador: "Colaborador",
        Questao1: "Questão 1",
        Questao2: "Questão 2",
        Questao3: "Questão 3",
        Questao4: "Questão 4",
        PontuacaoFinal: "Pontuação final",
      }

    },

    AdicionarRelatorioAuxiliar: {
      titulo: "Ferramenta de Auxílio para Autoavaliação da Fadiga (FAPA)",

      formulario: {
        tituloQuestao1QuaoAlertaVoceEsta: "Questão 1: Quão alerta você acha que está? (Considere sua condição antes de assumir a jornada)",
        tituloQuestao2VoceTeveSonoAdequado: "Questão 2: Você teve um sono adequado?",
        QuantoTempoDormiuNas24HorasAnteriores: "No início da jornada, por quanto tempo dormiu nas 24 horas anteriores?",
        QuantoTempoDormiuNas48HorasAnteriores: "No início da jornada, por quanto tempo dormiu nas 48 horas anteriores?",
        AoFimDaJornadaPorQuantasHorasTeraPermanicidoAcordado: "Ao fim da jornada prevista, por quantas horas você terá permanecido acordado, descontado qualquer tempo alocado para repouso em acomodação adequada ou repouso a bordo quando compondo tripulação aumentada?",
        tituloQuestao3QueHorasOcorreAPresenteJornada: "Questão 3: A que horas ocorre a presente jornada?",
        tituloQuestao4QualNivelDeRiscoOperacionalAssociado: "Questão 4: Qual o nível de risco operacional associado à jornada?",

        Rota: "Rota",
        
        Aeroportos: "Aeroportos",
        EspacoAereo: "Espaço Aéreo",
        NivelExperienciaTripulacao: "Nível de Experiência da Tripulação",
        CaracteristicasEOperacionalidadeDaAeronave: "Características e operacionalidade da aeronave",
        CondicoesAtmosfericas: "Condições Atmosféricas",

        botaoGerarAvaliacao: "Gerar Avaliação",


        Opcoes: {
          Baixo: "Baixo",
          Moderado: "Moderado",
          Elevado: "Elevado",
        },

        placeholder:{
          SelecioneUmaOpcao: "Selecione uma opção",
        }
      },

      tituloQuestao1QuaoAlertaVoceEsta: "Questão 1: Quão alerta você acha que está? (Considere sua condição antes de assumir a jornada)",
      tituloQuestao2VoceTeveSonoAdequado: "Questão 2: Você teve um sono adequado?",
      QuantoTempoDormiuNas24HorasAnteriores: "No início da jornada, por quanto tempo dormiu nas 24 horas anteriores?",
      QuantoTempoDormiuNas48HorasAnteriores: "No início da jornada, por quanto tempo dormiu nas 48 horas anteriores?",
      AoFimDaJornadaPorQuantasHorasTeraPermanicidoAcordado: "Ao fim da jornada prevista, por quantas horas você terá permanecido acordado, descontado qualquer tempo alocado para repouso em acomodação adequada ou repouso a bordo quando compondo tripulação aumentada?",
      pontos: "pontos",
      tituloQuestao3QueHorasOcorreAPresenteJornada: "Questão 3: A que horas ocorre a presente jornada?",
      tituloQuestao4QualNivelDeRiscoOperacionalAssociado: "Questão 4: Qual o nível de risco operacional associado à jornada?",

      paragrafoNota: "Nota",
      paragrafoSeORiscoElevadoEstiverPresenteInformarAoDespachoOperacional: "Se o Risco Elevado estiver presente, é recomendável considerar controles de risco tais como o cochilo, rotação de tarefa ou informar ao despacho operacional que você não se encontra apto para o serviço.",
      
      paragrafoPontuacao: "Pontuação",
      paragrafoSeORiscoElevadoEstiverPresenteInformarAoOperador: "Se o Risco Elevado estiver presente, é recomendável considerar controles de risco tais como o cochilo, rotação de tarefa ou informar ao operador que você não se encontra apto para o serviço.",

      rota: "Rota",
      aeroportos: "Aeroportos",
      espacoAereo: "Espaço Aéreo",
      nivelExperienciaTripulacao: "Nível de Experiência da Tripulação",
      caracteristicasEOperacionalidadeDaAeronave: "Características e operacionalidade da aeronave",
      condicoesAtmosfericas: "Condições Atmosféricas",

      tituloResultadoDosRiscos: "Resultado dos riscos",

      paragrafoOrientacaoAoTripulante: "Orientação ao Tripulante",

      paragrafoMecaONivelDeAlertaTripulacaoAumentada: "Meça o nível de alerta usando métodos objetivos e subjetivos e discuta com seu supervisor porque seu nível de alerta pode não ser suficiente para esta jornada e considere a possibilidade de ser escalado para outra jornada de forma a gerenciar o risco (por exemplo, em tripulação aumentada, período de repouso maior).",

      paragrafoMecaONivelDeAlertaChochilo: "Meça o nível de alerta usando métodos objetivos e subjetivos, discuta com seu supervisor se seu nível de alerta é adequado para esta jornada e considere o uso de estratégias de mitigação adicionais (por exemplo, cochilo, rotação de tarefa).",

      paragrafoMecaONivelDeAlertaCafeina: "Meça o nível de alerta usando métodos objetivos e subjetivos, discuta com seu supervisor se seu nível de alerta é adequado para esta jornada e considere controles de risco de fadiga benéficos para esta jornada (por exemplo, uso de cafeína, cuidado maior com a hidratação e alimentação).",


    }

  },

  Formularios: {

    FormulariosMensais: {
      deletar: "Tem certeza que gostaria de deletar esse parâmetro de fadiga?",
      titulo: "Formulários mensais",
      botaoAdicionarFormulario: "Adicionar formulário",

      tabela: {
        ID: "ID",
        MesAno: "Mês/Ano",
        Acoes: "Ações"
      }
    },

    CadastrarFormulario: {
      mensagemFormularioEstaSendoGerado: "O formulário está sendo gerado. Essa ação pode demorar alguns minutos",
      titulo: "Formulário mensal",
      formulario: {
        Data: "Data",
        Aplicabilidade: "Aplicabilidade",

        placeholder: {
          SelecionarAplicabilidade: "Selecionar aplicabilidade",
          Horas: "Horas",
          Quantidade: "Quantidade",
        },

        botaoCadastrarFormulario: "Cadastrar formulário",
      }
    },

    EditarFormulario: {

      titulo: "Formulário mensal",
      formulario: {
        Data: "Data",
        Aplicabilidade: "Aplicabilidade",

        placeholder: {
          SelecionarAplicabilidade: "Selecionar aplicabilidade",
          Horas: "Horas",
          Quantidade: "Quantidade",
        },

        botaoEditarFormulario: "Editar formulário",
      }

    },

    ProcurarFormulario: {
      titulo: "Formulário mensal",
      formulario: {
        Inicio: "Início",
        Termino: "Término",
        Aplicabilidade: "Aplicabilidade",

        placeholder: {
          SelecionarBase: "Selecionar base",
        }
      },

      tituloListaDeFormulariosDeEfetividade: "Lista de formulários de efetividade",
      tabela: {
        Secao: "Seção",
        Subsecao: "Subseção",
        Campo: "Campo",
      }
    }

  },

  ReportesDeFadigas: {

    ListaDeReportesDeFadigasAbertos: {
      tituloMotivo: "Motivo",
      tituloObservacoes: "Observações",
      botaoConfirmarVisualizacao: "Confirmar visualização",

      titulo: "Lista de reportes voluntários de fadigas - Abertos",
      tabela: {
        semParametroDeFadiga: "Não há parâmetros de fadiga cadastrados",
        ID: "ID",
        Tripulante: "Tripulante",
        Data: "Data",
        Acoes: "Ações",
      }
    },

    ListaDeReportesDeFadigasFechados: {
      tituloMotivo: "Motivo",
      tituloObservacoes: "Observações",

      titulo: "Lista de reportes voluntários de fadigas - Fechados",

      tabela: {
        semParametroDeFadiga: "Não há parâmetros de fadiga cadastrados",
        ID: "ID",
        Tripulante: "Tripulante",
        Data: "Data",
        Acoes: "Ações",
      }

    },

    AdicionarReporteDeFadiga: {
      titulo: "Reporte voluntário de fadiga",
      
      formulario: {
        Motivo: "Motivo",
        Data: "Data",
        OProblemaApresentadoPodeSerAlgoPontual: "O problema apresentado pode ser considerado Pontual, ou seja, é algo que permite o retorno às atividades no próximo dia de missão?",
        Observacoes: "Observações",

        botaoEnviarReporte: "Enviar reporte",

        placeholder: {
          SelecionarMotivo: "Selecionar motivo",
          SelecionarOpcao: "Selecionar opção",

        }
      }
    },

    EditarMotivosDeFadiga: {
      deletar: "Tem certeza que gostaria de deletar esse motivo de fadiga?",
      titulo: "Editar motivos de fadiga",

      formulario: {
        Nome: "Nome",

        placeholder: {
          NomeDoMotivoDeFadiga: "Nome do motivo de fadiga",
        }
      },

      tituloMotivosDeFadigaCadastrados: "Motivos de fadiga cadastrados",
      
      tabela: {
        Nome: "Nome",
        Acoes: "Ações",
      }
    },
  },

  TestesDeFadiga: {

    PesquisaDeRelatorios: {
      titulo: "Pesquisa de relatórios",
      
      formulario: {
        AplicabilidadeTipoDeColaborador: "Aplicabilidade - Tipo de Colaborador",
        Tripulantes135: "Tripulantes - 135",
        Tripulantes121: "Tripulantes - 121",
        Mecanicos: "Mecânicos",
        Coordenadores: "Coordenadores",
        DataInicial: "Data inicial",
        DataFinal: "Data final",
        MotivoDoEnvio: "Motivo do envio",
        Respondido: "Respondido",

        botaoProcurarQuestionarios: "Procurar questionários",

        placeholder: {
          SelecionarAplicabilidade: "Selecionar aplicabilidade",
          SelecionarTripulante: "Selecionar tripulante",
          SelecionarMecanico: "Selecionar mecânico",
          SelecionarCoordenador: "Selecionar coordenador",
          SelecionarMotivos: "Selecionar motivos",
          SelecionarStatus: "Selecionar status",
        }
      },

      tituloListaDeQuestionarios: "Lista de questionários",

      tabelaListaDeQuestionarios: {
        semQuestionarios: "Não há questionários cadastrados",
        Data: "Data",
        Colaborador: "Colaborador",
        Status: "Status",
        Motivo: "Motivo",
        Acoes: "Ações",
      },

      tituloDadosDoQuestionarioDeFadiga: "Dados do questionário de fadiga",
      tituloBotaoResultadoDaPesquisa: "Resultado da pesquisa",
      tituloBotaoAltResultadoDeProva: "Resultado de prova",
      botaoExportarCSV: "Exportar CSV",

      tabelaDadosDoQuestionario: {
        Pergunta: "Pergunta",
        Resposta: "Resposta",
      },
    }
  },

  JustificativaDeAtrasoOmni: {

    AdicionarJustificativaDeAtrasoOmni: {
      deletar: "Tem certeza que gostaria de deletar essa justificativa de atraso?",

      formulario: {
        Nome: "Nome",
        Motivo: "Motivo",
        Setor: "Setor",
        Tipo: "Tipo",
        
        opcoesTipo: {
          Decolagem: "Decolagem",
          TempoDeVoo: "Tempo de voo",
        },

        botaoAdicionarJustificativaDeAtrasoOmni: "Adicionar justificativa de atraso interna",

        placeholder: {
          Nome: "Nome",
          Motivo: "Motivo",
          Setor: "Setor",
          SelecioneTipo: "Selecione o tipo",
        }
      },

      tabela: {
        semJustificativasAtrasoOmni: "Sem justificativas de atraso interna cadastradas",
        ID: "ID",
        Nome: "Nome",
        Motivo: "Motivo",
        Setor: "Setor",
        Tipo: "Tipo",
        Acoes: "Ações",
      },

      tituloEditarJustificativaDeAtrasdoOmni: "Editar justificativa de atraso interna",

      formularioEditarJustificativaDeAtrasoOmni: {
        Nome: "Nome",
        Motivo: "Motivo",
        Setor: "Setor",
        Tipo: "Tipo",
        
        opcoesTipo: {
          Decolagem: "Decolagem",
          TempoDeVoo: "Tempo de voo",
        },

        botaoEditarJustificativa: "Editar justificativa de atraso interna",

        placeholder: {
          Nome: "Nome",
          Motivo: "Motivo",
          Setor: "Setor",
          SelecioneTipo: "Selecione o tipo",
        }
      }

    },
  },

  RelatorioAbastecimento: {

    ListaDeAbastecimentos: {
      lista: "Lista de abastecimentos",
      adicionar: "Adicionar abastecimento",
      editar: "Editar abastecimento",
      deletar: "Deletar abastecimento",

      tabela: {
        Data: "Data",
        Relatório: "N° do Relatório",
        Voo: "Nº do Voo",
        Aeronave: "Aeronave",
        Fornecedor: "Fornecedor",
        Localidade: "Localidade",
        Quantidade: "Quantidade",
        Acoes: "Ações",
      },

    },

    EditarAbastecimento: {
      titulo: "Editar abastecimento",
      dados: "Dados",
      formulario: {
        AnexarNotaFiscal: "Anexar nota fiscal",
        Aeronave: "Aeronave",
        Empresa: "Empresa",
        Relatorio: "Relatório",
        CombustivelSolicitado: "Combustível Solicitado (Kg ou Lb)",
        NumeroDaCe: "Número da CE",
        Trecho: "Trecho",
        Fornecedor: "Fornecedor",
        CombustivelAbastecido: "Combustível abastecido (L)",
        Localidade: "Localidade",
        Comandante: "Comandante",
        VendidoPara: "Vendido para",
        Endereco: "Endereço",
        Tipo: "Tipo",
        Reg: "Registro",
        Capt: "Comandante",
        InicioAbastecimento: "Início do abastecimento",
        Click: "Clique",
        TerminoAbastecimento: "Término do abastecimento",
        ProximaLocalidade: "Próxima localidade",
        NumeroHidrante: "N° hidrante",
        SeuNumeroDeVenda: "Seu n° de venda",
        NumeroDeVendaAnterior: "N° de venda anterior",
        LeituraInicial: "Leitura inicial",
        LeituraFinal: "Leitura final",
        Entregues: "Entregues",
        TipoCombustivel: "Tipo de combustível",
        Preco: "Preço.",
        Quantidade: "Quantidade",
        ValorUnitario: "Valor unitário",
        ValorTotal: "Valor total",
        ValorReembolsavel: "Valor reembolsável",
        ValorFinal: "Valor final",
        botaoEditarAbastecimento: "Editar abastecimento",
        placeholder: {
          SelecioneAeronave: "Selecione a aeronave",
          SelecioneRelatorio: "Selecione o relatório",
          SelecioneTrecho: "Selecione o trecho",
          SelecioneFornecedor: "Selecione o fornecedor de combustível",
          SelecioneLocal: "Selecione o local",
        }
      },
      aprovacoes: {
        titulo: "Aprovações",
        tabela: {
          Tipo: "Tipo",
          Aprovacao: "Aprovação",
          Acoes: "Ações",
        },
        modalReprovar: {
          Titulo: "Reprovar",
          Razao: "Razão da reprovação",
          BotaoReprovar: "Reprovar abastecimento",
        },
        modalAprovar: {
          Titulo: "Aprovar",
          BotaoAprovar: "Aprovar abastecimento",
        }
      }
    },

    AdicionarAbastecimento: {
      deletar: "Tem certeza que deseja excluir esse abastecimento?",
      titulo: "Cadastrar abastecimento",
      formulario: {
        AnexarNotaFiscal: "Anexar nota fiscal",
        Aeronave: "Aeronave",
        Empresa: "Empresa",
        Relatorio: "Relatório",
        CombustivelSolicitado: "Combustível Solicitado (Kg ou Lb)",
        NumeroDaCe: "Número da CE",
        Trecho: "Trecho",
        Fornecedor: "Fornecedor",
        CombustivelAbastecido: "Combustível abastecido (L)",
        Localidade: "Localidade",
        Comandante: "Comandante",
        VendidoPara: "Vendido para",
        Endereco: "Endereço",
        Tipo: "Tipo",
        Reg: "Registro",
        Capt: "Comandante",
        InicioAbastecimento: "Início do abastecimento",
        Click: "Clique",
        TerminoAbastecimento: "Término do abastecimento",
        ProximaLocalidade: "Próxima localidade",
        NumeroHidrante: "N° hidrante",
        SeuNumeroDeVenda: "Seu n° de venda",
        NumeroDeVendaAnterior: "N° de venda anterior",
        LeituraInicial: "Leitura inicial",
        LeituraFinal: "Leitura final",
        Entregues: "Entregues",
        TipoCombustivel: "Tipo de combustível",
        Preco: "Preço.",
        Quantidade: "Quantidade",
        ValorTotal: "Valor total",
        botaoAdicionarAbastecimento: "Adicionar abastecimento",
        placeholder: {
          SelecioneAeronave: "Selecione a aeronave",
          SelecioneRelatorio: "Selecione o relatório",
          SelecioneTrecho: "Selecione o trecho",
          SelecioneFornecedor: "Selecione o fornecedor de combustível",
          SelecioneLocal: "Selecione o local",
        }
      },

      tabela: {
        Trecho: "Trecho",
        NumeroDaCe: "Nº da CE",
        Fornecedor: "Fornecedor",
        Localidade: "Localidade",
        QuantidadeSolicitada: "Quantidade solicitada",
        QuantidadeAbastecida: "Quantidade abastecida",
        Acoes: "Ações",
      },

      modalEditarAbastecimento: {
        titulo: "Editar solicitação de combustível",
        formulario: {
          CombustivelSolicitado: "Combustível Solicitado (Kg ou Lb)",
          NumeroDaCe: "Número da CE",
          Trecho: "Trecho",
          Fornecedor: "Fornecedor",
          CombustivelAbastecido: "Combustível abastecido (L)",
          Localidade: "Localidade",
  
          botaoEditarAbastecimento: "Editar abastecimento",
    
        },
      },

    },
  },

  RelatoriosDeVoo: {

    ListaDeRelatoriosDeVoo: {

      titulo: "Relatórios de voo",
      botaoAdicionarRelatorioDeVoo: "Adicionar relatório de voo",

      formulario: {
        botaoMudarData: "Mudar data",
      },

      tabela: {
        ID: "ID",
        semRelatorios: "Não há relatórios cadastrados",
        NumeroDoRelatorio: "Número do relatório",
        Base: "Base",
        Data: "Data",
        Aeronave: "Aeronave",
        Frota: "Frota",
        Cliente: "Cliente",
        TipoDeVoo: "Tipo de voo",
        NumeroDoVoo: "Número do voo",
        Status: "Status",
        Acoes: "Ações",
      }
    },

    AdicionarRelatorioDeVoo: {
      titulo: "Cadastrar novo relatório de voo",
      
      formulario: {
        Data: "Data",
        Prefixo: "Prefixo",
        Voo: "Vôo",
        NumeroDeVoo: "Número de voo",
        NumeroDoRelatorio: "Número do relatório",
        SolicitouIsencao: "Solicitou isenção",
        PowerCheck: "Power Check",
        Base: "Base",
        Contrato: "Contrato",
        MecanicoResponsavel: "Mecânico responsável",
        Cliente: "Cliente",
        Observacoes: "Observações",
        
        botaoCriarRelatorioDeVoo: "Criar relatório de voo",
      }
    },

    EditarRelatoriosDeVoo: {
      trocarStatusDoRelatorioDeVoo: "Tem certeza que gostaria de trocar o status do relatório de voo?",
      confirmarSalvarTodos: "Deseja salvar todos os trechos?",
      titulo: "Editar relatório de voo",
      botaoRelatorio: "Relatório",
      botaoExtratoDB: "Extrato DB",
      botaoXML: "XML",

      botaoRelatorioDeVoo: {
        TrocarParaRascunho: "Trocar para rascunho",
        TrocarParaFinalizado: "Trocar para finalizado",
        TrocarParaCancelado: "Trocar para Cancelado",
      },

      erros: "Os seguintes erros de preenchimento impediram o relatório de ser finalizado",

      erros_salvar: "Os seguintes erros de preenchimento impediram o(s) trecho(s) de serem salvos",

      modalDiscrepanciaHorarios: {
        titulo: "Discrepância de horários preenchidos nos trechos com os recebidos do Flight Following",
        botaoSubstituirTodos: "Substituir todos os horários preenchidos pelos do Flight Following",
        botaoIgnorarTodos: "Ignorar todos os horários do Flight Following e manter os preenchidos",
        substituir: "Tem certeza que gostaria de substituir os horários do trecho pelos do Flight Following?",
        substituirTodos: "Tem certeza que gostaria de substituir os horários de todos os trechos pelos do Flight Following?",
        ignorar: "Tem certeza que gostaria de manter os horários do trecho e ignorar os do Flight Following?",
        ignorarTodos: "Tem certeza que gostaria de manter os horários de todos os trechos e ignorar os do Flight Following?",
        tabela: {
          ID: "ID",
          Trecho: "Trecho",
          FlightFollowing: "Flight Following",
          Preenchido: "Preenchido",
          Partida: "Partida",
          Decolagem: "Decolagem",
          Pouso: "Pouso",
          Corte: "Corte",
          Acoes: "Ações",
          botaoSubstituir: "Substituir",
          botaoIgnorar: "Ignorar",
        },
      },

      formularioEditarRelatorio: {
        Data: "Data",
        Prefixo: "Prefixo",
        Voo: "Vôo",
        NumeroDeVoo: "Número de voo",
        NumeroDoRelatorio: "Número do relatório",
        SolicitouIsencao: "Solicitou isenção",
        PowerCheck: "Power Check",
        Base: "Base",
        Contrato: "Contrato",
        MecanicoResponsavel: "Mecânico responsável",
        Cliente: "Cliente",
        Observacoes: "Observações",
        
        botaoEditarRelatorioDeVoo: "Editar relatório de voo",
      },

      tabelaVoosDia: {
        Titulo: "Outros voos do dia",
        SemVoos: "Não há outros voos no dia",
        Id: "Id",
        NumeroVoo: "Número do Voo",
        NumeroRelatório: "Número do Relatório",
        DecolagemPrevista: "Decolagem Prevista",
        Origem: "Origem",
        Cliente: "Cliente",
        Contrato: "Contrato",
        TipoVoo: "Tipo de Voo",
        Status: "Status",
      },

      excluirTripulante: "Tem certeza que deseja excluir esse tripulante? Ele será excluido de todos os trechos.",
      tituloCadastrarTripulacao: "Cadastrar tripulação",

      formularioCadastrarTripulacao: {
        Tripulante: "Tripulante",
        FuncaoDeBordo: "Função de bordo",
        DataDeApresentacao: "Data de Apresentação",
        HoraDeApresentacao: "Hora de Apresentação",

        botaoAdicionarTripulante: "Adicionar tripulante",
      },

      modalEditarTripulacao: {
        Titulo: "Editar Tripulante",
        FuncaoDeBordo: "Função de bordo",
        DataDeApresentacao: "Data de Apresentação",
        HoraDeApresentacao: "Hora de Apresentação",
        botaoEditarTripulante: "Editar tripulante",
      },

      tituloTripulantesCadastrados: "Tripulantes cadastrados",

      tabelaTripulantesCadastrados: {
        Nome: "Nome",
        CANAC: "CANAC",
        SISPAT: "SISPAT",
        FB: "FB",
        Apresentacao: "Apresentação",
        DecolagemPouso: "Decolagem/Pouso",
        TempoTotal: "Tempo Total",
        Navegacao: "Navegação",
        Instrumento: "Instrumento",
        Noturno: "Noturno",
        PousosDiurnos: "Pousos Diurnos",
        PousosNoturnos: "Pousos Noturnos",
        Pax: "Pax.",
        Carga: "Carga",
        Consumo: "Consumo",
        LongLine: "Long Line",
        ShortLine: "Short Line",
        Acoes: "Ações",
      },

      tituloCadastrarTrecho: "Cadastrar trecho",
      botaoSalvarTodos: "Editar todos os trechos",

      formularioCadastrarTrecho: {
        Origem: "Origem",
        Destino: "Destino",
        Partida: "Partida",
        DEC: "DEC.",
        POU: "POU.",
        Corte: "Corte",
        DECPOU: "DEC-POU",
        Total: "Total",
        Nav: "Nav.",
        IFR: "IFR",
        Noturno: "Noturno",
        Diurnos: "Diurnos",
        Noturnos: "Noturnos",
        Partidas: "Partidas",
        PAX: "PAX",
        Carga: "Carga",
        LongLine: "Long line",
        ShortLine: "ShortLine",
        Inicial: "Inicial",
        Final: "Final",
        CodigoPTBR: "Código PTBR",
        limparTrecho: "As edições do trecho foram apagadas.",
        SelecioneOpcao: "Selecione uma opção",

        botaoAdicionarTrecho: "Adicionar trecho",
      },

      tabelaCadastrarTrecho: {
        Realizados: "Realizados",
        Pousos: "Pousos",
        Dados: "Dados",
        CargaExterna: "Carga externa",
        Combustivel: "Combustível",
        OperacaoPTBR: "Operação PTBR",
        Acoes: "Ações",
        Numero: "N°",
        Origem: "Origem",
        Destino: "Destino",
        Partida: "Partida",
        DEC: "DEC.",
        POU: "POU.",
        Corte: "Corte",
        DECPOU: "DEC-POU",
        Total: "Total",
        Nav: "Nav.",
        IFR: "IFR",
        Noturno: "Noturno",
        Diurnos: "Diurnos",
        Noturnos: "Noturnos",
        Partidas: "Partidas",
        PAX: "PAX",
        Carga: "Carga",
        LongLine: "Long Line",
        ShortLine: "Short Line",
        Inicial: "Inicial",
        Final: "Final",
        CodigoPTBR: "Código PTBR",
      },

      tituloTotaisDosTrechos: "Totais dos trechos",

      tabelaTotaisDosTrechos: {
        DecolagemPouso: "Decolagem/Pouso",
        TempoTotal: "Tempo total",
        Navegacao: "Navegação",
        Instrumento: "Instrumento",
        Noturno: "Noturno",
        PousosDiurnos: "Pousos Diurnos",
        PousosNoturnos: "Pousos Noturnos",
        Pax: "Pax.",
        Carga: "Carga",
        Consumo: "Consumo",
      },

      excluirTrecho: "Tem certeza que deseja excluir esse trecho?",

      removerTripulanteDoTrecho: "Tem certeza que gostaria de remover este tripulante deste trecho?",

      tituloEdicaoTrecho: "Edição de Trecho",

      formularioEditarTrecho: {
        Origem: "Origem",
        Destino: "Destino",
        Partida: "Partida",
        DEC: "DEC.",
        POU: "POU.",
        Corte: "Corte",
        DECPOU: "DEC-POU",
        Total: "Total",
        Nav: "Nav.",
        IFR: "IFR",
        Noturno: "Noturno",
        Diurnos: "Diurnos",
        Noturnos: "Noturnos",
        Partidas: "Partidas",
        PAX: "PAX",
        Carga: "Carga",
        LongLine: "Long Line",
        ShortLine: "Short Line",
        Inicial: "Inicial",
        Final: "Final",
        CodigoPTBR: "Código PTBR",

        botaoEditarTrecho: "Editar trecho",
      },

      tituloTripulacaoCadastrada: "Tripulação cadastrada",

      formularioAdicionarTripulante: {
        Tripulante: "Tripulante",
        FuncaoDeBordo: "Função de bordo",
        
        botaoAdicionarTripulante: "Adicionar tripulante",
      },

      tabelaTripulantes: {
        Nome: "Nome",
        FuncaoDeBordo: "Função de bordo",
        Acoes: "Ações",
      },

      excluirAbastecimento: "Tem certeza que deseja excluir esse abastecimento?",
      mensagemDadosAtualizadosComSucesso: "Dados atualizados com sucesso",

      tituloCadastrarAbastecimento: "Cadastrar abastecimento",
      
      formularioAdicionarAbastecimento: {
        AnexarNotaFiscal: "Anexar nota fiscal",
        CombustivelSolicitado: "Combustível Solicitado (Kg ou Lb)",
        Trecho: "Trecho",
        NumeroDaCE: "Número da CE",
        Cia: "Cia.",
        CombustivelAbastecido: "Combustível abastecido (L)",
        Fornecedor: "Fornecedor",
        Localidade: "Localidade",
        
        botaoAdicionarAbastecimento: "Adicionar abastecimento",

      },

      tituloAbastecimentosCadastrados: "Abastecimentos cadastrados",

      tabelaAbastecimentosCadastrados: {
        Trecho: "Trecho",
        NumeroDaCE: "Nº da CE",
        Cia: "Cia.",
        QuantidadeSolicitada: "Quantidade solicitada",
        QuantidadeAbastecida: "Quantidade abastecida",
        Fornecedor: "Fornecedor",
        Localidade: "Localidade",
        Acoes: "Ações",
      },

      tituloEditarSolicitacaoDeCombustivel: "Editar solicitação de combustível",

      formularioEditarSolicitacaoDeCombustivel: {
        CombustivelSolicitado: "Combustível Solicitado (Kg ou Lb)",
        Trecho: "Trecho",
        NumeroDaCE: "Número da CE",
        Cia: "Cia.",
        CombustivelAbastecido: "Combustível abastecido (L)",
        Fornecedor: "Fornecedor",
        Localidade: "Localidade",
        
        botaoEditarAbastecimento: "Editar abastecimento",
      },

      tituloObservacoes: "Observações",

      formularioEditarObservacoes: {
        Observacoes: "Observações",

        botaoEditarObservacoes: "Editar observações",
      },

      tituloAlertasDoRelatorio: "Alertas do Relatório",

      tabelaAlertasDoRelatorio: {
        Mensagem: "Mensagem",
        Data: "Data",
      },

      aprovarRelatorio: "Tem certeza que deseja aprovar este relatório?",
      reabrirRelatorio: "Tem certeza que deseja reabrir este relatório?",
      reprovarRelatorio: "Tem certeza que deseja reprovar este relatório?",

      relatorioReabertoGerouImplicacoes: "Este relatório foi reaberto! Isso gerou as seguintes implicações",

      tabelaImplicacoes: {
        Mensagem: "Mensagem",
        Data: "Data",
      },

      tituloAprovacoes: "Aprovações",

      botaoReabrirRelatorio: "Reabrir relatório",
      
      tabelaAprovacoes: {
        Tipo: "Tipo",
        Tripulante: "Tripulante",
        Aprovacao: "Aprovação",
        Acoes: "Ações",
      },

      tituloJustificativaReprovacao: "Justificativa de reprovação",

      formularioReprovacao: {
        RazaoDaReprovacao: "Razão da reprovação",
        botaoReprovarRelatorio: "Reprovar relatório",
      },

      tituloLoginDoComandanteNoLDAP: "Login do comandante",

      formularioLogin: {

        botaoAcessarSistema: "Acessar o sistema",

        placeholder: {
          Email: "Seu e-mail",
          Senha: "Sua senha",
        }
      },

      tituloLogDoRelatorio: "Log do relatório",

      tabelaLogRelatorio: {
        Usuario: "Usuário",
        Acao: "Ação",
        Descricao: "Descrição",
        Data: "Data",
      }
      
    },

    RelatoriosPendentesDeAprovacao: {
      aprovar: "Tem certeza que deseja aprovar este relatório?",

      titulo: "Relatórios Pendentes de Aprovação",

      formulario: {
        Base: "Base",
        TipoDeAprovacao: "Tipo de Aprovação",
      },

      botaoAprovar: "APROVAR",
      
      tabela: {
        Data: "Data",
        Base: "Base",
        Aeronave: "Aeronave",
        Frota: "Frota",
        Contrato: "Contrato",
        TipoDeVoo: "Tipo de Voo",
        NumeroDoVoo: "N° do Voo",
        Status: "Status",
        Acoes: "Ações",
      }

    },

    ControleGeralTarifa: {
      titulo: "Controle geral de tarifas",
      formulario: {
        DataInicial: "Data Inicial",
        DataFinal: "Data Final",
        TipoDePesquisa: "Tipo de Pesquisa",
        OpcoesTipoDePesquisa: {
          PorTarifa: "Por tarifa",
          PorRelatorio: "Por relatório",
        },
        Aeronave: "Aeronave",
        Relatorio: "Relatório",
        Localidade: "Localidade",
        Isencao: "Isenção",
        TipoDeFornecedor: "Tipo de fornecedor",
        OpcoesTipoDeFornecedor: {
          ResponsavelPeloEspacoAereo: "Responsável pelo espaço aéreo",
          OperadorDeAeroporto: "Operador de aeroporto",
        },
        Fornecedor: "Fornecedor",
        Tarifa: "Tarifa",
        OpcoesTarifa: {
          TarifaPan: "Tarifa de Uso das Comunicações e dos Auxílios à Navegação Aérea em Rota (PAN)",
          TarifaAdr: "Tarifa de Uso das Comunicações e dos Auxílios-Rádio à Navegação Aérea em Área de Controle de Aeródromo (TAT ADR)",
          TarifaApp: "Tarifa de Uso das Comunicações e dos Auxílios-Rádio à Navegação Aérea em Área de Controle de Aproximação (TAT APP)",
          TarifaTpo: "Tarifa de Pouso (TPO)",
          TarifaPpm: "Tarifa de Permanência no Pátio de Manobras (PPM)",
          TarifaPpe: "Tarifa de Permanência na Área de Estadia (PPE)",
        },
        Status: "Status",
        OpcoesStatus: {
          Provisionado: "Provisionado",
          Faturado: "Faturado",
        },

        placeholder: {
          Selecione: "Selecione",
        },

        botaoPesquisar: "Pesquisar",
      },
      tabela: {
        Data: "Data",
        NumeroRelatorio: "N° relatório",
        Trecho: "Trecho",
        Aeronave: "Aeronave",
        Localidade: "Localidade",
        Isento: "Isento",
        EmailDeIsencao: "E-mail de isenção",
        TipoDeFornecedor: "Tipo de fornecedor",
        Fornecedor: "Fornecedor",
        Tarifa: "Tarifa",
        Moeda: "Moeda",
        Valor: "Valor",
        Status: "Status",
        Acoes: "Ações",
        Partida: "Partida",
        Origem: "Origem",
        Classe: "Classe",
        Grupo: "Grupo",
        PatioManobra: "Tempo de Permanência no Pátio de Manobra",
        AreaEstadia: "Tempo de Permanência na Área de Estadia",
        Pousos: "Pousos",
        TempoDecorrido: "Tempo Decorrido",
        Tpo: "TPO",
        Ppe: "PPE + PPM",
        Pan: "PAN",
        App: "TAT APP",
        Adr: "TAT ADR",
        Total: "Total",

      },

      modalEditarTarifa: {
        titulo: "Editar tarifa",
        formulario: {
          Status: "Status",
          OpcoesStatus: {
            Provisionado: "Provisionado",
            Faturado: "Faturado",
          },
          placeholder: {
            Selecione: "Selecione",
          },  
          botaoEditar: "Editar tarifa"
        },
      },

    },

    QuantidadeDeVoosPorDia: {
      titulo: "Quantidade de voos por dia",

      formulario: {
        DataInicial: "Data Inicial",
        DataFinal: "Data Final",
        Aeronave: "Aeronave",
        Frota: "Frota",
        Base: "Base",
        Tripulantes: "Tripulantes",
        TipoDeVoo: "Tipo de Voo",
        Contrato: "Contrato",
        SomenteAprovados: "Somente aprovados",
        BaseContratual: "Base Contratual",
        TipoDeFiltro: "Tipo de filtro",

        opcoesDeFiltro: {
          ContagemPorAeronave: "Contagem por aeronave",
          ContagemPorBase: "Contagem por base",
        },
      },

      tituloTotaisDaAeronavePorData: "Totais da aeronave por data",

      tabelaTotaisDaAeronavePorData: {
        Data: "Data",
        Base: "Base",
        Prefixo: "Prefixo",
        Frota: "Frota",
        QuantidadeDePousos: "Quantidade de Pousos",
        QuantidadeDeVoos: "Quantidade de Voos",
        QuantidadeDeCortes: "Quantidade de Cortes",
        QuantidadeDePAX: "Quantidade de PAX",
        QuantidadeDeCarga: "Quantidade de Carga",
      },

      tituloTotaisDaAeronavePorPeriodo: "Totais da aeronave por período",

      tabelaTotaisDaAeronavePorPeriodo: {
        DataInicial: "Data Inicial",
        DataFinal: "Data Final",
        Base: "Base",
        Prefixo: "Prefixo",
        Frota: "Frota",
        QuantidadeDePousos: "Quantidade de Pousos",
        QuantidadeDeVoos: "Quantidade de Voos",
        QuantidadeDeCortes: "Quantidade de Cortes",
        QuantidadeDePAX: "Quantidade de PAX",
        QuantidadeDeCarga: "Quantidade de Carga",
      },

      tituloTotaisDoModeloPorData: "Totais do modelo por data",

      tabelaTotaisDoModeloPorData: {
        Data: "Data",
        Base: "Base",
        Frota: "Frota",
        QuantidadeDePousos: "Quantidade de Pousos",
        QuantidadeDeVoos: "Quantidade de Voos",
        QuantidadeDeCortes: "Quantidade de Cortes",
        QuantidadeDePAX: "Quantidade de PAX",
        QuantidadeDeCarga: "Quantidade de Carga",
      },

      tituloTotaisDoModeloPorPeriodo: "Totais do modelo por período",

      tabelaTotaisDoModeloPorPeriodo: {
        DataInicial: "Data Inicial",
        DataFinal: "Data Final",
        Base: "Base",
        Frota: "Frota",
        QuantidadeDePousos: "Quantidade de Pousos",
        QuantidadeDeVoos: "Quantidade de Voos",
        QuantidadeDeCortes: "Quantidade de Cortes",
        QuantidadeDePAX: "Quantidade de PAX",
        QuantidadeDeCarga: "Quantidade de Carga",
      },

      tituloTotalGeralPorData: "Total Geral por data",

      tabelaTotalGeralPorData: {
        Data: "Data",
        Base: "Base",
        QuantidadeDePousos: "Quantidade de Pousos",
        QuantidadeDeVoos: "Quantidade de Voos",
        QuantidadeDeCortes: "Quantidade de Cortes",
        QuantidadeDePAX: "Quantidade de PAX",
        QuantidadeDeCarga: "Quantidade de Carga",
      },

      tituloTotalGeralPorPeriodo: "Total Geral por período",

      tabelaTotalGeralPorPeriodo: {
        DataInicial: "Data Inicial",
        DataFinal: "Data Final",
        Base: "Base",
        QuantidadeDePousos: "Quantidade de Pousos",
        QuantidadeDeVoos: "Quantidade de Voos",
        QuantidadeDeCortes: "Quantidade de Cortes",
        QuantidadeDePAX: "Quantidade de PAX",
        QuantidadeDeCarga: "Quantidade de Carga",
      }

    },

    RelatorioDeOcorrenciasAnormais: {
      titulo: "Relatório de Ocorrências Anormais",

      formulario: {
        DataInicial: "Data Inicial",
        DataFinal: "Data Final",
        SomenteAprovados: "Somente aprovados",
        RelatorioDeVoo: "Relatório de Voo",
        Aeronave: "Aeronave",
        Frota: "Frota",

        placeholder: {
          InformeONumeroDoRelatorioDeVoo: "Informe o número do relatório de voo",
        }
      },

      tabela: {
        Data: "Data",
        Prefixo: "Prefixo",
        Frota: "Frota",
        Base: "Base",
        TipoDeVoo: "Tipo de Voo",
        Contrato: "Contrato",
        Cliente: "Cliente",
        NumeroRelatorio: "N° Relatório",
        NumeroDoVoo: "N° do Voo",
        TipoDeOcorrencia: "Tipo de Ocorrência",
        DescricaoDaOcorrencia: "Descrição da Ocorrência",
        AcaoRequerida: "Ação Requerida",
        Observacoes: "Observações",
        Tripulantes: "Tripulantes",
      }

    },

    ControleDiarioDeUtilizacaoDeAeronavesContratadas: {
      osCamposDataClienteEBaseSaoObrigatoriosParaExportacaoEmPDF: "Os campos Data, Cliente e Base são obrigatórios para exportação em PDF.",

      titulo: "Controle Diário de Utilização de Aeronaves Contratadas",

      formulario: {
        Data: "Data",
        SomenteAprovados: "Somente aprovados",
        Base: "Base",
        Aeronave: "Aeronave",
        Contrato: "Contrato",
        Cliente: "Cliente",
        BaseContratual: "Base Contratual",
      },

      tabela: {
        Prefixo: "Prefixo",
        Frota: "Frota",
        Contrato: "Contrato",
        CodigoSAP: "Código SAP",
        TempoTotalDeVooNaDataDecolagemAoPouso: "Tempo Total de Voo na Data - 1ª Dec. ao  Últ. Pouso",
        TempoTotalDeVooNoDataPartidaAoCorte: "Tempo Total de Voo no Data - Partida ao Corte",
        TempoTotalDeVooOMNINaDataDecolagemAoPouso: "Tempo Total de Voo Interno na Data - 1ª Dec. ao  Últ. Pouso",
        TempoTotalDeVooOMNINoDataPartidaAoCorte: "Tempo Total de Voo Interno no Data - Partida ao Corte",
        IndisponibilidadesMotivos: "Indisponibilidades - Motivos",
        IndisponibilidadesHoras: "Indisponibilidades - Horas",
      }
    },

    BoletimDeDisponibilidade: {
      titulo: "Boletim de disponibilidade",

      formulario: {
        DataInicial: "Data Inicial",
        DataFinal: "Data Final",
        Contrato: "Contrato",
        SomenteAprovados: "Somente aprovados",
        BaseContratual: "Base Contratual",
      },

      tabela: {
        Contrato: "Contrato",
        PrefixoContratual: "Prefixo Contratual",
        Backup: "Backup",
        Data: "Data",
        TipoDeContrato: "Tipo de Contrato",
        VooDecolagemAoPouso: "Voo - 1ª Dec. ao  Últ. Pouso",
        VooPartidaAoCorte: "Voo - Partida ao Corte",
        QtdPousos: "Qtd. Pousos",
        QtdPartidas: "Qtd. Partidas",
        VooTotalDecolagemAoPouso: "Voo Total - 1ª Dec. ao  Últ. Pouso",
        DuracaoMediaDeVooDecolagemAoPouso: "Duração Média de Voo - 1ª Dec. ao  Últ. Pouso",
        VooTotalPartidaAoCorte: "Voo Total - Partida ao Corte",
        DuracaoMediaDeVooPartidaAoCorte: "Duração Média de Voo - Partida ao Corte",
        MaximoDeDisponibilidadeContratual: "Máximo de Disponibilidade Contratual",
        IndisponibilidadeReal: "Indisponibilidade Real",
        IndisponibilidadeContratual: "Indisponibilidade Contratual",
        DisponibilidadeReal: "Disponibilidade Real",
        DisponibilidadeContratual: "Disponibilidade Contratual",
        TipoMPRG: "Tipo MPRG",
        TipoMNPR: "Tipo MNPR",
        TipoOPS: "Tipo OPS",
        OcorrenciaAnormal: "Ocorrência Anormal",
      },

      tituloTotais: "Totais",

      tabelaTotais: {
        Contrato: "Contrato",
        PrefixoContratual: "Prefixo Contratual",
        Backup: "Backup",
        TipoDeContrato: "Tipo de Contrato",
        QtdPousos: "Qtd. Pousos",
        QtdPartidas: "Qtd. Partidas",
        VooTotalDecolagemAoPouso: "Voo Total - 1ª Dec. ao  Últ. Pouso",
        VooTotalPartidaAoCorte: "Voo Total - Partida ao Corte",
        DuracaoMediaDeVooDecolagemAoPouso: "Duração Média de Voo - 1ª Dec. ao  Últ. Pouso",
        DuracaoMediaDeVooPartidaAoCorte: "Duração Média de Voo - Partida ao Corte",
        TempoTotalRegistrado: "Tempo Total Registrado",
        MaximoDeDisponibilidadeContratual: "Máximo de Disponibilidade Contratual",
        IndisponibilidadeReal: "Indisponibilidade Real",
        IndisponibilidadeContratual: "Indisponibilidade Contratual",
        DisponibilidadeReal: "Disponibilidade Real",
        DisponibilidadeContratual: "Disponibilidade Contratual",
        TipoMPRG: "Tipo MPRG",
        TipoMNPR: "Tipo MNPR",
        TipoOPS: "Tipo OPS",
        OcorrenciaAnormal: "Ocorrência Anormal",

        PorcentagemIndisponibilidadeReal: "% Indisponibilidade Real",
        PorcentagemIndisponibilidadeContratual: "% Indisponibilidade Contratual",
        PorcentagemDisponibilidadeReal: "% Disponibilidade Real",
        PorcentagemDisponibilidadeContratual: "% Disponibilidade Contratual",
        PorcentagemTipoMPRG: "% Tipo MPRG",
        PorcentagemTipoMNPR: "% Tipo MNPR",
        PorcentagemTipoOPS: "% Tipo OPS",
        PorcentagemAproveitamentoDecolagemAoPouso: "% Aproveitamento - Decolagem ao Pouso",
        PorcentagemAproveitamentoPartidaAoCorte: "% Aproveitamento - Partida ao Corte",
      }

    },

    FichasDeDisponibilidade: {
      titulo: "Fichas de disponibilidade",

      formulario: {
        DataInicial: "Data Inicial",
        DataFinal: "Data Final",
        Aeronave: "Aeronave",
        Contrato: "Contrato",
        Base: "Base",
      },

      tabela: {
        Prefixo: "Prefixo",
        Contrato: "Contrato",
        InicioDisponibilidadeContratual: "Início disp. contratual",
        FimDispContratual: "Fim disp. contratual",
        InicioIndisponibilidade: "Início indisp.",
        FimIndisponibilidade: "Fim indisp.",
        Franquia: "Franquia",
        IndisponibilidadeTotal: "Indisp. Total",
        SemFranquia: "Sem franquia",
        TempoTotal: "Tempo total",
      }
    },

    RelatorioDeConsumo: {
      titulo: "Relatório de Consumo",

      formulario: {
        DataInicial: "Data Inicial",
        DataFinal: "Data Final",
        SomenteAprovados: "Somente aprovados",
        RelatorioDeVoo: "Relatório de Voo",
        Aeronave: "Aeronave",
        Frota: "Frota",
        Localidade: "Localidade",
        TipoDeVoo: "Tipo de Voo",
        Contrato: "Contrato",
        Cliente: "Cliente",
        NumeroDeReciboDoCombustivel: "N° de Recibo do Combustível",
        FornecedorDeCombustivel: "Fornecedor de Combustível",
        BaseContratual: "Base Contratual",
        
        placeholder: {
          InformeONumeroDoRelatorioDeVoo: "Informe o número do relatório de voo",
        }
      },

      tabela: {
        Data: "Data",
        Prefixo: "Prefixo",
        Frota: "Frota",
        Base: "Base",
        TipoDeVoo: "Tipo de Voo",
        Contrato: "Contrato",
        Cliente: "Cliente",
        NumeroRelatorio: "N° Relatório",
        NumeroDoVoo: "N° do Voo",
        Isencao: "Isenção",
        TotalVooDecolagemAoPouso: "Total Voo - 1ª Dec. ao  Últ. Pouso",
        TotalDoVooPartidaAoCorte: "Total do Voo - Partida ao Corte",
        TotalDoVooNavegacao: "Total do Voo - Navegação",
        TotalDoVooInstrumento: "Total do Voo - Instrumento",
        TotalDoVooNoturno: "Total do Voo - Noturno",
        TotalDoVooPartidas: "Total do Voo - Partidas",
        TotalDoVooPousosDiurnos: "Total do Voo - Pousos Diurnos",
        TotalDoVooPousosNoturnos: "Total do Voo - Pousos Noturnos",
        TotalDoVooPAX: "Total do Voo - PAX",
        TotalDoVooCarga: "Total do Voo - Carga",
        TipoDeContrato: "Tipo de Contrato",
        CombustivelAutorizado: "Combustível Autorizado",
        EmpresaDeCombustivel: "Empresa de Combustível",
        FornecedorDeCombustivel: "Fornecedor de Combustível",
        NumeroDaCE: "N° da CE",
        LocalDeAbastecimento: "Local de Abastecimento",
        ValorLitro: "Valor/Litro",
        ValorTotal: "Valor/Total",
        QuantidadeSolicitada: "Quantidade Solicitada",
        QuantidadeAbastecida: "Quantidade Abastecida",
        QuantidadeAbastecidaConvertida: "Quantidade Abastecida Convertida",
        Saldo: "Saldo",
        Consumo: "Consumo",
        ConsumoEmLitros: "Consumo em litros",
      },

      tituloTotais: "Totais",

      tabelaTotais: {
        Prefixo: "Prefixo",
        Frota: "Frota",
        TotalVooDecolagemAoPouso: "Total Voo - 1ª Dec. ao  Últ. Pouso",
        TotalDoVooPartidaAoCorte: "Total do Voo - Partida ao Corte",
        TotalDoVooNavegacao: "Total do Voo - Navegação",
        TotalDoVooInstrumento: "Total do Voo - Instrumento",
        TotalDoVooNoturno: "Total do Voo - Noturno",
        TotalDoVooPartidas: "Total do Voo - Partidas",
        TotalDoVooPousosDiurnos: "Total do Voo - Pousos Diurnos",
        TotalDoVooPousosNoturnos: "Total do Voo - Pousos Noturnos",
        TotalDoVooPAX: "Total do Voo - PAX",
        TotalDoVooCarga: "Total do Voo - Carga",
        CombustivelAutorizado: "Combustível Autorizado",
        ValorTotal: "Valor/Total",
        QuantidadeSolicitada: "Quantidade Solicitada",
        QuantidadeAbastecida: "Quantidade Abastecida",
        QuantidadeAbastecidaConvertida: "Quantidade Abastecida Convertida",
        Saldo: "Saldo",
        Consumo: "Consumo",
        ConsumoEmLitros: "Consumo em litros",
      }
    },

    RelatorioDeDisponibilidadeDeCombustivel: {
      titulo: "Relatório de Disponibilidade de Combustível",

      formulario: {
        MesInicio: "Mês Início",
        MesTermino: "Mês Término",
        Aeronave: "Aeronave",
        Base: "Base",
        Cliente: "Cliente",
        SomenteAprovados: "Somente aprovados",
      },

      tabela: {
        Inicio: "Início",
        Fim: "Fim",
        Aeronave: "Aeronave",
        Frota: "Frota",
        Contrato: "Contrato",
        Cliente: "Cliente",
        QuantidadeAbastecida: "Quantidade Abastecida",
        QuantidadeAbastecidaConvertida: "Quantidade Abastecida Convertida",
        Consumo: "Consumo",
        CAutorizado: "C. Autorizado",
        Saldo: "Saldo",
        HorasTotais: "Horas totais",
        Dias: "Dias",
        MediaDeHorasDeVooPorDia: "Média de Horas de Voo por Dia",
        MediaDeConsumoPorDia: "Média de Consumo por Dia",
        MediaDeConsumoPorHorasDeVoo: "Média de Consumo por Horas de voo",
      }

    },

    ExtratoDeDBEmBloco: {
      titulo: "Extrato de DB em bloco",

      formulario: {
        DataInicial: "Data Inicial",
        DataFinal: "Data Final",
        Aeronave: "Aeronave",
        Contrato: "Contrato",
        Base: "Base",
        Tripulantes: "Tripulantes",
        BasesContratual: "Bases Contratual",
        SomenteAprovados: "Somente aprovados",
      },

      tabela: {
        Data: "Data",
        Prefixo: "Prefixo",
        Frota: "Frota",
        Base: "Base",
        Contrato: "Contrato",
        Cliente: "Cliente",
        NumeroRelatorio: "N° Relatório",
        NumeroDoVoo: "N° do Voo",
      }
      
    },

    RelatorioDePousosPorLocalidade: {
      titulo: "Relatório de Pousos por Localidade",

      formulario: {
        DataInicial: "Data Inicial",
        DataFinal: "Data Final",
        SomenteAprovados: "Somente aprovados",
        Local: "Local",
        RelatorioDeVoo: "Relatório de Voo",
        Aeronave: "Aeronave",
        Frota: "Frota",

        placeholder: {
          InformeONumeroDoRelatorioDeVoo: "Informe o número do relatório de voo",
        }
      },

      tabela: {
        Data: "Data",
        Prefixo: "Prefixo",
        Frota: "Frota",
        Base: "Base",
        TipoDeVoo: "Tipo de Voo",
        Contrato: "Contrato",
        Cliente: "Cliente",
        NumeroRelatorio: "N° Relatório",
        NumeroDoVoo: "N° do Voo",
        Origem: "Origem",
        Destino: "Destino",
        Tripulantes: "Tripulantes",
        TotalDecolagemAoPouso: "Total - Decolagem ao Pouso",
        TotalPartidaAoCorte: "Total - Partida ao Corte",
        PousosDiurnos: "Pousos Diurnos",
        PousosNoturnos: "Pousos Noturnos",
      }


    },

    ApuracaoDeHoras: {
      titulo: "Apuração de horas",

      formulario: {
        DataInicial: "Data Inicial",
        DataFinal: "Data Final",
        Aeronave: "Aeronave",
        BaseContratual: "Base Contratual",
        Contrato: "Contrato",
        Cliente: "Cliente",
        Indisponibilidade: "Indisponibilidade",

        opcoesIndisponibilidade: {
          NaoExibir: "Não Exibir",
          ExibirApenasTotal: "Exibir apenas Total",
          ExibirApenasContratual: "Exibir apenas Contratual",
          ExibirTodas: "Exibir Todas",
        },

        SomenteAprovados: "Somente aprovados",
      },

      tabela: {
        Data: "Data",
        Contrato: "Contrato",
        PrefixoContratual: "Prefixo Contratual",
        Backup: "Backup",
        NumeroDoRelatorioDeVoo: "N° do Relatório de Voo",
        NumeroDoVoo: "N° do Voo",
        TipoDeContrato: "Tipo de Contrato",
        TempoTotalDeVooDecolagemAoPouso: "Tempo Total de Voo - 1ª Dec. ao  Últ. Pouso",
        TempoTotalDeVooPartidaAoCorte: "Tempo Total de Voo - Partida ao Corte",
        CombustivelConsumido: "Combustível consumido",
        CombustivelAbastecido: "Combustível abastecido",
        IndisponibilidadeDiariaTotal: "Indisponibilidade Diária - Total",
        IndisponibilidadeDiariaContratual: "Indisponibilidade Diária - Contratual",
        IndisponibilidadeMotivo: "Indisponibilidade - Motivo",
        IndisponibilidadeInicio: "Indisponibilidade - Início",
        IndisponibilidadeFim: "Indisponibilidade - Término",
      }

    },

    RelatorioDeTempoEmSolo: {
      titulo: "Relatório de Tempo em Solo",

      formulario: {
        DataInicial: "Data Inicial",
        DataFinal: "Data Final",
        SomenteAprovados: "Somente aprovados",
        Local: "Local",
        Aeronave: "Aeronave",
        Frota: "Frota",
      },

      tabela: {
        Data: "Data",
        Prefixo: "Prefixo",
        Frota: "Frota",
        TipoDeVoo: "Tipo de Voo",
        NumeroRelatorio: "N° Relatório",
        NumeroDoVoo: "N° do Voo",
        Origem: "Origem",
        Destino: "Destino",
        Pouso: "Pouso",
        DecolagemSeguinte: "Decolagem Seguinte",
        TempoEmSoloReal: "Tempo em Solo - Real"
      }
    },

    RelatorioDeTempoEntreTrechos: {
      titulo: "Relatório de Tempo entre Trechos",

      formulario: {
        DataInicial: "Data Inicial",
        DataFinal: "Data Final",
        SomenteAprovados: "Somente aprovados",
        RelatorioDeVoo: "Relatório de Voo",
        Aeronave: "Aeronave",
        Frota: "Frota",
        
        placeholder: {
          InformeONumeroDoRelatorioDeVoo: "Informe o número do relatório de voo",
        }
      },

      tabela: {
        Data: "Data",
        Prefixo: "Prefixo",
        Frota: "Frota",
        Base: "Base",
        TipoDeVoo: "Tipo de Voo",
        Contrato: "Contrato",
        Cliente: "Cliente",
        NumeroRelatorio: "N° Relatório",
        NumeroDoVoo: "N° do Voo",
        Tripulantes: "Tripulantes",
        QuantidadeDeTrechos: "Quantidade de trechos",
        TempoEntreTrechos: "Tempo entre Trechos",
        TotalDoVooDEPARR: "Total do Voo - DEC-POU",
        TotalDoVooTempoTotal: "Total do Voo - Tempo Total",
      }

    },

    ControleGeralDeRelatorios: {
      titulo: "Controle Geral de Relatórios",

      formulario: {
        DataInicial: "Data Inicial",
        DataFinal: "Data Final",
        AnaliticoOuSintetico: "Analítico ou Sintético",

        opcoesAnaliticoOuSintetico: {
          AnaliticoPorTripulante: "Analítico - Por Tripulante",
          AnaliticoPorRelatorio: "Analítico - Por Relatório",
          Sintetico: "Sintético",
        },

        SomenteAprovados: "Somente aprovados",
        RelatorioDeVoo: "Relatório de Voo",
        NumeroDoVoo: "N° do Voo",
        Aeronave: "Aeronave",
        Frota: "Frota",
        Base: "Base",
        TipoDeVoo: "Tipo de Voo",
        Contrato: "Contrato",
        Isencao: "Isenção",
        CargaExterna: "Carga externa",
        Cliente: "Cliente",
        Tripulantes: "Tripulantes",
        BasesContratual: "Bases Contratual",

        placeholder: {
          InformeONumeroDoRelatorioDeVoo: "Informe o número do relatório de voo",
          InformeONumeroDoVoo: "Informe o número do voo",
        }
      },

      tabela: {
        Data: "Data",
        Prefixo: "Prefixo",
        Frota: "Frota",
        Base: "Base",
        TipoDeVoo: "Tipo de Voo",
        Contrato: "Contrato",
        Cliente: "Cliente",
        NumeroRelatorio: "N° Relatório",
        NumeroDoVoo: "N° do Voo",
        Isencao: "Isenção",
        TotalDoVooDEPARR: "Total do Voo - DEC-POU",
        TotalDoVooTempoTotal: "Total do Voo - Tempo Total",
        TotalDoVooNavegacao: "Total do Voo - Navegação",
        TotalDoVooInstrumento: "Total do Voo - Instrumento",
        TotalDoVooNoturno: "Total do Voo - Noturno",
        TotalDoVooPousosDiurnos: "Total do Voo - Pousos Diurnos",
        TotalDoVooPousosNoturnos: "Total do Voo - Pousos Noturnos",
        TotalDoVooPAX: "Total do Voo - PAX",
        TotalDoVooCarga: "Total do Voo - Carga",
        TotalDoVooConsumo: "Total do Voo - Consumo",
        QuantidadeAbastecida: "Quantidade abastecida",
        Observacoes: "Observações",

        FB: "FB",
        Apresentacao: "Apresentação",
        Matricula: "Matrícula",
        Tripulante: "Tripulante",
        Etapa: "Etapa",
        Origem: "Origem",
        Destino: "Destino",
        HrPart: "Hr. Part.",
        DEP: "DEP.",
        ARR: "ARR.",
        Corte: "Corte",
        DEPARR: "DEC-POU",
        TempoTotal: "Tempo - Total",
        TempoNavegacao: "Tempo - Navegação",
        TempoInstrumento: "Tempo - Instrumento",
        TempoNoturno: "Tempo - Noturno",
        PousosDiurnos: "Pousos - Diurnos",
        PousosNoturnos: "Pousos - Noturnos",
        Partidas: "Partidas",
        PAX: "PAX.",
        Carga: "Carga",
        CargaExternaLongLine: "Carga Externa - Long Line",
        CargaExternaShortLine: "Carga Externa - Short Line",
        CombustivelInicial: "Combustível - Inicial",
        CombustivelFinal: "Combustível - Final",
      }

    },

    ExtratoDeRelatorioDeVooEmBloco: {
      titulo: "Extrato de Relatório de Voo em bloco",

      formulario: {
        DataInicial: "Data Inicial",
        DataFinal: "Data Final",
        Aeronave: "Aeronave",
        Contrato: "Contrato",
        Base: "Base",
        Tripulantes: "Tripulantes",
        BasesContratual: "Bases Contratual",
        SomenteAprovados: "Somente aprovados",
        linguagem: "Linguagem",
      },

      tabela: {
        Data: "Data",
        Prefixo: "Prefixo",
        Frota: "Frota",
        Base: "Base",
        Contrato: "Contrato",
        Cliente: "Cliente",
        NumeroRelatorio: "N° Relatório",
        NumeroDoVoo: "N° do Voo",
      }

    },

    ConferenciaDeMedicao: {
      titulo: "Conferência de medição",

      formulario: {
        DataInicial: "Data Inicial",
        DataFinal: "Data Final",
        Contrato: "Contrato",
        Cliente: "Cliente",
        TipoDeMedicao: "Tipo de Medição",

        opcoesMedicao: {
          Sintetica: "Sintética",
          Analitica: "Analítica",
        },

        SomenteAprovados: "Somente aprovados",
        BaseContratual: "Base Contratual",
      },

      tabela: {
        Contrato: "Contrato",
        PrefixoContrato: "Prefixo contrato",
        Status: "Status",
        NumeroDoVoo: "N° do Voo",
        Cliente: "Cliente",
        CodigoPTBR: "Código PTBR",
        LocalidadeInicio: "Localidade - início",
        LocalidadeFim: "Localidade - fim",
        Prefixo: "Prefixo",
        Inicio: "Início",
        Fim: "Fim",
      }
    },

    RelatorioDeVoosComCargaExterna: {
      titulo: "Relatório de Voos com Carga Externa",

      formulario: {
        DataInicial: "Data Inicial",
        DataFinal: "Data Final",
        SomenteAprovados: "Somente aprovados",
        RelatorioDeVoo: "Relatório de Voo",
        Aeronave: "Aeronave",
        Frota: "Frota",
        Tripulantes: "Tripulantes",

        placeholder: {
          InformeONumeroDoRelatorioDeVoo: "Informe o número do relatório de voo",
        }
      },

      tabela: {
        Data: "Data",
        Prefixo: "Prefixo",
        Frota: "Frota",
        Base: "Base",
        TipoDeVoo: "Tipo de Voo",
        Contrato: "Contrato",
        Cliente: "Cliente",
        NumeroRelatorio: "N° Relatório",
        NumeroDoVoo: "N° do Voo",
        Tripulantes: "Tripulantes",
        TotalDoVooDEPARR: "Total do Voo - DEC-POU",
        TotalDoVooTempoTotal: "Total do Voo - Tempo Total",
        CargaExternaLongLine: "Carga Externa - Long Line",
        CargaExternaShortLine: "Carga Externa - Short Line",
      }

    },

    RelatorioDePontualidade: {
      titulo: "Relatório de Pontualidade",

      formulario: {
        DataInicial: "Data Inicial",
        DataFinal: "Data Final",
        Base: "Base",
        SomenteAprovados: "Somente aprovados",
        TipoDeAtraso: "Tipo de atraso",

        opcoesTiposDeAtraso: {
          Decolagem: "Decolagem",
          TempoDeVoo: "Tempo de voo",
        },
      },

      tabela: {
        EstatisticasDeVooDe(dataInicial, dataFinal){
          return `Estastísticas de Voo de ${dataInicial} a ${dataFinal}`
        },

        Tipo: "Tipo",
        Valor: "Valor",
        TempoTotalDeAtraso: "Tempo Total de Atraso",
        Atrasados: "Atrasados",
        Pontuais: "Pontuais",
        MediaTempo: "Média Tempo",
        Operacoes: "Operações",
        Coordenacao: "Coordenação",
        Despacho: "Despacho",
        Manutencao: "Manutenção",
        NumeroVoos: "Nº Voos",
        AtrasadosInterno: "Atrasados Int",
        AtrasadosExterno: "Atrasados Ext",
        Pontualidade: "Pontualidade",
        PontualidadeSemAtrasoExterno: "Pont (s/ atrasos ext)",
        PontualidadeSemAtrasoInterno: "Pont (s/ atrasos int)",
        VooManutencao: "Voo Manutenção",
        VooGiros: "Voo Giros",
        VooTreinamento: "Voo Treinamento",
        VooPTBR: "Voo PTBR",
        VooOutrosClientes: "Voo Outros Clientes",
        VoosComerciais: "Voos Comerciais",
      }

    },

    RelatorioDeAbastecimentos: {
      titulo: "Relatório de Abastecimentos",

      formulario: {
        DataInicial: "Data Inicial",
        DataFinal: "Data Final",
        SomenteAprovados: "Somente aprovados",
        RelatorioDeVoo: "Relatório de Voo",
        Aeronave: "Aeronave",
        Frota: "Frota",
        Localidade: "Localidade",
        TipoDeVoo: "Tipo de Voo",
        Contrato: "Contrato",
        NumeroDeReciboDoCombustivel: "N° de Recibo do Combustível",
        FornecedorDeCombustivel: "Fornecedor de Combustível",
        BaseContratual: "Base Contratual",
        placeholder: {
          InformeONumeroDoRelatorioDeVoo: "Informe o número do relatório de voo",
          InformeONumeroDeReciboDoCombustivel: "Informe o número de recibo de combustível",
        }
      },

      tabela: {
        ID: "ID",
        Data: "Data",
        Aeronave: "Aeronave",
        Modelo: "Modelo",
        RelatorioDeVoo: "Relatório de Voo",
        NumeroRelatorioDeVoo: "N° Relatório de Voo",
        TipoDeVoo: "Tipo de Voo",
        Empresa: "Empresa",
        Fornecedor: "Fornecedor",
        Localidade: "Localidade",
        NumeroDoRecibo: "N° do Recibo",
        Quantidade: "Quantidade",
        ValorLitro: "Valor/Litro",
        ValorTotal: "Valor/Total",
        Reembolsavel: "Reembolsável",
        ValorReembolsavel: "Valor/Reembolsável",
        ValorFinal: "Valor/Final",
      }

    },

    RelatorioDeHorasGeradasPorTipoDeCargo: {
      titulo: "Relatório de Horas Geradas por Tipo de Cargo",

      formulario: {
        DataInicial: "Data Inicial",
        DataFinal: "Data Final",
        SomenteAprovados: "Somente aprovados",
        RelatorioDeVoo: "Relatório de Voo",
        Aeronave: "Aeronave",
        Frota: "Frota",
        Base: "Base",
        TipoDeVoo: "Tipo de Voo",
        Contrato: "Contrato",
        Cliente: "Cliente",
        BaseContratual: "Base Contratual",

        placeholder: {
          InformeONumeroDoRelatorioDeVoo: "Informe o número do relatório de voo",
        }
      },

      tabela: {
        Data: "Data",
        Prefixo: "Prefixo",
        Frota: "Frota",
        Base: "Base",
        TipoDeVoo: "Tipo de Voo",
        Contrato: "Contrato",
        TipoDeContrato: "Tipo de Contrato",
        Cliente: "Cliente",
        NumeroRelatorio: "N° Relatório",
        NumeroDoVoo: "N° do Voo",
        Isencao: "Isenção",
        TotalVooDecolagemAoPouso: "Total Voo - 1ª Dec. ao  Últ. Pouso",
        TotalDoVooPartidaAoCorte: "Total do Voo - Partida ao Corte",
        TotalDoVooNoturno: "Total do Voo - Noturno",
        HorasRealizadasTripulacao: "Horas realizadas - Tripulação",
        HorasRealizadasCMDTTotal: "Horas realizadas - CMDT - Total",
        HorasRealizadasCMDTNoturno: "Horas realizadas - CMDT - Noturno",
        HorasRealizadasCMDTDomFer: "Horas realizadas - CMDT - Dom/Fer",
        HorasRealizadasCOPILTotal: "Horas realizadas - COPIL - Total",
        HorasRealizadasCOPILNoturno: "Horas realizadas - COPIL - Noturno",
        HorasRealizadasCOPILDomFer: "Horas realizadas - COPIL - Dom/Fer",
        HorasRealizadasCMSTotal: "Horas realizadas - CMS - Total",
        HorasRealizadasCMSNoturno: "Horas realizadas - CMS - Noturno",
        HorasRealizadasCMSDomFer: "Horas realizadas - CMS - Dom/Fer",
      },

      tituloTotais: "Totais",

      tabelaTotais: {
        Prefixo: "Prefixo",
        Frota: "Frota",
        TotalVooDecolagemAoPouso: "Total Voo - 1ª Dec. ao  Últ. Pouso",
        TotalPartidaAoCorte: "Total - Partida ao Corte",
        TotalNoturno: "Total - Noturno",
        TotalTripulacao: "Total - Tripulação",
        TotalCMDTTotal: "Total - CMDT - Total",
        TotalCMDTNoturno: "Total - CMDT - Noturno",
        TotalCMDTDomFer: "Total - CMDT - Dom/Fer",
        TotalCOPILTotal: "Total - COPIL - Total",
        TotalCOPILNoturno: "Total - COPIL - Noturno",
        TotalCOPILDomFer: "Total - COPIL - Dom/Fer",
        TotalCMSTotal: "Total - CMS - Total",
        TotalCMSNoturno: "Total - CMS - Noturno",
        TotalCMSDomFer: "Total - CMS - Dom/Fer",
      }

    },

    ExtracaoDeXMLEmBloco: {
      titulo: "Extração de XML em bloco",

      formulario: {
        DataInicial: "Data Inicial",
        DataFinal: "Data Final",
        Aeronave: "Aeronave",
        Cliente: "Cliente",
        Contrato: "Contrato",
        Base: "Base",
        SomenteAprovados: "Somente aprovados",
        BaseContratual: "Base Contratual",
      },

      tabela: {
        Data: "Data",
        Prefixo: "Prefixo",
        Frota: "Frota",
        Base: "Base",
        Contrato: "Contrato",
        Cliente: "Cliente",
        NumeroRelatorio: "N° Relatório",
        NumeroDoVoo: "N° do Voo",
      }

    },

    ControleDeExperienciaNoturna: {
      titulo: "Controle de Experiência Noturna",

      formulario: {
        Tripulantes: "Tripulantes",
        Frotas: "Frotas",
        DataInicial: "Data Inicial",
        DataFinal: "Data Final",
        FuncaoDeBordo: "Função de bordo",
        Shore: "Shore",

        opcoesShore: {
          OnShore: "On-Shore",
          OffShore: "Off-Shore",
        },

        TipoDePesquisa: "Tipo de Pesquisa",
        
        opcoesTiposDePesquisa: {
          Totais: "Totais",
          PorVoo: "Por Voo",
        },

        TipoDeVoo: "Tipo de Voo",
      },

      tabelaTotais: {
        Matricula: "Matrícula",
        Nome: "Nome",
        PousosDiurnos: "Pousos Diurnos",
        PousosNoturnos: "Pousos Noturnos",
        HorasNoturnas: "Horas Noturnas",
        HorasTotais: "Horas Totais",
      },

      tabelaPorVoo: {
        Matricula: "Matrícula",
        Nome: "Nome",
        Data: "Data",
        Relatorio: "Relatório",
        Trecho: "Trecho",
        Frota: "Frota",
        FuncaoDeBordo: "Função de Bordo",
        Localidade: "Localidade",
        PousosDiurnos: "Pousos Diurnos",
        PousosNoturnos: "Pousos Noturnos",
        HorasNoturnas: "Horas Noturnas",
        HorasTotais: "Horas Totais",
      }



    }

  },

  Voos: {

    ListaDeVoos: {

      deletar: "Tem certeza que gostaria de deletar esse voo?",

      titulo: "Lista de voos",

      botaoEditarStatus: "Editar status",
      
      formulario: {
        DataInicial: "Data inicial",
        DataFinal: "Data final",
        Base: "Base",

        botaoProcurarVoos: "Procurar voos",

        placeholder: {
          SelecionarBase: "Selecionar base",
        }
      },

      tabela: {
        EstatisticasDeVooEm(dataInicial, dataFinal) {
          return `Estastísticas de Voo em ${dataInicial} a ${dataFinal}`
        },

        Tipo: "Tipo",
        Valor: "Valor",
        TempoTotalDeAtraso: "Tempo Total de Atraso",
        Atrasados: "Atrasados",
        Pontuais: "Pontuais",
        MediaTempo: "Média tempo",
        Operacoes: "Operações",
        Coordenacao: "Coordenação",
        Despacho: "Despacho",
        Manutencao: "Manutenção",
        NumeroVoos: "Nº Voos",
        AtrasadosInt: "Atrasados Int",
        AtrasadosExt: "Atrasados Ext",
        Pontualidade: "Pontualidade",
        PontSemAtrasosExt: "Pont (s/ atrasos ext)",
        PontSemAtrasosInt: "Pont (s/ atrasos int)",
        VooManutencao: "Voo Manutenção",
        VooGiros: "Voo Giros",
        VooTreinamento: "Voo Treinamento",
        VooPTBR: "Voo PTBR",
        VooOutrosClientes: "Voo Outros Clientes",
        VoosComerciais: "Voos Comerciais",
      },

      tituloVoosPara(dataInicial, dataFinal) {
        return `Voos para ${dataInicial} a ${dataFinal}`
      },

      listaVoosPara: {
        Atrasado: "Atrasado",
        SaidaPrevista: "Saída prevista",
        SaidaReal: "Saída real",
        Atraso: "Atraso",
        JustificativaPTBR: "Justificativa PTBR",
        Motivo: "Motivo",
        Codigo: "Código",
        JustificativaOmni: "Justificativa Interna",
        Setor: "Setor",
      }


    },

    EditarVoos: {
      deletar: "Tem certeza que gostaria de deletar esse voo?",
      titulo: "Editar voos",
      botaoResumoDeVoos: "Resumo de voos",

      formulario: {
        Data: "Data",
        Base: "Base",
        Aeronave: "Aeronave",
        TipoDeVoo: "Tipo de voo",
        SaidaPrevista: "Saída prevista",
        SaidaReal: "Saída real",
        Atraso: "Atraso",
        JustificativaOMNI: "Justificativa Interna",
        JustificativaPTBR: "Justificativa PTBR",
        CodigoPTBR: "Código PTBR",

        botaoSalvarVoo: "Salvar voo",

        placeholder: {
          SelecionarBase: "Selecionar base",
          SelecionarAeronave: "Selecionar aeronave",
          Formato: "Formato 00:00",
        }
      },

      tituloVoosPara(dataInicial, dataFinal) {
        return `Voos para ${dataInicial} a ${dataFinal}`
      },

      listaVoosPara: {
        Atrasado: "Atrasado",
        SaidaPrevista: "Saída prevista",
        SaidaReal: "Saída real",
        Atraso: "Atraso",
        JustificativaPTBR: "Justificativa PTBR",
        Motivo: "Motivo",
        Codigo: "Código",
        JustificativaOmni: "Justificativa Interna",
        Setor: "Setor",
      }
      
    },

    TesteDeAlerta: {

      titulo: "Teste de alerta",

      formulario: {
        Frotas: "Frotas",
        Escala: "Escala",
        Aeronaves: "Aeronaves",
        Tripulantes: "Tripulantes",
        TripulanteSubstituido: "Tripulante substituído",

        botaoTestarAlertas: "Testar alertas",

        placeholder: {
          SelecionarFrota: "Selecionar frota",
          SelecionarEscala: "Selecionar escala",
          SelecionarAeronave: "Selecionar aeronave",
          SelecionarTripulante: "Selecionar tripulante",
        }
      },

      erros: "Erros",
    }

  },

  TiposDeVoo: {

    ListaDeTiposDeVoo: {
      arquivar: "Tem certeza que gostaria de arquivar?",
      ativar: "Tem certeza que gostaria de ativar?",
      deletar: "Tem certeza que gostaria de deletar esse voo?",
      ativo: "Ativo",
      arquivado: "Arquivado",
      titulo: "Lista de tipos de voo",
      botaoAdicionarTipoDeVoo: "Adicionar tipo de voo",

      tabela: {
        semTiposDeVoo: "Não há tipos de vôo cadastrados",
        ID: "ID",
        Nome: "Nome",
        Abreviacao: "Abreviação",
        CodigoANAC: "Código ANAC",
        RequerNumeroDeVoo: "Requer N° de Voo",
        RequerIsencao: "Requer Isenção",
        Manutencao: "Manutenção",
        Faturado: "Faturado",
        Status: "Status",
        Acoes: "Ações",
      }
    },

    AdicionarTipoDeVoo: {

      titulo: "Cadastrar tipo de voo",

      formulario: {

        Nome: "Nome",
        Abreviacao: "Abreviação",
        CodigoANAC: "Código ANAC",
        RequerNumeroDeVoo: "Requer N° de Voo",
        RequerIsencao: "Requer Isenção",
        ExigeCliente: "Exige Cliente",
        Manutencao: "Manutenção",
        PowerCheck: "Giro de Manutenção ou Power Check",
        Faturado: "Faturado",

        botaoCadastrarTipoDeVoo: "Cadastrar tipo de voo",


        placeholder: {
          SelecioneCodigo: "Selecione o código",
        }
      }

    },

    EditarTipoDeVoo: {

      titulo: "Editar tipo de voo",

      formulario: {

        Nome: "Nome",
        Abreviacao: "Abreviação",
        CodigoANAC: "Código ANAC",
        RequerNumeroDeVoo: "Requer N° de Voo",
        RequerIsencao: "Requer Isenção",
        ExigeCliente: "Exige Cliente",
        Manutencao: "Manutenção",
        PowerCheck: "Giro de Manutenção ou Power Check",
        Faturado: "Faturado",

        botaoEditarTipoDeVoo: "Editar tipo de voo",


        placeholder: {
          SelecioneCodigo: "Selecione o código",
        }
      }

    }

  },

  FornecedoresCombustivel: {
    ListaDeFornecedores: {
      titulo: "Lista de fornecedores de combustível",
      botaoAdicionarFornecedor: "Adicionar fornecedor de fornecedor",
      deletar: "Tem certeza que gostaria de deletar essa fornecedor?",
      tabela: {
        ID: "ID",
        Nome: "Nome",
        Acoes: "Ações",
      },
    },

    CadastrarFornecedor: {
      titulo: "Cadastrar fornecedor de combustível",
      formulario: {
        Nome: "Nome",
        Email: "E-mail",
        Empresa: "Empresa",
        botaoAdicionar: "Adicionar",
      }
    },
    EditarFornecedor: {
      titulo: "Editar fornecedor de combustível",
      deletar: "Tem certeza que gostaria de deletar esta taxa?",
      formulario: {
        Nome: "Nome",
        Empresa: "Empresa",
        Email: "E-mail",
        RequerAprovacao: "Requer aprovação?",
        RequerExportacao: "Requer exportação caribbean?",
        RequerEmail: "Requer e-mail?",
        botaoAdicionar: "Editar",
        placeholder: {
          SelecionarEmpresa: "Selecionar empresa",
          SelecionarLocalidade: "Selecionar Localidade",
          SelecionarMoeda: "Selecionar moeda",
        }

      },

      PrecosPorLocalidade: {
        titulo: "Preços Por Localidades",
        tituloToken: "Preços Por Localidades TOKEN",
        tituloSupplierToken: "Edição de preços por localidade",
        AdicionarLocalidade: {
          titulo: "Adicionar Localidade",
          formulario: {
            Localidade: "Localidade",
            ValorLitro: "Valor/Litro",
            DataDeInicioDaVigencia: "Data de início da vigência",
            DataDeTerminoDaVigencia: "Data de término da vigência",
            Moeda: "Moeda",
            Ativos: "Ativos",
            botaoAdicionarLocalidade: "Adicionar localidades",
            placeholder: {
              SelecionarEmpresa: "Selecionar empresa",
              SelecionarLocalidade: "Selecionar localidade",
              SelecionarMoeda: "Selecionar moeda",
            }
          },

          tabela: {
            Localidade: "Localidade",
            Icao: "ICAO",
            InicioDaVigencia: "Início da vigência",
            TerminoDaVigencia: "Término da vigência",
            Moeda: "Moeda",
            Valor: "Valor",
          },

        },
        AdicionarLocalidadeToken: {
          titulo: "Adicionar Localidade",
          formulario: {
            Localidade: "Localidade",
            ValorLitro: "Valor/Litro",
            DataDeInicioDaVigencia: "Data de início da vigência",
            DataDeTerminoDaVigencia: "Data de término da vigência",
            Moeda: "Moeda",
            Ativos: "Ativos",
            botaoAdicionarLocalidade: "Adicionar localidades por token",
            placeholder: {
              SelecionarEmpresa: "Selecionar empresa",
              SelecionarLocalidade: "Selecionar localidade",
              SelecionarMoeda: "Selecionar moeda",
            }
          },

          tabela: {
            Token: "Token",
            Status: "Status",
            Localidade: "Localidade",
            InicioDaVigencia: "Início da vigência",
            TerminoDaVigencia: "Término da vigência",
            Moeda: "Moeda",
            Valor: "Valor",
          },

        },
        EditarLocalidadeToken: {
          titulo: "Editar Localidade",
          formulario: {
            Localidade: "Localidade",
            ValorLitro: "Por favor preencha abaixo o preço da localidade válido de ",
            Ate: " até ",
            DataDeInicioDaVigencia: "Data de início da vigência",
            DataDeTerminoDaVigencia: "Data de término da vigência",
            Moeda: "Moeda",
            Ativos: "Ativos",
            botaoEditarLocalidade: "Editar valor",
            placeholder: {
              ValorLitro: "Valor/Litro",
              SelecionarMoeda: "Selecionar moeda",
            }
          },
          tabela: {
            Token: "Token",
            Status: "Status",
            Localidade: "Localidade",
            InicioDaVigencia: "Início da vigência",
            TerminoDaVigencia: "Término da vigência",
            Moeda: "Moeda",
            Valor: "Valor",
          },

        },
      },


    },
  },

  Gratificacao: {

    ListaDeGratificacao: {
      deletar: "Tem certeza que gostaria de deletar essa gratificação?",
      titulo: "Lista de gratificação",
      botaoAdicionarGratificacao: "Adicionar gratificação",

      tabela: {
        semFornecedores: "Não há fornecedores cadastrados",
        ID: "ID",
        Nome: "Nome",
        Valor: "Valor",
        Acoes: "Ações",
      },

    },
    
    AdicionarGratificacao: {
      titulo: "Cadastrar gratificação",

      formulario: {
        Nome: "Nome",
        Valor: "Valor",

        botaoAdicionarGratificacao: "Adicionar gratificação",
      }
    },

    EditarGratificacao: {

      titulo: "Edição de gratificação",

      formulario: {
        Nome: "Nome",
        Valor: "Valor",
      }
    },

  },

  Importacoes: {

    ListaDeImportacoes: {

      atualizarSistemaComInformacoesDoRUBI: "Tem certeza que deseja atualizar o sistema com as informações do RUBI?",
      titulo: "Importações",
      naoFoiPossivelRealizarImportacaoDosDadosDoRUBI: "Não foi possível realizar a importação dos dados do RUBI pelos seguintes motivos",
      botaoImportar: "Importar",

      tabela: {
        ID: "ID",
        DataDeImportacao: "Data de Importação",
        Acoes: "Ações",
      },

      tituloLogDeEdicoes: "Log de edições",

      tabelaLogDeEdicoes: {
        ID: "ID",
        Colaborador: "Colaborador",
        Tipo: "Tipo",
        Campo: "Campo",
        ValorAntigo: "Valor Antigo",
        ValorNovo: "Valor Novo",

      }

    }

  },

  Incompatibilidades: {

    ListaDeIncompatibilidades: {
      deletar: "Tem certeza que gostaria de deletar essa incompatibilidade?",
      titulo: "Lista de incompatibilidades",

      tituloAdicionarTripulante: "Adicionar Tripulante",

      formulario: {
        PrimeiroTripulante: "Primeiro Tripulante",
        SegundoTripulante: "Segundo Tripulante",
        Obs: "Obs",
        
        botaoAdicionarTripulante: "Adicionar Tripulante",

        placeholder: {
          SelecionePrimeiroTripulante: "Selecione o primeiro tripulante",
          SelecioneSegundoTripulante: "Selecione o segundo tripulante",
          Observacoes: "Observações",
        }
      },

      tabela: {
        semIncompatibilidades: "Não há incompatibilidades cadastradas",
        ID: "ID",
        Nome: "Nome",
        Tripulante1: "Tripulante 1",
        Tripulante2: "Tripulante 2",
        Observacoes: "Observações",
        Acoes: "Ações"
      }
    },
  },

  Layout: {

    Topo: {
      bemVindo: "Bem-vindo,",
      botaoSair: "Sair",
      botaoMinhaConta: "Minha Conta",

      menuCadastros: {
        tituloMenu: "Cadastros",
        
        Empresas: "Empresas",
        ListaDeEmpresas: "Lista de empresas",
        CadastrarEmpresas: "Cadastrar empresas",
        Bases: "Bases",
        ListaDeBases: "Lista de bases",
        CadastrarBases: "Cadastrar bases",
        Aeronaves: "Aeronaves",
        ListaDeAeronaves: "Lista de aeronaves",
        CadastrarAeronaves: "Cadastrar aeronaves",
        ListaDeModelosDeAeronaves: "Lista de modelos de aeronaves",
        CadastrarModelosDeAeronave: "Cadastrar modelos de aeronave",
        Cargos: "Cargos",
        ListaDeCargos: "Lista de cargos",
        CadastrarCargos: "Cadastrar cargos",
        Setores: "Setores",
        ListaDeSetores: "Lista de setores",
        CadastrarSetores: "Cadastrar setores",
        Designacoes: "Designações",
        ListaDeDesignacoes: "Lista de designações",
        CadastrarDesignacoes: "Cadastrar designações",
        ComposicaoDaCabine: "Composição da Cabine",
        ExperienciaMinima: "Experiência Mínima",
        IncompatibilidadesDeTripulantes: "Incompatibilidades de tripulantes",
        GraduacoesDeTripulantes: "Graduações de tripulantes",
        CopilotosAutorizadosComando: "Copilotos Autorizados Comando",
        Gratificacoes: "Gratificações",
        ListaDeGratificacoes: "Lista de gratificações",
        CadastrarGratificacao: "Cadastrar gratificação",
        Processos: "Processos",
        ListaDeProcessos: "Lista de processos",
        CadastrarProcessos: "Cadastrar processos",
        ListaDeDocumentos: "Lista de documentos",
        CadastrarDocumentos: "Cadastrar documentos",
        OcorrenciaisAnormais: "Ocorrências anormais",
        ListaDeOcorrenciasAnormais: "Lista de ocorrências anormais",
        CadastrarOcorrenciaAnormal: "Cadastrar ocorrência anormal",
        FuncoesDeBordo: "Funções de bordo",
        ListaDeFuncoesDeBordo: "Lista de funções de bordo",
        CadastrarFuncaoDeBordo: "Cadastrar função de bordo",
        Locais: "Locais",
        ListaDeLocais: "Lista de locais",
        CadastrarLocal: "Cadastrar local",
        ListaDeTiposDeLocal: "Lista de tipos de local",
        CadastrarTipoDeLocal: "Cadastrar tipo de local",
        ListaDeOperadores: "Lista de operadores aeroportuários",
        CadastrarOperador: "Cadastrar operador aeroportuário",
        ListaDeResponsaveisPeloEspacoAereo: "Lista de responsáveis pelo espaço aéreo",
        CadastrarResponsavelPeloEspacoAereo: "Cadastrar responsável pelo espaço aéreo",
        TiposDeOperacao: "Tipos de operação",
        TiposDeVoo: "Tipos de voo",
        ListaDeTiposDeOperacao: "Lista de tipos de operação",
        CadastrarTipoDeOperacao: "Cadastrar tipo de operação",
        ListaDeTiposDeVoo: "Lista de tipos de voo",
        CadastrarTipoDeVoo: "Cadastrar tipo de voo",
        Petrobras: "Petrobras",
        ReferenciasPTBR: "Referências PTBR",
        FornecedoresDeCombustivel: "Fornecedores de combustível",
        ListaDeFornecedores: "Lista de fornecedores",
        CadastrarFornecedores: "Cadastrar fornecedores",
        Atrasos: "Atrasos",
        JustificativasDeAtrasoOmni: "Justificativas de Atraso",
      },

      menuFuncionarios: {
        tituloMenu: "Colaboradores",
        Controles: "Controles",
        Colaboradores: "Colaboradores",
        ListaDeTripulantes: "Lista de tripulantes",
        ListaDeColaboradores: "Lista de colaboradores",
        ListaDeColaboradoresAtivos: "Lista de colaboradores ativos",
        ListaDeTripulantesDesligados: "Lista de tripulantes desligados",
        ListaDeTodosOsTripulantes: "Lista de todos os tripulantes",
        ListaDeTripulantesPorDesignacao: "Lista de tripulantes por designação",
        ListaDeTripulantesPorICAO: "Lista de tripulantes por ICAO",
        PesquisaDeHabilitacoes: "Pesquisa de habilitações",
        Cadastrar: "Cadastrar",
        VencimentoDeCertificados: "Vencimento de certificados",
        VencimentoDeASOEEletrocardiograma: "Vencimento de ASO e Eletrocardiograma",
        ListaDeCertificadosGeral: "Lista de certificados geral",
        TreinamentosRequeridos: "Treinamentos requeridos",
        Senioridade: "Senioridade",
        ListagemDeFuncionariosSemCargo: "Listagem de colaboradores sem cargo",
        ListagemDeFuncionariosSemCargoArquivados: "Listagem de colaboradores sem cargo arquivados",
        DocumentosQPulse: "Docs Q-Pulse",
        ControleDeCertificadosPorDataDeEmissao: "Controle de certificados por data de emissão",
        CVODVO: "CVO / DVO",
        ListaDeColaboradoresCVODVO: "Lista de colaboradores CVO / DVO",
        ListaDeColaboradoresCVODVODesligados: "Lista de colaboradores CVO / DVO desligados",
        MestreDeCarga: "Mestre de carga",
        ListaDeMestresDeCarga: "Lista de mestres de carga",
        ListaDeMestresDeCargaDesligados: "Lista de mestres de carga desligados",
        VencimentoDeCertificados: "Vencimento de certificados",
        TreinamentosRequeridos: "Treinamentos requeridos",
        Controle: "Controle",
        QualificacaoDeFornecedores: "Qualificação de fornecedores",
        FiltroMultiploDeCertificados: "Filtro múltiplo de certificados",
        TreinamentosConsolidados: "Treinamentos Consolidados",
      },

      menuEscalas: {
        tituloMenu: "Escalas",

        Escalas: "Escalas",
        ListaDeEscalas: "Lista de escalas",
        CadastrarEscala: "Cadastrar escala",
        Regimes: "Regimes",
        ElaborarEscala: "Elaborar escala",
        PendenciasNaoResolvidas: "Pendências - Não Resolvidas",
        PendenciasArquivadas: "Pendências - Arquivadas",      
        EscalaDeBase: "Escala de base",
        ListaDeEscalasDeBase: "Lista de escalas de base",
        CadastrarEscalaDeBase: "Cadastrar escala de base",
        Contratos: "Contratos",
        ListaDeContratos: "Lista de contratos",
        CadastrarContratos: "Cadastrar contratos",
        Consulta: "Consulta",
        Clientes: "Clientes",
        ListaDeClientes: "Lista de clientes",
        CadastrarClientes: "Cadastrar clientes",
        EscalaDeCVODVO: "Escala de CVO/DVO",
        ListaDeEscalasDeCVODVO: "Lista de escalas de CVO/DVO",
        CadastrarEscalaDeCVODVO: "Cadastrar escala de CVO/DVO",
        EscalaDeMestreDeCarga: "Escala de Mestre de Carga",
        ListaDeEscalasDeMestreDeCarga: "Lista de escalas de mestre de carga",
        CadastrarEscalaDeMestreDeCarga: "Cadastrar escala de mestre de carga",
        SolicitacaoDeColaborador: "Solicitação de Colaborador",
        ListaDeSolicitacoes: "Lista de solicitações",
        ListaDeSolicitacoesPendentes: "Lista de solicitações pendentes",
        Siglas: "Siglas",
        ListaDeSiglas: "Lista de siglas",
        CadastrarSiglas: "Cadastrar siglas",
        Alertas: "Alertas",
        TestarAlertas: "Testar alertas",
        EnvioMensalPTBR: "Envio mensal PTBR",
        SolicitacoesDePagamento: "Solicitações de pagamento",
        DeslocamentoDeMissao: "Deslocamento de Missão",
        DeslocamentoDeTreinamento: "Deslocamento de Treinamento",
        TransporteDeMissao: "Transporte de Missão",
        TransporteDeTreinamento: "Transporte de Treinamento",
      },

      menuTreinamentos: {
        tituloMenu: "Treinamentos",

        Treinamentos: "Treinamentos",
        ListaDeTreinamentos: "Lista de treinamentos",
        CadastrarTreinamentos: "Cadastrar treinamentos",
        Certificados: "Certificados",
        ListaDeCertificados: "Lista de certificados",
        CadastrarCertificados: "Cadastrar certificados",
        Fornecedores: "Fornecedores",
        ListaDeFornecedores: "Lista de fornecedores",
        CadastrarFornecedores: "Cadastrar fornecedores",
      },

      menuFRMS: {
        tituloMenu: "FRMS",

        ParametrosDeFadiga: "Parâmetros de fadiga",
        ListaDeParametrosDeFadigas: "Lista de parâmetros de fadigas",
        CadastrarParametrosDeFadiga: "Cadastrar parâmetros de fadiga",
        Configuracoes: "Configurações",
        ConfiguracoesDePontuacao: "Configurações de pontuação",
        RelatoriosDeFadiga: "Relatórios de fadiga",
        CadastrarRelatoriosDeFadiga: "Cadastrar relatórios de fadiga",
        MonitoramentoDeFadiga: "Monitoramento de fadiga",
        RelacaoDeTripulantesFadigados: "Relação de tripulantes fadigados",
        RelacaoDeRelatoriosFaltantes: "Relação de relatórios faltantes",
        PesquisaDeRelatoriosDeFadigaDiarios: "Pesquisa de relatórios de fadiga - Diários",
        RevisaoDeRelatorioIncorreto: "Revisão de relatório incorreto",
        RelacaoDeAutoAvaliacoesDeFadiga: "Relação de auto avaliações de fadiga",
        EstatisticasDeEventosDeFadiga: "Estatísticas de eventos de fadiga",
        ImportacaoSIGLA: "Importação - SIGLA",
        CadastrarRelatorios: "Cadastrar relatórios",
        AvaliarEscalaPlanejada: "Avaliar escala planejada",
        EfetividadeDosControles: "Efetividade dos Controles",
        ListaDeFormulariosMensais: "Lista de formulários mensais",
        CadastrarFormularioMensal: "Cadastrar formulário mensal",
        EstatisticasDosFormulariosDeEfetividade: "Estatísticas dos formulários de efetividade",
        SimuladorDeRelatoriosDeFadiga: "Simulador de relatórios de fadiga",
        SimularRelatoriosDeFadiga: "Simular relatórios de fadiga",
        ReporteVoluntarioDeFadiga: "Reporte voluntário de fadiga",
        CadastroDeMotivosDeFadiga: "Cadastro de motivos de fadiga",
        ReportesVoluntariosDeFadigaAbertos: "Reportes voluntários de fadiga - Abertos",
        ReportesVoluntariosDeFadigaFechados: "Reportes voluntários de fadiga - Fechados",
        Tarefas: "Tarefas",
        ListaDeTarefas: "Lista de tarefas",
        CadastrarTarefas: "Cadastrar tarefas",
        TesteDeSonolencia: "Teste de sonolência",
        EscalasDeTestes: "Escalas de testes",
        CadastrarEscalaDeTestes: "Cadastrar escala de testes",
        PesquisaDeFadiga: "Pesquisa de fadiga",
        ControleDeRespostasDeQuestionario: "Controle de respostas de questionário",
      },

      menuVoos: {
        tituloMenu: "Voos",
        Abastecimentos: "Abastecimentos",
        ListaDeAbastecimentos: "Lista de Abastecimentos",
        CadastrarAbastecimentoAvulso: "Cadastrar abastecimento avulso",
        Relatorios: "Relatórios",
        ListaDeRelatoriosDeVoo: "Lista de relatórios de voo",
        CadastrarRelatorioDeVoo: "Cadastrar relatório de voo",
        EscalaDiaria: "Escala diária",
        ReboqueDeAeronave: "Reboque de Aeronave",
        ConsultarReboques: "Consultar",
        CadastrarReboques: "Cadastrar",
        ListaDeEscalasDiaria: "Lista de escalas diária",
        DisponibilidadeDeTripulantes: "Disponibilidade de Tripulantes",
        SimularEscalaDiaria: "Simular escala diária",
        MovimentacaoDeAeronavesMensal: "Movimentação de Aeronaves - Mensal",
        MovimentacaoDeAeronavesAnual: "Movimentação de Aeronaves - Anual",
        Indisponibilidade: "Indisponibilidade",
        AeronavesIndisponiveis: "Aeronaves indisponíveis",
        ListaDeIndisponibilidades: "Lista de Indisponibilidades",
        IndisponibilidadesArquivadas: "Indisponibilidades arquivadas",
        CadastrarIndisponibilidade: "Cadastrar indisponibilidade",
        PapeletasIndividuaisFIRA: "Papeletas individuais (FIRA)",
        ConsultaDePapeletas: "Consulta de Papeletas",
        ListaDePapeletas: "Lista de Papeletas",
        ControleDeFIRA: "Controle de FIRA",
        HorasDeVoo: "Horas de voo",
        GerarPagamentoNoClienteDePagamentos: "Gerar pagamentos no cliente de Pagamentos",
        Alertas: "Alertas",
        ListaDeAlertas: "Lista de alertas",
        RequisitosPersonalizados: "Requisitos Personalizados",
        Controles: "Controles",
        ConsultaContratos: "Consulta de Contratos",
        VisualizarHoraDeVoo: "Visualizar hora de voo",
        ControleGeralDeRelatorios: "Controle Geral de Relatórios",
        ExtratoDeXMLEmBloco: "Extrato de XML em bloco",
        ExtratoDeDBEmBloco: "Extrato de DB em bloco",
        ExtratoDeRelatoriosEmBloco: "Extrato de Relatórios em bloco",
        ControleDiarioDeUtilizacaoDeAeronavesContratadas: "Controle Diário de Utilização de Aeronaves Contratadas",
        QuantidadeDeVoosPorDia: "Quantidade de voos por dia",
        RelatorioDeAbastecimentos: "Relatório de Abastecimentos",
        RelatorioDeConsumo: "Relatório de Consumo",
        RelatorioDeDisponibilidadeDeCombustivel: "Relatório de Disponibilidade de Combustível",
        RelatorioDeHorasGeradasPorTipoDeCargo: "Relatório de Horas Geradas por Tipo de Cargo",
        RelatorioDePousosPorLocalidade: "Relatório de Pousos por Localidade",
        RelatorioDeTempoEmSolo: "Relatório de Tempo em Solo",
        RelatorioDeVoosComCargaExterna: "Relatório de Voos com Carga Externa",
        RelatorioDeTempoEntreTrechos: "Relatório de Tempo entre Trechos",
        ConsultaDeIndisponibilidade: "Consulta de indisponibilidade",
        BoletimDeDisponibilidade: "Boletim de disponibilidade",
        ApuracaoDeHoras: "Apuração de horas",
        ConferenciaDeMedicao: "Conferência de medição",
        ControleDeExperienciaNoturna: "Controle de Experiência Noturna",
        ControleDeTarifas: "Controle de Tarifas",
      },

      menuConfiguracoes: {
        UsuariosDoSistema: "Usuários do sistema",
        ListaDeUsuarios: "Lista de usuários",
        CadastrarUsuario: "Cadastrar de usuário",
        Emails: "E-mails",
        ListaDeEnderecoDeEmails: "Lista de endereço de e-mails",
        Importacoes: "Importações",
        Importar: "Importar",
        Diversos: "Diversos",
        LinksUteis: "Links Úteis",
      },
      
      atencaoVoceEstaUtilizandoOAmbienteDeHomologacao: "Atenção: Você está utilizando o ambiente de homologação",

    }

  },

  Locais: {

    ListaDeLocais: {
      deletar: "Tem certeza que gostaria de deletar essa localidade?",
      ativar: "Tem certeza que gostaria de ativar essa localidade?",
      arquivar: "Tem certeza que gostaria de arquivar essa localidade?",

      ativo: "Ativo",
      arquivado: "Arquivado",

      titulo: "Lista de locais",
      botaoAdicionarLocal: "Adicionar local",

      tabela: {
        semLocais: "Não há locais cadastrados",
        ID: "ID",
        Nome: "Nome",
        CodigoICAO: "Código ICAO",
        CodigoIATA: "Código IATA",
        Cidade: "Cidade",
        CoordenadaLat: "Coordenada lat.",
        CoordenadaLong: "Coordenada long.",
        Tipo: "Tipo",
        Shore: "Shore",
        Status: "Status",
        Acoes: "Ações",
      }
      
    },

    AdicionarLocal: {

      titulo: "Cadastrar local",

      formulario: {
        Nome: "Nome",
        CodigoICAO: "Código ICAO",
        Cidade: "Cidade",
        Shore: "Shore",
        Base: "Base operacional",

        opcoesShore: {
          OnShore: "On-Shore",
          OffShore: "Off-Shore",
        },

        Latitude: "Latitude",
        Longitude: "Longitude",
        CodigoIATA: "Código IATA",
        Tipo: "Tipo",
        Grupo: "Grupo",
        Classe: "Classe",
        Pais: "País",


        placeholder: {
          CodigoIATA: "Código IATA",

        }
      }

    },

    EditarLocal: {
      titulo: "Editar local",
     
      formulario: {
        Nome: "Nome",
        CodigoICAO: "Código ICAO",
        Cidade: "Cidade",
        Shore: "Shore",
        Base: "Base operacional",

        opcoesShore: {
          OnShore: "On-Shore",
          OffShore: "Off-Shore",
        },

        Latitude: "Latitude",
        Longitude: "Longitude",
        CodigoIATA: "Código IATA",
        Tipo: "Tipo",
        Grupo: "Grupo",
        Classe: "Classe",
        Pais: "País",

        placeholder: {
          CodigoIATA: "Código IATA",
        }
      }
    }
  },

  TiposDeLocalidades: {

    ListaDeTiposDeLocalidade: {

      deletar: "Tem certeza que gostaria de deletar esse tipo de localidade?",
      titulo: "Lista de tipos de localidade",
      botaoAdicionarTipoDeLocalidade: "Adicionar tipo de localidade",

      tabela: {
        semFuncoesDeBordo: "Não há funções de bordo cadastrados",
        ID: "ID",
        Descricao: "Descrição",
        Acoes: "Ações",
      }
    },

    AdicionarTipoDeLocalidade: {
      titulo: "Cadastrar tipo de localidade",

      formulario: {
        Descricao: "Descrição",
        SkipTransitHums: "Não faz inspeção entre voos & HUMS",
      }
    },

    EditarTipoDeLocalidade: {

      titulo: "Editar tipo de localidade",

      formulario: {
        Descricao: "Descrição",
        SkipTransitHums: "Não faz inspeção entre voos & HUMS",
      }
    }
  },

  Logs: {

    ListaLogs: {

      verRequest: "Ver request",

      titulo: "Logs",

      tabela: {
        semTripulantesCadastrados: "Não há tripulantes cadastrados",
        ID: "ID",
        Usuario: "Usuário",
        Acao: "Ação",
        Controller: "Controller",
        Action: "Action",
        Metodo: "Método",
        Request: "Request",
        Data: "Data",
      },

      tituloRequestDetalhado: "Request detalhado",

    }

  },

  Miscelania: {
    Overlay: {
      paragrafoCarregando: "Carregando..."
    },

    RequestApi: {
      seuUsuarioNaoTemPermissaoParaAcessarEstaPagina: "Seu usuário não tem permissão para acessar esta página.",
      seuUsuarioNaoTemPermissaoParaAcessarEstaFuncionalidade: "Seu usuário não tem permissão para acessar esta funcionalidade.",
    },
  },

  TiposDeOperacao: {

    ListaDeTiposDeOperacao: {
      deletar: "Tem certeza que gostaria de deletar essa operação?",
      titulo: "Lista de tipos de operação",
      botaoAdicionarTipoDeOperacao: "Adicionar tipo de operação",

      tabela: {
        semFuncoesDeBordo: "Não há funções de bordo cadastrados",
        ID: "ID",
        Nome: "Nome",
        Descricao: "Descrição",
        Acoes: "Ações",
      }
    },

    AdicionarTipoDeOperacao: {

      titulo: "Cadastrar tipo de operação",

      formulario: {
        Nome: "Nome",
        Descricao: "Descrição",
      }

    },

    EditarTipoDeOperacao: {
      titulo: "Editar tipo de operação",

      formulario: {
        Nome: "Nome",
        Descricao: "Descrição",
      }
    },

  },

  OrdensDePagamento: {

    ListaDeOrdensDePagamentoEnviadas: {
      deletar: "Tem certeza que gostaria de deletar esse cliente?",
      titulo: "Lista de OP enviadas",
      botaoAdicionarOrdemDePagamento: "Adicionar ordem de pagamento",

      tabela: {
        semFornecedoresCadastrados: "Não há fornecedores cadastrados",
        ID: "ID",
        Nome: "Nome",
        Codigo: "Código",
        Status: "Status",
        DataDeCriacao: "Data de criação",
        Acoes: "Ações",
      }
    },

    ListaDeOrdensDePagamentoAbertas: {
      deletar: "Tem certeza que gostaria de deletar esse cliente?",
      titulo: "Lista de OP abertas",
      botaoAdicionarOrdemDePagamento: "Adicionar ordem de pagamento",

      tabela: {
        semFornecedoresCadastrados: "Não há fornecedores cadastrados",
        ID: "ID",
        Nome: "Nome",
        Codigo: "Código",
        Status: "Status",
        DataDeCriacao: "Data de criação",
        Acoes: "Ações",
      }
    },

    AdicionarOrdemDePagamento: {

      opcoesTipo: {
        Missao: "Missão",
        Treinamentos: "Treinamentos",
      },

      titulo: "Criar ordem de pagamento",

      formulario: {
        Nome: "Nome",
        Tipo: "Tipo",
        Codigo: "Código",

        botaoAdicionarOrdemDePagamento: "Adicionar ordem de pagamento",
      }
    },

    EditarOrdemDePagamento: {
      titulo: "Edição de ordem de pagamento",
      erros: "Os seguintes erros impediram o pagamento de ser enviado",

      tabDadosDaOrdemDePagamento: {
        tituloTab: "Dados da ordem de pagamento",

        opcoesStatus:{
          Prevista: "Prevista",
          EnviadaParaAprovacao: "Enviada para Aprovação",
          Aprovada: "Aprovada",
          PagamentoAgendado: "Pagamento Agendado",
          PagamentoEfetuado: "Pagamento Efetuado",
          Cancelada: "Cancelada"
        },

        osEmailsEstaoSendoReenviados: "Os e-mails estão sendo reenviados. Essa operação pode levar entre 30 a 60 segundos. Em breve iniciaremos o envio.",
        osEmailsEstaoSendoEnviados: "Os e-mails estão sendo enviados. Essa operação pode levar entre 30 a 60 segundos. Em breve iniciaremos o envio.",

        formulario: {
          Nome: "Nome",
          Codigo: "Código",
          Status: "Status",
          DataDePagamento: "Data de pagamento",
        },

        botaoReenviarEmailDePagamento: "Reenviar e-mail de pagamento",
        botaoEnviarPagamento: "Enviar pagamento",

      },

      tabTreinamentos: {
        tituloTab: "Treinamentos",

        tabHoras: {
          tituloTab: "Horas",
          deletar: "Tem certeza que gostaria de deletar esse pagamento da OP?",
          botaoExportarHoras: "Exportar horas",
          tabela: {
            semPagamentosEmAberto: "Não há pagamentos em aberto",
            Acoes: "Ações",
            ID: "ID",
            Status: "Status",
            Nome: "Nome",
            TipoDeTreinamento: "Tipo de trein.",
            Aula: "Aula",
            Periodo: "Período",
            Treinamento: "Treinamento",
            NumeroERev: "Nº e Rev.",
            Local: "Local",
            HorasPagas: "Horas pagas",
            ValorDaHora: "Valor da hora",
            TotalDeHoras: "Total de horas",
          }
        },

        tabNacional: {
          tituloTab: "Nacional",
          deletar: "Tem certeza que gostaria de deletar esse pagamento da OP?",
          botaoExportarDiariasNacionais: "Exportar diárias nacionais",

          tabela: {
            semPagamentosEmAberto: "Não há pagamentos em aberto",
            Acoes: "Ações",
            ID: "ID",
            Saldo: "Saldo",
            Nome: "Nome",
            Periodo: "Período",
            Treinamento: "Treinamento",
            NumeroERev: "Nº e Rev.",
            Diarias: "Diárias",
            ValorDiaria: "Valor/diária",
            Desconto: "Desconto",
            TotalEmDiarias: "Total em diárias",
            Moeda: "Moeda",
          },

          tituloDiasDoPagamento: "Dias do pagamento",

          tabelaDiasDoPagamento: {
            Data: "Data",
            Diarias: "Diarias",
            Status: "Status",
          }

        },

        tabInternacional: {
          tituloTab: "Internacional",
          deletar: "Tem certeza que gostaria de deletar esse pagamento da OP?",
          botaoExportarDiariasInternacionais: "Exportar diárias internacionais",

          tabela: {
            semPagamentosEmAberto: "Não há pagamentos em aberto",
            Acoes: "Ações",
            ID: "ID",
            Saldo: "Saldo",
            Nome: "Nome",
            Periodo: "Período",
            Treinamento: "Treinamento",
            NumeroERev: "Nº e Rev.",
            Diarias: "Diárias",
            ValorDiaria: "Valor/diária",
            Desconto: "Desconto",
            TotalEmDiarias: "Total em diárias",
            Moeda: "Moeda",
          },
          
          tituloDiasDoPagamento: "Dias do pagamento",

          tabelaDiasDoPagamento: {
            Data: "Data",
            Diarias: "Diarias",
            Status: "Status",
          }

        }

      },

      tabEscala: {
        tituloTab: "Escala",

        tabHoras: {
          tituloTab: "Horas",
          deletar: "Tem certeza que gostaria de deletar esse pagamento da OP?",
          botaoExportarHoras: "Exportar horas",

          tabela: {
            semPagamentosEmAberto: "Não há pagamentos em aberto",
            Acoes: "Ações",
            ID: "ID",
            Status: "Status",
            Nome: "Nome",
            Periodo: "Período",
            HorasPagas: "Horas pagas",
            ValorDaHora: "Valor da hora",
            TotalPago: "Total pago",          }
        },
        tabDiarias: {
          tituloTab: "Diárias",
          deletar: "Tem certeza que gostaria de deletar esse pagamento da OP?",
          botaoExportarDiariasDeMissao: "Exportar diárias de missão",

          tabela: {
            semPagamentosEmAberto: "Não há pagamentos em aberto",
            Acoes: "Ações",
            ID: "ID",
            Saldo: "Saldo",
            Nome: "Nome",
            Frota: "Frota",
            Mes: "Mês",
            Revisao: "Revisão",
            Diarias: "Diárias",
            ValorDiaria: "Valor/Diária",
            Desconto: "Desconto",
            TotalEmDiarias: "Total em diárias",
            Moeda: "Moeda",
          },

          tituloDiasDoPagamento: "Dias do pagamento",

          tabelaDiasDoPagamento: {
            Data: "Data",
            Diarias: "Diarias",
            Status: "Status",
          }
        }
      },

      tabIndenizacoes: {
        tituloTab: "Indenizações",

        tabCheques: {
          tituloTab: "Cheques",
          deletar: "Tem certeza que gostaria de deletar esse pagamento da OP?",
          botaoExportarDiariasDeMissao: "Exportar diárias de missão",

          tabela: {
            semPagamentosEmAberto: "Não há pagamentos em aberto",
            Acoes: "Ações",
            ID: "ID",
            Examinador: "Examinador",
            Checado: "Checado",
            Data: "Data",
            Canac: "Canac",
            Matricula: "Matrícula",
            Valor: "Valor",
            Moeda: "Moeda",
          },

          tituloDiasDoPagamento: "Dias do pagamento",

          tabelaDiasDoPagamento: {
            Data: "Data",
            Diarias: "Diarias",
            Status: "Status",
          }
        },

        tabRepresentanteOperacional: {
          tituloTab: "Representante Operacional",
          deletar: "Tem certeza que gostaria de deletar esse pagamento da OP?",
          botaoExportarDiariasDeMissao: "Exportar diárias de missão",

          tabela: {
            semPagamentosEmAberto: "Não há pagamentos em aberto",
            Acoes: "Ações",
            ID: "ID",
            Nome: "Nome",
            Mes: "Mês",
            BaseOperacional: "Base Operacional",
            Revisao: "Revisão",
            ValorReferencia: "Valor referência",
            Quantidade: "Quantidade",
            ValorTotal: "Valor total",
            Moeda: "Moeda",
          },

          tituloDiasDoPagamento: "Dias do pagamento",

          tabelaDiasDoPagamento: {
            Data: "Data",
            Diarias: "Diarias",
            Status: "Status",
          }

        },

        tabDeslocamento: {
          tituloTab: "Deslocamento",
          deletar: "Tem certeza que gostaria de deletar esse pagamento da OP?",
          botaoExportarDiariasDeMissao: "Exportar diárias de missão",

          tabela: {
            semPagamentosEmAberto: "Não há pagamentos em aberto",
            Acoes: "Ações",
            ID: "ID",
            Nome: "Nome",
            Frota: "Frota",
            Mes: "Mês",
            Revisao: "Revisão",
            Distancia: "Distância",
            Valor: "Valor",
            Total: "Total",
            Moeda: "Moeda",
          }

        },

        tabTransporte: {
          tituloTab: "Transporte",
          deletar: "Tem certeza que gostaria de deletar esse pagamento da OP?",
          botaoExportarDiariasDeMissao: "Exportar diárias de missão",

          tabela: {
            semPagamentosEmAberto: "Não há pagamentos em aberto",
            Acoes: "Ações",
            ID: "ID",
            Nome: "Nome",
            Frota: "Frota",
            Mes: "Mês",
            Revisao: "Revisão",
            Moeda: "Moeda",
            Quantidade: "Quantidade",
            Valor: "Valor",
            Total: "Total",
          }
        }
      }
    }
  },

  SolicitacoesDePagamento: {

    SolicitacoesDePagamentoTransporteTreinamento: {
      aprovarSolicitacao: "Tem certeza que gostaria de aprovar essa solicitação?",
      statusDePagamentoAtualizadoComSucesso: "Status de pagamento atualizado com sucesso",
      reprovarSolicitacao: "Tem certeza que gostaria de reprovar essa solicitação?",

      titulo: "Solicitações de Pagamento - Transporte - Treinamento",

      tabela: {
        semSolicitacaoDePagamento: "Não há solicitação de pagamento cadastrada",
        ID: "ID",
        Nome: "Nome",
        Status: "Status",
        Lote: "Lote",
        Treinamento: "Treinamento",
        Base: "Base",
        Revisao: "Revisão",
        Quantidade: "Quantidade",
        Valor: "Valor",
        Moeda: "Moeda",
        Observacao: "Observação",
        Acoes: "Ações",
      },

      tituloReprovacaoDePagamento: "Reprovação de Pagamento",

      formulario: {
        Justificativa: "Justificativa",

        botaoReprovarPagamento: "Reprovar pagamento",
      }
    },

    SolicitacoesDePagamentoDeslocamentoTreinamento: {

      aprovarSolicitacao: "Tem certeza que gostaria de aprovar essa solicitação?",
      statusDePagamentoAtualizadoComSucesso: "Status de pagamento atualizado com sucesso",
      reprovarSolicitacao: "Tem certeza que gostaria de reprovar essa solicitação?",

      titulo: "Solicitações de Pagamento - Deslocamento - Treinamento",

      tabela: {
        semSolicitacaoDePagamento: "Não há solicitação de pagamento cadastrada",
        ID: "ID",
        Nome: "Nome",
        Status: "Status",
        Lote: "Lote",
        Treinamento: "Treinamento",
        Revisao: "Revisão",
        Inicio: "Início",
        Fim: "Fim",
        Quantidade: "Quantidade",
        Valor: "Valor",
        ValorTotal: "Valor Total",
        Moeda: "Moeda",
        Observacao: "Observação",
        Acoes: "Ações",
      },

      tituloReprovacaoDePagamento: "Reprovação de Pagamento",

      formulario: {
        Justificativa: "Justificativa",

        botaoReprovarPagamento: "Reprovar pagamento",
      },
      
      tituloBases: "Bases",

      tabelaBases: {
        Origem: "Origem",
        CEPOrigem: "CEP Origem",
        Destino: "Destino",
        CEPDestino: "CEP Destino",
      }

    },

    SolicitacoesDePagamentoTransporteMissao: {
      aprovarSolicitacao: "Tem certeza que gostaria de aprovar essa solicitação?",
      statusDePagamentoAtualizadoComSucesso: "Status de pagamento atualizado com sucesso",
      reprovarSolicitacao: "Tem certeza que gostaria de reprovar essa solicitação?",

      titulo: "Solicitações de Pagamento - Transporte - Missão",

      tabela: {
        semSolicitacaoDePagamento: "Não há solicitação de pagamento cadastrada",
        ID: "ID",
        Nome: "Nome",
        Status: "Status",
        Lote: "Lote",
        Frota: "Frota",
        Mes: "Mês",
        Base: "Base",
        Revisao: "Revisão",
        Quantidade: "Quantidade",
        Valor: "Valor",
        Moeda: "Moeda",
        Observacao: "Observação",
        Acoes: "Ações",
      },

      tituloReprovacaoDePagamento: "Reprovação de Pagamento",

      formulario: {
        Justificativa: "Justificativa",

        botaoReprovarPagamento: "Reprovar pagamento",
      }

    },

    SolicitacoesDePagamentoDeslocamentoMissao: {
      aprovarSolicitacao: "Tem certeza que gostaria de aprovar essa solicitação?",
      statusDePagamentoAtualizadoComSucesso: "Status de pagamento atualizado com sucesso",
      reprovarSolicitacao: "Tem certeza que gostaria de reprovar essa solicitação?",

      titulo: "Solicitações de Pagamento - Deslocamento - Missão",

      tabela: {
        semSolicitacaoDePagamento: "Não há solicitação de pagamento cadastrada",
        ID: "ID",
        Nome: "Nome",
        Status: "Status",
        Lote: "Lote",
        Frota: "Frota",
        Mes: "Mês",
        Revisao: "Revisão",
        Inicio: "Início",
        Fim: "Fim",
        Quantidade: "Quantidade",
        Valor: "Valor",
        ValorTotal: "Valor Total",
        Moeda: "Moeda",
        Observacao: "Observação",
        Acoes: "Ações",
      },

      tituloReprovacaoDePagamento: "Reprovação de Pagamento",

      formulario: {
        Justificativa: "Justificativa",

        botaoReprovarPagamento: "Reprovar pagamento",
      },
      
      tituloBases: "Bases",

      tabelaBases: {
        Origem: "Origem",
        CEPOrigem: "CEP Origem",
        Destino: "Destino",
        CEPDestino: "CEP Destino",
      }

    }

  },

  Pagamentos:{

    ListaDePagamentosEmAbertoHoras: {

      titulo: "Lista de pagamentos em aberto - horas",
      atencaoRelatoriosAindaNaoConcluidos: "Atenção! Há relatórios ainda não concluídos no período selecionado",

      formulario: {

        DataInicial: "Data inicial",
        DataFinal: "Data final",
        IncluirPagos: "Incluir pagos",

        botaoBuscarPagamentos: "Buscar pagamentos",
      },

      formularioOrdemDePagamento: {

        OrdemDePagamento: "Ordem de pagamento",

        placeholder: {
          SelecionarOrdemDePagamento: "Selecionar ordem de pagamento",
        },

        botaoAdicionarOrdemDePagamento: "Adicionar a ordem de pagamento",
        botaoDeletarPagamentos: "Deletar pagamentos",
      },

      tabela: {
        semPagamentosEmAberto: "Não há pagamentos em aberto",
        ID: "ID",
        Matricula: "Matrícula",
        NomeDoColaborador: "Nome do Colaborador",
        TotalGeral: "Total Geral",
        HorasDiurnas: "Horas Diurnas",
        HorasNoturnas: "Horas Noturnas",
        HorasDomingosFeriados: "Horas Domingos/Feriados",
        SomaGeral: "Soma Geral",
      }
    }
  },

  ValoresDePagamento: {

    EditarValoresDeDiarias: {

      opcoesTipo: {
        DiariaNacional: "Diária - nacional",
        DiariaInternacional: "Diária - internacional",
        DiariaEuropa: "Diária - Europa",
        IndenizacaoTransporte: "Indenização - transporte",
        IndenizacaoDeslocamento: "Indenização - deslocamento",
        IndenizacaoRepresentanteOperacional: "Indenização - representante operacional",
        IndenizacaoGratificacaoDeCheque: "Indenização - gratificação de cheque",
      },

        deletar: "Tem certeza que deseja deletar esse grupo de pagamentos?",
        titulo: "Editar valores de diárias",

        formulario: {
          Tipo: "Tipo",
          Cargo: "Cargo",
          Empresa: "Empresa",
          Moeda: "Moeda",
          Valor: "Valor",
        },

        tituloValoresCadastrados: "Valores cadastrados",

        tabela: {
          Tipo: "Tipo",
          Empresa: "Empresa",
          Moeda: "Moeda",
          Valor: "Valor",
          Cargos: "Cargos",
        },
    }

  },

  Processos: {

    ListaDeProcessos: {

      deletar: "Tem certeza que gostaria de deletar esse processo?",
      titulo: "Lista de processos",
      botaoAdicionarProcesso: "Adicionar processo",

      tabela: {

        semFornecedoresCadastrados: "Não há fornecedores cadastrados",
        ID: "ID",
        Nome: "Nome",
        Acoes: "Ações",
      }
    },

    AdicionarProcesso: {

      titulo: "Cadastrar processo",

      formulario: {

        Nome: "Nome",

        placeholder: {
          NomeDoProcesso: "Nome do processo",
        },

        botaoAdicionarProcesso: "Adicionar processo",
      }
    },

    EditarProcesso: {

      titulo: "Edição de processo",

      tabDadosDoProcesso: {

        tituloTab: "Dados do processo",

        formulario: {

          Nome: "Nome",

          placeholder: {
            NomeDoProcesso: "Nome do processo",
          },
        },

        tituloAdicionarNovoSubtipo: "Adicionar novo subtipo",

        formularioAdicionarNovoSubtipo: {

          NomeDoSubtipo: "Nome do subtipo",

          botaoAdicionarSubtipo: "Adicionar subtipo",

          placeholder: {
            NomeDoSubtipo: "Nome do subtipo",
          },
        },

        deletarDocumento: "Tem certeza que gostaria de deletar esse documento?",
        deletarSubtipoEDocumentosRelacionados: "Tem certeza que gostaria de deletar esse subtipo e documentos relacionados?",

        tituloDocumentos: "Documentos",

        formularioDocumentos: {

          Documentos: "Documentos",
          DocumentObrigatorio: "Documento obrigatório",

          botaoAdicionarDocumento: "Adicionar documento",

          placeholder: {
            SelecionarDocumentos: "Selecionar documentos",
          }
        },

        tabelaDocumentos: {
          semDocumentos: "Não há documentos cadastrados",
          ID: "ID",
          Documento: "Documento",
          DocumentoObrigatorio: "Documento obrigatório",
          Acoes: "Ações",
        }
      }
    }
  },

  PTBR: {

    ReferenciasPTBR: {
      titulo: "Referências PTBR",

      tabCodigosDaExportacaoXML: {
        tituloTab: "Códigos da exportação XML",

        deletarCodigo: "Tem certeza que gostaria de deletar esse código?",

        formulario: {
          CDOP: "CDOP",
          GRPOP: "GRPOP",
          Descricao: "Descrição",
          Tabela: "Tabela",
          UsoInterno: "Uso Interno",

          opcoesUsoInterno: {
            CodigoDePartida: "1 - Código de Partida",
            CodigoDeDecolagem: "2 - Código de Decolagem",
            CodigoDePouso: "3 - Código de Pouso",
            CodigoDeCorte:"4 - Código de Corte",
            CodigoDeVoo: "5 - Código de Voo",
            CodigoDeAtraso: "6 - Código de Atraso",
            CodigoPadraoDeVoo: "7 - Código Padrão de Voo",
          },

          botaoAdicionarCodigoPTBR: "Adicionar código PTBR",

          placeholder: {
            CDOP: "CDOP",
            GRPOP: "GRPOP",
            Descricao: "Descrição",
            NomeDaTabela: "Nome da tabela",
            SelecioneOUsoInterno: "Selecione o uso interno",
          }
        },

        tabela: {
          semCodigosPTBR: "Não há códigos PTBR cadastrados",
          ID: "ID",
          CDOP: "CDOP",
          GRPOP: "GRPOP",
          Descricao: "Descrição",
          Tabela: "Tabela",
          UsoInterno: "Uso Interno",
          Acoes: "Ações",
        },

        tituloEditarCodigoPTBR: "Editar código PTBR",

        forumlarioEditarCodigoPTBR: {

          CDOP: "CDOP",
          GRPOP: "GRPOP",
          Descricao: "Descrição",
          Tabela: "Tabela",
          UsoInterno: "Uso Interno",

          opcoesUsoInterno: {
            CodigoDePartida: "1 - Código de Partida",
            CodigoDeDecolagem: "2 - Código de Decolagem",
            CodigoDePouso: "3 - Código de Pouso",
            CodigoDeCorte:"4 - Código de Corte",
            CodigoDeVoo: "5 - Código de Voo",
            CodigoDeAtraso: "6 - Código de Atraso",
            CodigoPadraoDeVoo: "7 - Código Padrão de Voo",
          },

          botaoEditarCodigoPTBR: "Editar código PTBR",

          placeholder: {
            CDOP: "CDOP",
            GRPOP: "GRPOP",
            Descricao: "Descrição",
            NomeDaTabela: "Nome da tabela",
            SelecioneOUsoInterno: "Selecione o uso interno",
          }
        }
      },

      tabOperacoes: {
        tituloTab: "Operações",

        deletarOperacao: "Tem certeza que gostaria de deletar essa operação?",

        formulario: {
          Tipo: "Tipo",
          Descricao: "Descrição",
          CargaExterna: "Carga Externa",

          botaoAdicionarOperacaoPTBR: "Adicionar operação PTBR",

          placeholder: {
            Tipo: "Tipo",
            Descricao: "Descrição",

          }
        },

        tabela: {
          semOperacoesPTBR: "Não há operaçãos PTBR cadastrados",
          ID: "ID",
          Tipo: "Tipo",
          Descricao: "Descrição",
          CargaExterna: "Carga Externa",
          Acoes: "Ações",
        },

        tituloEditarOperacaoPTBR: "Editar operação PTBR",

        formularioEditarOperacaoPTBR: {
          Tipo: "Tipo",
          Descricao: "Descrição",
          CargaExterna: "Carga externa",

          botaoEditarOperacaoPTBR: "Editar operação PTBR",

          placeholder: {
            Tipo: "Tipo",
            Descricao: "Descrição",
          }
        }
      },

      tabCombustivel: {
        tituloTab: "Combustível",

        deletarCombustivel: "Tem certeza que gostaria de deletar esse combustível?",

        formulario:{
          Tipo: "Tipo",
          Descricao: "Descrição",
          
          botaoAdicionarCombustivelPTBR: "Adicionar combustível PTBR",

          placeholder: {
            Tipo: "Tipo",
            Descricao: "Descrição",
          },
        },

        tabela: {

          semCombustivelPTBR: "Não há combustívels PTBR cadastrados",
          ID: "ID",
          Tipo: "Tipo",
          Descricao: "Descrição",
          Acoes: "Ações",
        },

        tituloEditarCombustivelPTBR: "Editar combustível PTBR",

        formularioEditarCombustivelPTBR: {
          Tipo: "Tipo",
          Descricao: "Descrição",
          
          botaoEditarCombustivelPTBR: "Editar combustível PTBR",

          placeholder: {
            Tipo: "Tipo",
            Descricao: "Descrição",
          },
        }
      },

      tabCargaExterna: {
        tituloTab: "Carga Externa",

        deletarCargaExterna: "Tem certeza que gostaria de deletar essa carga externa?",

        formulario: {
          Tipo: "Tipo",
          Descricao: "Descrição",
          
          botaoAdicionarCargaExternaPTBR: "Adicionar carga externa PTBR",

          placeholder: {
            Tipo: "Tipo",
            Descricao: "Descrição",
          },
        },

        tabela: {
          semCargaExternaPTBR: "Não há carga externas PTBR cadastrados",
          ID: "ID",
          Tipo: "Tipo",
          Descricao: "Descrição",
          Acoes: "Ações",
        },

        tituloEditarCargaExternaPTBR: "Editar carga externa PTBR",

        formularioEditarCargaExternaPTBR: {
          Tipo: "Tipo",
          Descricao: "Descrição",
          
          botaoEditarCargaExternaPTBR: "Editar carga externa PTBR",

          placeholder: {
            Tipo: "Tipo",
            Descricao: "Descrição",
          },
        }
      },

      tabJustificativasDeAtraso: {
        tituloTab: "Justificativas de Atraso",

        deletarJustificativa: "Tem certeza que gostaria de deletar essa justificativa de atraso?",

        formulario: {
          Nome: "Nome",
          Motivo: "Motivo",
          Codigo: "Código",
          Tipo: "Tipo",

          opcoesTipo: {
            Decolagem: "Decolagem",
            TempoDeVoo: "Tempo de voo",
          },

          botaoAdicionarJustificativaDeAtrasoPTBR: "Adicionar justificativa de atraso PTBR",

          placeholder: {
            Nome: "Nome",
            Motivo: "Motivo",
            Codigo: "Código",
            SelecioneTipo: "Selecione o tipo",
          }
        },

        tabela: {
          semJustificativasDeAtrasoPTBR: "Não há justificativas de atraso PTBR cadastradas",
          Nome: "Nome",
          Motivo: "Motivo",
          Codigo: "Código",
          Tipo: "Tipo",
          Acoes: "Ações",
        },

        tituloEditarJustificativaDeAtrasoPTBR: "Editar justificativa de atraso PTBR",

        formularioEditarJustificativaDeAtrasoPTBR: {

          Nome: "Nome",
          Motivo: "Motivo",
          Codigo: "Código",
          Tipo: "Tipo",

          opcoesTipo: {
            Decolagem: "Decolagem",
            TempoDeVoo: "Tempo de voo",
          },

          botaoEditarJustificativaDeAtrasoPTBR: "Editar justificativa de atraso PTBR",

          placeholder: {
            Nome: "Nome",
            Motivo: "Motivo",
            Codigo: "Código",
            SelecioneTipo: "Selecione o tipo",
          }

        }

      },
    }

  },

  Cargos: {
    /* A palavra "Cargos" foi retirada da pagina RolesIndex, cujo título é "Lista de cargos". A página index é a fonte do nome do grupo de traduções por página. Se não tiver Index, busque por Add ou Edit (ex.:RolesAdd ou RolesEdit) */
    ListaDeCargos: {
      /* é o nome da Página RolesIndex, cujo título é lista de cargos */
      deletar:
        "Tem certeza que gostaria de deletar esse cargo?" /*é a frase que está no método delete, no window.confirm. Tadução básica, que só vai acontecer quando for básica */,
      titulo:
        "Lista de cargos" /* Título da página. Como saber se é o título da página? é o primeito item com tag <hx> da página, sendo x qualquer numero. Comum em praticamente todas as páginas */,
      botaoAdicionar:
        "Adicionar cargo" /* Título da página. Como saber se é o título da página? é o primeito item com tag <hx> da página, sendo x qualquer numero. Comum em todas as páginas do tipo Index. Importante: por ser um botão, eu iniciei com botao, para ficar bem entendido do que se trata */,
      tabela: {
        /* são os campos da tabela. Repare que nao usamos caracteres especiais, e isso será feito em todo o sistema. Ações, por exemplo, vira Acoes */
        semCargos: "Não há cargos cadastrados",
        ID: "ID",
        Nome: "Nome",
        CodigoRubi: "Código Rubi",
        Funcao: "Função",
        PagaDiaria: "Paga Diária?",
        Acoes: "Ações",
      },
    },
    AdicionarCargo: {
      /* mesmo processo de RolesIndex */
      titulo:
        "Cadastrar cargo" /* Título da página. Como saber se é o título da página? é o primeito item com tag <hx> da página, sendo x qualquer numero. Comum em praticamente todas as páginas */,
      formulario: {
        /* este formulário tem alguns selects. As opções dos selects, se nao forem variáveis, devem ser substituídas. IMPORTANTE: as vezes, o array com as opções estão no proprio select, as vezes o array com opções está onde setamos os states, em constructor(props). Repare que nesta página, as opções do select Tipo vem da api, entao nao há tradução (virá traduzido da API). Porem no campo Função, no selecte tem as opções. É importante que seja traduzido somente o label, o value deve SEMPRE se manter */
        Nome: "Nome",
        ValorH: "Valor/H",
        CodigoRubi: "Código Rubi",
        Tipo: "Tipo",
        Funcao: "Função",
        placeholder: {
          Nome: "Nome do cargo",
          ValorH: "Valor/H de treinamento do cargo",
          Tipo: "Tipo de operação",
          TipoFuncao: "Tipo de função",
        },
        opcoesFuncao: {
          /* acrescento um opcao antes de Funcao, para ficar claro do que se trata */
          Comandante: "Comandante",
          Copiloto: "Copiloto",
          Comissario: "Comissário",
        },
        ObrigatorioModeloDeCargo: "Obrigatório Modelo de cargo",
        ObrigatorioBase: "Obrigatório Base",
        ObrigatorioASO: "Obrigatório ASO",
        PagaDiaria: "Paga diária",
        tituloTiposDeCargo:
          "Tipos de cargo" /* repare que esse formulário tem um título entre os campos */,
        Tripulantes: "Tripulantes",
        CVODVO: "CVO / DVO",
        MestreDeCarga: "Mestre de carga",
        Mecanico: "Mecânico",
        Inspetor: "Inspetor",
        Administrativo: "Administrativo",
        botaoAdicionarCargo: "Adicionar cargo",
      },
    },
    EditarCargo: {
      /* mesmo processo de RolesIndex */
      atualizarSimilar:
        "Tem certeza de que deseja propagar os requisitos de certificados para os cargos equivalentes? O sistema irá substituir todos os requisitos dos cargos pelos atuais.",
      deletarEvento: "Tem certeza que deseja excluir este tipo de evento?",
      deletarSimilar:
        "Tem certeza que gostaria de deletar esse cargo relacionado?",
      deletarGrupo: "Tem certeza que gostaria de deletar esse grupo?",
      titulo: "Editar cargo",
      botaoAtualizarRequisitosDeCertificadosDeCargosEquivalentes:
        "Atualizar requisitos de certificados de cargos equivalentes",
      tabDados: {
        /* Repare que existe a tag <Tab eventKey={1} title="Dados">. Isso são tabs, tipo as que tem nas configurações do windows (Geral Avançado e etc), e o título dessa tab está dentro de title na tag Tab, e precisa ser traduzido*/
        tituloTab: "Dados",
        formulario: {
          /* lembre-se que as vezes o formulário de editar é diferente do de adicionar, as vezes tem campo em um e nao tem no outro, e isso pode gerar erros. Esses erros vao ser visíveis no terminal */
          Nome: "Nome",
          ValorH: "Valor/H",
          CodigoRubi: "Código Rubi",
          Tipo: "Tipo",
          Funcao: "Função",
          placeholder: {
            Registro: "Registro de cargo",
            SelectionarTipoOperacao: "Selecionar tipo de operação",
            SelectionarTipoFuncao: "Selecionar tipo de função",
          },
          opcoesFuncao: {
            /* acrescento um opcao antes de Funcao, para ficar claro do que se trata */
            Comandante: "Comandante",
            Copiloto: "Copiloto",
            Comissario: "Comissário",
          },
          ObrigatorioModeloDeCargo: "Obrigatório Modelo de cargo",
          ObrigatorioBase: "Obrigatório Base",
          ObrigatorioASO: "Obrigatório ASO",
          PagaDiaria: "Paga diária",
          tituloTiposDeCargo:
            "Tipos de cargo" /* repare que esse formulário tem um título entre os campos */,
          Tripulantes: "Tripulantes",
          CVODVO: "CVO / DVO",
          MestreDeCarga: "Mestre de carga",
          Mecanico: "Mecânico",
          Inspetor: "Inspetor",
          Administrativo: "Administrativo",
          botaoSalvarEdicao: "Salvar edição",
        },
      },
      tabCargosEquivalentes: {
        tituloTab: "Cargos equivalentes",
        formulario: {
          /* repare que há outro formulário na página. Como está dentro de um tab, vamos chamar apenas de formulario. Mas, se não fosse dentro de Tab, chamariamos de formularioCargosEquivalentes. Mesma coisa para a tabela abaixo */
          Cargo: "Cargo",
          placeholder: {
            SelecionarCargo: "Selecione o cargo",
          },

          botaoSalvarEdicao: "Salvar edição",
        },
        tabela: {
          Cargo: "Cargo",
          Acoes: "Ações",
        },
      },
      tabCertificados: {
        tituloTab: "Certificados",
        tituloAdicionarNovoGrupo: "Adicionar novo grupo",
        formulario: {
          Nome: "Nome",
          Tipo: "Tipo",
          placeholder: {
            NomeGrupo: "Nome do Grupo",
            SelecioneTipo: "Selecione o tipo",
          },
          opcoesTipo: {
            E: "E",
            OU: "OU",
          },
          botaoSalvarEdicao: "Salvar edição",
        },
        // embaixo desse formulário tem um componente que está na pasta Elements. Isso é comum. Nós vamos continuar aqui como se tudo estivesse na mesma página, dentro de uma iteração. Se em algum outro lugar isso acontecer e voce tiver duvidas, fale comigo.
        deletarCertificado:
          "Tem certeza que gostaria de deletar esse treinamento?",
        formularioEditarGrupo: {
          /* esse aqui é complicado. É um formulário dentro do componente e não está muito claro. Voce, possivelmente, erraria o nome. O que eu fiz: fui no botão de salvar do formulario e usei o nome que estava lá */
          Nome: "Nome",
          Tipo: "Tipo",
          opcoesTipo: {
            E: "E",
            OU: "OU",
          },
          botaoEditarGrupo: "Editar grupo",
        },
        formularioIncluirTreinamento: {
          /* Dei esse nome pelo motivo do de cima */ Treinamento: "Treinamento",
          botaoIncluirTreinamento: "Incluir treinamento",
        },
        tabelaGrupo: {
          /* E esse aqui? hahahaha é uma tabela de um grupo. Chamei de tabelaGrupo. Não precisa ser perfeito, mas tem que fazer sentido. E olha que eu sei exatamente do que se trata e poderia dar um nome perfeito, mas coloquei assim apenas para ilustrar como voce deve fazer */
          Treinamento: "Treinamento",
          Acoes: "Ações",
        },
      },
      tabEventos: {
        tituloTab: "Eventos",
        tituloAdicionarNovoEvento: "Adicionar novo tipo de evento",
        formulario: {
          Codigo: "Código",
          TipoEventos: "Tipos de Eventos",
          botaoSalvarTipoDeEvento: "Salvar tipo de evento",
          placeholder: {
            SelecioneTipo: "Selecione o tipo",
          },
          tabela: {
            ID: "Id.",
            Codigo: "Código.",
            TipoEvento: "Tipo de evento.",
            Acoes: "Ações",
          },
        },
      },
    },
  },

  EscalasDeBase: {

    ListaDeEscalasDeBase: {
      deletar: "Tem certeza que gostaria de deletar essa escala?",
      titulo: "Lista de escalas",
      botaoAdicionarEscala: "Adicionar escala",

      tabela: {
        semEscalasParaEsteMes: "Não há escalas cadastradas para este mês",
        ID: "ID",
        Referencia: "Referência",
        Acoes: "Ações",
      }
    },

    AdicionarEscalaDeBase: {
      titulo: "Cadastrar escala",

      formulario: {
        MesAno: "Mês/Ano",
        DataInicial: "Data inicial",
        DataFinal: "Data final",

        botaoSalvarEscalaDeBase: "Salvar escala de base",
      },
    },

    EditarEscalaDeBase: {

      trocarStatusParaVerificada: "Tem certeza que deseja trocar o status dessa grade para verificada?",
      trocarStatusParaAprovada: "Tem certeza que deseja trocar o status dessa grade para aprovada?",
      criarRevisaoDestaGrade: "Tem certeza que deseja criar uma revisão desta grade?",

      titulo: "Editar escala",

      botaoBloquearEscala: "Bloquear Escala",
      botaoDesbloquearEscala: "Desbloquear Escala",

      formulario: {
        DataInicial: "Data inicial",
        DataFinal: "Data final",
      },

      tituloGrades: "Grades",

      tabelaGrades: {
        Revisao: "Revisão",
        Status: "Status",
        Acoes: "Ações",
      },

      botaoMarcarComoVerificada: "Marcar como verificada",
      botaoMarcarComoAprovada: "Marcar como aprovada",
      botaoCriarRevisao: "Criar revisão",

      tituloRevisao: "Revisão",

      botaoConfirmarMudancaDeStatusParaVerificada: "Confirmar mudança de status para verificada",
      botaoAprovarEscala: "Aprovar escala",

      tabela: {
        Tripulante: "Tripulante",
        Designacao: "Designação",
        Base: "Base",
        DataInicial: "Data Inicial",
        DataFinal: "Data Final",
      }
    }
  },

  GradesDeEscala: {

    EditarGradeDeEscala: {
      naoEPossivelMudarAbaComEdicaoEmAberto: "Não é possível mudar de aba com uma edição em aberto. Salve ou descarte a edição para prosseguir.",
      descartarAlteracoes: "Tem certeza que deseja descartar as alterações?",
      salvarAlteracoes: "Tem certeza que deseja salvar as alterações?",

      titulo: "Edição de escala",

      botaoExibirAlertas: "Exibir alertas",
      botaoExibirAlertasDetalhados: "Exibir alertas detalhados",

      tabEscala: {
        tituloTab: "Escala",

        titulosAlternativos: {
          TripulacaoExtra: "Tripulacao Extra",
          Instrucao: "Instrução",
          ChefeDeEquipamento: "Chefe de equipamento",
          DispensaMedica: "Dispensa médica",
          Manutencao: "Manutenção",
          Ferias: "Férias",
          ForaDeEscala: "Fora de escala",
          Reserva: "Reserva",
        },

        removerAeronaveETodosSeusTripulantes: "Tem certeza que deseja remover esta aeronave e todos os seus tripulantes da escala?",
        adicionarLinhaNestaAeronave: "Tem certeza que deseja adicionar uma linha nesta aeronave?",
        removerLinhaDestaAeronave: "Tem certeza que deseja remover esta linha dessa aeronave?",
        removerTripulante: "Tem certeza que deseja remover este tripulante?",
        numeroDeRegimeNaoCadastrado: "Número de Regime não cadastrado",
        retirarTripulacaoDestaLinhaNestaAeronave: "Tem certeza que deseja retirar a tripulação desta linha nesta aeronave?",
        esteTripulanteJaEstaEscalado: "Este tripulante já está escalado nesta grade.",

        tituloEscala: "Escala",

        botaoAbrirEdicao: "Abrir Edição",
        botaoSalvarEdicao: "Salvar Edição",
        botaoDescartarMudancas: "Descartar Mudanças",

        nenhumaAeronaveEscalada: "Nenhuma aeronave escalada.",

        tabelaPrincipal: {
          Base: "Base",
          Aeronave: "Aeronave",
          Regime: "Regime",
          Grupo: "Grupo",
          Nome: "Nome",
          Matricula: "Mat.",
          Designacao: "Desig.",   

          tituloSelecioneUmaOpcao: "Selecione uma opção",
          botaoAlterarAsSiglasParaOPadraoDoRegime: "Alterar as siglas para o padrão do regime",
          botaoAlterarORegimeMantendoAsSiglas: "Alterar o regime mantendo as siglas",
          botaoCancelar: "Cancelar",

          staffIndisponivel: "Indisponível",
          staffNAOTRIPULADA: "NÃO TRIPULADA",

          tituloEscolherQuinzena: "Escolher quinzena",
          DataInicial: "Data inicial",
          botaoAdicionarAEscala: "Adicionar à escala",

          placeholder: {
            BAS: "BAS.",
            AER: "AER.",
            Indisponivel: "Indisponível",
            SelecionarRegime: "Seleciona regime",
            DataInicial: "Data inicial",
          },
        },

        tabelaAlternativa: {
          Nome: "Nome",
          Matricula: "Mat.",
          Designacao: "Desig.",
        },

        tituloTotais: "Totais",

        tabelaTotaisTripulacao: {
          Legenda: "Legenda",
          FaltandoComandantes: "Faltando Comandantes",
          SobrandoComandantes: "Sobrando Comandantes",
          FaltandoCopilotos: "Faltando Copilotos",
          SobrandoCopilotos: "Sobrando Copilotos",
          FaltandoComissarios: "Faltando Comissários",
          SobrandoComissarios: "Sobrando Comissários",
          QuantidadesCorretas: "Quantidades corretas",
        },

        tabelaTotaisAeronaves: {
          Base: "Base",
          Aircraft: "Acft.",
        },


      },

      tabAdicionarAeronave: {
        tituloTab: "Adicionar aeronave",

        tituloAeronavesDisponiveisParaEscalaDeTripulacao: "Aeronaves disponíveis para escala de tripulação",
        NenhumaAeronaveDisponivelCadastrada: "Nenhuma aeronave disponível cadastrada.",

        tabela: {
          Aeronave: "Aeronaves",
          Contrato: "Contrato",
        },

        tituloEscalarAeronave: "Escalar aeronave",
        
        formulario: {
          Aeronave: "Aeronave",
          Base: "Base",
          botaoEscalarAeronave: "Escalar aeronave",
        },

      },

      tabForaDaEscala: {
        tituloTab: "Fora da escala",

        tituloForaDeEscala: "Fora da escala",
        nenhumChefeDeEquipamentoDisponIvel: "Nenhum chefe de equipamento disponível.",

        tabela: {
          Tripulante: "Tripulante",
          Matricula: "Matrícula",
          Designacao: "Designação",
          AlocarNaEscala: "Alocar na escala",
        },

        formulario: {
          opcoesTipo: {
            FERIAS: "FÉRIAS",
            MEDICA: "MEDICA",
            MANUT: "MANUT",
            INS: "INS",
            FORA: "FORA",
            RESERVA: "RESERVA",
            EXTRA: "EXTRA",
          },

          placeholder: {
            DataInicial: "Data inicial",
            DataFinal: "Data final",
            Tipo: "Tipo",
            Sigla: "Sigla",
          }
        },
      },

      tabChefesDeEquipamento: {
        tituloTab: "Chefes de equipamento",

        tituloChefesDeEquipamento: "Chefes de equipamento",
        nenhumChefeDeEquipamentoDisponIvel: "Nenhum chefe de equipamento disponível.",

        tabela: {
          Tripulante: "Tripulante",
          Matricula: "Matrícula",
          Designacao: "Designação",
          AlocarNaEscala: "Alocar na escala",
        },

        placeholder: {
          DataInicial: "Data inicial",
          DataFinal: "Data final",
        },

        tituloSelecioneUmaSiglaParaPreencher: "Selecione uma sigla para preencher.",

        formulario: {
          Sigla: "Sigla",

          placeholder: {
            SelecionarSigla: "Selecionar sigla",
          }
        }
      },

      tabTreinamentos: {
        tituloTab: "Treinamentos",

        tituloTreinamentosPresenciaisDosTripulantesEscalados: "Treinamentos presenciais dos tripulantes escalados",
        naoHaTreinamentos: "Não há treinamentos.",

        tabela: {
          semTreinamentos: "Não há treinamentos.",
          ID: "ID",
          Matricula: "Mat.",
          NomeDeGuerra: "Nome de Guerra",
          Treinamento: "Treinamento",
          Codigo: "Código",
          Inicio: "Início",
          Fim: "Fim",
        }
      },

      tabSolicitacoes: {
        tituloTab: "Solicitações",

        reprovar: "Tem certeza que gostaria de reprovar essa solicitação?",
        aprovar: "Tem certeza que gostaria de aprovar essa solicitação?",

        tituloSolicitacoesDeTripulantes: "Solicitações de tripulantes",
        naohaSolicitacoes: "Não há solicitações.",

        tabela: {
          semSolicitacoes: "Não há solicitações cadastradas",
          ID: "ID",
          DataDeCriacao: "Data de Criação",
          NomeDoColaborador: "Nome do Colaborador",
          Inicio: "Início",
          Fim: "Fim",
          Justificativa: "Justificativa",
          ChefeDeFrotaDataResposta: "Chefe de Frota - Data Resposta",
          ChefeDeFrotaJustificativa: "Chefe de Frota - Justificativa",
        },

        tituloJustifiqueAReprovacao: "Justifique a reprovação",

        formulario: {
          botaoJustificar: "Justificar",
        },
      },

      tabSiglas: {
        tituloTab: "Siglas",

        tituloSiglas: "Siglas",
        nenhumaSiglaCadastrada: "Nenhuma sigla cadastrada.",

        tabela: {
          Sigla: "Sigla",
          Diaria: "Diária",
          Nome: "Nome",
          Descricao: "Descrição",
          Treinamento: "Treinamento",
        }
      },

      tituloRevisao: "Revisão",

      tabelaAeronave: {
        Aeronave: "Aeronave",
        Alerta: "Alerta",
      },

      tabelaNome: {
        NomeMatricula: "Nome (Matrícula)",
        Nom: "Nome",
        RegimeDeTrabalho: "Regime de Trabalho",
        Controlado: "Controlado",
        Alerta: "Alerta",
      }
    },

    EditarBaseDaGradeDeEscala: {
      deletar: "Tem certeza que deseja deletar esse representante de base?",
      
      titulo: "Edição de escala",

      formulario: {
        DataInicial: "Data inicial",
        DataFinal: "Data final",
        Funcionario: "Funcionário",
        Designacao: "Designação",
        Base: "Base",

        placeholder: {
          SelecionarFuncionario: "Selecionar funcionário",
          SelecionarBase: "Selecionar base",

        }
      },

      tabela: {
        Tripulante: "Tripulante",
        Designacao: "Designação",
        Base: "Base",
        DataInicial: "Data Inicial",
        DataFinal: "Data Final",
        Acoes: "Ações",
      }
    },

    GradesDeEscalaAlternativa: {
      descartarAlteracoes: "Tem certeza que deseja descartar as alterações?",
      salvarAlteracoes: "Tem certeza que deseja salvar as alterações?",

      titulo: "Edição de escala",
      botaoExibirAlertas: "Exibir alertas",

      tabEscala: {
        tituloTab: "Escala",

        titulosAlternativos: {
          TripulacaoExtra: "Tripulacao Extra",
          Instrucao: "Instrução",
          ChefeDeEquipamento: "Chefe de equipamento",
          DispensaMedica: "Dispensa médica",
          Manutencao: "Manutenção",
          Ferias: "Férias",
          ForaDeEscala: "Fora de escala",
          Reserva: "Reserva",
        },

        naoEPossivelAdicionarColaboradorEmModoDeEdicao: "Não é possível adicionar colaborador na escala em modo de edição",
        removerTripulante: "Tem certeza que deseja remover este tripulante?",

        tituloEscala: "Escala",

        formulario: {

          Funcionario: "Funcionário",
          Regime: "Regime",
          DataInicial: "Data inicial",

          botaoAdicionarAEscala: "Adicionar à escala",

          placeholder: {
            SelecionarFuncionario: "Selecionar funcionário",
            SelecionarRegime: "Selecionar regime",
            DataInicial: "Data inicial",
          }
        },

        botaoAbrirEdicao: "Abrir Edição",
        botaoSalvarEdicao: "Salvar Edição",
        botaoDescartarMudancas: "Descartar Mudanças",

        tituloEscalaPrincipal: "Escala principal",

        tabelaEscalaPrincipal: {
          Nome: "Nome",
          Matricula: "Mat.",
          Designacao: "Desig.",
        },

        tabelaEscalaAlternativa: {
          Nome: "Nome",
          Matricula: "Mat.",
          Designacao: "Desig.",
        }

      },
      
      tabForaDaEscala: {
        tituloTab: "Fora da escala",

        tituloForaDeEscala: "Fora da escala",

        nenhumChefeDeEquipamentoDisponIvel: "Nenhum chefe de equipamento disponível.",

        tabela: {
          Tripulante: "Tripulante",
          Matricula: "Matrícula",
          Funcao: "Função",
          AlocarNaEscala: "Alocar na escala",
        },

      },

      tabTreinamentos: {
        tituloTab: "Treinamentos",
      },

      tabSiglas: {
        tituloTab: "Siglas",
      },

      tituloRevisao: "Revisão",
    },

    GradesDeEscalaDeTreinamento: {

      descartarAlteracoes: "Tem certeza que deseja descartar as alterações?",
      salvarAlteracoes: "Tem certeza que deseja salvar as alterações?",

      titulo: "Edição de escala",

      botaoExibirAlertas: "Exibir alertas",
      botaoInclusaoAutomatica: "Inclusão automática",

      erros: "Os seguintes erros de preenchimento impediram o relatório de ser finalizado",

      tabEscala: {
        tituloTab: "Escala",

        naoEPossivelAdicionarColaboradorEmModoDeEdicao: "Não é possível adicionar colaborador na escala em modo de edição",
        removerTripulante: "Tem certeza que deseja remover este tripulante?",

        formulario: {
          Funcionario: "Funcionário",

          botaoAdicionarAEscala: "Adicionar à escala",

          placeholder: {
            SelecionarFuncionario: "Selecionar funcionário",
          }
        },

        casoSejaSelecionadaUmComunicadoDeTreinamentoNaSigla: "Caso seja selecionada um comunicado de treinamento na sigla, esta irá gerar pagamento de diária de treinamento nacional para o colaborador. Se não tiver certeza do treinamento, ou caso não queira gerar a diária automaticamente, preencha com uma sigla de treinamento ao invés da sigla de comunicado.",

        tituloEscala: "Escala",

        botaoAbrirEdicao: "Abrir Edição",
        botaoSalvarEdicao: "Salvar Edição",
        botaoDescartarMudancas: "Descartar Mudanças",

        tabela: {
          Nome: "Nome",
          Matricula: "Matr.",
          Designacao: "Desig.",

        }



      },

      tabFerias: {
        tituloTab: "Férias",

        tituloEscala: "Escala",

        formulario: {
          Funcionario: "Funcionário",
          DataInicial: "Data inicial",
          DataFinal: "Data final",

          botaoAdicionarAEscala: "Adicionar à escala",

          placeholder: {
            SelecionarFuncionario: "Selecionar funcionário",
            DataInicial: "Data inicial",
            DataFinal: "Data final",
          }
        },

        tabela: {
          Turma: "Turma",
          Nome: "Nome",
          Matricula: "Matrícula",
          Designacao: "Designação",

        },

        removerTripulante: "Tem certeza que deseja remover este tripulante desta escala?",
      },

      tabSiglas: {
        tituloTab: "Siglas",
      },

      tabTreinamentos: {
        tituloTab: "Treinamentos",

        tituloTreinamentosAssociadosATripulantesEscalados: "Treinamentos Associados a Tripulantes Escalados",

        naoHaTreinamentos: "Não há treinamentos.",

        tabelaTreinamentosAssociadosATripulantesEscalados: {
          semTreinamentos: "Não há treinamentos.",
          ID: "ID",
          Tripulante: "Tripulante",
          Treinamento: "Treinamento",
          Codigo: "Código",
          Certificado: "Certificado",
          DataInicial: "Data inicial",
          DataFinal: "Data final",
        },

        tituloTreinamentosElegiveis: "Treinamentos Elegíveis",

        tabelaTreinamentosElegiveis: {
          semTreinamentos: "Não há treinamentos.",
          ID: "ID",
          Tripulante: "Tripulante",
          Treinamento: "Treinamento",
          Codigo: "Código",
          Certificado: "Certificado",
          DataInicial: "Data inicial",
          DataFinal: "Data final",
        }

      },

      tituloRevisao: "Revisão",

      tabelarRevisao: {
        Nome: "Nome",
        Alerta: "Alerta",
      },

      tituloSelecioneOsTripulantesParaAdicionarAEscala: "Selecione os tripulantes para adicionar a escala",

      tabelaAdicionarTripulantes: {
        semTreinamentos: "Não há treinamentos.",
        ID: "ID",
        Tripulante: "Tripulante",
        Treinamento: "Treinamento",
        Certificado: "Certificado",
        Codigo: "Código",
        Periodo: "Período",
      },

      botaoIncluirColaboradores: "Incluir colaboradores",



    },

    GradesDeEscalaAlertas: {
      ListaGradesDeEscalaAlertas: {
        titulo: 'Alertas de escala',
        ativar: 'Tem certeza que gostaria de marcar como controlado esse alerta?',
        arquivar: 'Tem certeza que gostaria de desmarcar o controlado desse alerta?',
        tabela: {
          ID: 'ID',
          Cor: 'Cor',
          Tipo: 'Tipo',
          Mat: 'Mat.',
          Nome: 'Nome',
          Regime: 'Regime',
          Aeronave: 'Aeronave',
          Responsavel: 'Responsável',
          Controlado: 'Controlado',
          Alerta: 'Alerta',
          Comentarios: 'Comentários',
          Acoes: 'Ações',
        }
      },

      modal: {
        titulo: 'Editar comentários',
        tituloComentarios: 'Comentários',
        ComentariosAlerta: 'Comentários do alerta',
        form: {
          Comentario: 'Comentário',
        },
        tabela: {
          Autor: 'Autor',
          Mensagem: 'Mensagem',
        }

      },
    },

  },

  Siglas: {
    
    ListaDeSiglas: {

      deletar: "Tem certeza que gostaria de deletar essa sigla?",
      titulo: "Lista de siglas",
      botaoAdicionarSigla: "Adicionar sigla",

      tabela: {
        semSiglas: "Não há siglas cadastrados",
        ID: "ID",
        Sigla: "Sigla",
        Nome: "Nome",
        Descricao: "Descrição",
        Diaria: "Diária",
        Acoes: "Ações",
      }
    },

    AdicionarSigla: {

      titulo: "Cadastrar sigla",
      
      formulario: {
        Sigla: "Sigla",
        NomeInteiro: "Nome inteiro",
        Descricao: "Descrição",
        ContaDiaria: "Conta diária",
        TripulaAeronave: "Tripula a Aeronave",
        SiglaDeTreinamento: "Sigla de treinamento",
        SiglaDeTripulacaoExtra: "Sigla de tripulação extra",
        SiglaDeFerias: "Sigla de férias",
        SiglaDeFolga: "Sigla de folga",
        SiglaDeApresentacao: "Sigla de apresentação",
        SiglaOficialASerUsadaEmEscala: "Sigla oficial a ser usada em escala",
        SiglaOficialASerUsadaNaEscalaDiaria: "Sigla oficial a ser usada na Escala Diária",
        SiglaDeSobreaviso: "Sigla de sobreaviso",
        SiglaDeReserva: "Sigla de reserva",
        SelecioneACorDeFundo: "Selecione a cor de fundo",
        SelecioneACorDaFonte: "Selecione a cor da fonte",

        botaoAdicionarSigla: "Adicionar sigla",

        placeholder: {
          Sigla: "Sigla",
          NomeInteiro: "Nome inteiro",
        }
      }
    },

    EditarSigla: {
      titulo: "Editar sigla",

      formulario: {
        Sigla: "Sigla",
        NomeInteiro: "Nome inteiro",
        Descricao: "Descrição",
        ContaDiaria: "Conta diária",
        TripulaAeronave: "Tripula a Aeronave",
        SiglaDeTreinamento: "Sigla de treinamento",
        SiglaDeTripulacaoExtra: "Sigla de tripulação extra",
        SiglaDeFerias: "Sigla de férias",
        SiglaDeFolga: "Sigla de folga",
        SiglaDeApresentacao: "Sigla de apresentação",
        SiglaOficialASerUsadaEmEscala: "Sigla oficial a ser usada em escala",
        SiglaOficialASerUsadaNaEscalaDiaria: "Sigla oficial a ser usada na Escala Diária",
        SiglaDeSobreaviso: "Sigla de sobreaviso",
        SiglaDeReserva: "Sigla de reserva",
        SelecioneACorDeFundo: "Selecione a cor de fundo",
        SelecioneACorDaFonte: "Selecione a cor da fonte",

        placeholder: {
          Sigla: "Sigla",
          NomeInteiro: "Nome inteiro",
        }
      }
    }

  },

  PagamentosDeEscala: {

    PagamentosEmAbertoRepresentanteOperacional: {
      botaoCadastrarPagamento: "Cadastrar pagamento",
      
      eNecessarioSelecionarUmaOP: "É necessário selecionar uma OP para executar essa ação",
      deletarPagamentos: "Tem certeza que gostaria de deletar os pagamentos selecionados?",

      titulo: "Pagamentos em aberto - representante operacional",

      formulario: {
        OrdemDePagamento: "Ordem de pagamento",

        botaoAdicionarAOrdemDePagamento: "Adicionar a ordem de pagamento",
        botaoDeletarPagamentos: "Deletar pagamentos",

        placeholder: {
          SelecionarOrdemDePagamento: "Selecionar ordem de pagamento",
        }
      },

      tabela: {
        semPagamentosEmAberto: "Não há pagamentos em aberto",
        Acoes: "Ações",
        ID: "ID",
        Credito: "Crédito",
        Nome: "Nome",
        BaseContratual: "Base Contratual",
        BaseOperacional: "Base Operacional",
        Regime: "Regime",
        Mes: "Mês",
        Revisao: "Revisão",
        ValorReferencia: "Valor/Referência",
        Quantidade: "Quantidade",
        ValorTotal: "Valor Total",
        Moeda: "Moeda",
      },

      deletarEsseDia: "Tem certeza que deseja deletar esse dia?",

      tituloEditarPagamento: "Editar pagamento",

      formularioEditarPagamento: {

        Escala: "Escala",
        Revisao: "Revisão",
        Local: "Local",
        Tripulante: "Tripulante",
        ValorReferencia: "Valor/Referência",
        Quantidade: "Quantidade",
        Moeda: "Moeda",
        ValorTotal: "Valor Total",
        Observacao: "Observação",
        IgnorarSaldoDevedor: "Ignorar saldo devedor",
        JustificativaDeEdicao: "Justificativa de edição",

        botaoSalvarPagamento: "Salvar pagamento",

        placeholder: {
          Local: "Local",
          Tripulante: "Tripulante",
          Moeda: "Moeda",
          Observacao: "Observação",
          JustifiqueAEdicao: "Justifique a edição",
        }
      },


      tituloLogDeEdicoesDoPagamento: "Log de edições do pagamento",

      tabelaLogDeEdicoesDoPagamento: {

        Id: "Id",
        QuantidadeAnterior: "Quantidade - Anterior",
        QuantidadeEditada: "Quantidade - Editada",
        ValorUnitarioAnterior: "Valor unitário - Anterior",
        ValorUnitarioEditado: "Valor unitário - Editado",
        ValorTotalAnterior: "Valor total - Anterior",
        ValorTotalEditado: "Valor total - Editado",
        StatusDeSaldoDevedorAnterior: "Status de Saldo Devedor - Anterior",
        StatusDeSaldoDevedorEditado: "Status de Saldo Devedor - Editado",
        Usuario: "Usuário",
        Justificativa: "Justificativa",
        Data: "Data",
      },
    },

    AdicionarPagamentoEscala: {
      opcoesMoedas: {
        Euro: "Euro",
        Dolar: "Dólar",
        Real: "Real",
      },

      titulo: "Adicionar pagamento - escala",

      formulario: {
        EscalaGrade: "Escala / Grade",
        Tripulante: "Tripulante",
        DiariaValor: "Diária valor",
        DiariasPagas: "Diárias pagas",
        DiariaMoeda: "Diária moeda",
        DiariaTotal: "Diária total",  
        Observacao: "Observação",
        IgnorarSaldoDevedor: "Ignorar saldo devedor",

        botaoSalvarPagamento: "Salvar pagamento",

        placeholder: {
          SelecionarEscala: "Selecionar escala",
          SelecionarTripulante: "Selecionar tripulante",
          SelecionarMoeda: "Selecionar moeda",
          Observacao: "Observação",
        },
      }

    }, 

    AdicionarPagamentoRepresentanteOperacional: {
      opcoesMoedas: {
        Euro: "Euro",
        Dolar: "Dólar",
        Real: "Real",
      },

      titulo: "Adicionar pagamento - representante operacional",
      
      formulario: {
        EscalaGrade: "Escala / Grade",
        Tripulante: "Tripulante",
        ValorReferencia: "Valor/Referência",
        Quantidade: "Quantidade",
        Moeda: "Moeda",
        ValorTotal: "Valor total",  
        Observacao: "Observação",
        IgnorarSaldoDevedor: "Ignorar saldo devedor",

        botaoSalvarPagamento: "Salvar pagamento",

        placeholder: {
          SelecionarEscala: "Selecionar escala",
          SelecionarTripulante: "Selecionar tripulante",
          SelecionarMoeda: "Selecionar moeda",
          Observacao: "Observação",
        },
      }

    }, 

    PagamentosEmAbertoDiariasDeMissao: {
      botaoCadastrarPagamento: "Cadastrar pagamento",

      eNecessarioSelecionarUmaOP: "É necessário selecionar uma OP para executar essa ação",
      deletarPagamentosSelecionados: "Tem certeza que gostaria de deletar os pagamentos selecionados?",

      titulo: "Pagamentos em aberto - diárias de missão",

      formulario: {

        OrdemDePagamento: "Ordem de pagamento",
        botaoAdicionarAOrdemDePagamento: "Adicionar a ordem de pagamento",
        botaoDeletarPagamentos: "Deletar pagamentos",

        placeholder: {
          SelecionarOrdemDePagamento: "Selecionar ordem de pagamento",
        }
      },

      tabela: {
        semPagamentosEmAberto: "Não há pagamentos em aberto",
        Acoes: "Ações",
        ID: "ID",
        Credito: "Crédito",
        Nome: "Nome",
        Regime: "Regime",
        Frota: "Frota",
        Mes: "Mês",
        BaseContratual: "Base Contratual",
        BaseOperacional: "Base Operacional",
        Revisao: "Revisão",
        ValorDiaria: "Valor/diária",
        Diarias: "Diárias",
        TotalEmDiarias: "Total em diárias",
        Moeda: "Moeda",
      },


      deletarEsseDia: "Tem certeza que deseja deletar esse dia?",

      tituloEditarPagamento: "Editar pagamento",

      formularioEditarPagamento: {

        Escala: "Escala",
        Revisao: "Revisão",
        Local: "Local",
        Tripulante: "Tripulante",
        DiariaValor: "Diária valor",
        DiariasPagas: "Diárias pagas",
        DiariaMoeda: "Diária moeda",
        DiariaTotal: "Diária total",
        Observacao: "Observação",
        IgnorarSaldoDevedor: "Ignorar saldo devedor",
        JustificativaDeEdicao: "Justificativa de edição",

        botaoSalvarPagamento: "Salvar pagamento",

        placeholder: {
          Local: "Local",
          Tripulante: "Tripulante",
          Moeda: "Moeda",
          Observacao: "Observação",
          JustifiqueAEdicao: "Justifique a edição",
        }
      },

      tituloAdicionarDia: "Adicionar dia",
      
      formularioAdicionarDia: {
        Data: "Data",
        Coeficiente: "Coeficiente",
        
        botaoSalvarDia: "Salvar dia",
      },

      tabelaAdicionarDia: {
        Dia: "Dia",
        Coeficiente: "Coeficiente",
        Acoes: "Ações",
      },

      tituloLogDeEdicoesDoPagamento: "Log de edições do pagamento",

      tabelaLogDeEdicoesDoPagamento: {
        Id: "Id",
        QuantidadeAnterior: "Quantidade - Anterior",
        QuantidadeEditada: "Quantidade - Editada",
        ValorUnitarioAnterior: "Valor unitário - Anterior",
        ValorUnitarioEditado: "Valor unitário - Editado",
        ValorTotalAnterior: "Valor total - Anterior",
        ValorTotalEditado: "Valor total - Editado",
        StatusDeSaldoDevedorAnterior: "Status de Saldo Devedor - Anterior",
        StatusDeSaldoDevedorEditado: "Status de Saldo Devedor - Editado",
        Usuario: "Usuário",
        Justificativa: "Justificativa",
        Data: "Data",
      }
    },

    PagamentosEmAbertoDiariasInternacional: {
      deletar: "Tem certeza que gostaria de deletar os pagamentos selecionados?",

      titulo: "Pagamentos em aberto - diárias",
      tituloInternacional: "Internacional",

      formulario: {
        OrdemDePagamento: "Ordem de pagamento",
        
        botaoAdicionarAOrdemDePagamento: "Adicionar a ordem de pagamento",
        botaoDeletarPagamentos: "Deletar pagamentos",

        placeholder: {
          SelecionarOrdemDePagamento: "Selecionar ordem de pagamento",
        }
      },

      tabela: {
        semPagamentosEmAberto: "Não há pagamentos em aberto",
        Acoes: "Ações",
        ID: "ID",
        Nome: "Nome",
        Regime: "Regime",
        Periodo: "Período",
        Treinamento: "Treinamento",
        NumeroERev: "Nº e Rev.",
        Diarias: "Diárias",
        ValorDiaria: "Valor/diária",
        TotalEmDiarias: "Total em diárias",
        Moeda: "Moeda",
      }
    },

    AdicionarPagamentoDeslocamento:{
      opcoesMoedas: {
        Euro: "Euro",
        Dolar: "Dólar",
        Real: "Real",
      },

      titulo: "Adicionar pagamento - deslocamento",

      formulario: {
        EscalaGrade: "Escala / Grade",
        Tripulante: "Tripulante",
        DistanciaKm: "Distância (km)",
        ValorKm: "Valor/km",
        Moeda: "Moeda",
        ValorTotal: "Valor total",
        Observacao: "Observação",
        IgnorarSaldoDevedor: "Ignorar saldo devedor",

        botaoSalvarPagamento: "Salvar pagamento",

        placeholder: {
          SelecionarEscala: "Selecionar escala",
          SelecionarTripulante: "Selecionar tripulante",
          SelecionarMoeda: "Selecionar moeda",
          ValorTotal: "Valor total",
          Observacao: "Observação",
        }
      },

    },

    PagamentosEmAbertoIndenizacaoDeDeslocamento: {
      botaoCadastrarPagamento: "Cadastrar pagamento",

      eNecessarioSelecionarUmaOP: "É necessário selecionar uma OP para executar essa ação",
      deletarPagamentosSelecionados: "Tem certeza que gostaria de deletar os pagamentos selecionados?",

      titulo: "Pagamentos em aberto - indenização de deslocamento",

      formulario: {

        OrdemDePagamento: "Ordem de pagamento",
        botaoAdicionarAOrdemDePagamento: "Adicionar a ordem de pagamento",
        botaoDeletarPagamentos: "Deletar pagamentos",

        placeholder: {
          SelecionarOrdemDePagamento: "Selecionar ordem de pagamento",
        }
      },

      tabela: {
        semPagamentosEmAberto: "Não há pagamentos em aberto",
        Acoes: "Ações",
        ID: "ID",
        Credito: "Crédito",
        Nome: "Nome",
        Frota: "Frota",
        Regime: "Regime",
        Mes: "Mês",
        BaseContratual: "Base Contratual",
        BaseOperacional: "Base Operacional",
        Revisao: "Revisão",
        Distancia: "Distância",
        Valor: "Valor",
        Total: "Total",
        Moeda: "Moeda",
      },

      deletarEsseDia: "Tem certeza que deseja deletar esse dia?",

      tituloEditarPagamento: "Editar pagamento",

      formularioEditarPagamento: {
        Escala: "Escala",
        CodigoDoTreinamento: "Código do treinamento",
        Local: "Local",
        Tripulante: "Tripulante",
        Valor: "Valor",
        DistanciaKm: "Distância (Km)",
        Moeda: "Moeda",
        Total: "Total",
        Observacao: "Observação",
        IgnorarSaldoDevedor: "Ignorar saldo devedor",
        JustificativaDeEdicao: "Justificativa de edição",
        
        botaoSalvarPagamento: "Salvar pagamento",

        placeholder: {
          Local: "Local",
          Tripulante: "Tripulante",
          Moeda: "Moeda",
          Observacao: "Observação",
          JustifiqueAEdicao: "Justifique a edição",
        }
      },

      tituloLogDeEdicoesDoPagamento: "Log de edições do pagamento",

      tabelaLogDeEdicoesDoPagamento: {
        Id: "Id",
        QuantidadeAnterior: "Quantidade - Anterior",
        QuantidadeEditada: "Quantidade - Editada",
        ValorUnitarioAnterior: "Valor unitário - Anterior",
        ValorUnitarioEditado: "Valor unitário - Editado",
        ValorTotalAnterior: "Valor total - Anterior",
        ValorTotalEditado: "Valor total - Editado",
        StatusDeSaldoDevedorAnterior: "Status de Saldo Devedor - Anterior",
        StatusDeSaldoDevedorEditado: "Status de Saldo Devedor - Editado",
        Usuario: "Usuário",
        Justificativa: "Justificativa",
        Data: "Data",
      },
    },

    AdicionarPagamentoExtra: {
      opcoesMoedas: {
        Euro: "Euro",
        Dolar: "Dólar",
        Real: "Real",
      },

      titulo: "Adicionar pagamento - extra",

      formulario: {
        EscalaGrade: "Escala / Grade",
        Tripulante: "Tripulante",
        Quantidade: "Quantidade",
        Valor: "Valor",
        Moeda: "Moeda",
        ValorTotal: "Valor total",
        Observacao: "Observação",

        botaoSalvarPagamento: "Salvar pagamento",

        placeholder: {
          SelecionarEscala: "Selecionar escala",
          SelecionarTripulante: "Selecionar tripulante",
          SelecionarMoeda: "Selecionar moeda",
          Observacao: "Observação",
        }
      }


    },

    PagamentosEmAbertoExtra: {
      botaoCadastrarPagamento: "Cadastra pagamento",

      eNecessarioSelecionarUmaOP: "É necessário selecionar uma OP para executar essa ação",
      deletarPagamentosSelecionados: "Tem certeza que gostaria de deletar os pagamentos selecionados?",

      titulo: "Pagamentos em aberto - extra",

      formulario: {

        OrdemDePagamento: "Ordem de pagamento",
        botaoAdicionarAOrdemDePagamento: "Adicionar a ordem de pagamento",
        botaoDeletarPagamentos: "Deletar pagamentos",

        placeholder: {
          SelecionarOrdemDePagamento: "Selecionar ordem de pagamento",
        }
      },

      tabela: {
        semPagamentosEmAberto: "Não há pagamentos em aberto",
        Acoes: "Ações",
        ID: "ID",
        Credito: "Crédito",
        Nome: "Nome",
        Regime: "Regime",
        Frota: "Frota",
        Mes: "Mês",
        BaseContratual: "Base Contratual",
        BaseOperacional: "Base Operacional",
        Revisao: "Revisão",
        Quantidade: "Quantidade",
        Valor: "Valor",
        Total: "Total",
        Moeda: "Moeda",
      },
      
      deletarEsseDia: "Tem certeza que deseja deletar esse dia?",

      tituloEditarPagamento: "Editar pagamento",

      formularioEditarPagamento: {
        Escala: "Escala",
        Revisao: "Revisão",
        Local: "Local",
        Tripulante: "Tripulante",
        Valor: "Valor",
        Quantidade: "Quantidade",
        Moeda: "Moeda",
        Total: "Total",
        Observacao: "Observação",
        JustificativaDeEdicao: "Justificativa de edição",
        
        botaoSalvarPagamento: "Salvar pagamento",

        placeholder: {
          Local: "Local",
          Tripulante: "Tripulante",
          Moeda: "Moeda",
          Observacao: "Observação",
          JustifiqueAEdicao: "Justifique a edição",
        }
      },

      tituloLogDeEdicoesDoPagamento: "Log de edições do pagamento",

      tabelaLogDeEdicoesDoPagamento: {
        Id: "Id",
        QuantidadeAnterior: "Quantidade - Anterior",
        QuantidadeEditada: "Quantidade - Editada",
        ValorUnitarioAnterior: "Valor unitário - Anterior",
        ValorUnitarioEditado: "Valor unitário - Editado",
        ValorTotalAnterior: "Valor total - Anterior",
        ValorTotalEditado: "Valor total - Editado",
        StatusDeSaldoDevedorAnterior: "Status de Saldo Devedor - Anterior",
        StatusDeSaldoDevedorEditado: "Status de Saldo Devedor - Editado",
        Usuario: "Usuário",
        Justificativa: "Justificativa",
        Data: "Data",
      },

      
    },

    ListaDePagamentosEmAbertoHoras: {

      deletarPagamentosSelecionados: "Tem certeza que gostaria de deletar os pagamentos selecionados?",

      titulo: "Lista de pagamentos em aberto - horas",

      botaoCadastrarPagamento: "Cadastrar pagamento",

      formulario: {
        OrdemDePagamento: "Ordem de pagamento",
        botaoAdicionarAOrdemDePagamento: "Adicionar a ordem de pagamento",
        botaoDeletarPagamentos: "Deletar pagamentos",

        placeholder: {
          SelecionarOrdemDePagamento: "Selecionar ordem de pagamento",
        }
      },

      tabela: {
        semPagamentosEmAberto: "Não há pagamentos em aberto",
        Acoes: "Ações",
        ID: "ID",
        Nome: "Nome",
        TipoDeTreinamento: "Tipo de trein.",
        Aula: "Aula",
        Periodo: "Período",
        Treinamento: "Treinamento",
        NumeroERev: "Nº e Rev.",
        Local: "Local",
        HorasPagas: "Horas pagas",
        ValorDaHora: "Valor da hora",
        TotalDeHoras: "Total de horas",
      },

      tituloEditarPagamento: "Editar pagamento",

      formularioEditarPagamento: {
        NomeDoTreinamento: "Nome do Treinamento",
        Aula: "Aula",
        DataInicial: "Data inicial",
        DataFinal: "Data final",
        Local: "Local",
        Tripulante: "Tripulante",
        HorasPagas: "Horas pagas",
        HorasPNFPagas: "Horas PNF pagas",
        HorasDobradas: "Horas dobradas",
        ValorHora: "Valor hora",
        TotalPago: "Total Pago",

        botaoSalvarPagamento: "Salvar pagamento",
      }
    },

    AdicionarPagamentoHoras: {
      titulo: "Adicionar pagamento",

      formulario: {
        Treinamento: "Treinamento",
        Aula: "Aula",
        CodigoDoTreinamento: "Código do treinamento",
        Tipo: "Tipo",
        DataInicial: "Data inicial",
        DataFinal: "Data final",
        Local: "Local",
        Tripulante: "Tripulante",
        HorasPagas: "Horas pagas",
        HorasPNFPagas: "Horas PNF pagas",
        HorasDobradas: "Horas dobradas",
        ValorHora: "Valor hora",
        TotalPago: "Total Pago",

        botaoSalvarPagamento: "Salvar pagamento",

        placeholder: {
          SelecionarTreinamento: "Selecionar treinamento",
          SelecionarAula: "Selecionar aula",
          SelecionarTipo: "Selecionar tipo",
          Local: "Local",
          SelecionarTripulante: "Selecionar tripulante",
        },

      }
    },

    AdicionarPagamentoTransporte: {
      opcoesMoedas: {
        Euro: "Euro",
        Dolar: "Dólar",
        Real: "Real",
      },

      titulo: "Adicionar pagamento - transporte",

      formulario: {
        EscalaGrade: "Escala / Grade",
        Tripulante: "Tripulante",
        Quantidade:"Quantidade",
        Valor: "Valor",
        Moeda: "Moeda",
        ValorTotal: "Valor total",
        Observacao: "Observação",
        IgnorarSaldoDevedor: "Ignorar saldo devedor",

        botaoSalvarPagamento: "Salvar pagamento",

        placeholder: {
          SelecionarEscala: "Selecionar escala",
          SelecionarTripulante: "Selecionar tripulante",
          SelecionarMoeda: "Selecionar moeda",
          Observacao: "Observação",
        }
      }
    },

    PagamentosEmAbertoIndenizacaoDeTransporte: {
      botaoCadastrarPagamento: "Cadastrar pagamento",

      eNecessarioSelecionarUmaOP: "É necessário selecionar uma OP para executar essa ação",
      deletarPagamentosSelecionados: "Tem certeza que gostaria de deletar os pagamentos selecionados?",

      titulo: "Pagamentos em aberto - indenização de transporte",

      formulario: {

        OrdemDePagamento: "Ordem de pagamento",
        botaoAdicionarAOrdemDePagamento: "Adicionar a ordem de pagamento",
        botaoDeletarPagamentos: "Deletar pagamentos",

        placeholder: {
          SelecionarOrdemDePagamento: "Selecionar ordem de pagamento",
        }
      },

      tabela: {
        semPagamentosEmAberto: "Não há pagamentos em aberto",
        Acoes: "Ações",
        ID: "ID",
        Credito: "Crédito",
        Nome: "Nome",
        Regime: "Regime",
        Frota: "Frota",
        Mes: "Mês",
        BaseContratual: "Base Contratual",
        BaseOperacional: "Base Operacional",
        Revisao: "Revisão",
        Quantidade: "Quantidade",
        Valor: "Valor",
        Total: "Total",
        Moeda: "Moeda",
      },

      deletarEsseDia: "Tem certeza que deseja deletar esse dia?",

      tituloEditarPagamento: "Editar pagamento",

      formularioEditarPagamento: {
        Escala: "Escala",
        Revisao: "Revisão",
        Local: "Local",
        Tripulante: "Tripulante",
        Valor: "Valor",
        Quantidade: "Quantidade",
        Moeda: "Moeda",
        Total: "Total",
        Observacao: "Observação",
        IgnorarSaldoDevedor: "Ignorar saldo devedor",
        JustificativaDeEdicao: "Justificativa de edição",
        
        botaoSalvarPagamento: "Salvar pagamento",

        placeholder: {
          Local: "Local",
          Tripulante: "Tripulante",
          Moeda: "Moeda",
          Observacao: "Observação",
          JustifiqueAEdicao: "Justifique a edição",
        }
      },

      tituloLogDeEdicoesDoPagamento: "Log de edições do pagamento",

      tabelaLogDeEdicoesDoPagamento: {
        Id: "Id",
        QuantidadeAnterior: "Quantidade - Anterior",
        QuantidadeEditada: "Quantidade - Editada",
        ValorUnitarioAnterior: "Valor unitário - Anterior",
        ValorUnitarioEditado: "Valor unitário - Editado",
        ValorTotalAnterior: "Valor total - Anterior",
        ValorTotalEditado: "Valor total - Editado",
        StatusDeSaldoDevedorAnterior: "Status de Saldo Devedor - Anterior",
        StatusDeSaldoDevedorEditado: "Status de Saldo Devedor - Editado",
        Usuario: "Usuário",
        Justificativa: "Justificativa",
        Data: "Data",
      },
    },
  },

  PendenciasDeEscala: {

    ListaDePendenciasArquivadas: {
      titulo: "Lista de Pendências Arquivadas",

      tabela: {
        semSolicitacoes: "Não há solicitações cadastradas",
        Acoes: "Ações",
        ID: "ID",
        Data: "Data",
        Matricula: "Matrícula",
        Nome: "Nome",
        EscalaDiariaID: "Escala Diária - ID",
        EscalaDiariaBase: "Escala Diária - Base",
        RelatorioDeVooID: "Relatório de Voo - ID",
        RelatorioDeVooBase: "Relatório de Voo - Base",
        EscalaDeMissao: "Escala de Missão",
        EscalaDeMissaoBase: "Escala de Missão - Base",
        ArquivadaEm: "Arquivada em",
        Usuario: "Usuário",
      }

    },

    ListaDePendenciasNaoResolvidas: {
      arquivarPendencia: "Tem certeza que gostaria de arquivar essa pendência?",
      botaoArquivar: "Arquivar",

      titulo: "Lista de Pendências - Não resolvidas",

      tabela: {
        semPendencias: "Não há pendências restantes",
        Acoes: "Ações",
        ID: "ID",
        Data: "Data",
        Matricula: "Matrícula",
        Nome: "Nome",
        EscalaDiariaID: "Escala Diária - ID",
        EscalaDiariaBase: "Escala Diária - Base",
        RelatorioDeVooID: "Relatório de Voo - ID",
        RelatorioDeVooBase: "Relatório de Voo - Base",
        EscalaDeMissao: "Escala de Missão",
        EscalaDeMissaoBase: "Escala de Missão - Base",


      }

    }
    
  },

  RegimesDeEscala: {

    RegimesDeTrabalho: {

      opcoesRegimes: {
        Escala: "Escala",
        Administrativo: "Administrativo",
      },

      opcoesTitulo: {
        MestreDeCarga: "Mestre de carga",
        CVODVO: "CVO/DVO",
        EscalaDeTripulantes: "Escala de tripulantes",
      },

      titulo: "Regimes de trabalho",

      formulario: {
        Nome: "Nome",
        RegimeDeTrabalho: "Regime de trabalho",
        DiasDeMissao: "Dias de missão",
        DiasDeFolga: "Dias de folga",
        IdEscalaRubi: "Id Escala - Rubi",
        IdTurmaRubi: "Id Turma - Rubi",

        botaoSalvarRegime: "Salvar regime",

        placeholder: {
          Nome: "Nome",
          SelecionarTipoDeRegime: "Selecionar tipo de regime",
          DiasDeMissao: "Dias de missão",
          DiasDeFolga: "Dias de folga",
          IdEscalaRubi: "Id Escala - Rubi",
          IdTurmaRubi: "Id Turma - Rubi",
        }
      },

      tabela: {
        Nome: "Nome",
        IdRubiEscala: "Id Rubi Escala",
        IdRubiTurma: "Id Rubi Turma",
        RegimeDeTrabalho: "Regime de trabalho",
        DiasDeMissao: "Dias de missão",
        DiasDeFolga: "Dias de folga",
        Acoes: "Ações",

        placeholder: {
          Nome: "Nome",
          IdEscalaRubi: "Id Escala - Rubi",
          IdTurmaRubi: "Id Turma - Rubi",
          SelecionarRegime: "Selecionar regime",
        }
      }
    },
  },

  Escalas: {

    ListaDeEscalasCVODVO: {
      botaoDuplicar: "Duplicar",
      deletar: "Tem certeza que gostaria de deletar essa escala?",

      titulo: "Lista de escalas - CVO/DVO",

      botaoAdicionarEscala: "Adicionar escala",

      tabela: {
        semEscalasEsteMes: "Não há escalas cadastradas para este mês",
        ID: "ID",
        Base: "Base",
        Empresa: "Empresa",
        Referencia: "Referência",
        Acoes: "Ações",
      }
    },

    DuplicarEscalaCVODVO: {
      aguardeEnquantoAEscalaEDuplicada: "Aguarde enquanto a escala é duplicada. Este processo pode levar alguns minutos.",
      titulo: "Duplicar escala",

      formulario: {
        MesAno: "Mês/Ano",
        DataInicial: "Data inicial",
        DataFinal: "Data final",

        tituloRegimesDaEscala: "Regimes da escala",
        
        botaoSalvarDuplicacao: "Salvar duplicação",
      }
    },

    AdicionarEscalaCVODVO: {
      titulo: "Cadastrar escala - CVO/DVO",

      formulario: {
        MesAno: "Mês/ano",
        Base: "Base",
        Empresa: "Empresa",
        DataInicial: "Data inicial",
        DataFinal: "Data final",

        botaoSalvarEscala: "Salvar escala",
      }
    },

    EditarEscalaCVODVO: {
      efetivarGrade: "Tem certeza que deseja efetivar esta grade? Esta ação é irreversível.",
      trocarStatusDessaGradeParaVerificada: "Tem certeza que deseja trocar o status dessa grade para verificada?",
      trocarStatusDessaGradeParaAprovada: "Tem certeza que deseja trocar o status dessa grade para aprovada?",
      trocarStatusDessaGradeParaRascunho: "Tem certeza que deseja trocar o status dessa grade para rascunho?",
      criarRevisaoDestaGrade: "Tem certeza que deseja criar uma revisão desta grade?",

      deletarFrota: "Tem certeza que gostaria de deletar essa frota?",

      tituloCVODVO: "CVO/DVO",

      titulo: "Editar escala",

      botaoBloquearEscala: "Bloquear Escala",
      botaoDesbloquearEscala: "Desbloquear Escala",

      tituloGrades: "Grades",

      tabelaGrades: {
        Revisao: "Revisão",
        Status: "Status",
        Efetivacao: "Efetivação",
        Acoes: "Ações",

        botaoGerarPDF: "Gerar PDF",
        botaoMarcarComoVerificada: "Marcar como verificada",
        botaoRelatorioDeAlertas: "Relatório de alertas",
        botaoMarcarComoAprovada: "Marcar como aprovada",
        botaoCriarRevisao: "Criar revisão",
        botaoEfetivar: "Efetivar",
        botaoEscalaEfetivada: "Escala Efetivada",

        EstamosProcessandoAAprovacao: "Estamos processando a aprovação da escala. Aguarde...",
      },

      tituloRegimesDeTrabalho: "Regimes de trabalho",

      formularioRegimesDeTrabalho: {
        Regime: "Regime",
        DataDeInicio: "Data de início",

        placeholder: {
          SelecioneORegime: "Selecione o regime",
        }
      },

      tituloRegimesEmUso: "Regimes em uso",

      tabelaRegimesEmUso: {
        ID: "ID",
        Regime: "Regime",
        DataDeInicio: "Data de início",
        Acoes: "Ações",

        //ScheduleUsedRegimeEdit abaixo

        deletarRegime: "Tem certeza que gostaria de deletar esse regime?",
      },

      tituloRevisao: "Revisão",

      tituloAlertasImpeditivos: "ALERTAS IMPEDITIVOS",

      existemAsSeguintesPendencias: "Existem as seguintes pendências não arquivadas para esta escala",

      botaoConfirmarMudancaDeStatusParaVerificada: "Confirmar mudança de status para verificada",
      botaoVoltarParaRascunho: "Voltar para rascunho",
      botaoAprovarEscala: "Aprovar escala",

      tituloEscala: "Escala",

      tabelaEscala: {
        Nome: "Nome",
        Matricula: "Matr.",
        Funcao: "Função",
      },

      tituloInstrucao: "Instrução",

      tabelaInstrucao: {
        Nome: "Nome",
        Matricula: "Matr.",
        Designacao: "Desig.",
      },

      tituloChefeDeEquipamento: "Chefe de equipamento",

      tabelaChefeDeEquipamento: {
        Nome: "Nome",
        Matricula: "Matr.",
        Designacao: "Desig.",
      },

      tituloDispensaMedica: "Dispensa médica",

      tabelaDispensaMedica: {
        Nome: "Nome",
        Matricula: "Matr.",
        Designacao: "Desig.",
      },

      tituloManutencao: "Manutenção",

      tabelaManutencao: {
        Nome: "Nome",
        Matricula: "Matr.",
        Designacao: "Desig.",
      },

      tituloFerias: "Férias",

      tabelaFerias: {
        Nome: "Nome",
        Matricula: "Matr.",
        Designacao: "Desig.",
      },

      tituloForaDeEscala: "Fora de escala",

      tabelaForaDeEscala: {
        Nome: "Nome",
        Matricula: "Matr.",
        Designacao: "Desig.",
      },

      tituloAlteracoesNaEscala: "Alterações na escala",

      tituloRevisaoAtual: "Revisão Atual",

      tabelaRevisaoAtual: {
        Base: "Base",
        Aeronave: "Aeronave",
        Grupo: "Grupo",
        Nome: "Nome",
        Matricula: "Matr.",
        Designacao: "Desig.",

        //ScheduleGradeAircraftLineChanged abaixo

        Indisponivel: "Indisponível",
      },

      tituloRevisaoAnterior: "Revisão Anterior",

      tabelaRevisaoAnterior: {
        Base: "Base",
        Aeronave: "Aeronave",
        Grupo: "Grupo",
        Nome: "Nome",
        Matricula: "Matr.",
        Designacao: "Desig.",

        //ScheduleGradeAircraftLineChangedOriginalView abaixo
        Indisponivel: "Indisponível",
      },

      nenhumaAlteracaoNaEscalaPrincipal: "Nenhuma alteração na escala principal de tripulantes.",
    },

    ListaDeEscalasMestreDeCarga: {
      botaoDuplicar: "Duplicar",
      deletar: "Tem certeza que gostaria de deletar essa escala?",

      titulo: "Lista de escalas - Mestre de carga",
      botaoAdicionarEscala: "Adicionar escala",

      tabela: {
        semEscalasEsteMes: "Não há escalas cadastradas para este mês",
        ID: "ID",
        Base: "Base",
        Empresa: "Empresa",
        Referencia: "Referência",
        Acoes: "Ações",

      }

    },

    DuplicarEscalaMestreDeCarga: {
      aguardeEnquantoAEscalaEDuplicada: "Aguarde enquanto a escala é duplicada. Este processo pode levar alguns minutos.",
      titulo: "Duplicar escala",

      formulario: {
        MesAno: "Mês/Ano",
        DataInicial: "Data inicial",
        DataFinal: "Data final",

        tituloRegimesDaEscala: "Regimes da escala",
        
        botaoSalvarDuplicacao: "Salvar duplicação",
      }
    },

    EditarEscalaMestreDeCarga: {
      efetivarGrade: "Tem certeza que deseja efetivar esta grade? Esta ação é irreversível.",
      trocarStatusDessaGradeParaVerificada: "Tem certeza que deseja trocar o status dessa grade para verificada?",
      trocarStatusDessaGradeParaAprovada: "Tem certeza que deseja trocar o status dessa grade para aprovada?",
      trocarStatusDessaGradeParaRascunho: "Tem certeza que deseja trocar o status dessa grade para rascunho?",
      criarRevisaoDestaGrade: "Tem certeza que deseja criar uma revisão desta grade?",

      deletarFrota: "Tem certeza que gostaria de deletar essa frota?",

      tituloMestreDeCarga: "Mestre de Carga",

      titulo: "Editar escala",

      botaoBloquearEscala: "Bloquear Escala",
      botaoDesbloquearEscala: "Desbloquear Escala",

      tituloGrades: "Grades",

      tabelaGrades: {
        Revisao: "Revisão",
        Status: "Status",
        Efetivacao: "Efetivação",
        Acoes: "Ações",

        botaoGerarPDF: "Gerar PDF",
        botaoMarcarComoVerificada: "Marcar como verificada",
        botaoRelatorioDeAlertas: "Relatório de alertas",
        botaoMarcarComoAprovada: "Marcar como aprovada",
        botaoCriarRevisao: "Criar revisão",
        botaoEfetivar: "Efetivar",
        botaoEscalaEfetivada: "Escala Efetivada",

        EstamosProcessandoAAprovacao: "Estamos processando a aprovação da escala. Aguarde...",
      },

      tituloRegimesDeTrabalho: "Regimes de trabalho",

      formularioRegimesDeTrabalho: {
        Regime: "Regime",
        DataDeInicio: "Data de início",

        placeholder: {
          SelecioneORegime: "Selecione o regime",
        }
      },

      tituloRegimesEmUso: "Regimes em uso",

      tabelaRegimesEmUso: {
        ID: "ID",
        Regime: "Regime",
        DataDeInicio: "Data de início",
        Acoes: "Ações",

        //ScheduleUsedRegimeEdit abaixo

        deletarRegime: "Tem certeza que gostaria de deletar esse regime?",
      },

      tituloRevisao: "Revisão",

      tituloAlertasImpeditivos: "ALERTAS IMPEDITIVOS",

      existemAsSeguintesPendencias: "Existem as seguintes pendências não arquivadas para esta escala",

      botaoConfirmarMudancaDeStatusParaVerificada: "Confirmar mudança de status para verificada",
      botaoVoltarParaRascunho: "Voltar para rascunho",
      botaoAprovarEscala: "Aprovar escala",

      tituloEscala: "Escala",

      tabelaEscala: {
        Nome: "Nome",
        Matricula: "Matr.",
        Funcao: "Função",
      },

      tituloInstrucao: "Instrução",

      tabelaInstrucao: {
        Nome: "Nome",
        Matricula: "Matr.",
        Designacao: "Desig.",
      },

      tituloChefeDeEquipamento: "Chefe de equipamento",

      tabelaChefeDeEquipamento: {
        Nome: "Nome",
        Matricula: "Matr.",
        Designacao: "Desig.",
      },

      tituloDispensaMedica: "Dispensa médica",

      tabelaDispensaMedica: {
        Nome: "Nome",
        Matricula: "Matr.",
        Designacao: "Desig.",
      },

      tituloManutencao: "Manutenção",

      tabelaManutencao: {
        Nome: "Nome",
        Matricula: "Matr.",
        Designacao: "Desig.",
      },

      tituloFerias: "Férias",

      tabelaFerias: {
        Nome: "Nome",
        Matricula: "Matr.",
        Designacao: "Desig.",
      },

      tituloForaDeEscala: "Fora de escala",

      tabelaForaDeEscala: {
        Nome: "Nome",
        Matricula: "Matr.",
        Designacao: "Desig.",
      },

      tituloAlteracoesNaEscala: "Alterações na escala",

      tituloRevisaoAtual: "Revisão Atual",

      tabelaRevisaoAtual: {
        Base: "Base",
        Aeronave: "Aeronave",
        Grupo: "Grupo",
        Nome: "Nome",
        Matricula: "Matr.",
        Designacao: "Desig.",

        //ScheduleGradeAircraftLineChanged abaixo

        Indisponivel: "Indisponível",
      },

      tituloRevisaoAnterior: "Revisão Anterior",

      tabelaRevisaoAnterior: {
        Base: "Base",
        Aeronave: "Aeronave",
        Grupo: "Grupo",
        Nome: "Nome",
        Matricula: "Matr.",
        Designacao: "Desig.",

        //ScheduleGradeAircraftLineChangedOriginalView abaixo
        Indisponivel: "Indisponível",
      },

      nenhumaAlteracaoNaEscalaPrincipal: "Nenhuma alteração na escala principal de tripulantes.",
    },

    AdicionarEscalaMestreDeCarga: {
      titulo: "Cadastrar escala - Mestre de carga",
      
      formulario: {
        MesAno: "Mês/ano",
        Base: "Base",
        Empresa: "Empresa",
        DataInicial: "Data inicial",
        DataFinal: "Data final",

        botaoSalvarEscala: "Salvar escala",
      },

    },

    ListaDeEscalaDiaria: {
      botaoDisponivel: "Disponível",
      botaoIndisponivel: "Indisponível",

      deletar: "Tem certeza que gostaria de deletar essa escala?",

      titulo: "Lista de escala diária",

      botaoAdicionarProgramacao: "Adicionar programação",

      formulario: {
        botaoMudarData: "Mudar data",
      },

      tabela: {
        semProgramacaoParaHoje: "Não há programação cadastrada para hoje",
        ID: "ID",
        Base: "Base",
        Aeronave: "Aeronave",
        Modelo: "Modelo",
        Contrato: "Contrato",
        Disponibilidade: "Disponibilidade",
        ComandanteS: "Comandante(s)",
        CopilotoS: "Copiloto(s)",
        ComissarioS: "Comissário(s)",
        Apresentacao: "Apresentação",
        Corte: "Corte",
        Status: "Status",
        Acoes: "Ações"
      }
    },

    AdicionarEscalaDiaria: {
      titulo: "Cadastrar escala diária",

      formulario: {
        Data: "Data",
        Base: "Base",
        TripulacaoExtra: "Tripulação Extra",
        Prefixo: "Prefixo",
        Contrato: "Contrato",
        DesejaImportarTripulacaoDaEscala: "Deseja importar tripulação da escala",

        botaoSalvarProgramacao: "Salvar programação",
      }


    },

    EditarEscalaDiaria: {
      trocarOStatusDaEscala: "Tem certeza que gostaria de trocar o status da escala?",
      aprovarEscalaMesmoComAlertasVermelhos: "Tem certeza que gostaria de aprovar a escala mesmo com os alertas vermelhos?",

      titulo: "Editar escala diária",

      tituloEditarEscalaDiariaTripulacaoExtra: "Editar escala diária Tripulação Extra",

      botaoProgramacao: {
        TrocarParaRascunho: "Trocar para Rascunho",
        TrocarParaAprovada: "Trocar para Aprovada",
      },

      botaoAlertas: "Alertas",

      erros: "Os seguintes erros de preenchimento impediram a ficha de indisponibilidade de ser processada",

      tituloDisponibilidadeDaAeronave: "Disponibilidade da Aeronave",

      formularioDisponibilidadeDaAeronave: {
        Disponivel: "Disponível",
        IndisponivelDesde: "Indisponível desde",
        Razao: "Razão",
        Previsao: "Previsão",
        FlightFollowingAnormal: "Flight following anormal",
        AnormalDesde: "Anormal desde",
        InspetorMecanicoResponsavel: "Inspetor / Mecânico Responsável",
        Observacoes: "Observações",
      },

      tituloCriarGrupo: "Criar grupo",

      formularioCriarGrupo: {
        HorarioDeApresentacao: "Horário de Apresentação",
        HorarioDeTerminoDaJornada: "Horário de Término da Jornada",
        Situacao: "Situação",
        Voos: "Vôos",
        
        botaoAdicionarGrupo: "Adicionar grupo",
      },

      tituloAlertasDeAprovacao: "Alertas de aprovação",

      tabelaAlertasDeAprovacao: {
        Mensagem: "Mensagem",
        Data: "Data",
      },

      tituloLogDeStatus: "Log de status",

      tabelaLogDeStatus: {
        Usuario: "Usuário",
        Acao: "Ação",
        Descricao: "Descrição",
        Justificativa: "Justificativa",
        Data: "Data",
      },

      tituloAlertas: "Alertas",

      formularioAlertas: {
        Justificativa: "Justificativa",

        botaoContinuarAprovacao: "Continuar aprovação",
      },

      //ScheduleGroupStaff abaixo
      deletarTripulante: "Tem certeza que deseja deletar esse tripulante?",
      deletarGrupo: "Tem certeza que deseja deletar esse grupo?",
      deletarVoo: "Tem certeza que deseja deletar esse voo?",
      
      tituloGrupoAs(Numero, Inicio, Fim) {
        // Verifico se o Fim é nulo, se for, retorno apenas o Inicio
        if (Fim == null) {
          return `Grupo ${Numero} - ${Inicio}`
        }
        return `Grupo ${Numero} - ${Inicio} às ${Fim}`
      },
      
      formularioGrupo: {
        HorarioDeApresentacao: "Horário de Apresentação",
        HorarioDeTerminoDaJornada: "Horário de Término da Jornada",
        Situacao: "Situação",
        Voos: "Vôos",
        botaoEditarGrupo: "Editar grupo",
      },

      formularioAdicionarComandante: {
        Comandante: "Comandante",
        FuncaoDeBordo: "Função de bordo comandante",
      },

      formularioAdicionarCopiloto: {
        Copiloto: "Copiloto",
        FuncaoDeBordo: "Função de bordo copiloto",
      },

      formularioAdicionarComissario: {
        Comissario: "Comissário",
        FuncaoDeBordo: "Função de bordo comissário",
      },

      tabelaTripulantes: {
        Tripulante: "Tripulante",
        FuncaoDeBordo: "Função de bordo",
      },

      tabelaGrupo: {
        Voo: "Vôo",
      }

    },

    SimulacaoEscalaDiaria:{
      titulo: "Simulação escala diária",

      tituloSimulacaoEscalaDiariaTripulacaoExtra: "Simulação escala diária - tripulação extra",

      formulario: {
        Data: "Data",
        TripulacaoExtra: "Tripulação Extra",
        Prefixo: "Prefixo",
        Contrato: "Contrato",
        HorarioDeApresentacao: "Horário de Apresentação",
        HorarioDeTerminoDaJornada: "Horário de Término da Jornada",
        Situacao: "Situação",
      },

      formularioAdicionarComandante: {
        Comandante: "Comandante",
        FuncaoDeBordo: "Função de bordo comandante",
      },

      formularioAdicionarCopiloto: {
        Copiloto: "Copiloto",
        FuncaoDeBordo: "Função de bordo copiloto",
      },

      formularioAdicionarComissario: {
        Comissario: "Comissário",
        FuncaoDeBordo: "Função de bordo comissário",
      },

      tabelaGrupo: {
        Tripulante: "Tripulante",
        FuncaoDeBordo: "Função de bordo",
      },

      formularioSimularProgramacao: {
        botaoSimularProgramacao: "Simular programação",
      },

      tituloAlertas: "Alertas",

      formularioContinuarAprovacao: {
        Justificativa: "Justificativa",
        botaoContinuarAprovacao: "Continuar aprovação",
      },

    },

    ListaDeEscalas: {
      botaoDuplicar: "Duplicar",
      deletar: "Tem certeza que gostaria de deletar essa escala?",

      titulo: "Lista de escalas",
      botaoAdicionarEscala: "Adicionar escala",

      tabela: {
        semEscalasEsteMes: "Não há escalas cadastradas para este mês",
        ID: "ID",
        Frota: "Frota",
        Empresa: "Empresa",
        Referencia: "Referência",
        Acoes: "Ações",
      }
    },

    DuplicarEscala: {
      aguardeEnquantoAEscalaEDuplicada: "Aguarde enquanto a escala é duplicada. Este processo pode levar alguns minutos.",
      titulo: "Duplicar escala",

      formulario: {
        MesAno: "Mês/Ano",
        DataInicial: "Data inicial",
        DataFinal: "Data final",

        tituloRegimesDaEscala: "Regimes da escala",
        
        botaoSalvarDuplicacao: "Salvar duplicação",
      }

    },

    AdicionarEscala: {

      titulo: "Cadastrar escala",

      formulario: {
        MesAno: "Mês/ano",
        Frota: "Frota",
        DataInicial: "Data inicial",
        DataFinal: "Data final",
        Empresa: "Empresa",

        botaoSalvarEscala: "Salvar escala",
      }

    },

    EditarEscala: {
      efetivarGrade: "Tem certeza que deseja efetivar esta grade? Esta ação é irreversível.",
      trocarStatusDessaGradeParaVerificadaMesmoHavendoPendencias: "Tem certeza que deseja trocar o status dessa grade para verificada, mesmo havendo pendências ainda não arquivadas?",
      trocarStatusDessaGradeParaVerificada: "Tem certeza que deseja trocar o status dessa grade para verificada?",
      trocarStatusDessaGradeParaAprovada: "Tem certeza que deseja trocar o status dessa grade para aprovada?",
      trocarStatusDessaGradeParaRascunho: "Tem certeza que deseja trocar o status dessa grade para rascunho?",
      criarRevisaoDestaGrade: "Tem certeza que deseja criar uma revisão desta grade?",

      deletarGrade: "Tem certeza que gostaria de deletar essa grade?",

      titulo: "Editar escala",

      botaoBloquearEscala: "Bloquear Escala",
      botaoDesbloquearEscala: "Desbloquear Escala",

      formulario: {
        DataInicial: "Data inicial",
        DataFinal: "Data final",
      },

      tituloGrades: "Grades",

      tabelaGrades: {
        Revisao: "Revisão",
        Status: "Status",
        Efetivacao: "Efetivação",
        Acoes: "Ações",

        botaoGerarPDF: "Gerar PDF",
        botaoMarcarComoVerificada: "Marcar como verificada",
        botaoAlertas: "Alertas",
        botaoMarcarComoAprovada: "Marcar como aprovada",
        botaoCriarRevisao: "Criar revisão",
        botaoEfetivar: "Efetivar",
        botaoEscalaEfetivada: "Escala Efetivada",

        EstamosProcessandoAAprovacao: "Estamos processando a aprovação da escala. Aguarde...",

        //ScheduleGradeObservationModal abaixo

        tituloEditarObservacoesDaGrade: "Editar observações da grade",

        formularioEditarObservacoesDaGrade: {
          Observacoes: "Observações",
          
          botaoEditarObservacoesDaGrade: "Editar observações da grade",
        }

      },

      tituloRegimesDeTrabalho: "Regimes de trabalho",

      formularioRegimesDeTrabalho: {
        Regime: "Regime",
        DataDeInicio: "Data de início",

        placeholder: {
          SelecioneORegime: "Selecione o regime",
        }
      },

      tituloRegimesEmUso: "Regimes em uso",

      tabelaRegimesEmUso: {
        ID: "ID",
        Regime: "Regime",
        DataDeInicio: "Data de início",
        Acoes: "Ações",
      },

      tituloRevisao: "Revisão",

      tituloAlertasImpeditivos: "ALERTAS IMPEDITIVOS",

      tabelaAlertas: {
        Matricula: "Matrícula",
        Nome: "Nome",
        Setor: "Setor",
        Alerta: "Alerta",
      },

      existemAsSeguintesPendencias: "Existem as seguintes pendências não arquivadas para esta escala",

      botaoConfirmarMudancaDeStatusParaVerificada: "Confirmar mudança de status para verificada",
      botaoVoltarParaRascunho: "Voltar para rascunho",
      botaoAprovarEscala: "Aprovar escala",

      tabelaAlertasCompacta: {
        NomeMatricula: "Nome (Matrícula)",
        Alerta: "Alerta"
      },

      nenhumaAeronaveEscalada: "Nenhuma aeronave escalada.",

      botaoAprovado: "Aprovado",

      tabelaVisualizarEscala: {
        Base: "Base",
        Aeronave: "Aeronave",
        Grupo: "Grupo",
        Nome: "Nome",
        Matricula: "Mat.",
        Designacao: "Desig.",
      },

      tituloTripulacaoExtra: "Tripulação extra",

      tabelaTripulacaoExtra: {
        Nome: "Nome",
        Matricula: "Matr.",
        Designacao: "Desig.",
      },

      tituloInstrucao: "Instrução",

      tabelaInstrucao: {
        Nome: "Nome",
        Matricula: "Matr.",
        Designacao: "Desig.",
      },

      tituloChefeDeEquipamento: "Chefe de equipamento",

      tabelaChefeDeEquipamento: {
        Nome: "Nome",
        Matricula: "Matr.",
        Designacao: "Desig.",
      },

      tituloDispensaMedica: "Dispensa médica",

      tabelaDispensaMedica: {
        Nome: "Nome",
        Matricula: "Matr.",
        Designacao: "Desig.",
      },

      tituloManutencao: "Manutenção",

      tabelaManutencao: {
        Nome: "Nome",
        Matricula: "Matr.",
        Designacao: "Desig.",
      },

      tituloFerias: "Férias",

      tabelaFerias: {
        Nome: "Nome",
        Matricula: "Matr.",
        Designacao: "Desig.",
      },

      tituloForaDeEscala: "Fora de escala",

      tabelaForaDeEscala: {
        Nome: "Nome",
        Matricula: "Matr.",
        Designacao: "Desig.",
      },

      tituloAlteracoesNaEscala: "Alterações na escala",

      tituloRevisaoAtual: "Revisão Atual",

      tabelaRevisaoAtual: {
        Base: "Base",
        Aeronave: "Aeronave",
        Grupo: "Grupo",
        Nome: "Nome",
        Matricula: "Matr.",
        Designacao: "Desig.",
      },

      tituloRevisaoAnterior: "Revisão Anterior",

      tabelaRevisaoAnterior: {
        Base: "Base",
        Aeronave: "Aeronave",
        Grupo: "Grupo",
        Nome: "Nome",
        Matricula: "Matr.",
        Designacao: "Desig.",
      },

      nenhumaAlteracaoNaEscalaPrincipal: "Nenhuma alteração na escala principal de tripulantes.",
    },

    ElaboracaoDeEscala: {

      todosOsCamposDoFormularioDevemSerPreenchdios: "Todos os campos do formulário devem ser preenchdios",

      formulario: {
        Mes: "Mês",
        Ano: "Ano",
        Frota: "Frota",
        
        botaoBases: "Bases",
        botaoRodizio: "Rodízio",
        botaoVencimentos: "Vencimentos",

        placeholder: {
          SelecionarFrota: "Selecionar frota",
        }
      },

      tituloElaboraçãoDeEscalaBases: "Elaboração de Escala - Bases",

      tabDatas: {
        tituloEscalaDe: "Escala de",

        tabela: {
          Nome: "Nome",
          Escala: "Escala",
          Base: "Base",
          Aeronave: "Aeronave",
          TotalHoras: "Total Horas",
        },
      },

      tabTotaisDoPeriodo: {
        tituloTab: "Totais do período",

        tituloEscalaDe: "Escala de",

        tabela: {
          Nome: "Nome",
          TotalAno: "Total ano",
          TotalGeral: "Total geral",
        },
      },

      tituloElaboracaoDeEscalaRodizio: "Elaboração de Escala - Rodízio",

      tabelaElaboracaoDeEscalaRodizio: {
        Base: "Base",
        TotalHoras: "Total horas",
        TotalDeTripulantes: "Total de tripulantes",
        VagasDisponiveis: "Vagas disponíveis",
        MediaDeHoras: "Média de horas",
      },

      tituloTotalDeHorasEntreCMDT(dataInicial, hoje) {
        return `Total de horas entre ${dataInicial} e ${hoje} - CMDT`
      },

      tabelaTotalDeHorasEntreCMDT:{
        Total90Dias: "Total 90 dias",
        Tripulante: "Tripulante",
        Matricula: "Matrícula",
        FB: "FB",
        Base: "Base",
      },

      tituloTotalDeHorasEntreCOPIL(dataInicial, hoje) {
        return `Total de horas entre ${dataInicial} e ${hoje} - COPIL`
      },

      tabelaTotalDeHorasEntreCOPIL: {
        Total90Dias: "Total 90 dias",
        Tripulante: "Tripulante",
        Matricula: "Matrícula",
        FB: "FB",
        Base: "Base",
      },

      tituloTotalDeHorasEntreCMS(dataInicial, hoje) {
        return `Total de horas entre ${dataInicial} e ${hoje} - CMS`
      },

      tabelaTotalDeHorasEntreCMS: {
        Total90Dias: "Total 90 dias",
        Tripulante: "Tripulante",
        Matricula: "Matrícula",
        FB: "FB",
        Base: "Base",
      },

      tituloSugestaoDeRodizio: "Sugestão de rodízio",

      tabelaSugestaoDeRodizio: {
        Tripulante1: "Tripulante 1",
        FB: "FB",
        TotalDeHoras: "Total de Horas",
        Tripulante2: "Tripulante 2",
        FB: "FB",
        TotalDeHoras: "Total de Horas",
        BaseAAlocar: "Base a Alocar",
      },

      tituloElaboracaoDeEscalaVencimentos: "Elaboração de Escala - Vencimentos",

      formularioElaboracaoDeEscalaVencimentos: {
        Certificados: "Certificados",

        tabela: {
          Matricula: "Mat.",
          NomeDeGuerra: "Nome de Guerra",
          CHTFrota: "CHT Frota",
          CCF: "CCF",
          TotalHoras: "Total Horas",
          VencimentoNoturno: "Venc. Noturno",
        },

        placeholder: {
          SelecionarCertificados: "Selecionar certificados",
        }
      }
    },

    ListaDeEscalasDeTreinamentos: {
      botaoDuplicar: "Duplicar",
      deletar: "Tem certeza que gostaria de deletar essa escala?",

      titulo: "Lista de escalas de treinamentos",

      botaoAdicionarEscala: "Adicionar escala",

      tabela: {
        semEscalasCadastradasParaEsteMes: "Não há escalas cadastradas para este mês",
        ID: "ID",
        Frota: "Frota",
        Referencia: "Referência",
        Acoes: "Ações",
      }
    },

    AdicionarEscalaDeTreinamento: {
      titulo: "Cadastrar escala de treinamentos",

      formulario: {
        MesAno: "Mês/ano",
        Frota: "Frota",
        DataInicial: "Data inicial",
        DataFinal: "Data final",

        botaoSalvarEscala: "Salvar escala",
      }
    },

    DuplicarEscalaDeTreinamento: {
      aguardeEnquantoAEscalaEDuplicada: "Aguarde enquanto a escala é duplicada. Este processo pode levar alguns minutos.",

      titulo: "Duplicar escala",

      formulario: {
        DataInicial: "Data inicial",
        DataFinal: "Data final",

        tituloRegimesDaEscala: "Regimes da escala",

        botaoSalvarDuplicacao: "Salvar duplicação",
      }

    },


    EditarEscalaDeTreinamento: {
      trocarStatusDessaGradeParaVerificada: "Tem certeza que deseja trocar o status dessa grade para verificada?",
      trocarStatusDessaGradeParaAprovada: "Tem certeza que deseja trocar o status dessa grade para aprovada?",
      trocarStatusDessaGradeParaRascunho: "Tem certeza que deseja trocar o status dessa grade para rascunho?",

      criarRevisaoDestaGrade: "Tem certeza que deseja criar uma revisão desta grade?",

      deletarEssaGrade: "Tem certeza que gostaria de deletar essa grade?",

      titulo: "Editar escala",

      botaoBloquearEscala: "Bloquear Escala",
      botaoDesbloquearEscala: "Desbloquear Escala",

      formulario: {
        DataInicial: "Data inicial",
        DataFinal: "Data final",
      },

      tituloGrades: "Grades",

      tabelaGrades: {
        Revisao: "Revisão",
        Status: "Status",
        Acoes: "Ações",

        botaoGerarPDF: "Gerar PDF",
        botaoMarcarComoVerificada: "Marcar como verificada",
        botaoAlertas: "Alertas",
        botaoMarcarComoAprovada: "Marcar como aprovada",
        botaoCriarRevisao: "Criar revisão",

        //?
        botaoEfetivar: "Efetivar",
        botaoEscalaEfetivada: "Escala Efetivada",
        EstamosProcessandoAAprovacao: "Estamos processando a aprovação da escala. Aguarde...",


        //ScheduleGradeObservationModal abaixo

        tituloEditarObservacoesDaGrade: "Editar observações da grade",

        formularioEditarObservacoesDaGrade: {
          Observacoes: "Observações",
          
          botaoEditarObservacoesDaGrade: "Editar observações da grade",
        }

      },

      tituloRegimesDeTrabalho: "Regimes de trabalho",

      formularioRegimesDeTrabalho: {
        Regime: "Regime",
        DataDeInicio: "Data de início",

        placeholder: {
          SelecioneORegime: "Selecione o regime",
        }
      },

      tituloRegimesEmUso: "Regimes em uso",

      tabelaRegimesEmUso: {
        ID: "ID",
        Regime: "Regime",
        DataDeInicio: "Data de início",
        Acoes: "Ações",
      },

      tituloRevisao: "Revisão",

      tituloAlertasImpeditivos: "ALERTAS IMPEDITIVOS",

      ///duvida linha869

      botaoConfirmarMudancaDeStatusParaVerificada: "Confirmar mudança de status para verificada",
      botaoVoltarParaRascunho: "Voltar para rascunho",
      botaoAprovarEscala: "Aprovar escala",

      tituloTreinamentos: "Treinamentos",

      tabelaTreinamentos: {
        Nome: "Nome",
        Matricula: "Matr.",
        Designacao: "Desig.",
      },

      tituloFerias: "Férias",

      tabelaFerias: {
        Nome: "Nome",
        Matricula: "Matr.",
        Designacao: "Desig.",
      },

      tituloAlteracoesNaEscala: "Alterações na escala",

      tituloRevisaoAtual: "Revisão Atual",

      tabelaRevisaoAtual: {
        Base: "Base",
        Aeronave: "Aeronave",
        Grupo: "Grupo",
        Nome: "Nome",
        Matricula: "Matr.",
        Designacao: "Desig.",
      },

      tituloRevisaoAnterior: "Revisão Anterior",

      tabelaRevisaoAnterior: {
        Base: "Base",
        Aeronave: "Aeronave",
        Grupo: "Grupo",
        Nome: "Nome",
        Matricula: "Matr.",
        Designacao: "Desig.",
      },
    }
  },
  
  Setores: {
    ListaDeSetores: {
      titulo: 'Lista de setores',
      deletar: 'Tem certeza que gostaria de deletar esse setor?',
      botaoAdicionarSetor: 'Adicionar setor',
      tabela: {
        ID: 'ID',
        Nome: 'Nome',
        Acoes: 'Ações',
      },
    },
    EditarSetor: {
      titulo: 'Editar setor',
      deletarEmail: 'Tem certeza que gostaria de deletar esse e-mail relacionado?',
      formulario: {
        Nome: 'Nome',
        Email: 'E-mail',
        botaoAdicionarEmail: 'Salvar adição de e-mail',
        placeholder: {
          registroDoSetor: 'Registro do setor',
          emailDoSetor: 'E-mail do setor',
        },
      },
      tabela: {
        Email: 'E-mail',
        Acoes: 'Ações'
      },
    },
    CadastrarSetor: {
      titulo: 'Cadastrar setor',
      formulario: {
        Nome: 'Nome',
        placeholder: {
          registroDoSetor: 'Registro do setor',
        },
      },
    }
  },

  Configuracoes: {

    EditarConfiguracoes: {
      deletarConfiguracao: "Tem certeza que gostaria de deletar essa configuração?",
      deletarTarefa: "Tem certeza que gostaria de deletar essa tarefa?",

      titulo: "Edição de configurações de fadiga",

      formulario: {
        AplicabilidadeTipoDeColaborador: "Aplicabilidade - Tipo de Colaborador",
        LimiteDePontosZonaAzul: "Limite de pontos - zona azul",
        LimiteDePontosZonaAmarela: "Limite de pontos - zona amarela",
        LimiteDePontosZonaVermelha: "Limite de pontos - zona vermelha",
        LimiteDePontosDiario: "Limite de pontos - diário",
        PontuacaoPorDiaDeFolga: "Pontuação por dia de folga",

        placeholder: {
          SelecionarAplicabilidade: "Selecionar aplicabilidade",
        }
      },

      tituloConfiguracoesDePontuacao: "Configurações de Pontuação",

      tabelaConfiguracoesDePontuacao: {
        TipoDeColaborador: "Tipo de Colaborador",
        Acoes: "Ações",
      },

      tituloEditarConfiguracao: "Editar configuração",

      formularioEditarConfiguracao: {
        AplicabilidadeTipoDeColaborador: "Aplicabilidade - Tipo de Colaborador",
        LimiteDePontosZonaAzul: "Limite de pontos - zona azul",
        LimiteDePontosZonaAmarela: "Limite de pontos - zona amarela",
        LimiteDePontosZonaVermelha: "Limite de pontos - zona vermelha",
        LimiteDePontosDiario: "Limite de pontos - diário",
        PontuacaoPorDiaDeFolga: "Pontuação por dia de folga",

        placeholder: {
          SelecionarAplicabilidade: "Selecionar aplicabilidade",
        }
      },

      tituloTarefasDeRestricao: "Tarefas de restrição",

      formularioTarefasDeRestricao: {
        Tarefa: "Tarefa",
        LimiteDaRestricao: "Limite da restrição",
        Restricao: "Restrição",

        botaoCadastrarTarefa: "Cadastrar tarefa",

        placeholder: {
          SelecionarAplicabilidade: "Selecionar aplicabilidade",
          SelecionarLimite: "Selecionar limite",
          Restricao: "Restrição",
        }
      },

      tituloTarefasDaAplicabilidade: "Tarefas da aplicabilidade",

      tabelaTarefasDaAplicabilidade: {
        Limite: "Limite",
        Tarefa: "Tarefa",
        Restricao: "Restrição",
        Acoes: "Ações",
      },



    }

  },

  AutorizacoesDeCopilotos: {

    ListaDeCopilotosAutorizados: {
      deletarRegistro: "Tem certeza que gostaria de deletar esse registro?",

      titulo: "Lista de copilotos autorizados a lançar horas em comando",

      tituloAdicionarAutorizacao: "Adicionar Autorização",

      formulario: {
        Tripulante: "Tripulante",
        Frota: "Frota",

        botaoAdicionarAutorizacao: "Adicionar autorização",

        placeholder: {
          SelecioneOTripulante: "Selecione o tripulante",
          SelecioneAFrota: "Selecione a frota",
        },
      },

      tabela:{
        semGraduacoes: "Não há graduações cadastradas",
        ID: "ID",
        Nome: "Nome",
        Frota: "Frota",
        Acoes: "Ações",
      }
    }

  },

  VoosTotais: {
    DisponibilidadeDeTripulantes: {
      titulo: "Disponibilidade de Tripulantes",

      formulario: {
        botaoMudarData: "Mudar data",
      },

      tabela: {
        semProgramacaoParaHoje: "Não há programação cadastrada para hoje",

        Matricula: "Mat.",
        NomeDeGuerra: "Nome de Guerra",
        Cargo: "Cargo",
        Base: "Base",
        Aeronave: "Aeronave",
        Frota: "Frota",
        HorasRealizadasDisponiveisDia: "Horas Realizadas (Disponíveis) - dia",
        HorasRealizadasDisponiveisMes: "Horas Realizadas (Disponíveis) - mes",
        HorasRealizadasDisponiveisAno: "Horas Realizadas (Disponíveis) - ano",
        HorasRealizadasUltimos30Dias: "Horas Realizadas - Últ. 30 dias",
        JornadaMensal: "Jornada - Mensal",
        ExperienciaNoturna: "Exp. Noturna",
        CargaExterna: "Carga Externa",
        Fadiga: "Fadiga",
        ValidadeASO: "Validade ASO",
        PendenciasQPulse: "Pendências Q-Pulse",
      }
    }
  },

  Graduacoes: {
    ListaDeGraduacoesDeTripulantes: {
      deletarRegistro: "Tem certeza que gostaria de deletar esse registro?",

      titulo: "Lista de graduações de tripulantes",
      tituloAdicionarGraduacao: "Adicionar Graduação",

      formulario: {
        Tripulante: "Tripulante",
        Frota: "Frota",
        Graduacao: "Graduação",

        opcoesGraduacao: {
          Vermelho: "Vermelho",
          Amarelo: "Amarelo",
          Verde: "Verde",
        },

        botaoAdicionarGraduacao: "Adicionar graduação",

        placeholder:{
        SelecioneOTripulante: "Selecione o tripulante",
        SelecioneAFrota: "Selecione a frota",
        SelecioneAGraduacao: "Selecione a graduação",
        }
      },

      tabela: {
        semGraduacoes: "Não há graduações cadastradas",
        ID: "ID",
        Nome: "Nome",
        Frota: "Frota",
        Graduacao: "Graduação",
        Acoes: "Ações",
      }
      
    }
  },

  Habilitacoes: {
    PesquisaDeHabilitacoes: {

      opcoesCodigoDeHabilitacao: {
        CCF: "CCF",
        CHT: "CHT",
      },

      opcoesHabilitacao: {
        SelecionarTipo: "Selecionar tipo",
        IFRH: "IFRH",
      },

      titulo: "Pesquisa de habilitações",

      formulario: {
        Tripulante: "Tripulante",
        ExibirTripulantesDesligados: "Exibir tripulantes desligados",
        Codigo: "Código",
        Tipo: "Tipo",
        VencimentoInicio: "Vencimento início",
        VencimentoFim: "Vencimento fim",
        Aeronave: "Aeronave",

        botaoProcurarHabilitacoes: "Procurar habilitações",

        placeholder: {
          SelecionarBase: "Selecionar base",
          SelecionarCodigo: "Selecionar código",
          SelecionarTipo: "Selecionar tipo",
        }
      },

      botaoExportarEmCSV: "Exportar em CSV",

      tabela: {
        Matricula: "Mat.",
        Apelido: "Apelido",
        CANAC: "CANAC",
        Licenca: "Licença",
        CCF: "CCF",
        IFRH: "IFRH",
      }

    },

    StatusDeFrota: {
      deletarVoo: "Tem certeza que gostaria de deletar esse voo?",

      titulo: "Status de frota",
      botaoEditarStatus: "Editar status",

      formulario: {
        DataInicial: "Data inicial",
        DataFinal: "Data final",
        Base: "Base",

        botaoProcurarVoos: "Procurar voos",

        placeholder: {
          SelecionarBase: "Selecionar base",
        }
      },
      
      tituloVoosPara(dataInicial, dataFinal) {
        return `Voos para ${dataInicial} a ${dataFinal}`
      },

      listaVoosPara: {
        Atrasado: "Atrasado",
        SaidaPrevista: "Saída prevista",
        SaidaReal: "Saída real",
        Atraso: "Atraso",
        JustificativaPTBR: "Justificativa PTBR",
        Motivo: "Motivo",
        Codigo: "Código",
        JustificativaOmni: "Justificativa Interna",
        Setor: "Setor",
      }

      
    }
  },

  Papeletas: {

    ListaDePapeletas: {
      deletar: "Tem certeza que gostaria de deletar essa papeleta?",
      trocarStatus: "Tem certeza que deseja trocar o status da papeleta?",

      botaoAprovarSelecionados: "Aprovar selecionados",

      titulo: "Lista de papeletas",

      tabela: {
        semPapeletasPendentes: "Não há papeletas pendentes",
        ID: "ID",
        Nome: "Nome",
        Matricula: "Matrícula",
        Referencia: "Referência",
        Alertas: "Alertas",
        Status: "Status",
        Acoes: "Ações",
      }
    },

    AdicionarPapeleta: {
      titulo: "Cadastrar papeleta",

      formulario: {
        MesAno: "Mês/ano",

        Tripulante: "Tripulante",
      }
    },

    EditarPapeleta: {
      aguardeEnquantoOArquivoEGerado: "Aguarde enquanto o arquivo é gerado. Este processo pode levar alguns minutos.",
      atualizarAsInformacoes: "Tem certeza que deseja atualizar as informações? As alterações realizadas na FIRA serão perdidas.",

      titulo: "Edição de papeleta",

      botaoAtualizar: "Atualizar",
      botaoAlertas: "Alertas",

      tituloPendencias: "Pendências",

      tabelaPendencias: {
        Data: "Data",
        Localidades: "Localidades",
        Situacao: "Situação",
        Horarios: "Horários",
        Totais: "Totais",
        Apresentacao: "Apresentação",
        Liberacao: "Liberação",
        InicioDaRefeicao: "Início da Refeição",
        TerminoDaRefeicao: "Término da Refeição",
        InicioDaSegundaRefeicao: "Início da Segunda Refeição",
        TerminoDaSegundaRefeicao: "Término da Segunda Refeição",
        HorasDeJornada: "Horas de Jornada",
        VooNoturno: "Voo Noturno",
        VooTotal: "Voo Total",   

        ///pendencyday
        AtualizarAsInformacoesDestaDataDeAcordoComAPendencia: "Tem certeza que deseja atualizar as informações desta data de acordo com a pendência? As alterações realizadas na FIRA nesta data serão perdidas",
        tituloInterrupcoes: "Interrupções",

        tabelaInterrupcoes: {
          Inicio: "Início",
          Fim: "Fim",
          Total: "Total",
        },

        tituloEquipamentos: "Equipamentos",

        tabelaEquipamentos: {
          Frota: "Frota",
        },      
      },

      tituloPapeleta: "Papeleta",

      tabelaPapeleta: {
        Data: "Data",
        Localidades: "Localidades",
        Situacao: "Situação",
        Horarios: "Horários",
        Totais: "Totais",
        Apresentacao: "Apresentação",
        Liberacao: "Liberação",
        ApresentacaoData: "Apresentação data",
        ApresentacaoHora: "Apresentação hora",
        InicioDaRefeicaoData: "Início da Refeição data",
        InicioDaRefeicaoHora: "Início da Refeição hora",
        TerminoDaRefeicaoData: "Término da Refeição data",
        TerminoDaRefeicaoHora: "Término da Refeição hora",
        InicioDaSegundaRefeicaoData: "Início da Segunda Refeição data",
        InicioDaSegundaRefeicaoHora: "Início da Segunda Refeição hora",
        TerminoDaSegundaRefeicaoData: "Término da Segunda Refeição data",
        TerminoDaSegundaRefeicaoHora: "Término da Segunda Refeição hora",
        LiberacaoData: "Liberação data",
        Liberacaohora: "Liberação hora",
        HorasDeJornada: "Horas de Jornada",
        VooNoturno: "Voo Noturno",
        VooTotal: "Voo Total",

        ///////editday
        DeletarFrota: "Tem certeza que deseja deletar essa frota?",
        DeletarInterrupcao: "Tem certeza que deseja deletar essa interrupção?",
        AtualizarInformacoesDestaData: "Tem certeza que deseja atualizar as informações desta data? As alterações realizadas na FIRA nesta data serão perdidas",
        
        placeholder: {
          SelecionarSituacao: "Selecionar situação",
        },

        tituloInterrupcoes: "Interrupções",

        formularioInterrupcoes: {
          InicioDaInterrupcao: "Início da interrupção",
          FimDaInterrupcao: "Fim da interrupção",

          botaoAdicionarInterrupcao: "Adicionar interrupção",
        },

        tabelaInterrupcoes: {
          Inicio: "Início",
          Fim: "Fim",
          Total: "Total",
          Acoes: "Ações",
        },

        tituloEquipamentos: "Equipamentos",

        formularioEquipamentos: {
          botaoAdicionarFrota: "Adicionar frota",

          placeholder: {
            SelecionarFrota: "Selecionar frota",
          }
        },

        tabelaEquipamentos: {
          Frota: "Frota",
          Acoes: "Ações",
        }

      },

      tituloAlertasDoRelatorio: "Alertas do relatório",

      tabelaAlertasDoRelatorio: {
        Mensagem: "Mensagem",
      },

      tituloAlertas: "Alertas",


      /////////aqui acaba o papersedit

      //////aprovals
      trocarStatus: "Tem certeza que deseja trocar o status da papeleta?",
      reabrir: "Tem certeza que deseja reabrir a papeleta?",

      botaoForcarAprovacao: "Forçar Aprovação",
      botaoAprovacaoTripulante: "Aprovação - Tripulante",
      botaoAprovacaoGestor: "Aprovação - Gestor",
      botaoReabrirPapeleta: "Reabrir papeleta",
      botaoPapeletaAprovada: "Papeleta aprovada",

      erros: "Os seguintes erros de preenchimento nos dias indicados impediram a papeleta de ser finalizada",

      tituloLogDeAprovacoes: "Log de aprovações",

      tabelaLogDeAprovacoes: {
        Usuario: "Usuário",
        Acao: "Ação",
        Data: "Data",
      },

     tituloFIRA: "FIRA",

     botaoReprovacaoGestor: "Reprovação - Gestor",

    },

    ListaDePapeletasFinalizadas: {
      deletar: "Tem certeza que gostaria de deletar essa papeleta?",

      titulo: "Lista de papeletas finalizadas",

      tabela: {
        semPapeletasPendentes: "Não há papeletas pendentes",
        ID: "ID",
        Nome: "Nome",
        Matricula: "Matrícula",
        Referencia: "Referência",
        Acoes: "Ações",
      }
    },

    ListaDePapeletasPendentesGestor: {
      deletar: "Tem certeza que gostaria de deletar essa papeleta?",
      trocarStatus: "Tem certeza que deseja trocar o status da papeleta?",

      titulo: "Lista de papeletas pendentes - Gestor",

      botaoAprovarSelecionados: "Aprovar selecionados",

      tabela: {
        semPapeletasPendentes: "Não há papeletas pendentes",
        ID: "ID",
        Nome: "Nome",
        Matricula: "Matrícula",
        Referencia: "Referência",
        Alertas: "Alertas",
        Acoes: "Ações",
      }
    },

    ListaDePapeletasPendentesTripulantes: {
      deletar: "Tem certeza que gostaria de deletar essa papeleta?",

      titulo: "Lista de papeletas pendentes - Tripulantes",

      tabela: {
        semPapeletasPendentes: "Não há papeletas pendentes",
        ID: "ID",
        Nome: "Nome",
        Matricula: "Matrícula",
        Referencia: "Referência",
        Acoes: "Ações",
      }
    },

    ControleRequisicaoCustomizada: {
      titulo: "Consulta de papeletas - Gestores",

      formulario: {
        Data: "Data",
        RequisitosPersonalizados: "Requisitos Personalizados",
        Tripulante: "Tripulante",
      },

      tabela: {
        Matricula: "Mat.",
        Nome: "Nome",
        Requisito: "Requisito",
        Tipo: "Tipo",
        Dias: "Dias",
        LimiteDeHoras: "Limite de Horas",
        HorasRealizadas: "Horas Realizadas",
      }

    },

    ControleDePapeletas: {
      titulo: "Controle de papeletas",

      formulario: {
        DataInicial: "Data Inicial",
        DataFinal: "Data Final",
        Nome: "Nome",

        placeholder: {
          SelecionarTripulantes: "Selecionar tripulantes",
        }
      },

      tabela: {
        semInformacao: "Não há informação a ser exibida",
        Tripulante: "Tripulante",
        SomaDeHorasDeJornada: "Soma de Horas de Jornada",
        SomaDeHorasDeVooNoturno: "Soma de Horas de Voo Noturno",
        SomaDeHorasDeVooTotal: "Soma de Horas de Voo Total",
      }

    },

    ConsultaDePapeletas: {
      titulo: "Consulta de papeletas",

      formulario: {
        DataInicial: "Data Inicial",
        DataFinal: "Data Final",
      },

      tabela: {
        MesAno: "Mês/Ano",
        Alertas: "Alertas",
        Acoes: "Ações",
      }
    },

    ConsultaDePapeletasGestores: {
      aguardeEnquantoOArquivoEGerado: "Aguarde enquanto o arquivo é gerado. Este processo pode levar alguns minutos.",

      titulo: "Consulta de papeletas - Gestores",

      formulario: {
        DataInicial: "Data Inicial",
        DataFinal: "Data Final",
        Tripulante: "Tripulante",
        ExibirDesligados: "Exibir desligados",
        SomenteComAlertas: "Somente com alertas",
      },

      tabela: {
        Tripulante: "Tripulante",
        MesAno: "Mês/Ano",
        Alertas: "Alertas",
        Acoes: "Ações",
      }

    }
    
  },

  RelatoriosDeFadiga: {
    ListaDeRelatoriosDeFadigas: {
      botaoAdicionarRelatorioDeFadiga: "Adicionar relatório de fadiga",

      titulo: "Lista de relatórios de fadigas",

      tabela: {
        semParametroDeFadiga: "Não há parâmetros de fadiga cadastrados",
        Data: "Data",
        Revisao: "Revisão",
        Tripulante: "Tripulante",
        Folga: "Folga",
        QuantidadeDePontosAtual: "Quantidade de pontos atual",
        QuantidadeDePontosReportados: "Quantidade de pontos reportados",
        Acoes: "Ações",
      }
    },

    AdicionarRelatorioDeFadiga: {
      noParametroAPontuacaoMaximaFoiUltrapassada(name){
        return `No parâmetro ${name} a pontuação máxima foi ultrapassada, confirma o envio do relatório?`
      },

      noParametroAPontuacaoMinimaNaoFoiAtingida(name){
        return `No parâmetro ${name} a pontuação mínima não foi atingida, confirma o envio do relatório?`
      },

      titulo: "Cadastrar relatório de fadiga",

      formulario: {
        Data: "Data",
        Bases: "Bases",
        
        botaoAdicionarRelatorioDeFadiga: "Adicionar relatório de fadiga",

        placeholder: {
          SelecionarBase: "Selecionar base",
          SelecionarOpcao: "Selecionar opção",
          Horas: "Horas",
          Quantidade: "Quantidade",
        }
      }

    },

    EditarRelatorioDeFadiga: {
      noParametroAPontuacaoMaximaFoiUltrapassada(name){
        return `No parâmetro ${name} a pontuação máxima foi ultrapassada, confirma o envio do relatório?`
      },

      noParametroAPontuacaoMinimaNaoFoiAtingida(name){
        return `No parâmetro ${name} a pontuação mínima não foi atingida, confirma o envio do relatório?`
      },

      titulo: "Edição de relatório de fadiga - Revisão",

      paragrafoStatusDaRevisao: "Status da revisão",
      paragrafoQuantidadeDePontosAtual: "Quantidade de pontos atual",
      paragrafoQuantidadeDePontosReportados: "Quantidade de pontos reportados",

      tabRevisao: {
        tituloTab: "Revisão ",
        
        paragrafoStatusDaRevisao: "Status da revisão",
        paragrafoQuantidadeDePontosAtual: "Quantidade de pontos atual",
        paragrafoQuantidadeDePontosReportados: "Quantidade de pontos reportados",
      },
      
      tituloCriarRevisao: "Criar revisão",
      
      formularioCriarRevisao: {

        botaoCriarRevisaoDeRelatorioDeFadiga: "Criar revisão de relatório de fadiga",

        placeholder: {
          SelecionarOpcao: "Selecionar opção",
          Horas: "Horas",
          Quantidade: "Quantidade",
        }
      }
    },

    EditarParametroDeFadiga: {
      deletar: "Tem certeza que gostaria de deletar essa opção?",

      titulo: "Editar parâmetro de fadiga",

      formulario: {
        Nome: "Nome",
        Tipo: "Tipo",
        Operador: "Operador",
        PontosPorHora: "Pontos por hora",
        PontosPorQuantidade: "Pontos por quantidade",
        LimiteDePontos: "Limite de pontos",

        placeholder: {
          NomeDoParametroDeFadiga: "Nome do parâmetro de fadiga",
          SelecionarCliente: "Selecionar cliente",
          QuantidadeDePontosPorHora: "Quantidade de pontos por hora",
          QuantidadeDePontosPorQuantidade: "Quantidade de pontos por quantidade",
        },
      }, 
      tituloAdicionarOpcoes: "Adicionar opções",

      formularioAdicionarOpcoes: {
          Nome: "Nome",
          Pontos: "Pontos",

          placeholder: {
            NomeDoParametroDeFadiga: "Nome do parâmetro de fadiga",
            QuantidadeDePontos: "Quantidade de pontos",
          }
      },

      tituloOpcoes: "Opções",

      tabelaOpcoes: {
          Opcao: "Opção",
          Pontos: "Pontos",
          Acoes: "Ações",
      }

    },

    SimuladorDeRelatoriosDeFadiga: {
      titulo: "Simulador de relatórios de fadiga",

      formulario: {
        DataInicial: "Data inicial",
        DataFinal: "Data final",
        AplicabilidadeTipoDeColaborador: "Aplicabilidade - Tipo de Colaborador",
        QuantidadeDePontos: "Quantidade de pontos",

        botaoGerarSimulacaoDeRelatoriosDeFadiga: "Gerar simulação de relatórios de fadiga",

        placeholder: {
          SelecionarAplicabilidade: "Selecionar aplicabilidade",
        }
      },

      tabDatas: {
        botaoGerarRelatoriosDeFadiga: "Gerar relatórios de fadiga",
        botaoCopiarParaProximasDatas: "Copiar para próximas datas",

        formulario: {
          MarcarComoFolga: "Marcar como folga",
          Data: "Data",

          placeholder: {
            SelecionarOpcao: "Selecionar opção",
            Horas: "Horas",
            Quantidade: "Quantidade",
          }
        }
      },

      tabela: {
        Data: "Data",
        Diaria: "Diária",
        Acumulada: "Acumulada",
      }

      
    },

    RevisarHorariosDePonto: {
      titulo: "Revisar horários de ponto",

      tituloUtilizeEstaFerramentaParaCorrigirOsReportes: "Utilize esta ferramenta para corrigir os reportes de acordo com a API de ponto.",
      tituloAtencaoCasoOReportNaoExistaDeveraSerCriado: "Atenção: Caso o reporte não exista, ele deverá ser criado manualmente primeiro.",

      formulario: {
        AplicabilidadeTipoDeColaborador: "Aplicabilidade - Tipo de Colaborador",
        Tripulantes135: "Tripulantes - 135",
        Tripulantes121: "Tripulantes - 121",
        Mecanicos: "Mecânicos",
        Coordenadores: "Coordenadores",
        Data: "Data",
        
        botaoRevisarHorarios: "Revisar horários",

        placeholder: {
          SelecionarAplicabilidade: "Selecionar aplicabilidade",
          SelecionarTripulante: "Selecionar tripulante",
          SelecionarMecanico: "Selecionar mecânico",
          SelecionarCoordenador: "Selecionar coordenador",
        }
      }
    },

    AdicionarRelatorioDeFadigaAdministrador: {
      noParametroAPontuacaoMaximaFoiUltrapassada(name){
        return `No parâmetro ${name} a pontuação máxima foi ultrapassada, confirma o envio do relatório?`
      },

      noParametroAPontuacaoMinimaNaoFoiAtingida(name){
        return `No parâmetro ${name} a pontuação mínima não foi atingida, confirma o envio do relatório?`
      },

      titulo: "Cadastrar relatório de fadiga",

      formulario: {
        AplicabilidadeTipoDeColaborador: "Aplicabilidade - Tipo de Colaborador",
        Tripulantes135: "Tripulantes - 135",
        Tripulantes121: "Tripulantes - 121",
        Mecanicos: "Mecânicos",
        Coordenadores: "Coordenadores",
        Data: "Data",
        Bases: "Bases",

        botaoAdicionarRelatorioDeFadiga: "Adicionar relatório de fadiga",

        placeholder: {
          SelecionarAplicabilidade: "Selecionar aplicabilidade",
          SelecionarTripulante: "Selecionar tripulante",
          SelecionarMecanico: "Selecionar mecânico",
          SelecionarCoordenador: "Selecionar coordenador",
          SelecionarBase: "Selecionar base",
          SelecionarOpcao: "Selecionar opção",
          Horas: "Horas",
          Quantidade: "Quantidade",
        }
      }

    },

    EditarRelatorioDeFadigaAdministrador: {
      noParametroAPontuacaoMaximaFoiUltrapassada(name){
        return `No parâmetro ${name} a pontuação máxima foi ultrapassada, confirma o envio do relatório?`
      },

      noParametroAPontuacaoMinimaNaoFoiAtingida(name){
        return `No parâmetro ${name} a pontuação mínima não foi atingida, confirma o envio do relatório?`
      },

      titulo: "Edição de relatório de fadiga - Revisão",

      paragrafoStatusDaRevisao: "Status da revisão",
      paragrafoQuantidadeDePontosAtual: "Quantidade de pontos atual",
      paragrafoQuantidadeDePontosReportados: "Quantidade de pontos reportados",

      tabRevisao: {
        tituloTab: "Revisão ",
        
        paragrafoStatusDaRevisao: "Status da revisão",
        paragrafoQuantidadeDePontosAtual: "Quantidade de pontos atual",
        paragrafoQuantidadeDePontosReportados: "Quantidade de pontos reportados",
      },
      
      tituloCriarRevisao: "Criar revisão",
      
      formularioCriarRevisao: {

        botaoCriarRevisaoDeRelatorioDeFadiga: "Criar revisão de relatório de fadiga",

        placeholder: {
          SelecionarOpcao: "Selecionar opção",
          Horas: "Horas",
          Quantidade: "Quantidade",
        }
      }
    },

    EstatisticasDeEventosDeFadiga: {
      opcoesEvento: {
        Verde: "Verde",
        Amarelo: "Amarelo",
        Vermelho: "Vermelho",
      },

      opcoesPeriodo: {
        UmDia: "1 dia",
        DoisDias: "2 dias",
        TresDias: "3 dias",
      },

      titulo: "Estatísticas de Eventos de Fadiga",

      formulario: {
        DataInicial: "Data inicial",
        DataFinal: "Data final",
        TipoDeEvento: "Tipo de Evento",
        AplicabilidadeTipoDeColaborador: "Aplicabilidade - Tipo de Colaborador",
        PeriodoEstatisticoAnteriorAoEvento: "Período Estatístico Anterior ao Evento",

        botaoProcurarRelatorios: "Procurar relatórios",

        placeholder: {
          DeixarEmBrancoParaTodos: "Deixar em branco para todos.",
          SelecionarAplicabilidade: "Selecionar aplicabilidade",
          SelecionarPeriodo: "Selecionar período",
        }
      },

      tabela: {
        semEventosDeFadigaParaEstePeriodo: "Não há eventos de fadiga para este período.",
      }
    },

    FiltroDeRelatorio: {
      deletar: "Tem certeza que gostaria de deletar esse parâmetro de fadiga?",

      titulo: "Pesquisa de relatórios",

      formulario: {
        DataInicial: "Data inicial",
        DataFinal: "Data final",
        AplicabilidadeTipoDeColaborador: "Aplicabilidade - Tipo de Colaborador",
        Mecanicos: "Mecânicos",
        Coordenadores: "Coordenadores",
        Tripulantes: "Tripulantes",
        Cargos: "Cargos",
        Frotas: "Frotas",
        Bases: "Bases",
        ApenasIncidentesDeFadiga: "Apenas incidentes de fadiga",

        botaoProcurarRelatorios: "Procurar relatórios",

        placeholder: {
          SelecionarAplicabilidade: "Selecionar aplicabilidade",
          SelecionarMecanicos: "Selecionar Mecânicos",
          SelecionarCoordenadores: "Selecionar Coordenadores",
          SelecionarTripulantes: "Selecionar Tripulantes",
          SelecionarCargos: "Selecionar cargos",
          SelecionarFrotas: "Selecionar frotas",
          SelecionarBases: "Selecionar bases",
        }
      },

      tituloListaDeRelatoriosDeFadiga: "Lista de relatórios de fadiga",

      botaoMostrarEsconderTripulantes: "Mostrar/Esconder tripulantes",
      botaoFiltrarTripulantes: "Filtrar tripulantes",

      tabela: {
        Nome: "Nome",
        Pontos: "Pontos",
      }

    },

    RelatorioDeEventosIncidentesDeFadiga: {
      titulo: "Relatório de Eventos/Incidentes de Fadiga",

      formulario: {
        DataInicial: "Data inicial",

        DataFinal: "Data final",
        AplicabilidadeTipoDeColaborador: "Aplicabilidade - Tipo de Colaborador",
        Mecanicos: "Mecânicos",
        Coordenadores: "Coordenadores",
        Tripulantes: "Tripulantes",
        TipoDeEventoIncidente: "Tipo de Evento/Incidente",
        ApenasIncidentesDeFadigaChecados: "Apenas incidentes de fadiga checados",

        botaoProcurarRelatorios: "Procurar relatórios",

        placeholder: {
          SelecionarAplicabilidade: "Selecionar aplicabilidade",
          SelecionarMecanicos: "Selecionar Mecânicos",
          SelecionarCoordenadores: "Selecionar Coordenadores",
          SelecionarTripulantes: "Selecionar Tripulantes",
          SelecionarIncidente: "Selecionar incidente",
        }
      },

      tituloListaDeEventosIncidentesDeFadiga: "Lista de eventos/incidentes de fadiga",

      tabela: {
        semEventosIncidentesDeFadiga: "Não ocorreram eventos/incidentes de fadiga no período",
        ID: "ID",
        TipoDeEvento: "Tipo de Evento",
        Data: "Data",
        Revisao: "Revisão",
        Tripulante: "Tripulante",
        PontuacaoReportada: "Pontuação reportada",
        PontuacaoTotal: "Pontuação total",
        Checado: "Checado",
        DataDaChecagem: "Data da Checagem",
        AcaoRealizada: "Ação Realizada",
        Acoes: "Ações",
      },

      tituloEditarPlanoDeAcao: "Editar plano de ação",

      formularioEditarPlanoDeAcao: {
        PlanoDeAcao: "Plano de Ação",

        botaoEditarPlanoDeAcao: "Editar plano de ação"
      },

      marcarEsteIncidenteComoChecado: "Tem certeza que deseja marcar este incidente como checado?",
    },

    PesquisaDeRelatoriosNaoPreenchidos: {
      titulo: "Pesquisa de relatórios não preenchidos",

      formulario: {
        DataInicial: "Data inicial",
        DataFinal: "Data final",
        AplicabilidadeTipoDeColaborador: "Aplicabilidade - Tipo de Colaborador",
        Bases: "Bases",
        IncluirFolgaCadastradaAutomaticamente: "Incluir folga cadastrada automaticamente",

        botaoProcurarRelatorios: "Procurar relatórios",

        placeholder: {
          SelecionarAplicabilidade: "Selecionar aplicabilidade",
          SelecionarBase: "Selecionar base",
        }
      },

      tituloListaDeRelatOriosDeFadigasFaltantes: "Lista de relatórios de fadigas faltantes",

      tabela: {
        semReportesFaltantes: "Não há reportes faltantes nesse período",
        Nome:"Nome",
        Data: "Data",
        Situacao: "Situação",
      }
    },

    PesquisaDeRelatorios: {
      titulo: "Pesquisa de relatórios",

      formulario: {
        DataInicial: "Data inicial",
        DataFinal: "Data final",
        AplicabilidadeTipoDeColaborador: "Aplicabilidade - Tipo de Colaborador",
        Mecanicos: "Mecânicos",
        Coordenadores: "Coordenadores",
        Tripulantes: "Tripulantes",
        Cargos: "Cargos",
        Bases: "Bases",

        botaoProcurarRelatarios: "Procurar relatórios",

        placeholder: {
          SelecionarAplicabilidade: "Selecionar aplicabilidade",
          SelecionarMecanicos: "Selecionar Mecânicos",
          SelecionarCoordenadores: "Selecionar Coordenadores",
          SelecionarTripulantes: "Selecionar Tripulantes",
          SelecionarCargos: "Selecionar cargos",
          SelecionarBases: "Selecionar bases",
        }
      },

      tituloTotalDoPeriodo: "Total do Período",

      tabelaTotalDoPeriodo: {
        semParametrosDeFadiga: "Não há parâmetros de fadiga cadastrados",
        NaoFadigados: "Não fadigados",
        PontosAzul: "Pontos Azul",
        PontosAmarelo: "Pontos Amarelo",
        PontosVermelho: "Pontos Vermelho",
      },

      tituloTotalDiario: "Total Diário",

      tabelaTotalDiario: {
        semParametrosDeFadiga: "Não há parâmetros de fadiga cadastrados",
        Data: "Data",
        NaoFadigados: "Não fadigados",
        PontosAzul: "Pontos Azul",
        PontosAmarelo: "Pontos Amarelo",
        PontosVermelho: "Pontos Vermelho",
      },

      tituloListaDeRelatoriosDeFadigas: "Lista de relatórios de fadigas",

      tabelaListaDeRelatoriosDeFadigas: {
        semParametrosDeFadiga: "Não há parâmetros de fadiga cadastrados",
        Data: "Data",
        Revisao: "Revisão",
        Tripulante: "Tripulante",
        Folga: "Folga",
        QuantidadeDePontosAtual: "Quantidade de pontos atual",
        QuantidadeDePontosReportados: "Quantidade de pontos reportados",
        DiaDePreenchimento: "Dia de preenchimento",
        Acoes: "Ações",
      },

      tituloDadosDoRelatorioDeFadiga: "Dados do relatório de fadiga",

      paragrafoQuantidadeDePontosAtual: "Quantidade de pontos atual",
      paragrafoQuantidadeDePontosReportados: "Quantidade de pontos reportados",

      tabelaDadosDoRelatorioDeFadiga: {
        Parametro: "Parâmetro",
        Dados: "Dados",
        Pontos: "Pontos",
      }
    },

    Importacoes: {
      titulo: "Importações",

      formulario: {
        Aplicabilidade: "Aplicabilidade",
        Arquivo: "Arquivo",

        tituloErrosDeImportacao: "Erros de importação",

        botaoImportar: "Importar",

        placeholder: {
          SelecionarAplicabilidade: "Selecionar aplicabilidade",
          Arquivo: "Arquivo",
        }
      },

      tabela: {
        ID: "ID",
        DataDosRelatorios: "Data dos relatórios",
        DataDeImportacao: "Data de Importação",
        Arquivo: "Arquivo",
        Hash: "Hash",
        Acoes: "Ações",
      }


    },

    AvaliarEscalaPlanejada: {
      titulo: "Avaliar Escala Planejada",

      formulario: {
        Aplicabilidade: "Aplicabilidade",
        Arquivo: "Arquivo",

        tituloErrosDeImportacao: "Erros de importação",

        botaoImportar: "Importar",

        placeholder: {
          SelecionarAplicabilidade: "Selecionar aplicabilidade",
          Arquivo: "Arquivo",
        }
      },

      tabela: {
        semParametrosDeFadiga: "Não há parâmetros de fadiga cadastrados",
        Data: "Data",
        Revisao: "Revisão",
        Tripulante: "Tripulante",
        Folga: "Folga",
        QuantidadeDePontosAtual: "Quantidade de pontos atual",
        QuantidadeDePontosReportados: "Quantidade de pontos reportados",
        Status: "Status",
        Acoes: "Ações",
      }

    }

  },

  Tripulantes: {
    ListadeTripulantes: {
      titulo: "Lista de colaboradores",

      botaoAdicionarFuncionario: "Adicionar colaborador",

      tabela: {
        semTripulantes: "Não há colaboradores cadastrados",
        Nome: "Nome",
        Matricula: "Matrícula",
        Cargo: "Cargo",
        Licenca: "Licença",
        CANAC: "CANAC",
        Acoes: "Ações",
      }
    },

    AdicionarFuncionario: {
      titulo: "Cadastrar colaborador",

      formulario: {
        tituloInformacoesPessoais: "Informações pessoais",

        Nome: "Nome",
        Apelido: "Apelido",
        Telefone1: "Telefone 1",
        Telefone2: "Telefone 2",
        EstadoCivil: "Estado civil",
        Email: "E-mail",
        Naturalidade: "Naturalidade",
        Escolaridade: "Escolaridade",
        NomeDaMae: "Nome da mãe",
        NomeDoPai: "Nome do pai",
        Raca: "Raça",
        Foto: "Foto",
        DataDeNascimento: "Data de nascimento",

        tituloEndereco: "Endereço",

        Endereco: "Endereço",
        Numero: "Número",
        Complemento: "Complemento",
        Bairro: "Bairro",
        Cidade: "Cidade",
        Estado: "Estado",
        Pais: "País",
        CEP: "CEP",
        CPF: "CPF",
        Identidade: "Identidade",
        IdentidadeUF: "Identidade - UF",
        IdentidadeDataDeExpedicao: "Identidade - data de expedição",
        PIS: "PIS",
        IdentidadeOrgaoExpeditor: "Identidade - orgão expeditor",
        ConfidenceUS: "Confidence US",
        ExpiracaoConfidenceUS: "Expiração confidence US",
        ConfidenceEU: "Confidence EU",
        ExpiracaoConfidenceEU: "Expiração confidence EU",
        CTPS: "CTPS",
        CTPSNumeroDeSerie: "CTPS - N de Serie",
        CTPSExpedicao: "CTPS expedição",
        CTPSUF: "CTPS UF",
        TipoSanguineo: "Tipo sanguíneo",
        Matricula: "Matrícula",
        SISPAT: "SISPAT",
        CANAC: "CANAC",
        Licenca: "Licença",
        Contratacao: "Contratação",
        CargoDeAdmissao: "Cargo de admissão",
        CargoAtual: "Cargo Atual",
        EstadoDeNascimento: "Estado de nascimento",
        CidadeDeNascimento: "Cidade de nascimento",
        PaisDeNascimento: "País de nascimento",
        ASO: "ASO",
        Eletrocardiograma: "Eletrocardiograma",
        CodigoSapiens: "Código Sapiens",

        botaoAdicionarFuncionario: "Adicionar colaborador",

        placeholder: {
          Arquivo: "Arquivo",
        }
      }
    },

    EditarFuncionario: {
      titulo: "Edição de funcionário",

      botaoRestaurar: "Restaurar",
      botaoArquivoMorto: "Arquivo Morto",

      botaoExportacoes: {
        Exportacoes: "Exportações",
        ANAC: "ANAC",
        Declaracao: "Declaração",
        Designacoes: "Designações",
        Indicacoes: "Indicações",
        FileDigitalCompleto: "File digital completo",
        Certificacoes: "Certificações",
        VisualizarTodos: "Visualizar todos",
        VisualizarValidos: "Visualizar válidos",
        Curriculo: "Currículo",
        VisualizarPTBR: "Visualizar PT-BR",
        VisualizarENUS: "Visualizar EN-US",
      },

      tabDadosDoFuncionario: {
        tituloTab: "Dados do funcionário",

        formulario: {
          tituloInformacoesPessoais: "Informações pessoais",
  
          Nome: "Nome",
          Apelido: "Apelido",
          Telefone1: "Telefone 1",
          Telefone2: "Telefone 2",
          EstadoCivil: "Estado civil",
          Email: "E-mail",
          Naturalidade: "Naturalidade",
          Escolaridade: "Escolaridade",
          NomeDaMae: "Nome da mãe",
          NomeDoPai: "Nome do pai",
          Raca: "Raça",
          Foto: "Foto",
          DataDeNascimento: "Data de nascimento",
  
          tituloEndereco: "Endereço",
  
          Endereco: "Endereço",
          Numero: "Número",
          Complemento: "Complemento",
          Bairro: "Bairro",
          Cidade: "Cidade",
          Estado: "Estado",
          Pais: "País",
          CEP: "CEP",
          CPF: "CPF",
          Identidade: "Identidade",
          IdentidadeUF: "Identidade - UF",
          IdentidadeDataDeExpedicao: "Identidade - data de expedição",
          PIS: "PIS",
          IdentidadeOrgaoExpeditor: "Identidade - orgão expeditor",
          ConfidenceUS: "Confidence US",
          ExpiracaoConfidenceUS: "Expiração confidence US",
          ConfidenceEU: "Confidence EU",
          ExpiracaoConfidenceEU: "Expiração confidence EU",
          CTPS: "CTPS",
          CTPSNumeroDeSerie: "CTPS - N de Serie",
          CTPSExpedicao: "CTPS expedição",
          CTPSUF: "CTPS UF",
          TipoSanguineo: "Tipo sanguíneo",
          Matricula: "Matrícula",
          SISPAT: "SISPAT",
          CANAC: "CANAC",
          Licenca: "Licença",
          Contratacao: "Contratação",
          CargoDeAdmissao: "Cargo de admissão",
          CargoAtual: "Cargo Atual",
          EstadoDeNascimento: "Estado de nascimento",
          CidadeDeNascimento: "Cidade de nascimento",
          PaisDeNascimento: "País de nascimento",
          ASO: "ASO",
          Eletrocardiograma: "Eletrocardiograma",
          CodigoSapiens: "Código Sapiens",
  
          placeholder: {
            Arquivo: "Arquivo",
          }
        }        

      },

      tabAdministrativo: {
        tituloTab: "Administrativo",

        deletar: "Tem certeza que gostaria de deletar esse arquivo?",
        
        tituloAdicionarArquivos: "Adicionar arquivos",
        formulario: {
          TipoDeArquivo: "Tipo de arquivo",
          Arquivo: "Arquivo",
          NomeDoArquivo: "Nome do arquivo",
          DataDeValidade: "Data de validade",

          botaoAdicionarArquivo: "Adicionar arquivo",

          placeholder: {
            Arquivo: "Arquivo",
            NomeDoArquivo: "Nome do arquivo",
          }
        },

        tabela: {
          semArquivos: "Não há arquivos cadastrados",
          NomeDoArquivo: "Nome do arquivo",
          Tipo: "Tipo",
          Validade: "Validade",
          Acoes: "Ações",
        }

      },

      tabHorasDeVoo: {
        tituloTab: "Horas de voo",

        deletar: "Tem certeza que gostaria de deletar esse arquivo?",
        tituloTotaisDeHoras: "Totais de horas",

        tabelaTotaisDeHoras: {
          semAeronaves: "Não há aeronaves cadastrados",
          ID: "ID",
          Modelo: "Modelo",
          FB: "FB",
          Total: "Total",
          IFR: "IFR.",
          Noturno: "Noturno",
          APP: "APP",
          Diurno: "Diurno",
        },

        tituloAdicionarArquivos: "Adicionar arquivos",

        formularioAdicionarArquivo: {
          Arquivo: "Arquivo",
          NomeDoArquivo: "Nome do arquivo",

          botaoAdicionarArquivo: "Adicionar arquivo",

          placeholder: {
            Arquivo: "Arquivo",
            NomeDoArquivo: "Nome do arquivo",
          }
        },

        tabelaArquivos: {
          semArquivos: "Não há arquivos cadastrados",
          NomeDoArquivo: "Nome do arquivo",
          Validade: "Validade",
          Acoes: "Ações",
        }
      },

      tabHabilitacoes: {
        tituloTab: "Habilitações",

        opcoesCodigoDeHabilitacao: {
          CCF: "CCF",
          CHT: "CHT",
        },

        opcoesHabilitacao: {
          SelecionarTipo: "Selecionar tipo",
          IFRH: "IFRH",
        },

        ativar: "Tem certeza que gostaria de ativar essa habilitação?",
        deletar: "Tem certeza que gostaria de deletar essa habilitação?",
        arquivar: "Tem certeza que gostaria de arquivar essa habilitação?",

        tituloHabilitacoes: "Habilitações",

        botaoEsconderArquivoMorto: "Esconder arquivo morto",
        botaoMostrarArquivoMorto: "Mostrar arquivo morto",

        nenhumaHabilitacaoCadastrada: "Nenhuma habilitação cadastrada.",

        tabela: {
          Codigo: "Código",
          Frota: "Frota",
          Tipo: "Tipo",
          CANAC: "CANAC",
          Licenca: "Licença",
          Vencimento: "Vencimento",
          Status: "Status",
          Acoes: "Ações",

          Ativo: "ativo",
          Arquivado: "arquivado",
        },

        tituloCadastrarHabilitacao: "Cadastrar habilitação",

        formulario: {
          Codigo: "Código",
          Validade: "Validade",
          Frota: "Frota",
          Tipo: "Tipo",
          
          botaoSalvarHabilitacao: "Salvar habilitação",
        }
      },

      tabProcessos: {
        tituloTab: "Processos",

        deletar: "Tem certeza que gostaria de deletar esse arquivo?",

        tituloCadastrarProcesso: "Cadastrar processo",

        formulario: {
          DataDeEmissao: "Data de emissão",
          DataDeValidade: "Data de validade",
          Frota: "Frota",
          Processo: "Processo",
          Subtipo: "Subtipo",
          ArquivoDeProcessosFileDigital: "Arquivo de processos(FILE DIGITAL)",

          botaoAdicionarProcesso: "Adicionar processo",

          placeholder: {
            Arquivo: "Arquivo",
          }
        },

        tituloProcessos: "Processos",

        tabela: {
          semArquivosDeProcessos: "Não há arquivos de processos",
          Frota:"Frota",
          Processo: "Processo",
          Subtipo: "Subtipo",
          DataDeEmissao: "Data de emissão",
          Validade: "Validade",
          Acoes: "Ações",
        }

      },

      tabCertificacoes: {
        tituloTab: "Certificações",

        ativar: "Tem certeza que gostaria de ativar esse certificado?",
        arquivar: "Tem certeza que gostaria de arquivar esse certificado?",
        deletar: "Tem certeza que gostaria de deletar esse certificado?",

        tituloCertificados: "Certificados",

        botaoEsconderArquivoMorto: "Esconder arquivo morto",
        botaoMostrarArquivoMorto: "Mostrar arquivo morto",

        nenhumCertificadoCadastrado: "Nenhum certificado cadastrado.",

        tabela: {
          NomeDoCertificado: "Nome do certificado",
          Inicio: "Início",
          Fim: "Fim",
          Vencimento: "Vencimento",
          Status: "Status",
          Arquivo: "Arquivo",
          Acoes: "Ações",

          Ativo: "ativo",
          Arquivado: "arquivado",
        },

        tituloCadastrarCertificado: "Cadastrar certificado",

        formulario: {
          Certificado: "Certificado",
          Fornecedor: "Fornecedor",
          DataDeInicio: "Data de início",
          DataFinal: "Data final",
          CargaHoraria: "Carga horária",
          QuantidadeDePousosNoturnos: "Quantidade de pousos noturnos",
          Observacoes: "Observações",

          botaoSalvarCertificado: "Salvar certificado",

          placeholder: {
            SelecionarCertificado: "Selecionar certificado",
            SelecionarFornecedor: "Selecionar fornecedor",
          }
        },

        temCertezaQueGostariaDeImportarEsteArquivo: "Tem certeza que gostaria de importar este arquivo? Ao importar, o arquivo anterior será substituido permanentemente.",

        formularioAdicionarArquivo: {
          placeholder: {
            Arquivo: "Arquivo",
          }
        }


      },

      tabAvaliacoes: {
        tituloTab: "Avaliações",

        ativar: "Tem certeza que gostaria de ativar esse certificado?",
        arquivar: "Tem certeza que gostaria de arquivar esse certificado?",
        deletar: "Tem certeza que gostaria de deletar esse certificado?",

        tituloAvaliacoes: "Avaliações",

        botaoEsconderArquivoMorto: "Esconder arquivo morto",
        botaoMostrarArquivoMorto: "Mostrar arquivo morto",

        nenhumCertificadoCadastrado: "Nenhum certificado cadastrado.",

        tabela: {
          NomeDoCertificado: "Nome do certificado",
          Inicio: "Início",
          Fim: "Fim",
          Vencimento: "Vencimento",
          Status: "Status",
          Arquivo: "Arquivo",
          Acoes: "Ações",

          Ativo: "ativo",
          Arquivado: "arquivado",
        },

        tituloCadastrarCertificado: "Cadastrar certificado",

        formulario: {
          Certificado: "Certificado",
          Fornecedor: "Fornecedor",
          DataDeInicio: "Data de início",
          DataFinal: "Data final",
          CargaHoraria: "Carga horária",
          QuantidadeDePousosNoturnos: "Quantidade de pousos noturnos",
          Observacoes: "Observações",

          botaoSalvarCertificado: "Salvar certificado",

          placeholder: {
            SelecionarCertificado: "Selecionar certificado",
            SelecionarFornecedor: "Selecionar fornecedor",
          }
        },


      },

      tabFIRA: {
        tituloTab: "FIRA",
        
        deletar: "Tem certeza que gostaria de deletar esse arquivo?",

        tituloAdicionarArquivos: "Adicionar arquivos",

        formulario: {
          Data: "Data",
          Arquivo: "Arquivo",

          botaoAdicionarArquivo: "Adicionar arquivo",

          placeholder: {
            Arquivo: "Arquivo",
          }
        },

        tabela: {
          semArquivos: "Não há arquivos cadastrados",
          Data: "Data",
          Acoes: "Ações",
        }
      },

      tabCargos: {
        tituloTab: "Cargos",

        ativar: "Tem certeza que gostaria de ativar esse cargo?",
        arquivar: "Tem certeza que gostaria de arquivar esse cargo?",
        deletar: "Tem certeza que gostaria de deletar esse cargo?",

        tituloCargos: "Cargos",

        nenhumCargoCadastrado: "Nenhum cargo cadastrado.",

        tabela: {
          Cargo: "Cargo",
          CodigoRubi: "Cód. Rubi",
          Status: "Status",
          Data: "Data",
          Acoes: "Ações",

          Ativo: "ativo",
          Arquivado: "arquivado",
        },

        tituloCadastrarCargo: "Cadastrar cargo",

        formulario: {
          Cargo: "Cargo",
          DataInicial: "Data inicial",

          botaoSalvarCargo: "Salvar cargo",
        }


      },

      tabDesignacoes: {
        tituloTab: "Designações",

        ativar: "Tem certeza que gostaria de ativar essa designação?",
        deletar: "Tem certeza que gostaria de deletar essa designação?",
        arquivar: "Tem certeza que gostaria de arquivar essa designação?",

        tituloDesignacoes: "Designações",

        nenhumaDesignacaoCadastrada: "Nenhuma designação cadastrada.",

        tabela: {
          Designacao: "Designação",
          Frota: "Frota",
          Status: "Status",
          Data: "Data",
          Acoes: "Ações",

          Ativo: "ativo",
          Arquivado: "arquivado",
        },

        tituloCadastrarDesignacao: "Cadastrar designação",

        formulario: {
          Designacao: "Designação",
          DataInicial: "Data inicial",
          Frota: "Frota",

          botaoSalvarDesignacao: "Salvar designação",
        }
      },

      tabIndicacoes: {
        tituloTab: "Indicações",

        ativar: "Tem certeza que gostaria de ativar essa indicação?",
        arquivar: "Tem certeza que gostaria de arquivar essa indicação?",
        deletar: "Tem certeza que gostaria de deletar essa indicação?",

        tituloIndicacao: "Indicação",

        nenhumaIndicacaoCadastrada: "Nenhuma indicação cadastrada.",
        
        tabela: {
          Designacao: "Designação",
          Frota: "Frota",
          Status: "Status",
          Data: "Data",
          Acoes: "Ações",

          Ativo: "ativo",
          Arquivado: "arquivado",
        },

        tituloCadastrarIndicacao: "Cadastrar indicação",

        formulario: {
          Designacao: "Designação",
          Validade: "Validade",
          Frota: "Frota",

          botaoSalvarIndicacao: "Salvar indicação",
        }

      },

      tabRegimes: {
        tituloTab: "Regimes",

        ativar: "Tem certeza que gostaria de ativar essa quinzena?",
        arquivar: "Tem certeza que gostaria de arquivar essa quinzena?",
        deletar: "Tem certeza que gostaria de deletar essa quinzena?",

        tituloRegimes: "Regimes",

        nenhumRegimeCadastrado: "Nenhum regime cadastrado.",

        tabela: {
          Regime: "Regime",
          Data: "Data",
          Mes: "Mês",
          Ano: "Ano",
          Status: "Status",
          Acoes: "Ações",
          
          Ativo: "ativo",
          Arquivado: "arquivado",
        },

        tituloCadastrarRegime: "Cadastrar regime",

        formulario: {
          Regime: "Regime",
          DataInicial: "Data inicial",

          botaoSalvarRegime: "Salvar regime",
        }
      },

      tabGratificacoes: {
        tituloTab: "Gratificações",

        ativar: "Tem certeza que gostaria de ativar essa gratificação?",
        arquivar: "Tem certeza que gostaria de arquivar essa gratificação?",
        deletar: "Tem certeza que gostaria de deletar essa gratificação?",

        tituloGratificacoes: "Gratificações",
        nenhumaGratificacaoCadastrada: "Nenhuma gratificação cadastrada.",

        tabela: {
          Gratificacao: "Gratificação",
          Data: "Data",
          Status: "Status",
          Acoes: "Ações",

          Ativo: "ativo",
          Arquivado: "arquivado",
        },

        tituloCadastrarGratificacao: "Cadastrar gratificação",

        formulario: {
          Gratificacao: "Gratificação",
          DataInicial: "Data inicial",

          botaoSalvarGratificacao :"Salvar gratificação",
        }

      },

      tabAprovacoes: {
        tituloTab: "Aprovações",

        tituloAprovacoesDeClientes: "Aprovações de clientes",

        nenhumaAprovacaoCadastrada: "Nenhuma aprovação cadastrada.",

        tabela: {
          Client: "Client",
          Grupo: "Grupo",
          Funcao: "Função",
          Aeronaves: "Aeronaves",
        }

      },

      tabICAO: {
        tituloTab: "ICAO",

        ativar: "Tem certeza que gostaria de ativar esse ICAO?",
        deletar: "Tem certeza que gostaria de deletar esse ICAO?",
        arquivar: "Tem certeza que gostaria de arquivar esse ICAO?",

        tituloICAOS: "ICAOS",

        nenhumICAOCadastrado: "Nenhum ICAO cadastrado.",

        tabela: {
          Level: "Level",
          Vencimento: "Vencimento",
          DataDeInsercao: "Data de Inserção",
          Status: "Status",
          Acoes: "Ações",

          Ativo: "ativo",
          Arquivado: "arquivado",
        },

        tituloCadastrarICAO: "Cadastrar ICAO",

        formulario: {
          Level: "Level",
          DataDeVencimento: "Data de vencimento",

          botaoSalvarICAO: "Salvar ICAO",
        }
      },

      tabPagamentos: {
        tituloTab: "Pagamentos",

        tabHoras: {
          tituloTab: "Horas",

          tabela: {
            semPagamentosEmAberto: "Não há pagamentos em aberto",
            ID: "ID",
            CodigoTreinamento: "Código trein.",
            TipoDeTreinamento: "Tipo de trein.",
            Aula: "Aula",
            Periodo: "Período",
            Treinamento: "Treinamento",
            NumeroERev: "Nº e Rev.",
            Local: "Local",
            HorasPagas: "Horas pagas",
            ValorDaHora: "Valor da hora",
            TotalDeHoras: "Total de horas",
          }

        },

        tabDiariaNacional: {
          tituloTab: "Diária nacional",

          tabela: {
            semPagamentosEmAberto: "Não há pagamentos em aberto",
            ID: "ID",
            CodigoTreinamento: "Código trein.",
            Periodo: "Período",
            Treinamento: "Treinamento",
            NumeroERev: "Nº e Rev.",
            Diarias: "Diárias",
            ValorDiaria: "Valor/diária",
            TotalEmDiarias: "Total em diárias",
            Moeda: "Moeda",
          }

        },
        
        tabDiariaInternacional: {
          tituloTab: "Diária internacional",

          tabela: {
            semPagamentosEmAberto: "Não há pagamentos em aberto",
            ID: "ID",
            CodigoTreinamento: "Código trein.",
            Periodo: "Período",
            Treinamento: "Treinamento",
            NumeroERev: "Nº e Rev.",
            Diarias: "Diárias",
            ValorDiaria: "Valor/diária",
            TotalEmDiarias: "Total em diárias",
            Moeda: "Moeda",
          }
        }

      },

      tabFerias: {
        tituloTab: "Férias",

        ativar: "Tem certeza que gostaria de ativar essa indicação?",
        arquivar: "Tem certeza que gostaria de arquivar essa indicação?",

        tituloFerias: "Férias",

        nenhumaIndicacaoCadastrada: "Nenhuma indicação cadastrada.",

        tabela: {
          Limite: "Limite",
          Direito: "Direito",
          InicioEscala: "Início Escala",
          TerminoEscala: "Término Escala",
        }


      },

      tabBaseContratual: {
        tituloTab: "Base contratual",

        ativar: "Tem certeza que gostaria de ativar essa base?",
        arquivar: "Tem certeza que gostaria de arquivar essa base?",
        deletar: "Tem certeza que gostaria de deletar essa base?",

        tituloBases: "Bases",

        nenhumaBaseCadastrada: "Nenhuma base cadastrada.",

        tabela: {
          Base: "Base",
          Status: "Status",
          Acoes: "Ações",

          Ativo: "ativo",
          Arquivado: "arquivado",
        },

        tituloAdicionarBase: "Adicionar base",

        formulario: {
          Base: "Base",

          botaoSalvarBase: "Salvar base",
        }

      },

      tabCentroDeCusto: {
        tituloTab: "Centro de custo",

        ativar: "Tem certeza que gostaria de ativar esse centro de custo?",
        arquivar: "Tem certeza que gostaria de arquivar esse centro de custo?",
        deletar: "Tem certeza que gostaria de deletar esse centro de custo?",

        tituloCentroDeCusto: "Centro de custo",

        nenhumCentroDeCustoCadastrado: "Nenhum centro de custo cadastrado.",

        tabela: {
          CentroDeCusto: "Centro de custo",
          Data: "Data",
          Status: "Status",
          Acoes: "Ações",

          Ativo: "ativo",
          Arquivado: "arquivado",
        },

        tituloCadastrarCentroDeCusto: "Cadastrar centro de custo",

        formulario: {
          CentroDeCusto: "Centro de custo",
          DataInicial: "Data inicial",

          botaoSalvarCentroDeCusto: "Salvar centro de custo",
        }

      },

      tabHorasGarantidas: {
        tituloTab: "Horas garantidas",

        ativar: "Tem certeza que gostaria de ativar essas horas garantidas?",
        arquivar: "Tem certeza que gostaria de arquivar essas horas garantidas?",
        deletar: "Tem certeza que deseja deletar essas horas garantidas?",

        tituloCentroDeCusto: "Centro de custo",

        botaoEsconderArquivoMorto: "Esconder arquivo morto",
        botaoMostrarArquivoMorto: "Mostrar arquivo morto",

        nenhumaHorasGarantidasCadastrado: "Nenhuma horas garantidas cadastrado.",

        tabela: {
          HorasGarantidasAdicional: "Horas Garantidas - Adicional",
          Codigo: "Código",
          CadastradoEm: "Cadastrado em",
          Status: "Status",
          Acoes: "Ações",

          Ativo: "ativo",
          Arquivado: "arquivado",
        },

        tituloCadastrarHorasGarantidas: "Cadastrar horas garantidas",

        formulario: {
          HorasGarantidasAdicional: "Horas Garantidas - Adicional",
          Codigo: "Código",
          
          botaoSalvarHorasGarantidas: "Salvar horas garantidas",
        },
      }
    },

    ListaDeFuncionariosCVODVO: {
      titulo: "Lista de funcionários CVO/DVO",

      botaoAdicionarFuncionario: "Adicionar funcionário",

      tabela: {
        semCVODVO: "Não há CVO/DVO cadastrados",
        Nome: "Nome",
        Matricula: "Matrícula",
        Cargo: "Cargo",
        Licenca: "Licença",
        CANAC: "CANAC",
        Acoes: "Ações",
      }
    },

    ListaDeFuncionariosCVODVOdesligados: {
      titulo: "Lista de funcionários CVO/DVO desligados",

      botaoAdicionarFuncionario: "Adicionar funcionário",

      tabela: {
        semCVODVO: "Não há CVO/DVO cadastrados",
        Nome: "Nome",
        Matricula: "Matrícula",
        Cargo: "Cargo",
        Licenca: "Licença",
        CANAC: "CANAC",
        Acoes: "Ações",
      }
    },

    ListaDeCertificadosAVencerPorColaborador: {
      titulo: "Lista de certificados a vencer por colaborador",

      tabela: {
        semTripulantes: "Não há tripulantes cadastrados",
        Tripulante: "Tripulante",
        Certificados: "Certificados",
        Prazo: "Prazo",
        Expirado: "Expirado",
        DataDeExpiracao: "Data de expiração",
      }
    },

    CVOSemCertificado: {
      titulo: "Colaboradores sem certificado",

      tabela: {
        semColaboradorSemCertificado: "Não há colaborador sem certificado",
        Tripulante: "Tripulante",
        Cargo: "Cargo",
        Grupo: "Grupo",
        Certificado: "Certificado",
      }
    },

    ListaDeCertificadosAVencerPorMestreDeCarga: {
      titulo: "Lista de certificados a vencer por mestre de carga",

      tabela: {
        semTripulantes: "Não há tripulantes cadastrados",
        Tripulante: "Tripulante",
        Certificados: "Certificados",
        Prazo: "Prazo",
        Expirado: "Expirado",
        DataDeExpiracao: "Data de expiração",
      }
    },

    ListaDeMestresDeCargaDesligados: {
      titulo: "Lista de mestres de carga desligados",
      botaoAdicionarFuncionario: "Adicionar funcionário",

      tabela: {
        semMestres: "Não há mestres cadastrados",
        Nome: "Nome",
        Matricula: "Matrícula",
        Cargo: "Cargo",
        Licenca: "Licença",
        CANAC: "CANAC",
        Acoes: "Ações",
      }
    },

    ListaDeMestresDeCarga: {
      titulo: "Lista de mestres de carga",
      botaoAdicionarFuncionario: "Adicionar funcionário",

      tabela: {
        semMestres: "Não há mestres cadastrados",
        Nome: "Nome",
        Matricula: "Matrícula",
        Cargo: "Cargo",
        Licenca: "Licença",
        CANAC: "CANAC",
        Acoes: "Ações",
      }
    },
    
    MestreDeCargaSemCertificado: {
      titulo: "Colaboradores sem certificado",

      tabela: {
        semColaboradorSemCertificado: "Não há colaborador sem certificado",
        Colaborador: "Colaborador",
        Cargo: "Cargo",
        Grupo: "Grupo",
        Certificado: "Certificado",
      }

    },

    ControleDeCertificadosPorDataDeEmissao: {
      titulo: 'Controle de certificados por data de emissão',
      formulario: {
        DataInicial: 'Data Inicial',
        DataFinal: 'Data Final',
      },
      tabela: {
        ID: 'ID',
        Matricula: 'Matrícula',
        Nome: 'Nome',
        Certificado: 'Certificado',
        DataDeEmissao: 'Data de emissão',
        DataDeVencimento: 'Data de vencimento',
      },
      eNecessarioPreencherDataDeInicioEFimParaPesquisasAnaliticas: 'É necessário preencher data de início e fim para pesquisas analíticas.',

    },

    ListaDeFuncionariosQuePossuemDocumentosPendentes: {

      titulo: "Lista de funcionários que possuem documentos pendentes",

      tituloAListaDeDocumentosPendentesEAtualizadaUmaVezAoDia: "A lista de documentos pendentes é atualizada uma vez ao dia, as 05:00.",

      tabela: {
        semTripulantes: "Não há tripulantes cadastrados",
        Matricula: "Matrícula",
        Nome: "Nome",
        Documentos: "Documentos",
      }
    },

    VisualizarHorasDeVoo: {
      opcoesTipo: {
        Sintetica: "Sintética (Ignora filtro de data)",
        Analitica: "Analítica",
      },

      eNecessarioPreencherDataDeInicioEFimParaPesquisasAnaliticas: "É necessário preencher data de início e fim para pesquisas analíticas",
      
      titulo: "Visualizar horas de voo",

      formulario: {
        DataInicial: "Data Inicial",
        DataFinal: "Data Final",
        FB: "FB",
        Listagem: "Listagem",
        Modelo: "Modelo",
        Nome: "Nome",

        placeholder: {
          SelecionarTipo: "Selecionar tipo",
          SelecionarModelosDeAeronave: "Selecionar modelos de aeronave",
          SelecionarTripulantes: "Selecionar tripulantes",
        }
      },

      tabela: {
        semAeronaves: "Não há aeronaves cadastrados",
        ID: "ID",
        Data: "Data",
        Matricula: "Mat.",
        Apelido: "Apelido",
        Modelo: "Modelo",
        FB: "FB",
        Simulador: "Simulador",
        Total: "Total",
        IFR: "IFR.",
        Noturno: "Noturno",
        APP: "APP",
        Diu: "Diu",
        Not: "Not",
        CgExt: "Cg. Ext.",
      },

      tituloTotais: "Totais",

      tabelaTotais: {
        semAeronaves: "Não há aeronaves cadastrados",
        ID: "ID",
        Matricula: "Mat.",
        Apelido: "Apelido",
        Modelo: "Modelo",
        Total: "Total",
        IFR: "IFR.",
        Noturno: "Noturno",
        APP: "APP",
        Diu: "Diu",
        Not: "Not",
      }

      

    },

    AdicionarHorasDoTripulante: {
      deletar: "Tem certeza que gostaria de deletar essa hora?",

      titulo: "Adicionar horas do tripulante",

      formulario: {
        Aeronave: "Aeronave",
        FB: "FB",
        Total: "Total",
        IFR: "IFR",
        Noturno: "Noturno",
        HNav: "H. Nav",
        Data: "Data",
        APP: "APP",
        Diurno: "Diurno",
        Empresa: "Empresa",
        CargaExterna: "Carga Externa",
        Observacoes: "Observações",

        botaoAdicionarHoras: "Adicionar horas",

        opcoesEmpresa: {
          Omni: "Costa do Sol",
          Outros: "Outros",
        },

        placeholder: {
          SelecionarAeronave: "Selecionar aeronave",
          SelecionarTipo: "Selecionar tipo",
        }
      },

      tituloListagemDeHoras: "Listagem de horas",

      tabelaListagemDeHoras: {
        semAeronaves: "Não há aeronaves cadastrados",
        ID: "ID",
        Modelo: "Modelo",
        FB: "FB",
        Total: "Total",
        IFR: "IFR.",
        Noturno: "Noturno",
        APP: "APP",
        Diurno: "Diurno",
        Data: "Data",
        Acoes: "Ações",
      },

      tituloTotaisDeHoras: "Totais de horas",

      tabelaTotaisDeHoras: {
        semAeronaves: "Não há aeronaves cadastrados",
        ID: "ID",
        Modelo: "Modelo",
        FB: "FB",
        Total: "Total",
        IFR: "IFR.",
        Noturno: "Noturno",
        APP: "APP",
        Diurno: "Diurno",
      },

      tituloEditarHorasDeVoo: "Editar horas de voo",

      formularioEditarHorasDeVoo: {
        Aeronave: "Aeronave",
        FB: "FB",
        Total: "Total",
        IFR: "IFR",
        Noturno: "Noturno",
        HNav: "H. Nav",
        Data: "Data",
        APP: "APP",
        Diurno: "Diurno",
        Empresa: "Empresa",

        opcoesEmpresa: {
          Omni: "Costa do Sol",
          Outros: "Outros",
        },

        CargaExterna: "Carga Externa",
        Observacoes: "Observações",

        botaoEditarHora: "Editar hora",

        placeholder: {
          SelecionarAeronave: "Selecionar aeronave",
          SelecionarTipo: "Selecionar tipo",
        }
      }


    },

    ListagemDeFuncionariosSemCargoArquivados: {
      titulo: "Listagem de funcionários sem cargo arquivados",

      botaoAdicionarFuncionario: "Adicionar funcionário",

        tabela: {
          semTripulantes: "Não há tripulantes cadastrados",
          Nome: "Nome",
          Matricula: "Matrícula",
          Cargo: "Cargo",
          Licenca: "Licença",
          CANAC: "CANAC",
          Acoes: "Ações",
        }
    },

    ListaDeASOVencidos: {
      titulo: "Lista de aso e eletrocardiagrama por tripulante",

      tabela: {
        semTripulantes: "Não há tripulantes cadastrados",
        Tripulante: "Tripulante",
        Matricula: "Matrícula",
        Idade: "Idade",
        ASO: "ASO",
        AtualizacaoASO: "Atualização ASO",
        Eletrocardiograma: "Eletrocardiograma",
        AtualizacaoEletro: "Atualização Eletro",
      }
    },

    ControleDeTreinamentosConsolidados: {
      titulo: "Controle de Treinamentos Consolidados",

      formulario: {
        AplicabilidadeTipoDeColaborador: "Aplicabilidade - Tipo de Colaborador",

        opcoesAplicabilidade: {
          Tripulantes135: "Tripulantes - 135",
          Tripulantes121: "Tripulantes - 121",
          Coordenadores: "Coordenadores",
          MestresDeCarga: "Mestres de Carga",
        },

        Colaboradores: "Colaboradores",
        Certificados: "Certificados",
        Designacoes: "Designações",
        ApenasAtivos: "Apenas ativos",
        OcultarCamposPadroesDeTripulantes: "Ocultar campos padrões de tripulantes",


        placeholder: {
          SelecionarAplicabilidade: "Selecionar aplicabilidade",
          SelecionarColaboradores: "Selecionar colaboradores",
          SelecionarCertificados: "Selecionar certificados",
          SelecionarModeloDeAeronave: "Selecionar modelo de aeronave",
        }
      },

      botaoExportarEmCSV: "Exportar em CSV",

      tabela: {
        Matricula: "Mat.",
        NomeDeGuerra: "Nome de Guerra",
        Designacao: "Designação",
        Cargo: "Cargo",
        Licenca: "Licença",
        CHT: "CHT",
        IFR: "IFR",
        CMA: "CMA",
        Noturno: "Noturno",
      }

    },

    ListaDeCertificados: {
      titulo: "Lista de certificados a vencer por tripulante",

      tabela: {
        semTripulantes: "Não há tripulantes cadastrados",
        Tripulante: "Tripulante",
        Certificado: "Certificado",
        CargaHoraria: "Carga Horária",
        Prazo: "Prazo",
        Expirado: "Expirado",
        DataDeExpiracao: "Data de expiração",
      }
    },

    CertificadosDeFiltroMultiplo: {
      formulario: {
        Certificados: "Certificados",

        placeholder: {
          SelecionarCertificados: "Selecionar certificados",
        }
      },

      tabela: {
        Tripulante: "Tripulante",
        Matricula: "Matrícula",

      }
    },

    ListaDeCertificadosAVencerPorTripulante: {

      titulo: "Lista de certificados a vencer por tripulante",

      tabela: {
        semTripulantes: "Não há tripulantes cadastrados",
        Tripulante: "Tripulante",
        Certificados: "Certificados",
        Prazo: "Prazo",
        Expirado: "Expirado",
        DataDeExpiracao: "Data de expiração",
      }

    },

    ListaDeTripulantesPorDesignacao: {
      titulo: "Lista de tripulantes por designação",

      tabela: {
        semTripulantes: "Não há tripulantes cadastrados",
        Matricula: "Matrícula",
        Nome: "Nome",
        Cargo: "Cargo",
        Designacao: "Designação",
        Modelo: "Modelo",
        DataDesig: "Data desig.",
      },
    },

    ListagemDeTripulantesPorSenioridade: {
      titulo: "Listagem de Tripulantes por Senioridade",
      
      botaoExportarEmCSV: "Exportar em CSV",

      tabela: {
        Matricula: "Mat.",
        Tripulante: "Tripulante",
        Designacoes: "Designações",
        Quinzena: "Quinzena",
        Cargo: "Cargo",
        Licenca: "Licença",
        Admissao: "Admissão",
        Senioridade: "Senioridade",
        Icao: "Icao",
        Total: "Total",
        UmP: "1P",
        DoisP: "2P",
        Heli: "Heli.",
        UmPH: "1PH",
        Mono: "Mono",
        Multi: "Multi",
        UmPMu: "1PMu",
        MuH: "MuH",
        UmPMuH: "1PMuH",
        GP: "GP",
        GP1P: "GP - 1P",
        MP: "MP",
        MP1P: "MP - 1P",
        PP: "PP",
        PP1P: "PP - 1P",
        IFR: "IFR",
        Not: "Not.",
      }
    },

    ListaDeICAOSTripulante: {
      titulo: "Lista de ICAOS tripulante",

      tabela: {
        semTripulantes: "Não há tripulantes cadastrados",
        Matricula: "Matrícula",
        Tripulante: "Tripulante",
        Designacao: "Designação",
        Frota: "Frota",
        Level: "Level",
        DataDeExpiracao: "Data de expiração",
        Status: "Status",
        DataDeInsercao: "Data de inserção",
      }
    },

    ListaDeTripulantesDesligados: {
      titulo: "Lista de tripulantes desligados",
      botaoAdicionarFuncionario: "Adicionar funcionário",

      tabela: {
        semTripulantes: "Não há tripulantes cadastrados",
        Nome: "Nome",
        Matricula: "Matrícula",
        Cargo: "Cargo",
        Licenca: "Licença",
        CANAC: "CANAC",
        Acoes: "Ações",
      },
    },

    ListaDeTodosOsTripulantes: {
      titulo: "Lista colaboradores",

      botaoAdicionarFuncionario: "Adicionar colaborador",

      tabela: {
        semTripulantes: "Não há colaboradores cadastrados",
        Nome: "Nome",
        Matricula: "Matrícula",
        Cargo: "Cargo",
        Licenca: "Licença",
        CANAC: "CANAC",
        Acoes: "Ações",
      }
    },

    ColaboradoresSemCertificado: {
      titulo: "Colaboradores sem certificado",

      tabela: {
        semColaboradorSemCertificado: "Não há colaborador sem certificado",
        Colaborador: "Colaborador",
        Cargo: "Cargo",
        Grupo: "Grupo",
        Certificado: "Certificado",
      }
    },

    ListaDeFuncionariosSemCargo: {
      titulo: "Lista de funcionários sem cargo",

      botaoAdicionarFuncionario: "Adicionar funcionário",

      tabela: {
        semTripulantes: "Não há tripulantes cadastrados",
        Nome: "Nome",
        Matricula: "Matrícula",
        Cargo: "Cargo",
        Licenca: "Licença",
        CANAC: "CANAC",
        Acoes: "Ações",
      }

    }




  },
  
  Solicitacoes: {
    ListaDeSolicitacoes: {
      reprovar: "Tem certeza que gostaria de reprovar essa solicitação?",
      aprovar: "Tem certeza que gostaria de aprovar essa solicitação?",


      titulo: "Lista de Solicitações",

      tabela: { 
        semSolicitacoes: "Não há solicitações cadastradas",
        DataDeCriacao: "Data de Criação",
        NomeDoColaborador: "Nome do Colaborador",
        Inicio: "Início",
        Fim: "Fim",
        Justificativa: "Justificativa",
        Status: "Status",
        ChefeDeFrota: "Chefe de Frota",
        ChefeDeFrotaDataResposta: "Chefe de Frota - Data Resposta",
        ChefeDeFrotaAprovacao: "Chefe de Frota - Aprovação",
        ChefeDeFrotaJustificativa: "Chefe de Frota - Justificativa",
        Administrativo: "Administrativo",
        AdministrativoDataResposta: "Administrativo - Data Resposta",
        AdministrativoAprovacao: "Administrativo - Aprovação",
        AdministrativoResposta: "Administrativo - Resposta",
        
      }
    },

    SolicitaçãoDeAlteracaoDeEscala: {
      aprovar: "Tem certeza que deseja aprovar essa solicitação?",
      reprovar: "Tem certeza que deseja reprovar essa solicitação?",

      solicitacaoReprovadaComSucesso: "Solicitação reprovada com sucesso",
      eNecessarioPreencherUmaJustificativaParaReprovacao: "É necessário preencher uma justificativa para reprovação",

      titulo: "Solicitação de Alteração de Escala",

      tabela: {
        Nome: "Nome",
        Inicio: "Início",
        Fim: "Fim",
        Justificativa: "Justificativa",
      },

      botaoConfirmarAprovacao: "Confirmar aprovação",
      botaoConfirmarReprovacao: "Confirmar reprovação",

      placeholder: {
        InstrucoesAoEscalador: "Instruções ao escalador",
        JustifiqueAReprovacao: "Justifique a reprovação",
      },

      paragrafoSolicitacaoJaRespondida: "Solicitação já respondida.",
    },

    ListaDeSolicitacoesPendentes: {
      reprovar: "Tem certeza que gostaria de reprovar essa solicitação?",
      aprovar: "Tem certeza que gostaria de aprovar essa solicitação?",

      titulo: "Lista de Solicitações Pendentes",

      tabela: {
        semSolicitacoes: "Não há solicitações cadastradas",
        Acoes: "Ações",
        ID: "ID",
        DataDeCriacao: "Data de Criação",
        NomeDoColaborador: "Nome do Colaborador",
        Inicio: "Início",
        Fim: "Fim",
        Justificativa: "Justificativa",
        ChefeDeFrotaDataResposta: "Chefe de Frota - Data Resposta",
        ChefeDeFrotaJustificativa: "Chefe de Frota - Justificativa",
      },

      tituloJustifiqueAReprovacao: "Justifique a reprovação",

      formulario: {
        botaoJustificar: "Justificar",
      }
    }
  },

  Fornecedores: {
    ListaDeFornecedores: {
      ativo: "ativo",
      arquivado: "arquivado",

      ativar: "Tem certeza que gostaria de ativar esse fornecedor?",
      arquivar: "Tem certeza que gostaria de arquivar esse fornecedor?",

      titulo: "Lista de fornecedores",
      botaoAdicionarFornecedor: "Adicionar fornecedor",

      tabela: {
        semFornecedores: "Não há fornecedores cadastrados",
        ID: "ID",
        Nome: "Nome",
        Email: "E-mail",
        Telefone: "Telefone",
        Pais: "País",
        Status: "Status",
        Acoes: "Ações",
      }
    },

    AdicionarFornecedor: {
      titulo: "Cadastrar fornecedor",

      formulario: {
        Nome: "Nome",
        Endereco: "Endereço",
        Cidade: "Cidade",
        Estado: "Estado",
        Pais: "País",
        CEP: "CEP",
        Telefone: "Telefone",
        Email: "E-mail",
        Observacoes: "Observações",

        placeholder: {
          NomeDoFornecedor: "Nome do fornecedor",
          EnderecoDoFornecedor: "Endereço do fornecedor",
          CidadeDoFornecedor: "Cidade do fornecedor",
          EstadoProvinciaDoFornecedor: "Estado/Provincia do fornecedor",
          SelecionarPais: "Selecionar país",
          CEPDoFornecedor: "CEP do fornecedor",
          TelefoneDoFornecedor: "Telefone do fornecedor",
          EmailDoFornecedor: "E-mail do fornecedor",

        }
      }
    },

    EditarFornecedor: {
      titulo: "Edição de fornecedor",

      tabDadosDoFornecedor: {
        tituloTab: "Dados do fornecedor",

        formulario: {
          Nome: "Nome",
          Endereco: "Endereço",
          Cidade: "Cidade",
          Estado: "Estado",
          Pais: "País",
          CEP: "CEP",
          Telefone: "Telefone",
          Email: "E-mail",
          Observacoes: "Observações",
  
          placeholder: {
            NomeDoFornecedor: "Nome do fornecedor",
            EnderecoDoFornecedor: "Endereço do fornecedor",
            CidadeDoFornecedor: "Cidade do fornecedor",
            EstadoProvinciaDoFornecedor: "Estado/Provincia do fornecedor",
            SelecionarPais: "Selecionar país",
            CEPDoFornecedor: "CEP do fornecedor",
            TelefoneDoFornecedor: "Telefone do fornecedor",
            EmailDoFornecedor: "E-mail do fornecedor",
  
          }
        }
      },

      tabCertificadosDoFornecedor: {
        tituloTab: "Certificados do fornecedor",

        deletarCertificado: "Tem certeza que gostaria de deletar esse certificado?",
        ativarFornecedor: "Tem certeza que gostaria de ativar esse fornecedor",
        arquivarFornecedor: "Tem certeza que gostaria de arquivar esse fornecedor?",

        tabela: {
          Certificado: "Certificado",
          Tipo: "Tipo",
          Telefone: "Telefone",
          Cidade: "Cidade",
          Pais: "País",
          Expiracao: "Expiração",
          CustoH: "Custo/H",
          Reembolso: "Reembolso",
          Status: "Status",
          Acoes: "Ações",

          Ativo: "ativo",
          Arquivado: "arquivado",
        },

        tituloAdicionarCertificado: "Adicionar certificado",

        formulario: {
          Certificados: "Certificados",
          CodigoANAC: "Código ANAC",
          Expiracao: "Expiração",
          Certificacao: "Certificação",
          PrazoParaCancelamentoComRetornoDoPagamentoEmDias: "Prazo para Cancelamento com Retorno do Pagamento (em dias)",
          Endereco: "Endereço",
          Cidade: "Cidade",
          Estado: "Estado",
          Pais: "País",
          ContatoNome: "Contato nome",
          Telefone: "Telefone",
          Email: "E-mail",
          Observacoes: "Observações",
          ValorHora: "Valor Hora",

          botaoSalvarCertificado: "Salvar certificado",

          placeholder: {
            SelecionarCertificado: "Selecionar certificado",
            EnderecoDoFornecedor: "Endereço do fornecedor",
            CidadeDofornecedor: "Cidade do fornecedor",
            EstadoProvinciaDoFornecedor: "Estado/Provincia do fornecedor",
            SelecionarPais: "Selecionar país",
            TelefoneDoFornecedor: "Telefone do fornecedor",
            EmailDoFornecedor: "E-mail do fornecedor",
          },
        },
      }
    },
  },

  Tarefas: {

    ListaDeTarefas: {
      titulo: "Lista de tarefas",
      
      botaoAdicionarTarefa: "Adicionar tarefa",

      tabela: {
        semTarefas: "Não há tarefas cadastrados",
        ID: "ID",
        Nome: "Nome",
        Acoes: "Ações",
      }
    },

    AdicionarTarefa: {
      titulo: "Cadastrar tarefas de restrição",

      formulario: {
        Tarefa: "Tarefa",

        botaoCadastrarTarefa: "Cadastrar tarefa",

        placeholder: {
          TarefaDeRestricao: "Tarefa de restrição",
        }
      }
    },

    EditarTarefa: {
      titulo: "Editar tarefa de restrição",

      formulario: {
        Tarefa: "Tarefa",

        placeholder: {
          TarefaDeRestricao: "Tarefa de restrição",
        }
      }

    }

  },

  Treinamentos: {

    ListaDeTreinamentos: {
      titulo: "Lista de treinamentos",

      botaoAdicionarTreinamento: "Adicionar treinamento",

      tabela: {
        semTreinamentos: "Não há treinamentos cadastrados",
        ID: "ID",
        Nome: "Nome",
        Status: "status",
        CodigoDeControle: "Código de controle",
        TiposDeCertificado: "Tipos de certificado",
        Modalidade: "Modalidade",
        DataInicial: "Data inicial",
        DataFinal: "Data final",
        Acoes: "Ações",
      }
    },

    AdicionarDeTreinamento: {
      titulo: "Cadastrar treinamento",

      formulario: {
        DataDeInicio: "Data de início",
        DataDeTermino: "Data de término",
        Nome: "Nome",
        Observacoes: "Observações",
            
        botaoAdicionarTreinamento: "Adicionar treinamento",

        placeholder: {
          DataDeInicio: "Data de início",
          DataDeTermino: "Data de término",
          NomeDoTreinamento: "Nome do treinamento",
        }
      }
    },

    EditarTreinamento: {
      trocarStatus: "Tem certeza que gostaria de trocar o status do treinamento?",
      trocarStatusParaCancelado: "Tem certeza que gostaria de trocar o status do treinamento para cancelado?",
      trocarStatusParaDivulgado: "Tem certeza que gostaria de trocar o status do treinamento para divulgado?",
      trocarStatusParaFinalizado: "Tem certeza que gostaria de trocar o status do treinamento para finalizado?",

      ignorarFichas: "Ignorar fichas",
      fichasNecessarias: "Fichas necessárias",

      gerarOsPagamentosDosAlunosDePresencaConfirmada: "Tem certeza que gostaria de gerar os pagamentos dos alunos de presença confirmada deste treinamento?",

      selecioneUmTipoDeExportacao: "Selecione um tipo de exportação.",
      desejaEnviarEmail: "Deseja enviar e-mail?",
      naoHaNenhumArquivoAnexado: "Não há nenhum arquivo anexado, tem certeza que deseja prosseguir?",

      titulo: "Edição de treinamento",

      botaoTripulantesElegiveis: "Tripulantes elegíveis",
      botaoConfirmarPagamentos: "Confirmar pagamentos",

      botaoExportar: {
        Exportar: "Exportar",
        Solo: "Solo",
        SoloTIC: "Solo TIC",
        Simulador: "Simulador",
        EAD: "EAD",
      },

      botaoFichas: {
        TrocarParaIgnorarFichas: "Trocar para ignorar fichas",
        TrocarParaFichasNecessarias: "Trocar para fichas necessárias",
      },

      botaoAlertas: "Alertas",

      botaoStatus: {
        TrocarParaDivulgado: "Trocar para Divulgado",
        TrocarParaCancelado: "Trocar para Cancelado",
        TrocarParaFinalizado: "Trocar para Finalizado",
        Cancelado: "Cancelado",
      },

      botaoEmail: "E-mail",

      tabDadosDoTreinamento: {
        tituloTab: "Dados do treinamento",

        formulario: {
          DataDeInicio: "Data de início",
          DataDeTermino: "Data de término",
          Nome: "Nome",
          Codigo: "Código",
          Revisao: "Revisão",
          Observacoes: "Observações",

          placeholder: {
            DataDeInicio: "Data de início",
            DataDeTermino: "Data de término",
            NomeDoTreinamento: "Nome do treinamento",
          }
        }

      },

      tabAulas: {
        tituloTab: "Aulas",

        deletarAula: "Tem certeza que gostaria de deletar essa aula?",
        mensagemDadosAtualizadosComSucesso: "Os dados foram atualizados com sucesso",

        tituloAdicionarCertificado: "Adicionar certificado",

        formularioAdicionarCertificado: {
          Certificado: "Certificado",
          Fornecedor: "Fornecedor",
          DataDeInicio: "Data de início",
          DataDeTermino: "Data de término",
          Periodo: "Período",
          TipoDeModalidade: "Tipo de modalidade",

          opcoesTipoDeModalidade: {
            Presencial: "Presencial",
            EAD: "EAD",
          },

          botaoAdicionarCertificado: "Adicionar certificado",

          placeholder: {
            SelecionarCertificado: "Selecionar certificado",
            SelecionarFornecedor: "Selecionar fornecedor",
            DataDeInicio: "Data de início",
            DataDeTermino: "Data de término",
            PeriodoDaAula: "Período da aula",
            SelecionarTipoDeModalidade: "Selecionar tipo de modalidade",
          }
        },

        tituloListaDeCertificados: "Lista de certificados",

        tabelaListaDeCertificados: {
          Certificado: "Certificado",
          Fornecedor: "Fornecedor",
          Cidade: "Cidade",
          Inicio: "Início",
          Fim: "Fim",
          Modalidade: "Modalidade",
          Acoes: "Ações",
        },

        tituloEditarCertificadoFornecedor: "Editar certificado/fornecedor",

        formularioCertificadoFornecedor: {
          DataDeInicio: "Data de início",
          DataDeTermino: "Data de término",
          Certificado: "Certificado",
          Fornecedor: "Fornecedor",
          Periodo: "Período",
          TipoDeModalidade: "Tipo de modalidade",

          opcoesTipoDeModalidade: {
            Presencial: "Presencial",
            EAD: "EAD",
          },

          botaoSalvarFornecedor: "Salvar fornecedor",

          placeholder: {
            DataDeInicio: "Data de início",
            DataDeTermino: "Data de término",
            SelecionarFornecedor: "Selecionar fornecedor",
            PeriodoDaAula: "Período da aula",
            SelecionarTipoDeModalidade: "Selecionar tipo de modalidade",
          }
        },

        tabInstrutores: {
          tituloTab: "Instrutores",

          deletarInstrutor: "Tem certeza que gostaria de deletar o instrutor dessa aula?",
          
          tituloAdicionarInstrutor: "Adicionar instrutor",

          formulario: {
            Instrutor: "Instrutor",
            CargaHoraria: "Carga horária",

            botaoAdicionarInstrutor: "Adicionar instrutor",

            placeholder: {
              SelecionarInstrutor: "Selecionar instrutor",
              PreenchaACargaHoraria: "Preencha a carga horária",
            }
          },

          tituloListaDeInstrutores: "Lista de instrutores",

          tabelaListaDeInstrutores: {
            semCertificados: "Não há certificados cadastrados",
            ID: "ID",
            Instrutor: "Instrutor",
            Horas: "Horas",
            Certificado: "Certificado",
            Periodo: "Período",
            Acoes: "Ações",
          },

          formularioDatas: {

            a: "a",

            placeholder: {
              DataDeInicio: "Data de início",
              DataDeTermino: "Data de término",
            }
          }



        },

        tabExaminadores: {
          tituloTab: "Examinadores",

          deletarExaminador: "Tem certeza que gostaria de deletar o examinador dessa aula?",

          tituloAdicionarExaminador: "Adicionar examinador",

          formulario: {
            Examinador: "Examinador",
            CargaHoraria: "Carga horária",

            botaoAdicionarExaminador: "Adicionar examinador",

            placeholder: {
              SelecionarExaminador: "Selecionar examinador",
              PreenchaACargaHoraria: "Preencha a carga horária",
            }
          },

          tituloListaDeExaminadores: "Lista de examinadores",

          tabelaListaDeExaminadores: {
            semCertificados: "Não há certificados cadastrados",
            ID: "ID",
            Examinador: "Examinador",
            Horas: "Horas",
            Certificado: "Certificado",
            Periodo: "Período",
            Acoes: "Ações",
          }


        },


        tituloVisualizarCertificadoFornecedor: "Visualizar certificado/fornecedor",

        tituloInstrutores: "Instrutores",

        tabelaInstrutores: {
          Nome: "Nome",
          Inicio: "Início",
          Fim: "Fim",
          Horas: "Horas",
        },

        tituloExaminadores: "Examinadores",

        tabelaExaminadores: {
          Nome: "Nome",
          Inicio: "Início",
          Fim: "Fim",
          Horas: "Horas",
        }


      },

      tabAlunos: {
        tituloTab: "Alunos",

        deletarAlunoDessaAula: "Tem certeza que gostaria de deletar o aluno dessa aula?",
        deletarAlunoDesseTreinamento: "Tem certeza que gostaria de deletar o aluno desse treinamento?",

        tituloAdicionarAluno: "Adicionar aluno",

        formularioAdicionarAluno: {
          Tripulante: "Tripulante",
          
          botaoAdicionarTripulante: "Adicionar tripulante",

          placeholder: {
            SelecionarTripulante: "Selecionar Tripulante",
          }
        },

        tituloListaDeAlunos: "Lista de alunos",

        nenhumAlunoCadastrado: "Nenhum aluno cadastrado.",

        botaoRemoverTodasAsAulas: "Remover todas as aulas",

        tituloCertificadoDeTreinamentoDe(DataInicial, DataFinal) {
          return `De ${DataInicial} a ${DataFinal}`;
        },

        formularioObservacoes: {
          placeholder: {
            Observacoes: "Observações",
          }
        }
      },

      tabDiarias: {
        tituloTab: "Diárias",

        tituloDiariasDoTreinamento: "Diárias do treinamento",
        nenhumaDiariaCadastrada: "Nenhuma diária cadastrada.",

        tabela: {
          Funcionario: "Funcionário",
          Ida: "Ida",
          CheckIn: "Check-in",
          Inicio: "Início",
          Fim: "Fim",
          CheckOut: "Check-out",
          Volta: "Volta",
          Qtd: "Qtd.",
          Diarias: "Diárias",
          VDiaria: "V. diária",
          VTotal: "V. Total",
        }

      },

      tabPresenca: {
        tituloTab: "Presença",

        confirmarTodasAsPresencas: "Tem certeza que gostaria de confirmar todas as presenças desse treinamento?",
        confirmarPresencaDesseAluno: "Tem certeza que gostaria de confirmar a presença desse aluno?",

        confirmarAusenciaDesseAluno: "Tem certeza que gostaria de confirmar a ausência desse aluno?",

        tituloListaDePresenca: "Lista de presença",

        botaoConfirmarTodasAsPresencas: "Confirmar todas as presenças",
        nenhumAlunoCadastrado: "Nenhum aluno cadastrado.",

        tabela: {
          Funcionario: "Funcionário",
          PresencaAusencia: "Presença / Ausência",

          PresencaConfirmada: "Presença confirmada",
          AusenciaConfirmada: "Ausência confirmada",

          ConfirmarPresenca: "Confirmar presença",
          ConfirmarAusencia: "Confirmar ausência",
        }
      },

      tabAlertas: {
        tituloTab: "Alertas",

        deletarComentario: "Tem certeza que gostaria de deletar esse comentário?",

        tituloListaDeAlertas: "Lista de alertas",

        tabelaListaDeAlertas: {
          semAlertas: "Não há alertas cadastrados.",
          ID: "ID",
          Tipo: "Tipo",
          Tripulante: "Tripulante",
          Cargo: "Cargo",
          Aula: "Aula",
          Titulo: "Título",
          Acoes: "Ações",
        },

        tituloAdicionarComentarioNesteAlertaDeTreinamento: "Adicionar comentário neste alerta de treinamento",

        formulario: {
          Comentario: "Comentário",

          botaoAdicionarComentario: "Adicionar Comentário",
        },

        tituloComentariosSobreOAlerta: "Comentários sobre o alerta",

        tabelaComentariosSobreOAlerta: {
          semComentarios: "Não há comentários cadastrados",
          Comentario: "Comentário",
          Usuario: "Usuário",
          Data: "Data",
          Acoes: "Ações",
        },
      },

      tabResultados: {
        tituloTab: "Resultados",

        finalizarTodosOsCertificados: "Tem certeza que gostaria de finalizar todos os certificados de tripulantes aprovados?",

        tituloInstrutoresExaminadores: "Instrutores / Examinadores",

        nenhumAlunoCadastrado: "Nenhum aluno cadastrado.",

        tabelaIntrutoresExaminadores: {
          Instrutor: "Instrutor",
          Examinador: "Examinador",
          PagamentoViaLogbook: "Pagamento via logbook",

          formulario: {
            Horas: "Horas",
            HorasDobradas: "Horas dobradas",
            Acoes: "Ações",

            botaoConfirmarPagamento: "Confirmar pagamento",
          },
        },

        tituloTripulantes: "Tripulantes",
        botaoFinalizarTodos: "Finalizar todos",

        tabelaTripulantes: {
          HoraPF: "Hora PF",
          HoraPNF: "Hora PNF",
          Finalizado: "Finalizado",

          HorasPF: "Horas PF",
          HorasPNF: "Horas PNF",
          Status: "Status",
          Faltante: "Faltante",

          MarcarAlunoComoFaltante: "Tem certeza que gostaria de marcar o aluno como faltante?",

          formulario: {
            Reprovado: "Reprovado",
            MarcarComoFaltante: "Marcar como faltante",
            Acoes: "Ações",

            botaoFaltante: "Faltante",
            botaoInserirResultado: "Inserir resultado",
          },

          Nota: "Nota",
          Horas: "Horas",

          MarcarComoFaltante: "MarcarComoFaltante",
          Acoes: "Ações",

          botaoAtualizarNota: "Atualizar nota",
        }


      },

      tabLogbook: {
        tituloTab: "Logbook",

        finalizarSessao: "Tem certeza que gostaria de finalizar essa sessão?",
        reabrirSessao: "Tem certeza que gostaria de reabrir essa sessão?",
        deletarSessao: "Tem certeza que gostaria de deletar essa sessão?",
        dadosAtualizadosComSucesso: "Os dados foram atualizados com sucesso",

        tituloAdicionarSessao: "Adicionar sessão",
        botaoConfirmarHoras: "Confirmar horas",

        formularioAdicionarSessao: {
          Certificado: "Certificado",
          Data: "Data",
          Inicio: "Início",
          Fim: "Fim",
          Examinador: "Examinador",
          Instrutor: "Instrutor",
          PilotFlying: "Pilot Flying",
          PilotMonitoring: "Pilot Monitoring",

          botaoAdicionarSessao: "Adicionar sessão",

          placeholder: {
            SelecionarCertificado: "Selecionar certificado",
            Data: "Data",
            HorarioDeInicio: "Horário de início",
            HorarioDeFim: "Horário de fim",
          },
        },

        tituloListaDeSessoes: "Lista de sessões",

        tabelaListaDeSessoes: {
          Certificado: "Certificado",
          Inicio: "Início",
          Fim: "Fim",
          HorasTotais: "Horas totais",
          Tripulacao: "Tripulação",
          Arquivo: "Arquivo",
          Status: "Status",
          Acoes: "Ações",

          Aberto: "Aberto",
          Finalizado: "Finalizado",
          Confirmado: "Confirmado",

          ImportarArquivo: "Tem certeza que gostaria de importar este arquivo? Ao importar, o arquivo anterior, se houver, será substituido permanentemente.",
          
          formularioListaDeSessoes: {
            placeholder: {
              Arquivo: "Arquivo",
            }
          },
        },

        opcoesTipo: {
          Examinador: "Examinador",
          Instrutor: "Instrutor",
          PilotFlying: "Pilot Flying",
          PilotMonitoring: "Pilot Monitoring",
        },

        deletarTripulante: "Tem certeza que deseja deletar esse tripulante?",

        tituloAdicionarTripulante: "Adicionar tripulante",

        formularioAdicionarTripulante: {
          Tripulante: "Tripulante",
          Tipo: "Tipo",
        },

        tabelaAdicionarTripulante: {
          Tripulante: "Tripulante",
          Matricula: "Matrícula",
          Tipo: "Tipo",
          Acoes: "Ações",
        },

        tituloDuplicarSessao: "Duplicar sessão",

        formularioDuplicarSessao: {
          Data: "Data",
          Inicio: "Início",
          Fim: "Fim",

          botaoDuplicarSessao: "Duplicar sessão",

          placeholder: {
            Data: "Data",
            HorarioDeInicio: "Horário de início",
            HorarioDeFim: "Horário de fim",
          }
        }

      },

      tabRevisao: {
        tituloTab: "Revisão",

        tituloRevisoes: "Revisões",

        botaoCriarRevisao: "Criar revisão",

        nenhumaRevisaoParaEsteTreinamento: "Nenhuma revisão para este treinamento.",
        
        tabela: {
          DataDeCriacao: "Data de criação",
          Status: "Status",
          Acoes: "Ações",
        }

      },

      tituloSelecioneOTipoDePDF: "Selecione o tipo de PDF",

      botaoSolo: "SOLO",
      botaoSoloTIC: "SOLO TIC",
      botaoSimulador: "SIMULADOR",
      botaoEAD: "EAD",

      botaoConfirmarTrocaDeStatus: "Confirmar troca de status",
      botaoCancelar: "Cancelar",

      tituloInformativoDeAlertas: "Informativo de alertas",

      tituloTripulantesElegiveis: "Tripulantes elegíveis",

      tabelaTripulantesElegiveis: {
        Tripulante: "Tripulante",
        Certificado: "Certificado",
        DataDeExpiracao: "Data de expiração",
        Prazo: "Prazo",
        Acoes: "Ações",
      },

      tituloEnvioDeEmail: "Envio de e-mail",

      tituloUploadDeArquivos: "Upload de arquivos",

      formularioUploadDeArquivos: {
        Arquivo: "Arquivo",
        SelecionarExportacaoDoTreinamento: "Selecionar exportação do treinamento",
        
        opcoesTipo: {
          Solo: "SOLO",
          SoloTIC: "SOLO TIC",
          Simulador: "SIMULADOR",
          EAD: "EAD",
        },

        SelecionarDestinatariosExtras: "Selecionar destinatários extras",
        botaoEnviarEmail: "Enviar e-mail",

        placeholder: {
          Arquivo: "Arquivo",
          SelecionarTipo: "Selecionar tipo",
          SeparePorVirgula: "Separe por vírgula",
        }
      }
    }
  },

  Links: {
    LinksUteis: {
      deletar: "Tem certeza que gostaria de deletar esse link?",
      
      titulo: "Links Úteis",

      tituloAdicionarLink: "Adicionar link",

      formulario: {
        Nome: "Nome",
        Link: "Link",
      },

      tabela: {
        semIncompatibilidades: "Não há incompatibilidades cadastradas",
        ID: "ID",
        Nome: "Nome",
        Link: "Link",
        Acoes: "Ações",
      }
    }
  },

  Usuarios: {
    ListaDeUsuarios: {
      deletar: "Tem certeza que gostaria de deletar esse usuário?",
      titulo: "Lista de usuários",

      tabela: {
        semUsuarios: "Não há usuários cadastrados",
        ID: "ID",
        Nome: "Nome",
        Funcionario: "Funcionário",
        Email: "E-mail",
        Criacao: "Criação",
        Acoes: "Ações",
      }
    },

    AdicionarUsuario: {
      titulo: "Cadastrar usuário",

      formulario: {
        Nome: "Nome",
        Email: "E-mail",
        Funcionario: "Funcionário",
        UsadoEmSigtrip: "Usado em sigvoos",
        UsadoEmSigrfms: "Usado no portal",

        placeholder: {
          SelecionarBase: "Selecionar base",
          SelecionarFuncionario: "Selecionar funcionário",
        }
      }
    },

    EditarUsuario: {
      titulo: "Editar usuário",
      deletarEmpresa: "Tem certeza que deseja deletar esta empresa?",
      formulario: {
        Nome: "Nome",
        Email: "E-mail",
        Funcionario: "Funcionário",
        UsadoEmSigtrip: "Usado em sigvoos",
        UsadoEmSigrfms: "Usado no portal",

        placeholder: {
          SelecionarBase: "Selecionar base",
          SelecionarFuncionario: "Selecionar funcionário",
        }
      },

      tituloGruposDePermissoes: "Grupos de permissões",

      tituloBasesRelacionadas: "Bases relacionadas",

      formularioBasesRelacionadas: {
        botaoSalvarBasesRelacionadas: "Salvar bases relacionadas",
      },
      botaoSalvar: "Salvar",
      botaoSalvarGrupos: "Salvar Grupos",


      tituloEmpresas: "Empresas",
      adicionarEmpresa: "Adicionar empresa",

      formularioEmpresas: {
        Empresas: "Empresas",
        botaoSalvarEmpresas: "Salvar empresas",
        botaoAdicionarEmpresa: "Adicionar empresa",

        placeHolder: {
          SelecionarEmpresa: "Selecionar empresa",
          SelecionarFuncionario: "Selecionar funcionário",
        },
      },
      tabelaEmpresas: {
        Empresa: "Empresa",
      },
    },

    EditarSenha: {
      titulo: "Alteração de senha",

      formulario: {
        SenhaAtual: "Senha atual",
        NovaSenha: "Nova senha",
        RepitaANovaSenha: "Repita a nova senha",

        placeholder: {
          SenhaAtual: "Senha atual",
          NovaSenha: "Nova senha",
          RepitaANovaSenha: "Repita a nova senha",
        }
      }
    },

    RecuperarSenha: {
      paragrafoVoltarParaLogin: "Voltar para login",

      formulario: {

        botaoRecuperarSenha: "Recuperar senha",

        placeholder: {
          SeuEmail: "Seu e-mail",
        }
      }
    },

    SistemaSuspenso: {
      titulo: "Sistema suspenso para manutenção",

      tituloAtualizacao: "Atualização",

      paragrafoPrevisaoDeVolta: "Previsão de volta",
    },

    Login: {
      usuarioNaoCadastrado: "Usuário não cadastrato. Solicite a TI a criação do usuário.",
      usuarioInativo: "Usuário inativo neste sistema. Solicite a TI a liberação do usuário.",
      usuarioSemPermissoes: "Usuário sem permissões para este sistema. Solicite a TI as permissões de acesso para este usuário.",
      usuarioOuSenhaInvalidos: "Usuário ou senha inválidos.",

      paragrafoModuloAdministrativo: "MÓDULO ADMINISTRATIVO",

      formulario: {
        paragrafoAtencao: "ATENÇÃO: VOCÊ ACESSARÁ O AMBIENTE DE HOMOLOGAÇÃO",

        botaoAcessarOSistema: "Acessar o sistema",

        placeholder: {
          SeuEmail: "Seu E-mail",
          SuaSenha: "Sua senha",
        }
      },

      paragrafoOLoginDeveSerFeitoComUsuarioESenhaOmniRubi: "O LOGIN DEVE SER FEITO COM O USUÁRIO E SENHA RUBI",

      paragrafoEsqueciMinhaSenha: "Esqueci minha senha",

      paragrafoParaRecuperarSuaSenha: "Para recuperar sua senha, entre em contato com o setor de TI."

    }

  },


  RequisitosDeExperiencia: {
    EditarRequisitoDeExperiencia: {
      titulo: "Editar Requisito de Experiência Mínima",
      
      formulario: {
        DesignacaoDoTripulante: "Designação do tripulante",

        opcoesFuncao: {
          Comandante: "Comandante",
          Copiloto: "Co-piloto",
          Comissario: "Comissário",
        },

        MinimoDeHorasParaOperacional: "Mínimo de horas para operacional",
        RequerTripulanteComDesignacao: "Requer tripulante com designação",
        MinimoDeHorasNoModelo: "Mínimo de horas no modelo",
        MinimoDeHorasTotais: "Mínimo de horas totais",

        botaoAdicionarRequisito: "Adicionar requisito",
        
        placeholder: {
          SelecionarFuncao: "Selecionar função",
          MinimoDeHorasParaOperacional: "Mínimo de horas para operacional",
          SelecionarDesignacao: "Selecionar designação",
          MinimoDeHorasNoModelo: "Mínimo de horas no modelo",
          MinimoDeHorasTotais: "Mínimo de horas totais",
        }
      },

      tabela: {
        DesignacaoDoTripulante: "Designação do tripulante",
        MinimoDeHorasParaOperacional: "Mínimo de horas para operacional",
        RequerTripulanteComDesignacao: "Requer tripulante com designação",
        MinimoDeHorasNoModelo: "Mínimo de horas no modelo",
        MinimoDeHorasTotais: "Mínimo de horas totais",
        Acoes: "Ações",
      }
    }
  },

  Alertas: {
    ListaDeAlertas: {
      titulo: "Lista de alertas",

      tabela: {
        semAlertas: "Não há alertas cadastrados",

        ID: "ID",
        Nome: "Nome",
        EscalaDeMissao: "Escala de Missão",
        Cor: "Cor",
        RelatorioDeVoo: "Relatório de voo",
        EscalaDiaria: "Escala diária",
        Papeletas: "Papeletas",
        Acoes: "Ações"
      }
    },

    EditarAlerta: {
      titulo: "Editar alerta",

      formulario: {
        EscalaDeMissaoAtivo: "Escala de Missão - Ativo",
        EscalaDeMissaoCor: "Escala de Missão - Cor",

        opcoesCor: {
          Vermelho: "Vermelho",
          Laranja: "Laranja",
          Verde: "Verde",
        },

        RelatorioDeVooAtivo: "Relatório de voo - Ativo",
        RelatorioDeVooCor: "Relatório de voo - Cor",

        EscalaDiariaAtivo: "Escala diária - Ativo",
        EscalaDiariaCor: "Escala diária - Cor",

        PapeletasAtivo: "Papeletas - Ativo",
        PapeletasCor: "Papeletas - Cor",

        AreaResponsavel: "Área responsável",
        Premissas: "Premissas",
      },

      tituloRevisoesPendentes: "Revisões pendentes",

      tabelaRevisoesPendentes: {
        AreaResponsavel: "Área responsável",
        Premissas: "Premissas",
        EscalaDeMissaoAtivo: "Escala de missão - Ativo",
        EscalaDeMissaoCor: "Escala de missão - Cor",
        RelatorioDeVooAtivo: "Relatório de voo - Ativo",
        RelatorioDeVooCor: "Relatório de voo - Cor",
        EscalaDiariaAtivo: "Escala diária - Ativo",
        EscalaDiariaCor: "Escala diária - Cor",
        PapeletasAtivo: "Papeletas - Ativo",
        PapeletasCor: "Papeletas - Cor",
        Autor: "Autor",
        Acoes: "Ações",
      },

      naoHaRevisoesPendentes: "Não há revisões pendentes",

      tituloLogDeRevisoes: "Log de revisões",

      tabelaLogDeRevisoes: {
        Situacao: "Situação",
        Data: "Data",
        AreaResponsavel: "Área responsável",
        Premissas: "Premissas",
        EscalaDeMissaoAtivo: "Escala de missão - Ativo",
        EscalaDeMissaoCor: "Escala de missão - Cor",
        RelatorioDeVooAtivo: "Relatório de voo - Ativo",
        RelatorioDeVooCor: "Relatório de voo - Cor",
        EscalaDiariaAtivo: "Escala diária - Ativo",
        EscalaDiariaCor: "Escala diária - Cor",
        PapeletasAtivo: "Papeletas - Ativo",
        PapeletasCor: "Papeletas - Cor",
        Autor: "Autor",
        Aprovacao: "Aprovação",
        Inicial: "Inicial",
        Aprovada: "Aprovada",
        Reprovada: "Reprovada",
      },



    }
  }
});

export default getLocale;



// WEBPACK FOOTER //
// ./src/i18n/pt-BR.jsx